export function dataInJs() {
var PCCList = [{
	"areaId": 11,
	"areaName": "北京市",
	"longitude": 116.40528500,
	"latitude": 39.90498900,
	"children": [{
		"areaId": 110101,
		"areaName": "东城区",
		"longitude": 116.41005000,
		"latitude": 39.93157000,
		"children": []
	}, {
		"areaId": 110102,
		"areaName": "西城区",
		"longitude": 116.36003000,
		"latitude": 39.93050000,
		"children": []
	}, {
		"areaId": 110105,
		"areaName": "朝阳区",
		"longitude": 125.28830000,
		"latitude": 43.83339000,
		"children": []
	}, {
		"areaId": 110106,
		"areaName": "丰台区",
		"longitude": 116.28625000,
		"latitude": 39.85850000,
		"children": []
	}, {
		"areaId": 110107,
		"areaName": "石景山区",
		"longitude": 116.22290000,
		"latitude": 39.90564000,
		"children": []
	}, {
		"areaId": 110108,
		"areaName": "海淀区",
		"longitude": 116.29812000,
		"latitude": 39.95931000,
		"children": []
	}, {
		"areaId": 110109,
		"areaName": "门头沟区",
		"longitude": 116.10137000,
		"latitude": 39.94043000,
		"children": []
	}, {
		"areaId": 110111,
		"areaName": "房山区",
		"longitude": 116.14257000,
		"latitude": 39.74786000,
		"children": []
	}, {
		"areaId": 110112,
		"areaName": "通州区",
		"longitude": 121.07293000,
		"latitude": 32.06760000,
		"children": []
	}, {
		"areaId": 110113,
		"areaName": "顺义区",
		"longitude": 116.65417000,
		"latitude": 40.13020000,
		"children": []
	}, {
		"areaId": 110114,
		"areaName": "昌平区",
		"longitude": 116.23120000,
		"latitude": 40.22072000,
		"children": []
	}, {
		"areaId": 110115,
		"areaName": "大兴区",
		"longitude": 116.34149000,
		"latitude": 39.72668000,
		"children": []
	}, {
		"areaId": 110116,
		"areaName": "怀柔区",
		"longitude": 116.63168000,
		"latitude": 40.31602000,
		"children": []
	}, {
		"areaId": 110117,
		"areaName": "平谷区",
		"longitude": 117.12133000,
		"latitude": 40.14056000,
		"children": []
	}, {
		"areaId": 110118,
		"areaName": "密云区",
		"longitude": 116.84295000,
		"latitude": 40.37618000,
		"children": []
	}, {
		"areaId": 110119,
		"areaName": "延庆区",
		"longitude": 115.97494000,
		"latitude": 40.45672000,
		"children": []
	}]
}, {
	"areaId": 12,
	"areaName": "天津市",
	"longitude": 117.19018200,
	"latitude": 39.12559600,
	"children": [{
		"areaId": 120101,
		"areaName": "和平区",
		"longitude": 120.88349000,
		"latitude": 24.17477000,
		"children": []
	}, {
		"areaId": 120102,
		"areaName": "河东区",
		"longitude": 118.41055000,
		"latitude": 35.08803000,
		"children": []
	}, {
		"areaId": 120103,
		"areaName": "河西区",
		"longitude": 117.22327000,
		"latitude": 39.10959000,
		"children": []
	}, {
		"areaId": 120104,
		"areaName": "南开区",
		"longitude": 117.15074000,
		"latitude": 39.13821000,
		"children": []
	}, {
		"areaId": 120105,
		"areaName": "河北区",
		"longitude": 114.14895900,
		"latitude": 22.49408600,
		"children": []
	}, {
		"areaId": 120106,
		"areaName": "红桥区",
		"longitude": 117.15145000,
		"latitude": 39.16715000,
		"children": []
	}, {
		"areaId": 120110,
		"areaName": "东丽区",
		"longitude": 117.31436000,
		"latitude": 39.08630000,
		"children": []
	}, {
		"areaId": 120111,
		"areaName": "西青区",
		"longitude": 117.00927000,
		"latitude": 39.14123000,
		"children": []
	}, {
		"areaId": 120112,
		"areaName": "津南区",
		"longitude": 114.17413400,
		"latitude": 22.24676000,
		"children": []
	}, {
		"areaId": 120113,
		"areaName": "北辰区",
		"longitude": 117.13217000,
		"latitude": 39.22131000,
		"children": []
	}, {
		"areaId": 120114,
		"areaName": "武清区",
		"longitude": 117.04443000,
		"latitude": 39.38415000,
		"children": []
	}, {
		"areaId": 120115,
		"areaName": "宝坻区",
		"longitude": 117.31030000,
		"latitude": 39.71761000,
		"children": []
	}, {
		"areaId": 120116,
		"areaName": "滨海新区",
		"longitude": 117.70162000,
		"latitude": 39.02668000,
		"children": []
	}, {
		"areaId": 120117,
		"areaName": "宁河区",
		"longitude": 117.82550000,
		"latitude": 39.33048000,
		"children": []
	}, {
		"areaId": 120118,
		"areaName": "静海区",
		"longitude": 116.97436000,
		"latitude": 38.94582000,
		"children": []
	}, {
		"areaId": 120119,
		"areaName": "蓟州区",
		"longitude": 0.00000000,
		"latitude": 0.00000000,
		"children": []
	}]
}, {
	"areaId": 13,
	"areaName": "河北省",
	"longitude": 114.50246100,
	"latitude": 38.04547400,
	"children": [{
		"areaId": 1301,
		"areaName": "石家庄市",
		"longitude": 114.50246100,
		"latitude": 38.04547400,
		"children": [{
			"areaId": 130102,
			"areaName": "长安区",
			"longitude": 108.94586000,
			"latitude": 34.15559000
		}, {
			"areaId": 130104,
			"areaName": "桥西区",
			"longitude": 114.86962000,
			"latitude": 40.81945000
		}, {
			"areaId": 130105,
			"areaName": "新华区",
			"longitude": 113.29402000,
			"latitude": 33.73730000
		}, {
			"areaId": 130107,
			"areaName": "井陉矿区",
			"longitude": 114.06518000,
			"latitude": 38.06705000
		}, {
			"areaId": 130108,
			"areaName": "裕华区",
			"longitude": 114.53115000,
			"latitude": 38.00604000
		}, {
			"areaId": 130109,
			"areaName": "藁城区",
			"longitude": 114.84671000,
			"latitude": 38.02162000
		}, {
			"areaId": 130110,
			"areaName": "鹿泉区",
			"longitude": 114.31347000,
			"latitude": 38.08782000
		}, {
			"areaId": 130111,
			"areaName": "栾城区",
			"longitude": 114.64834000,
			"latitude": 37.90022000
		}, {
			"areaId": 130121,
			"areaName": "井陉县",
			"longitude": 114.14257000,
			"latitude": 38.03688000
		}, {
			"areaId": 130123,
			"areaName": "正定县",
			"longitude": 114.57296000,
			"latitude": 38.14445000
		}, {
			"areaId": 130125,
			"areaName": "行唐县",
			"longitude": 114.55316000,
			"latitude": 38.43654000
		}, {
			"areaId": 130126,
			"areaName": "灵寿县",
			"longitude": 114.38259000,
			"latitude": 38.30845000
		}, {
			"areaId": 130127,
			"areaName": "高邑县",
			"longitude": 114.61142000,
			"latitude": 37.61556000
		}, {
			"areaId": 130128,
			"areaName": "深泽县",
			"longitude": 115.20358000,
			"latitude": 38.18353000
		}, {
			"areaId": 130129,
			"areaName": "赞皇县",
			"longitude": 114.38775000,
			"latitude": 37.66135000
		}, {
			"areaId": 130130,
			"areaName": "无极县",
			"longitude": 114.97509000,
			"latitude": 38.17653000
		}, {
			"areaId": 130131,
			"areaName": "平山县",
			"longitude": 114.18600000,
			"latitude": 38.25994000
		}, {
			"areaId": 130132,
			"areaName": "元氏县",
			"longitude": 114.52539000,
			"latitude": 37.76668000
		}, {
			"areaId": 130133,
			"areaName": "赵县",
			"longitude": 114.77612000,
			"latitude": 37.75628000
		}, {
			"areaId": 130171,
			"areaName": "石家庄高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130172,
			"areaName": "石家庄循环化工园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130181,
			"areaName": "辛集市",
			"longitude": 115.20626000,
			"latitude": 37.94079000
		}, {
			"areaId": 130183,
			"areaName": "晋州市",
			"longitude": 115.04348000,
			"latitude": 38.03135000
		}, {
			"areaId": 130184,
			"areaName": "新乐市",
			"longitude": 114.68985000,
			"latitude": 38.34417000
		}]
	}, {
		"areaId": 1302,
		"areaName": "唐山市",
		"longitude": 118.17539300,
		"latitude": 39.63511300,
		"children": [{
			"areaId": 130202,
			"areaName": "路南区",
			"longitude": 118.15431000,
			"latitude": 39.62505000
		}, {
			"areaId": 130203,
			"areaName": "路北区",
			"longitude": 118.20079000,
			"latitude": 39.62436000
		}, {
			"areaId": 130204,
			"areaName": "古冶区",
			"longitude": 118.45803000,
			"latitude": 39.71993000
		}, {
			"areaId": 130205,
			"areaName": "开平区",
			"longitude": 118.26171000,
			"latitude": 39.67128000
		}, {
			"areaId": 130207,
			"areaName": "丰南区",
			"longitude": 118.11282000,
			"latitude": 39.56483000
		}, {
			"areaId": 130208,
			"areaName": "丰润区",
			"longitude": 118.12976000,
			"latitude": 39.82440000
		}, {
			"areaId": 130209,
			"areaName": "曹妃甸区",
			"longitude": 118.46037900,
			"latitude": 39.27307000
		}, {
			"areaId": 130224,
			"areaName": "滦南县",
			"longitude": 118.67410000,
			"latitude": 39.50390000
		}, {
			"areaId": 130225,
			"areaName": "乐亭县",
			"longitude": 118.91250000,
			"latitude": 39.42561000
		}, {
			"areaId": 130227,
			"areaName": "迁西县",
			"longitude": 118.31616000,
			"latitude": 40.14587000
		}, {
			"areaId": 130229,
			"areaName": "玉田县",
			"longitude": 117.73880000,
			"latitude": 39.90049000
		}, {
			"areaId": 130271,
			"areaName": "河北唐山芦台经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130272,
			"areaName": "唐山市汉沽管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130273,
			"areaName": "唐山高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130274,
			"areaName": "河北唐山海港经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130281,
			"areaName": "遵化市",
			"longitude": 117.96444000,
			"latitude": 40.18741000
		}, {
			"areaId": 130283,
			"areaName": "迁安市",
			"longitude": 118.70068000,
			"latitude": 39.99833000
		}, {
			"areaId": 130284,
			"areaName": "滦州市",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 1303,
		"areaName": "秦皇岛市",
		"longitude": 119.58657900,
		"latitude": 39.94253100,
		"children": [{
			"areaId": 130302,
			"areaName": "海港区",
			"longitude": 119.61046000,
			"latitude": 39.93450000
		}, {
			"areaId": 130303,
			"areaName": "山海关区",
			"longitude": 119.77563000,
			"latitude": 39.97869000
		}, {
			"areaId": 130304,
			"areaName": "北戴河区",
			"longitude": 119.48388000,
			"latitude": 39.83408000
		}, {
			"areaId": 130306,
			"areaName": "抚宁区",
			"longitude": 119.24487000,
			"latitude": 39.87538000
		}, {
			"areaId": 130321,
			"areaName": "青龙满族自治县",
			"longitude": 118.95242000,
			"latitude": 40.40743000
		}, {
			"areaId": 130322,
			"areaName": "昌黎县",
			"longitude": 119.16595000,
			"latitude": 39.70884000
		}, {
			"areaId": 130324,
			"areaName": "卢龙县",
			"longitude": 118.89288000,
			"latitude": 39.89176000
		}, {
			"areaId": 130371,
			"areaName": "秦皇岛市经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130372,
			"areaName": "北戴河新区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 1304,
		"areaName": "邯郸市",
		"longitude": 114.53103000,
		"latitude": 36.59385000,
		"children": [{
			"areaId": 130402,
			"areaName": "邯山区",
			"longitude": 114.48375000,
			"latitude": 36.60006000
		}, {
			"areaId": 130403,
			"areaName": "丛台区",
			"longitude": 114.49343000,
			"latitude": 36.61847000
		}, {
			"areaId": 130404,
			"areaName": "复兴区",
			"longitude": 121.35261300,
			"latitude": 24.82090800
		}, {
			"areaId": 130406,
			"areaName": "峰峰矿区",
			"longitude": 114.21148000,
			"latitude": 36.41937000
		}, {
			"areaId": 130407,
			"areaName": "肥乡区",
			"longitude": 114.79998000,
			"latitude": 36.54807000
		}, {
			"areaId": 130408,
			"areaName": "永年区",
			"longitude": 114.48925000,
			"latitude": 36.78356000
		}, {
			"areaId": 130423,
			"areaName": "临漳县",
			"longitude": 114.61950000,
			"latitude": 36.33461000
		}, {
			"areaId": 130424,
			"areaName": "成安县",
			"longitude": 104.56738000,
			"latitude": 31.53487000
		}, {
			"areaId": 130425,
			"areaName": "大名县",
			"longitude": 115.15362000,
			"latitude": 36.27994000
		}, {
			"areaId": 130426,
			"areaName": "涉县",
			"longitude": 113.69183000,
			"latitude": 36.58072000
		}, {
			"areaId": 130427,
			"areaName": "磁县",
			"longitude": 114.37387000,
			"latitude": 36.37392000
		}, {
			"areaId": 130430,
			"areaName": "邱县",
			"longitude": 115.17407000,
			"latitude": 36.82082000
		}, {
			"areaId": 130431,
			"areaName": "鸡泽县",
			"longitude": 114.87420000,
			"latitude": 36.92374000
		}, {
			"areaId": 130432,
			"areaName": "广平县",
			"longitude": 114.94653000,
			"latitude": 36.48046000
		}, {
			"areaId": 130433,
			"areaName": "馆陶县",
			"longitude": 115.29913000,
			"latitude": 36.53719000
		}, {
			"areaId": 130434,
			"areaName": "魏县",
			"longitude": 114.93518000,
			"latitude": 36.36171000
		}, {
			"areaId": 130435,
			"areaName": "曲周县",
			"longitude": 114.95196000,
			"latitude": 36.77671000
		}, {
			"areaId": 130471,
			"areaName": "邯郸经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130473,
			"areaName": "邯郸冀南新区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130481,
			"areaName": "武安市",
			"longitude": 114.20153000,
			"latitude": 36.69281000
		}]
	}, {
		"areaId": 1305,
		"areaName": "邢台市",
		"longitude": 114.56575000,
		"latitude": 37.04560000,
		"children": [{
			"areaId": 130502,
			"areaName": "襄都区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130503,
			"areaName": "信都区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130505,
			"areaName": "任泽区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130506,
			"areaName": "南和区",
			"longitude": 114.68371000,
			"latitude": 37.00488000
		}, {
			"areaId": 130522,
			"areaName": "临城县",
			"longitude": 114.50387000,
			"latitude": 37.43977000
		}, {
			"areaId": 130523,
			"areaName": "内丘县",
			"longitude": 114.51212000,
			"latitude": 37.28671000
		}, {
			"areaId": 130524,
			"areaName": "柏乡县",
			"longitude": 114.69332000,
			"latitude": 37.48242000
		}, {
			"areaId": 130525,
			"areaName": "隆尧县",
			"longitude": 114.77615000,
			"latitude": 37.35351000
		}, {
			"areaId": 130528,
			"areaName": "宁晋县",
			"longitude": 114.92117000,
			"latitude": 37.61696000
		}, {
			"areaId": 130529,
			"areaName": "巨鹿县",
			"longitude": 115.03524000,
			"latitude": 37.21801000
		}, {
			"areaId": 130530,
			"areaName": "新河县",
			"longitude": 115.24987000,
			"latitude": 37.52718000
		}, {
			"areaId": 130531,
			"areaName": "广宗县",
			"longitude": 115.14254000,
			"latitude": 37.07460000
		}, {
			"areaId": 130532,
			"areaName": "平乡县",
			"longitude": 115.03002000,
			"latitude": 37.06317000
		}, {
			"areaId": 130533,
			"areaName": "威县",
			"longitude": 115.26370000,
			"latitude": 36.97680000
		}, {
			"areaId": 130534,
			"areaName": "清河县",
			"longitude": 115.66479000,
			"latitude": 37.07122000
		}, {
			"areaId": 130535,
			"areaName": "临西县",
			"longitude": 115.50097000,
			"latitude": 36.87078000
		}, {
			"areaId": 130571,
			"areaName": "河北邢台经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130581,
			"areaName": "南宫市",
			"longitude": 115.39068000,
			"latitude": 37.35799000
		}, {
			"areaId": 130582,
			"areaName": "沙河市",
			"longitude": 114.49810000,
			"latitude": 36.85770000
		}]
	}, {
		"areaId": 1306,
		"areaName": "保定市",
		"longitude": 115.48233100,
		"latitude": 38.86765700,
		"children": [{
			"areaId": 130602,
			"areaName": "竞秀区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130606,
			"areaName": "莲池区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130607,
			"areaName": "满城区",
			"longitude": 115.32296000,
			"latitude": 38.94972000
		}, {
			"areaId": 130608,
			"areaName": "清苑区",
			"longitude": 115.49267000,
			"latitude": 38.76709000
		}, {
			"areaId": 130609,
			"areaName": "徐水区",
			"longitude": 115.65829000,
			"latitude": 39.02099000
		}, {
			"areaId": 130623,
			"areaName": "涞水县",
			"longitude": 115.71517000,
			"latitude": 39.39404000
		}, {
			"areaId": 130624,
			"areaName": "阜平县",
			"longitude": 114.19683000,
			"latitude": 38.84763000
		}, {
			"areaId": 130626,
			"areaName": "定兴县",
			"longitude": 115.80786000,
			"latitude": 39.26312000
		}, {
			"areaId": 130627,
			"areaName": "唐县",
			"longitude": 114.98516000,
			"latitude": 38.74513000
		}, {
			"areaId": 130628,
			"areaName": "高阳县",
			"longitude": 115.77880000,
			"latitude": 38.70003000
		}, {
			"areaId": 130629,
			"areaName": "容城县",
			"longitude": 115.87158000,
			"latitude": 39.05350000
		}, {
			"areaId": 130630,
			"areaName": "涞源县",
			"longitude": 114.69128000,
			"latitude": 39.35388000
		}, {
			"areaId": 130631,
			"areaName": "望都县",
			"longitude": 115.15670000,
			"latitude": 38.70996000
		}, {
			"areaId": 130632,
			"areaName": "安新县",
			"longitude": 115.93557000,
			"latitude": 38.93532000
		}, {
			"areaId": 130633,
			"areaName": "易县",
			"longitude": 115.49810000,
			"latitude": 39.34885000
		}, {
			"areaId": 130634,
			"areaName": "曲阳县",
			"longitude": 114.70123000,
			"latitude": 38.62154000
		}, {
			"areaId": 130635,
			"areaName": "蠡县",
			"longitude": 115.57717000,
			"latitude": 38.48974000
		}, {
			"areaId": 130636,
			"areaName": "顺平县",
			"longitude": 115.13470000,
			"latitude": 38.83854000
		}, {
			"areaId": 130637,
			"areaName": "博野县",
			"longitude": 115.47033000,
			"latitude": 38.45640000
		}, {
			"areaId": 130638,
			"areaName": "雄县",
			"longitude": 116.10873000,
			"latitude": 38.99442000
		}, {
			"areaId": 130671,
			"areaName": "保定高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130672,
			"areaName": "保定白沟新城",
			"longitude": 121.64051200,
			"latitude": 24.12813300
		}, {
			"areaId": 130681,
			"areaName": "涿州市",
			"longitude": 115.98062000,
			"latitude": 39.48622000
		}, {
			"areaId": 130682,
			"areaName": "定州市",
			"longitude": 114.99020000,
			"latitude": 38.51623000
		}, {
			"areaId": 130683,
			"areaName": "安国市",
			"longitude": 115.32321000,
			"latitude": 38.41391000
		}, {
			"areaId": 130684,
			"areaName": "高碑店市",
			"longitude": 115.87368000,
			"latitude": 39.32655000
		}]
	}, {
		"areaId": 1307,
		"areaName": "张家口市",
		"longitude": 114.88409100,
		"latitude": 40.81190100,
		"children": [{
			"areaId": 130702,
			"areaName": "桥东区",
			"longitude": 114.89430000,
			"latitude": 40.78844000
		}, {
			"areaId": 130703,
			"areaName": "桥西区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130705,
			"areaName": "宣化区",
			"longitude": 115.15497000,
			"latitude": 40.56618000
		}, {
			"areaId": 130706,
			"areaName": "下花园区",
			"longitude": 115.28744000,
			"latitude": 40.50236000
		}, {
			"areaId": 130708,
			"areaName": "万全区",
			"longitude": 114.74050000,
			"latitude": 40.76694000
		}, {
			"areaId": 130709,
			"areaName": "崇礼区",
			"longitude": 115.27993000,
			"latitude": 40.97519000
		}, {
			"areaId": 130722,
			"areaName": "张北县",
			"longitude": 114.71432000,
			"latitude": 41.15977000
		}, {
			"areaId": 130723,
			"areaName": "康保县",
			"longitude": 114.60031000,
			"latitude": 41.85225000
		}, {
			"areaId": 130724,
			"areaName": "沽源县",
			"longitude": 115.68859000,
			"latitude": 41.66959000
		}, {
			"areaId": 130725,
			"areaName": "尚义县",
			"longitude": 113.97134000,
			"latitude": 41.07782000
		}, {
			"areaId": 130726,
			"areaName": "蔚县",
			"longitude": 114.58892000,
			"latitude": 39.84067000
		}, {
			"areaId": 130727,
			"areaName": "阳原县",
			"longitude": 114.15051000,
			"latitude": 40.10361000
		}, {
			"areaId": 130728,
			"areaName": "怀安县",
			"longitude": 114.38559000,
			"latitude": 40.67425000
		}, {
			"areaId": 130730,
			"areaName": "怀来县",
			"longitude": 115.51773000,
			"latitude": 40.41536000
		}, {
			"areaId": 130731,
			"areaName": "涿鹿县",
			"longitude": 115.22403000,
			"latitude": 40.37636000
		}, {
			"areaId": 130732,
			"areaName": "赤城县",
			"longitude": 115.83187000,
			"latitude": 40.91438000
		}, {
			"areaId": 130771,
			"areaName": "张家口经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130772,
			"areaName": "张家口市察北管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130773,
			"areaName": "张家口市塞北管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 1308,
		"areaName": "承德市",
		"longitude": 117.93915200,
		"latitude": 40.97620400,
		"children": [{
			"areaId": 130802,
			"areaName": "双桥区",
			"longitude": 117.94320000,
			"latitude": 40.97466000
		}, {
			"areaId": 130803,
			"areaName": "双滦区",
			"longitude": 117.74487000,
			"latitude": 40.95375000
		}, {
			"areaId": 130804,
			"areaName": "鹰手营子矿区",
			"longitude": 117.65985000,
			"latitude": 40.54744000
		}, {
			"areaId": 130821,
			"areaName": "承德县",
			"longitude": 118.17639000,
			"latitude": 40.76985000
		}, {
			"areaId": 130822,
			"areaName": "兴隆县",
			"longitude": 117.50073000,
			"latitude": 40.41709000
		}, {
			"areaId": 130824,
			"areaName": "滦平县",
			"longitude": 117.33276000,
			"latitude": 40.94148000
		}, {
			"areaId": 130825,
			"areaName": "隆化县",
			"longitude": 117.72970000,
			"latitude": 41.31412000
		}, {
			"areaId": 130826,
			"areaName": "丰宁满族自治县",
			"longitude": 116.64920000,
			"latitude": 41.20481000
		}, {
			"areaId": 130827,
			"areaName": "宽城满族自治县",
			"longitude": 118.49176000,
			"latitude": 40.60829000
		}, {
			"areaId": 130828,
			"areaName": "围场满族蒙古族自治县",
			"longitude": 117.76010000,
			"latitude": 41.94368000
		}, {
			"areaId": 130871,
			"areaName": "承德高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130881,
			"areaName": "平泉市",
			"longitude": 118.70196000,
			"latitude": 41.01839000
		}]
	}, {
		"areaId": 1309,
		"areaName": "沧州市",
		"longitude": 116.85746100,
		"latitude": 38.31058200,
		"children": [{
			"areaId": 130902,
			"areaName": "新华区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130903,
			"areaName": "运河区",
			"longitude": 116.85706000,
			"latitude": 38.31352000
		}, {
			"areaId": 130921,
			"areaName": "沧县",
			"longitude": 116.87817000,
			"latitude": 38.29361000
		}, {
			"areaId": 130922,
			"areaName": "青县",
			"longitude": 116.80316000,
			"latitude": 38.58345000
		}, {
			"areaId": 130923,
			"areaName": "东光县",
			"longitude": 116.53668000,
			"latitude": 37.88570000
		}, {
			"areaId": 130924,
			"areaName": "海兴县",
			"longitude": 117.49758000,
			"latitude": 38.13958000
		}, {
			"areaId": 130925,
			"areaName": "盐山县",
			"longitude": 117.23092000,
			"latitude": 38.05647000
		}, {
			"areaId": 130926,
			"areaName": "肃宁县",
			"longitude": 115.82971000,
			"latitude": 38.42272000
		}, {
			"areaId": 130927,
			"areaName": "南皮县",
			"longitude": 116.70224000,
			"latitude": 38.04109000
		}, {
			"areaId": 130928,
			"areaName": "吴桥县",
			"longitude": 116.38470000,
			"latitude": 37.62546000
		}, {
			"areaId": 130929,
			"areaName": "献县",
			"longitude": 116.12695000,
			"latitude": 38.19228000
		}, {
			"areaId": 130930,
			"areaName": "孟村回族自治县",
			"longitude": 117.10412000,
			"latitude": 38.05338000
		}, {
			"areaId": 130971,
			"areaName": "河北沧州经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130972,
			"areaName": "沧州高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130973,
			"areaName": "沧州渤海新区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 130981,
			"areaName": "泊头市",
			"longitude": 116.57824000,
			"latitude": 38.08359000
		}, {
			"areaId": 130982,
			"areaName": "任丘市",
			"longitude": 116.10330000,
			"latitude": 38.71124000
		}, {
			"areaId": 130983,
			"areaName": "黄骅市",
			"longitude": 117.33883000,
			"latitude": 38.37060000
		}, {
			"areaId": 130984,
			"areaName": "河间市",
			"longitude": 116.09930000,
			"latitude": 38.44549000
		}]
	}, {
		"areaId": 1310,
		"areaName": "廊坊市",
		"longitude": 116.71387300,
		"latitude": 39.52924400,
		"children": [{
			"areaId": 131002,
			"areaName": "安次区",
			"longitude": 116.70308000,
			"latitude": 39.52057000
		}, {
			"areaId": 131003,
			"areaName": "广阳区",
			"longitude": 116.71069000,
			"latitude": 39.52278000
		}, {
			"areaId": 131022,
			"areaName": "固安县",
			"longitude": 116.29916000,
			"latitude": 39.43833000
		}, {
			"areaId": 131023,
			"areaName": "永清县",
			"longitude": 116.50091000,
			"latitude": 39.32069000
		}, {
			"areaId": 131024,
			"areaName": "香河县",
			"longitude": 117.00634000,
			"latitude": 39.76133000
		}, {
			"areaId": 131025,
			"areaName": "大城县",
			"longitude": 120.32093400,
			"latitude": 23.85238200
		}, {
			"areaId": 131026,
			"areaName": "文安县",
			"longitude": 116.45846000,
			"latitude": 38.87325000
		}, {
			"areaId": 131028,
			"areaName": "大厂回族自治县",
			"longitude": 116.98916000,
			"latitude": 39.88649000
		}, {
			"areaId": 131071,
			"areaName": "廊坊经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 131081,
			"areaName": "霸州市",
			"longitude": 116.39154000,
			"latitude": 39.12569000
		}, {
			"areaId": 131082,
			"areaName": "三河市",
			"longitude": 117.07229000,
			"latitude": 39.98358000
		}]
	}, {
		"areaId": 1311,
		"areaName": "衡水市",
		"longitude": 115.66599300,
		"latitude": 37.73509700,
		"children": [{
			"areaId": 131102,
			"areaName": "桃城区",
			"longitude": 115.67529000,
			"latitude": 37.73499000
		}, {
			"areaId": 131103,
			"areaName": "冀州区",
			"longitude": 115.57934000,
			"latitude": 37.55082000
		}, {
			"areaId": 131121,
			"areaName": "枣强县",
			"longitude": 115.72576000,
			"latitude": 37.51027000
		}, {
			"areaId": 131122,
			"areaName": "武邑县",
			"longitude": 115.88748000,
			"latitude": 37.80181000
		}, {
			"areaId": 131123,
			"areaName": "武强县",
			"longitude": 115.98226000,
			"latitude": 38.04138000
		}, {
			"areaId": 131124,
			"areaName": "饶阳县",
			"longitude": 115.72558000,
			"latitude": 38.23529000
		}, {
			"areaId": 131125,
			"areaName": "安平县",
			"longitude": 120.16681000,
			"latitude": 23.00076300
		}, {
			"areaId": 131126,
			"areaName": "故城县",
			"longitude": 115.97076000,
			"latitude": 37.34773000
		}, {
			"areaId": 131127,
			"areaName": "景县",
			"longitude": 116.26904000,
			"latitude": 37.69260000
		}, {
			"areaId": 131128,
			"areaName": "阜城县",
			"longitude": 116.14431000,
			"latitude": 37.86881000
		}, {
			"areaId": 131171,
			"areaName": "河北衡水高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 131172,
			"areaName": "衡水滨湖新区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 131182,
			"areaName": "深州市",
			"longitude": 115.55993000,
			"latitude": 38.00109000
		}]
	}]
}, {
	"areaId": 14,
	"areaName": "山西省",
	"longitude": 112.54924800,
	"latitude": 37.85701400,
	"children": [{
		"areaId": 1401,
		"areaName": "太原市",
		"longitude": 112.54924800,
		"latitude": 37.85701400,
		"children": [{
			"areaId": 140105,
			"areaName": "小店区",
			"longitude": 112.56878000,
			"latitude": 37.73565000
		}, {
			"areaId": 140106,
			"areaName": "迎泽区",
			"longitude": 112.56338000,
			"latitude": 37.86326000
		}, {
			"areaId": 140107,
			"areaName": "杏花岭区",
			"longitude": 112.56237000,
			"latitude": 37.88429000
		}, {
			"areaId": 140108,
			"areaName": "尖草坪区",
			"longitude": 112.48709000,
			"latitude": 37.94193000
		}, {
			"areaId": 140109,
			"areaName": "万柏林区",
			"longitude": 112.51553000,
			"latitude": 37.85923000
		}, {
			"areaId": 140110,
			"areaName": "晋源区",
			"longitude": 112.47985000,
			"latitude": 37.72479000
		}, {
			"areaId": 140121,
			"areaName": "清徐县",
			"longitude": 112.35888000,
			"latitude": 37.60758000
		}, {
			"areaId": 140122,
			"areaName": "阳曲县",
			"longitude": 112.67861000,
			"latitude": 38.05989000
		}, {
			"areaId": 140123,
			"areaName": "娄烦县",
			"longitude": 111.79473000,
			"latitude": 38.06689000
		}, {
			"areaId": 140171,
			"areaName": "山西转型综合改革示范区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 140181,
			"areaName": "古交市",
			"longitude": 112.16918000,
			"latitude": 37.90983000
		}]
	}, {
		"areaId": 1402,
		"areaName": "大同市",
		"longitude": 121.60555700,
		"latitude": 24.67599700,
		"children": [{
			"areaId": 140212,
			"areaName": "新荣区",
			"longitude": 113.13504000,
			"latitude": 40.25618000
		}, {
			"areaId": 140213,
			"areaName": "平城区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 140214,
			"areaName": "云冈区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 140215,
			"areaName": "云州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 140221,
			"areaName": "阳高县",
			"longitude": 113.75012000,
			"latitude": 40.36256000
		}, {
			"areaId": 140222,
			"areaName": "天镇县",
			"longitude": 114.09310000,
			"latitude": 40.42299000
		}, {
			"areaId": 140223,
			"areaName": "广灵县",
			"longitude": 114.28204000,
			"latitude": 39.76082000
		}, {
			"areaId": 140224,
			"areaName": "灵丘县",
			"longitude": 114.23672000,
			"latitude": 39.44043000
		}, {
			"areaId": 140225,
			"areaName": "浑源县",
			"longitude": 113.69552000,
			"latitude": 39.69962000
		}, {
			"areaId": 140226,
			"areaName": "左云县",
			"longitude": 112.70266000,
			"latitude": 40.01336000
		}, {
			"areaId": 140271,
			"areaName": "山西大同经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 1403,
		"areaName": "阳泉市",
		"longitude": 113.58328500,
		"latitude": 37.86118800,
		"children": [{
			"areaId": 140302,
			"areaName": "城区",
			"longitude": 114.19505300,
			"latitude": 22.32673000
		}, {
			"areaId": 140303,
			"areaName": "矿区",
			"longitude": 113.55677000,
			"latitude": 37.86895000
		}, {
			"areaId": 140311,
			"areaName": "郊区",
			"longitude": 117.80868000,
			"latitude": 30.91976000
		}, {
			"areaId": 140321,
			"areaName": "平定县",
			"longitude": 113.65789000,
			"latitude": 37.78601000
		}, {
			"areaId": 140322,
			"areaName": "盂县",
			"longitude": 113.41235000,
			"latitude": 38.08579000
		}]
	}, {
		"areaId": 1404,
		"areaName": "长治市",
		"longitude": 120.52761400,
		"latitude": 22.67706200,
		"children": [{
			"areaId": 140403,
			"areaName": "潞州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 140404,
			"areaName": "上党区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 140405,
			"areaName": "屯留区",
			"longitude": 112.89196000,
			"latitude": 36.31579000
		}, {
			"areaId": 140406,
			"areaName": "潞城区",
			"longitude": 113.22888000,
			"latitude": 36.33414000
		}, {
			"areaId": 140423,
			"areaName": "襄垣县",
			"longitude": 113.05157000,
			"latitude": 36.53527000
		}, {
			"areaId": 140425,
			"areaName": "平顺县",
			"longitude": 113.43603000,
			"latitude": 36.20005000
		}, {
			"areaId": 140426,
			"areaName": "黎城县",
			"longitude": 113.38766000,
			"latitude": 36.50301000
		}, {
			"areaId": 140427,
			"areaName": "壶关县",
			"longitude": 113.20700000,
			"latitude": 36.11301000
		}, {
			"areaId": 140428,
			"areaName": "长子县",
			"longitude": 112.87731000,
			"latitude": 36.12125000
		}, {
			"areaId": 140429,
			"areaName": "武乡县",
			"longitude": 112.86343000,
			"latitude": 36.83687000
		}, {
			"areaId": 140430,
			"areaName": "沁县",
			"longitude": 112.69863000,
			"latitude": 36.75628000
		}, {
			"areaId": 140431,
			"areaName": "沁源县",
			"longitude": 112.33758000,
			"latitude": 36.50008000
		}, {
			"areaId": 140471,
			"areaName": "山西长治高新技术产业园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 1405,
		"areaName": "晋城市",
		"longitude": 112.85127400,
		"latitude": 35.49755300,
		"children": [{
			"areaId": 140502,
			"areaName": "城区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 140521,
			"areaName": "沁水县",
			"longitude": 112.18710000,
			"latitude": 35.69102000
		}, {
			"areaId": 140522,
			"areaName": "阳城县",
			"longitude": 112.41485000,
			"latitude": 35.48614000
		}, {
			"areaId": 140524,
			"areaName": "陵川县",
			"longitude": 113.28060000,
			"latitude": 35.77532000
		}, {
			"areaId": 140525,
			"areaName": "泽州县",
			"longitude": 112.83947000,
			"latitude": 35.50789000
		}, {
			"areaId": 140581,
			"areaName": "高平市",
			"longitude": 112.92288000,
			"latitude": 35.79705000
		}]
	}, {
		"areaId": 1406,
		"areaName": "朔州市",
		"longitude": 112.43338700,
		"latitude": 39.33126100,
		"children": [{
			"areaId": 140602,
			"areaName": "朔城区",
			"longitude": 112.43189000,
			"latitude": 39.31982000
		}, {
			"areaId": 140603,
			"areaName": "平鲁区",
			"longitude": 112.28833000,
			"latitude": 39.51155000
		}, {
			"areaId": 140621,
			"areaName": "山阴县",
			"longitude": 112.81662000,
			"latitude": 39.52697000
		}, {
			"areaId": 140622,
			"areaName": "应县",
			"longitude": 113.19052000,
			"latitude": 39.55279000
		}, {
			"areaId": 140623,
			"areaName": "右玉县",
			"longitude": 112.46902000,
			"latitude": 39.99011000
		}, {
			"areaId": 140671,
			"areaName": "山西朔州经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 140681,
			"areaName": "怀仁市",
			"longitude": 113.10009000,
			"latitude": 39.82806000
		}]
	}, {
		"areaId": 1407,
		"areaName": "晋中市",
		"longitude": 112.73646500,
		"latitude": 37.69649500,
		"children": [{
			"areaId": 140702,
			"areaName": "榆次区",
			"longitude": 112.70788000,
			"latitude": 37.69780000
		}, {
			"areaId": 140703,
			"areaName": "太谷区",
			"longitude": 112.55246000,
			"latitude": 37.42161000
		}, {
			"areaId": 140721,
			"areaName": "榆社县",
			"longitude": 112.97558000,
			"latitude": 37.07210000
		}, {
			"areaId": 140722,
			"areaName": "左权县",
			"longitude": 113.37918000,
			"latitude": 37.08235000
		}, {
			"areaId": 140723,
			"areaName": "和顺县",
			"longitude": 113.56988000,
			"latitude": 37.32963000
		}, {
			"areaId": 140724,
			"areaName": "昔阳县",
			"longitude": 113.70517000,
			"latitude": 37.61863000
		}, {
			"areaId": 140725,
			"areaName": "寿阳县",
			"longitude": 113.17495000,
			"latitude": 37.88899000
		}, {
			"areaId": 140727,
			"areaName": "祁县",
			"longitude": 112.33358000,
			"latitude": 37.35790000
		}, {
			"areaId": 140728,
			"areaName": "平遥县",
			"longitude": 112.17553000,
			"latitude": 37.18920000
		}, {
			"areaId": 140729,
			"areaName": "灵石县",
			"longitude": 111.77740000,
			"latitude": 36.84814000
		}, {
			"areaId": 140781,
			"areaName": "介休市",
			"longitude": 111.91824000,
			"latitude": 37.02771000
		}]
	}, {
		"areaId": 1408,
		"areaName": "运城市",
		"longitude": 111.00395700,
		"latitude": 35.02277800,
		"children": [{
			"areaId": 140802,
			"areaName": "盐湖区",
			"longitude": 110.99827000,
			"latitude": 35.01510000
		}, {
			"areaId": 140821,
			"areaName": "临猗县",
			"longitude": 110.77432000,
			"latitude": 35.14455000
		}, {
			"areaId": 140822,
			"areaName": "万荣县",
			"longitude": 121.40749300,
			"latitude": 23.71534600
		}, {
			"areaId": 140823,
			"areaName": "闻喜县",
			"longitude": 111.22265000,
			"latitude": 35.35553000
		}, {
			"areaId": 140824,
			"areaName": "稷山县",
			"longitude": 110.97924000,
			"latitude": 35.59993000
		}, {
			"areaId": 140825,
			"areaName": "新绛县",
			"longitude": 111.22509000,
			"latitude": 35.61566000
		}, {
			"areaId": 140826,
			"areaName": "绛县",
			"longitude": 111.56668000,
			"latitude": 35.49096000
		}, {
			"areaId": 140827,
			"areaName": "垣曲县",
			"longitude": 111.67166000,
			"latitude": 35.29923000
		}, {
			"areaId": 140828,
			"areaName": "夏县",
			"longitude": 111.21966000,
			"latitude": 35.14121000
		}, {
			"areaId": 140829,
			"areaName": "平陆县",
			"longitude": 111.21704000,
			"latitude": 34.83772000
		}, {
			"areaId": 140830,
			"areaName": "芮城县",
			"longitude": 110.69455000,
			"latitude": 34.69384000
		}, {
			"areaId": 140881,
			"areaName": "永济市",
			"longitude": 110.44537000,
			"latitude": 34.86556000
		}, {
			"areaId": 140882,
			"areaName": "河津市",
			"longitude": 110.71160000,
			"latitude": 35.59478000
		}]
	}, {
		"areaId": 1409,
		"areaName": "忻州市",
		"longitude": 112.73353800,
		"latitude": 38.41769000,
		"children": [{
			"areaId": 140902,
			"areaName": "忻府区",
			"longitude": 112.74603000,
			"latitude": 38.40414000
		}, {
			"areaId": 140921,
			"areaName": "定襄县",
			"longitude": 112.95733000,
			"latitude": 38.47387000
		}, {
			"areaId": 140922,
			"areaName": "五台县",
			"longitude": 113.25256000,
			"latitude": 38.72774000
		}, {
			"areaId": 140923,
			"areaName": "代县",
			"longitude": 112.95913000,
			"latitude": 39.06717000
		}, {
			"areaId": 140924,
			"areaName": "繁峙县",
			"longitude": 113.26303000,
			"latitude": 39.18886000
		}, {
			"areaId": 140925,
			"areaName": "宁武县",
			"longitude": 112.30423000,
			"latitude": 39.00211000
		}, {
			"areaId": 140926,
			"areaName": "静乐县",
			"longitude": 111.94158000,
			"latitude": 38.36020000
		}, {
			"areaId": 140927,
			"areaName": "神池县",
			"longitude": 112.20541000,
			"latitude": 39.09000000
		}, {
			"areaId": 140928,
			"areaName": "五寨县",
			"longitude": 111.84890000,
			"latitude": 38.90757000
		}, {
			"areaId": 140929,
			"areaName": "岢岚县",
			"longitude": 111.57388000,
			"latitude": 38.70452000
		}, {
			"areaId": 140930,
			"areaName": "河曲县",
			"longitude": 111.13821000,
			"latitude": 39.38439000
		}, {
			"areaId": 140931,
			"areaName": "保德县",
			"longitude": 111.08656000,
			"latitude": 39.02248000
		}, {
			"areaId": 140932,
			"areaName": "偏关县",
			"longitude": 111.50863000,
			"latitude": 39.43609000
		}, {
			"areaId": 140971,
			"areaName": "五台山风景名胜区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 140981,
			"areaName": "原平市",
			"longitude": 112.70584000,
			"latitude": 38.73181000
		}]
	}, {
		"areaId": 1410,
		"areaName": "临汾市",
		"longitude": 111.51797300,
		"latitude": 36.08415000,
		"children": [{
			"areaId": 141002,
			"areaName": "尧都区",
			"longitude": 111.57870000,
			"latitude": 36.08298000
		}, {
			"areaId": 141021,
			"areaName": "曲沃县",
			"longitude": 111.47525000,
			"latitude": 35.64119000
		}, {
			"areaId": 141022,
			"areaName": "翼城县",
			"longitude": 111.71810000,
			"latitude": 35.73881000
		}, {
			"areaId": 141023,
			"areaName": "襄汾县",
			"longitude": 111.44204000,
			"latitude": 35.87711000
		}, {
			"areaId": 141024,
			"areaName": "洪洞县",
			"longitude": 111.67501000,
			"latitude": 36.25425000
		}, {
			"areaId": 141025,
			"areaName": "古县",
			"longitude": 111.92041000,
			"latitude": 36.26688000
		}, {
			"areaId": 141026,
			"areaName": "安泽县",
			"longitude": 112.24981000,
			"latitude": 36.14803000
		}, {
			"areaId": 141027,
			"areaName": "浮山县",
			"longitude": 111.84744000,
			"latitude": 35.96854000
		}, {
			"areaId": 141028,
			"areaName": "吉县",
			"longitude": 110.68148000,
			"latitude": 36.09873000
		}, {
			"areaId": 141029,
			"areaName": "乡宁县",
			"longitude": 110.84652000,
			"latitude": 35.97072000
		}, {
			"areaId": 141030,
			"areaName": "大宁县",
			"longitude": 110.75216000,
			"latitude": 36.46624000
		}, {
			"areaId": 141031,
			"areaName": "隰县",
			"longitude": 110.93881000,
			"latitude": 36.69258000
		}, {
			"areaId": 141032,
			"areaName": "永和县",
			"longitude": 121.51366000,
			"latitude": 25.00780200
		}, {
			"areaId": 141033,
			"areaName": "蒲县",
			"longitude": 111.09674000,
			"latitude": 36.41243000
		}, {
			"areaId": 141034,
			"areaName": "汾西县",
			"longitude": 111.56811000,
			"latitude": 36.65063000
		}, {
			"areaId": 141081,
			"areaName": "侯马市",
			"longitude": 111.37207000,
			"latitude": 35.61903000
		}, {
			"areaId": 141082,
			"areaName": "霍州市",
			"longitude": 111.75500000,
			"latitude": 36.56380000
		}]
	}, {
		"areaId": 1411,
		"areaName": "吕梁市",
		"longitude": 111.13433500,
		"latitude": 37.52436600,
		"children": [{
			"areaId": 141102,
			"areaName": "离石区",
			"longitude": 111.15059000,
			"latitude": 37.51770000
		}, {
			"areaId": 141121,
			"areaName": "文水县",
			"longitude": 112.02829000,
			"latitude": 37.43841000
		}, {
			"areaId": 141122,
			"areaName": "交城县",
			"longitude": 112.15850000,
			"latitude": 37.55120000
		}, {
			"areaId": 141123,
			"areaName": "兴县",
			"longitude": 111.12692000,
			"latitude": 38.46321000
		}, {
			"areaId": 141124,
			"areaName": "临县",
			"longitude": 110.99282000,
			"latitude": 37.95271000
		}, {
			"areaId": 141125,
			"areaName": "柳林县",
			"longitude": 110.88922000,
			"latitude": 37.42932000
		}, {
			"areaId": 141126,
			"areaName": "石楼县",
			"longitude": 110.83520000,
			"latitude": 36.99731000
		}, {
			"areaId": 141127,
			"areaName": "岚县",
			"longitude": 111.67627000,
			"latitude": 38.27874000
		}, {
			"areaId": 141128,
			"areaName": "方山县",
			"longitude": 111.24011000,
			"latitude": 37.88979000
		}, {
			"areaId": 141129,
			"areaName": "中阳县",
			"longitude": 111.17950000,
			"latitude": 37.35715000
		}, {
			"areaId": 141130,
			"areaName": "交口县",
			"longitude": 111.18103000,
			"latitude": 36.98213000
		}, {
			"areaId": 141181,
			"areaName": "孝义市",
			"longitude": 111.77362000,
			"latitude": 37.14414000
		}, {
			"areaId": 141182,
			"areaName": "汾阳市",
			"longitude": 111.78820000,
			"latitude": 37.26605000
		}]
	}]
}, {
	"areaId": 15,
	"areaName": "内蒙古自治区",
	"longitude": 111.67080100,
	"latitude": 40.81831100,
	"children": [{
		"areaId": 1501,
		"areaName": "呼和浩特市",
		"longitude": 111.67080100,
		"latitude": 40.81831100,
		"children": [{
			"areaId": 150102,
			"areaName": "新城区",
			"longitude": 108.96080000,
			"latitude": 34.26641000
		}, {
			"areaId": 150103,
			"areaName": "回民区",
			"longitude": 111.62402000,
			"latitude": 40.80827000
		}, {
			"areaId": 150104,
			"areaName": "玉泉区",
			"longitude": 111.67456000,
			"latitude": 40.75227000
		}, {
			"areaId": 150105,
			"areaName": "赛罕区",
			"longitude": 111.70224000,
			"latitude": 40.79207000
		}, {
			"areaId": 150121,
			"areaName": "土默特左旗",
			"longitude": 111.14898000,
			"latitude": 40.72229000
		}, {
			"areaId": 150122,
			"areaName": "托克托县",
			"longitude": 111.19101000,
			"latitude": 40.27492000
		}, {
			"areaId": 150123,
			"areaName": "和林格尔县",
			"longitude": 111.82205000,
			"latitude": 40.37892000
		}, {
			"areaId": 150124,
			"areaName": "清水河县",
			"longitude": 120.55978000,
			"latitude": 24.26865000
		}, {
			"areaId": 150125,
			"areaName": "武川县",
			"longitude": 111.45785000,
			"latitude": 41.09289000
		}, {
			"areaId": 150172,
			"areaName": "呼和浩特经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 1502,
		"areaName": "包头市",
		"longitude": 109.84040500,
		"latitude": 40.65816800,
		"children": [{
			"areaId": 150202,
			"areaName": "东河区",
			"longitude": 121.30033400,
			"latitude": 22.96993400
		}, {
			"areaId": 150203,
			"areaName": "昆都仑区",
			"longitude": 109.83862000,
			"latitude": 40.64175000
		}, {
			"areaId": 150204,
			"areaName": "青山区",
			"longitude": 114.39117000,
			"latitude": 30.63427000
		}, {
			"areaId": 150205,
			"areaName": "石拐区",
			"longitude": 110.27322000,
			"latitude": 40.67297000
		}, {
			"areaId": 150206,
			"areaName": "白云鄂博矿区",
			"longitude": 109.97367000,
			"latitude": 41.76968000
		}, {
			"areaId": 150207,
			"areaName": "九原区",
			"longitude": 109.96496000,
			"latitude": 40.60554000
		}, {
			"areaId": 150221,
			"areaName": "土默特右旗",
			"longitude": 110.52417000,
			"latitude": 40.56880000
		}, {
			"areaId": 150222,
			"areaName": "固阳县",
			"longitude": 110.06372000,
			"latitude": 41.01851000
		}, {
			"areaId": 150223,
			"areaName": "达尔罕茂明安联合旗",
			"longitude": 110.43258000,
			"latitude": 41.69875000
		}, {
			"areaId": 150271,
			"areaName": "包头稀土高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 1503,
		"areaName": "乌海市",
		"longitude": 106.82556300,
		"latitude": 39.67373400,
		"children": [{
			"areaId": 150302,
			"areaName": "海勃湾区",
			"longitude": 106.82220000,
			"latitude": 39.66955000
		}, {
			"areaId": 150303,
			"areaName": "海南区",
			"longitude": 106.88656000,
			"latitude": 39.44128000
		}, {
			"areaId": 150304,
			"areaName": "乌达区",
			"longitude": 106.72723000,
			"latitude": 39.50500000
		}]
	}, {
		"areaId": 1504,
		"areaName": "赤峰市",
		"longitude": 118.95680600,
		"latitude": 42.27531700,
		"children": [{
			"areaId": 150402,
			"areaName": "红山区",
			"longitude": 118.95755000,
			"latitude": 42.24312000
		}, {
			"areaId": 150403,
			"areaName": "元宝山区",
			"longitude": 120.98575200,
			"latitude": 24.76097500
		}, {
			"areaId": 150404,
			"areaName": "松山区",
			"longitude": 121.57720600,
			"latitude": 25.04969800
		}, {
			"areaId": 150421,
			"areaName": "阿鲁科尔沁旗",
			"longitude": 120.06527000,
			"latitude": 43.87988000
		}, {
			"areaId": 150422,
			"areaName": "巴林左旗",
			"longitude": 119.38012000,
			"latitude": 43.97031000
		}, {
			"areaId": 150423,
			"areaName": "巴林右旗",
			"longitude": 118.66461000,
			"latitude": 43.53387000
		}, {
			"areaId": 150424,
			"areaName": "林西县",
			"longitude": 118.04733000,
			"latitude": 43.61165000
		}, {
			"areaId": 150425,
			"areaName": "克什克腾旗",
			"longitude": 117.54562000,
			"latitude": 43.26501000
		}, {
			"areaId": 150426,
			"areaName": "翁牛特旗",
			"longitude": 119.03042000,
			"latitude": 42.93147000
		}, {
			"areaId": 150428,
			"areaName": "喀喇沁旗",
			"longitude": 118.70144000,
			"latitude": 41.92917000
		}, {
			"areaId": 150429,
			"areaName": "宁城县",
			"longitude": 119.34375000,
			"latitude": 41.59661000
		}, {
			"areaId": 150430,
			"areaName": "敖汉旗",
			"longitude": 119.92163000,
			"latitude": 42.29071000
		}]
	}, {
		"areaId": 1505,
		"areaName": "通辽市",
		"longitude": 122.26311900,
		"latitude": 43.61742900,
		"children": [{
			"areaId": 150502,
			"areaName": "科尔沁区",
			"longitude": 122.25573000,
			"latitude": 43.62257000
		}, {
			"areaId": 150521,
			"areaName": "科尔沁左翼中旗",
			"longitude": 123.31912000,
			"latitude": 44.13014000
		}, {
			"areaId": 150522,
			"areaName": "科尔沁左翼后旗",
			"longitude": 122.35745000,
			"latitude": 42.94897000
		}, {
			"areaId": 150523,
			"areaName": "开鲁县",
			"longitude": 121.31884000,
			"latitude": 43.60003000
		}, {
			"areaId": 150524,
			"areaName": "库伦旗",
			"longitude": 121.77600000,
			"latitude": 42.72998000
		}, {
			"areaId": 150525,
			"areaName": "奈曼旗",
			"longitude": 120.66348000,
			"latitude": 42.84527000
		}, {
			"areaId": 150526,
			"areaName": "扎鲁特旗",
			"longitude": 120.91507000,
			"latitude": 44.55592000
		}, {
			"areaId": 150571,
			"areaName": "通辽经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 150581,
			"areaName": "霍林郭勒市",
			"longitude": 119.65429000,
			"latitude": 45.53454000
		}]
	}, {
		"areaId": 1506,
		"areaName": "鄂尔多斯市",
		"longitude": 109.99029000,
		"latitude": 39.81717900,
		"children": [{
			"areaId": 150602,
			"areaName": "东胜区",
			"longitude": 109.96289000,
			"latitude": 39.82236000
		}, {
			"areaId": 150603,
			"areaName": "康巴什区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 150621,
			"areaName": "达拉特旗",
			"longitude": 110.03317000,
			"latitude": 40.40010000
		}, {
			"areaId": 150622,
			"areaName": "准格尔旗",
			"longitude": 111.23645000,
			"latitude": 39.86783000
		}, {
			"areaId": 150623,
			"areaName": "鄂托克前旗",
			"longitude": 107.48403000,
			"latitude": 38.18396000
		}, {
			"areaId": 150624,
			"areaName": "鄂托克旗",
			"longitude": 107.98226000,
			"latitude": 39.09456000
		}, {
			"areaId": 150625,
			"areaName": "杭锦旗",
			"longitude": 108.72934000,
			"latitude": 39.84023000
		}, {
			"areaId": 150626,
			"areaName": "乌审旗",
			"longitude": 108.84610000,
			"latitude": 38.59092000
		}, {
			"areaId": 150627,
			"areaName": "伊金霍洛旗",
			"longitude": 109.74908000,
			"latitude": 39.57393000
		}]
	}, {
		"areaId": 1507,
		"areaName": "呼伦贝尔市",
		"longitude": 119.75816800,
		"latitude": 49.21533300,
		"children": [{
			"areaId": 150702,
			"areaName": "海拉尔区",
			"longitude": 119.73640000,
			"latitude": 49.21220000
		}, {
			"areaId": 150703,
			"areaName": "扎赉诺尔区",
			"longitude": 117.79270200,
			"latitude": 49.48694300
		}, {
			"areaId": 150721,
			"areaName": "阿荣旗",
			"longitude": 123.45941000,
			"latitude": 48.12581000
		}, {
			"areaId": 150722,
			"areaName": "莫力达瓦达斡尔族自治旗",
			"longitude": 124.51498000,
			"latitude": 48.48055000
		}, {
			"areaId": 150723,
			"areaName": "鄂伦春自治旗",
			"longitude": 123.72604000,
			"latitude": 50.59777000
		}, {
			"areaId": 150724,
			"areaName": "鄂温克族自治旗",
			"longitude": 119.75650000,
			"latitude": 49.14284000
		}, {
			"areaId": 150725,
			"areaName": "陈巴尔虎旗",
			"longitude": 119.42434000,
			"latitude": 49.32684000
		}, {
			"areaId": 150726,
			"areaName": "新巴尔虎左旗",
			"longitude": 118.26989000,
			"latitude": 48.21842000
		}, {
			"areaId": 150727,
			"areaName": "新巴尔虎右旗",
			"longitude": 116.82366000,
			"latitude": 48.66473000
		}, {
			"areaId": 150781,
			"areaName": "满洲里市",
			"longitude": 117.47946000,
			"latitude": 49.58272000
		}, {
			"areaId": 150782,
			"areaName": "牙克石市",
			"longitude": 120.71170000,
			"latitude": 49.28560000
		}, {
			"areaId": 150783,
			"areaName": "扎兰屯市",
			"longitude": 122.73757000,
			"latitude": 48.01363000
		}, {
			"areaId": 150784,
			"areaName": "额尔古纳市",
			"longitude": 120.19094000,
			"latitude": 50.24249000
		}, {
			"areaId": 150785,
			"areaName": "根河市",
			"longitude": 121.52197000,
			"latitude": 50.77996000
		}]
	}, {
		"areaId": 1508,
		"areaName": "巴彦淖尔市",
		"longitude": 107.41695900,
		"latitude": 40.75740200,
		"children": [{
			"areaId": 150802,
			"areaName": "临河区",
			"longitude": 107.42668000,
			"latitude": 40.75827000
		}, {
			"areaId": 150821,
			"areaName": "五原县",
			"longitude": 108.26916000,
			"latitude": 41.09631000
		}, {
			"areaId": 150822,
			"areaName": "磴口县",
			"longitude": 107.00936000,
			"latitude": 40.33062000
		}, {
			"areaId": 150823,
			"areaName": "乌拉特前旗",
			"longitude": 108.65219000,
			"latitude": 40.73649000
		}, {
			"areaId": 150824,
			"areaName": "乌拉特中旗",
			"longitude": 108.52587000,
			"latitude": 41.56789000
		}, {
			"areaId": 150825,
			"areaName": "乌拉特后旗",
			"longitude": 106.98971000,
			"latitude": 41.43151000
		}, {
			"areaId": 150826,
			"areaName": "杭锦后旗",
			"longitude": 107.15133000,
			"latitude": 40.88627000
		}]
	}, {
		"areaId": 1509,
		"areaName": "乌兰察布市",
		"longitude": 113.11454300,
		"latitude": 41.03412600,
		"children": [{
			"areaId": 150902,
			"areaName": "集宁区",
			"longitude": 113.11452000,
			"latitude": 41.03530000
		}, {
			"areaId": 150921,
			"areaName": "卓资县",
			"longitude": 112.57757000,
			"latitude": 40.89414000
		}, {
			"areaId": 150922,
			"areaName": "化德县",
			"longitude": 114.01071000,
			"latitude": 41.90433000
		}, {
			"areaId": 150923,
			"areaName": "商都县",
			"longitude": 113.57772000,
			"latitude": 41.56213000
		}, {
			"areaId": 150924,
			"areaName": "兴和县",
			"longitude": 113.83395000,
			"latitude": 40.87186000
		}, {
			"areaId": 150925,
			"areaName": "凉城县",
			"longitude": 112.49569000,
			"latitude": 40.53346000
		}, {
			"areaId": 150926,
			"areaName": "察哈尔右翼前旗",
			"longitude": 113.22131000,
			"latitude": 40.77880000
		}, {
			"areaId": 150927,
			"areaName": "察哈尔右翼中旗",
			"longitude": 112.63537000,
			"latitude": 41.27742000
		}, {
			"areaId": 150928,
			"areaName": "察哈尔右翼后旗",
			"longitude": 113.19216000,
			"latitude": 41.43554000
		}, {
			"areaId": 150929,
			"areaName": "四子王旗",
			"longitude": 111.70654000,
			"latitude": 41.53312000
		}, {
			"areaId": 150981,
			"areaName": "丰镇市",
			"longitude": 113.10983000,
			"latitude": 40.43690000
		}]
	}, {
		"areaId": 1522,
		"areaName": "兴安盟",
		"longitude": 122.07031700,
		"latitude": 46.07626800,
		"children": [{
			"areaId": 152201,
			"areaName": "乌兰浩特市",
			"longitude": 122.06378000,
			"latitude": 46.06235000
		}, {
			"areaId": 152202,
			"areaName": "阿尔山市",
			"longitude": 119.94317000,
			"latitude": 47.17716000
		}, {
			"areaId": 152221,
			"areaName": "科尔沁右翼前旗",
			"longitude": 121.95269000,
			"latitude": 46.07950000
		}, {
			"areaId": 152222,
			"areaName": "科尔沁右翼中旗",
			"longitude": 121.46807000,
			"latitude": 45.05605000
		}, {
			"areaId": 152223,
			"areaName": "扎赉特旗",
			"longitude": 122.91229000,
			"latitude": 46.72670000
		}, {
			"areaId": 152224,
			"areaName": "突泉县",
			"longitude": 121.59396000,
			"latitude": 45.38187000
		}]
	}, {
		"areaId": 1525,
		"areaName": "锡林郭勒盟",
		"longitude": 116.09099600,
		"latitude": 43.94401800,
		"children": [{
			"areaId": 152501,
			"areaName": "二连浩特市",
			"longitude": 111.98297000,
			"latitude": 43.65303000
		}, {
			"areaId": 152502,
			"areaName": "锡林浩特市",
			"longitude": 116.08603000,
			"latitude": 43.93341000
		}, {
			"areaId": 152522,
			"areaName": "阿巴嘎旗",
			"longitude": 114.96826000,
			"latitude": 44.02174000
		}, {
			"areaId": 152523,
			"areaName": "苏尼特左旗",
			"longitude": 113.65060000,
			"latitude": 43.85687000
		}, {
			"areaId": 152524,
			"areaName": "苏尼特右旗",
			"longitude": 112.65741000,
			"latitude": 42.74690000
		}, {
			"areaId": 152525,
			"areaName": "东乌珠穆沁旗",
			"longitude": 116.97293000,
			"latitude": 45.51108000
		}, {
			"areaId": 152526,
			"areaName": "西乌珠穆沁旗",
			"longitude": 117.60983000,
			"latitude": 44.59623000
		}, {
			"areaId": 152527,
			"areaName": "太仆寺旗",
			"longitude": 115.28302000,
			"latitude": 41.87727000
		}, {
			"areaId": 152528,
			"areaName": "镶黄旗",
			"longitude": 113.84472000,
			"latitude": 42.23927000
		}, {
			"areaId": 152529,
			"areaName": "正镶白旗",
			"longitude": 115.00067000,
			"latitude": 42.30712000
		}, {
			"areaId": 152530,
			"areaName": "正蓝旗",
			"longitude": 116.00363000,
			"latitude": 42.25229000
		}, {
			"areaId": 152531,
			"areaName": "多伦县",
			"longitude": 116.48565000,
			"latitude": 42.20300000
		}, {
			"areaId": 152571,
			"areaName": "乌拉盖管委会",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 1529,
		"areaName": "阿拉善盟",
		"longitude": 105.70642200,
		"latitude": 38.84481400,
		"children": [{
			"areaId": 152921,
			"areaName": "阿拉善左旗",
			"longitude": 105.67532000,
			"latitude": 38.82930000
		}, {
			"areaId": 152922,
			"areaName": "阿拉善右旗",
			"longitude": 101.66705000,
			"latitude": 39.21533000
		}, {
			"areaId": 152923,
			"areaName": "额济纳旗",
			"longitude": 101.06887000,
			"latitude": 41.96755000
		}, {
			"areaId": 152971,
			"areaName": "内蒙古阿拉善经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}]
}, {
	"areaId": 21,
	"areaName": "辽宁省",
	"longitude": 123.42909600,
	"latitude": 41.79676700,
	"children": [{
		"areaId": 2101,
		"areaName": "沈阳市",
		"longitude": 123.42909600,
		"latitude": 41.79676700,
		"children": [{
			"areaId": 210102,
			"areaName": "和平区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 210103,
			"areaName": "沈河区",
			"longitude": 123.45871000,
			"latitude": 41.79625000
		}, {
			"areaId": 210104,
			"areaName": "大东区",
			"longitude": 123.46997000,
			"latitude": 41.80539000
		}, {
			"areaId": 210105,
			"areaName": "皇姑区",
			"longitude": 123.42527000,
			"latitude": 41.82035000
		}, {
			"areaId": 210106,
			"areaName": "铁西区",
			"longitude": 124.37369000,
			"latitude": 43.17456000
		}, {
			"areaId": 210111,
			"areaName": "苏家屯区",
			"longitude": 123.34405000,
			"latitude": 41.66475000
		}, {
			"areaId": 210112,
			"areaName": "浑南区",
			"longitude": 123.45770700,
			"latitude": 41.71945000
		}, {
			"areaId": 210113,
			"areaName": "沈北新区",
			"longitude": 123.52658000,
			"latitude": 42.05297000
		}, {
			"areaId": 210114,
			"areaName": "于洪区",
			"longitude": 123.30807000,
			"latitude": 41.79400000
		}, {
			"areaId": 210115,
			"areaName": "辽中区",
			"longitude": 120.67951000,
			"latitude": 24.14383000
		}, {
			"areaId": 210123,
			"areaName": "康平县",
			"longitude": 123.35446000,
			"latitude": 42.75081000
		}, {
			"areaId": 210124,
			"areaName": "法库县",
			"longitude": 123.41214000,
			"latitude": 42.50608000
		}, {
			"areaId": 210181,
			"areaName": "新民市",
			"longitude": 122.82867000,
			"latitude": 41.99847000
		}]
	}, {
		"areaId": 2102,
		"areaName": "大连市",
		"longitude": 121.61862200,
		"latitude": 38.91459000,
		"children": [{
			"areaId": 210202,
			"areaName": "中山区",
			"longitude": 121.73913200,
			"latitude": 25.13399100
		}, {
			"areaId": 210203,
			"areaName": "西岗区",
			"longitude": 121.61238000,
			"latitude": 38.91469000
		}, {
			"areaId": 210204,
			"areaName": "沙河口区",
			"longitude": 121.58017000,
			"latitude": 38.90536000
		}, {
			"areaId": 210211,
			"areaName": "甘井子区",
			"longitude": 121.56567000,
			"latitude": 38.95017000
		}, {
			"areaId": 210212,
			"areaName": "旅顺口区",
			"longitude": 121.26202000,
			"latitude": 38.85125000
		}, {
			"areaId": 210213,
			"areaName": "金州区",
			"longitude": 121.71893000,
			"latitude": 39.10040000
		}, {
			"areaId": 210214,
			"areaName": "普兰店区",
			"longitude": 121.96316000,
			"latitude": 39.39465000
		}, {
			"areaId": 210224,
			"areaName": "长海县",
			"longitude": 122.58859000,
			"latitude": 39.27274000
		}, {
			"areaId": 210281,
			"areaName": "瓦房店市",
			"longitude": 121.98104000,
			"latitude": 39.62843000
		}, {
			"areaId": 210283,
			"areaName": "庄河市",
			"longitude": 122.96725000,
			"latitude": 39.68815000
		}]
	}, {
		"areaId": 2103,
		"areaName": "鞍山市",
		"longitude": 122.99563200,
		"latitude": 41.11062600,
		"children": [{
			"areaId": 210302,
			"areaName": "铁东区",
			"longitude": 124.40976000,
			"latitude": 43.16241000
		}, {
			"areaId": 210303,
			"areaName": "铁西区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 210304,
			"areaName": "立山区",
			"longitude": 123.02948000,
			"latitude": 41.15008000
		}, {
			"areaId": 210311,
			"areaName": "千山区",
			"longitude": 122.96048000,
			"latitude": 41.07507000
		}, {
			"areaId": 210321,
			"areaName": "台安县",
			"longitude": 122.43585000,
			"latitude": 41.41265000
		}, {
			"areaId": 210323,
			"areaName": "岫岩满族自治县",
			"longitude": 123.28875000,
			"latitude": 40.27996000
		}, {
			"areaId": 210381,
			"areaName": "海城市",
			"longitude": 122.68457000,
			"latitude": 40.88142000
		}]
	}, {
		"areaId": 2104,
		"areaName": "抚顺市",
		"longitude": 123.92110900,
		"latitude": 41.87595600,
		"children": [{
			"areaId": 210402,
			"areaName": "新抚区",
			"longitude": 123.91264000,
			"latitude": 41.86205000
		}, {
			"areaId": 210403,
			"areaName": "东洲区",
			"longitude": 124.03759000,
			"latitude": 41.85190000
		}, {
			"areaId": 210404,
			"areaName": "望花区",
			"longitude": 123.78283000,
			"latitude": 41.85532000
		}, {
			"areaId": 210411,
			"areaName": "顺城区",
			"longitude": 123.94506000,
			"latitude": 41.88321000
		}, {
			"areaId": 210421,
			"areaName": "抚顺县",
			"longitude": 124.17755000,
			"latitude": 41.71217000
		}, {
			"areaId": 210422,
			"areaName": "新宾满族自治县",
			"longitude": 125.04049000,
			"latitude": 41.73409000
		}, {
			"areaId": 210423,
			"areaName": "清原满族自治县",
			"longitude": 124.92807000,
			"latitude": 42.10221000
		}]
	}, {
		"areaId": 2105,
		"areaName": "本溪市",
		"longitude": 123.77051900,
		"latitude": 41.29790900,
		"children": [{
			"areaId": 210502,
			"areaName": "平山区",
			"longitude": 123.76892000,
			"latitude": 41.29970000
		}, {
			"areaId": 210503,
			"areaName": "溪湖区",
			"longitude": 120.47914400,
			"latitude": 23.96231500
		}, {
			"areaId": 210504,
			"areaName": "明山区",
			"longitude": 123.81746000,
			"latitude": 41.30827000
		}, {
			"areaId": 210505,
			"areaName": "南芬区",
			"longitude": 123.74523000,
			"latitude": 41.10060000
		}, {
			"areaId": 210521,
			"areaName": "本溪满族自治县",
			"longitude": 124.12741000,
			"latitude": 41.30059000
		}, {
			"areaId": 210522,
			"areaName": "桓仁满族自治县",
			"longitude": 125.36062000,
			"latitude": 41.26798000
		}]
	}, {
		"areaId": 2106,
		"areaName": "丹东市",
		"longitude": 124.38304400,
		"latitude": 40.12429600,
		"children": [{
			"areaId": 210602,
			"areaName": "元宝区",
			"longitude": 124.39575000,
			"latitude": 40.13651000
		}, {
			"areaId": 210603,
			"areaName": "振兴区",
			"longitude": 124.36035000,
			"latitude": 40.10489000
		}, {
			"areaId": 210604,
			"areaName": "振安区",
			"longitude": 124.42816000,
			"latitude": 40.15826000
		}, {
			"areaId": 210624,
			"areaName": "宽甸满族自治县",
			"longitude": 124.78247000,
			"latitude": 40.73187000
		}, {
			"areaId": 210681,
			"areaName": "东港市",
			"longitude": 120.45448900,
			"latitude": 22.46662600
		}, {
			"areaId": 210682,
			"areaName": "凤城市",
			"longitude": 124.06671000,
			"latitude": 40.45302000
		}]
	}, {
		"areaId": 2107,
		"areaName": "锦州市",
		"longitude": 121.13574200,
		"latitude": 41.11926900,
		"children": [{
			"areaId": 210702,
			"areaName": "古塔区",
			"longitude": 121.12832000,
			"latitude": 41.11725000
		}, {
			"areaId": 210703,
			"areaName": "凌河区",
			"longitude": 121.15089000,
			"latitude": 41.11496000
		}, {
			"areaId": 210711,
			"areaName": "太和区",
			"longitude": 121.10354000,
			"latitude": 41.10929000
		}, {
			"areaId": 210726,
			"areaName": "黑山县",
			"longitude": 122.12081000,
			"latitude": 41.69417000
		}, {
			"areaId": 210727,
			"areaName": "义县",
			"longitude": 120.30000000,
			"latitude": 23.50000000
		}, {
			"areaId": 210781,
			"areaName": "凌海市",
			"longitude": 121.35705000,
			"latitude": 41.17370000
		}, {
			"areaId": 210782,
			"areaName": "北镇市",
			"longitude": 121.79858000,
			"latitude": 41.59537000
		}]
	}, {
		"areaId": 2108,
		"areaName": "营口市",
		"longitude": 122.23515100,
		"latitude": 40.66743200,
		"children": [{
			"areaId": 210802,
			"areaName": "站前区",
			"longitude": 122.25896000,
			"latitude": 40.67266000
		}, {
			"areaId": 210803,
			"areaName": "西市区",
			"longitude": 122.20641000,
			"latitude": 40.66640000
		}, {
			"areaId": 210804,
			"areaName": "鲅鱼圈区",
			"longitude": 122.13266000,
			"latitude": 40.26865000
		}, {
			"areaId": 210811,
			"areaName": "老边区",
			"longitude": 122.37996000,
			"latitude": 40.68030000
		}, {
			"areaId": 210881,
			"areaName": "盖州市",
			"longitude": 122.35464000,
			"latitude": 40.40446000
		}, {
			"areaId": 210882,
			"areaName": "大石桥市",
			"longitude": 122.50927000,
			"latitude": 40.64567000
		}]
	}, {
		"areaId": 2109,
		"areaName": "阜新市",
		"longitude": 121.64896200,
		"latitude": 42.01179600,
		"children": [{
			"areaId": 210902,
			"areaName": "海州区",
			"longitude": 119.13128000,
			"latitude": 34.56986000
		}, {
			"areaId": 210903,
			"areaName": "新邱区",
			"longitude": 121.79251000,
			"latitude": 42.09181000
		}, {
			"areaId": 210904,
			"areaName": "太平区",
			"longitude": 120.71852300,
			"latitude": 24.12647200
		}, {
			"areaId": 210905,
			"areaName": "清河门区",
			"longitude": 121.41610000,
			"latitude": 41.78309000
		}, {
			"areaId": 210911,
			"areaName": "细河区",
			"longitude": 121.68013000,
			"latitude": 42.02533000
		}, {
			"areaId": 210921,
			"areaName": "阜新蒙古族自治县",
			"longitude": 121.75787000,
			"latitude": 42.06510000
		}, {
			"areaId": 210922,
			"areaName": "彰武县",
			"longitude": 122.54022000,
			"latitude": 42.38625000
		}]
	}, {
		"areaId": 2110,
		"areaName": "辽阳市",
		"longitude": 123.18152000,
		"latitude": 41.26940200,
		"children": [{
			"areaId": 211002,
			"areaName": "白塔区",
			"longitude": 123.17470000,
			"latitude": 41.27025000
		}, {
			"areaId": 211003,
			"areaName": "文圣区",
			"longitude": 123.18521000,
			"latitude": 41.26267000
		}, {
			"areaId": 211004,
			"areaName": "宏伟区",
			"longitude": 123.19290000,
			"latitude": 41.21852000
		}, {
			"areaId": 211005,
			"areaName": "弓长岭区",
			"longitude": 123.41963000,
			"latitude": 41.15181000
		}, {
			"areaId": 211011,
			"areaName": "太子河区",
			"longitude": 123.18182000,
			"latitude": 41.25337000
		}, {
			"areaId": 211021,
			"areaName": "辽阳县",
			"longitude": 123.10574000,
			"latitude": 41.20542000
		}, {
			"areaId": 211081,
			"areaName": "灯塔市",
			"longitude": 123.33926000,
			"latitude": 41.42612000
		}]
	}, {
		"areaId": 2111,
		"areaName": "盘锦市",
		"longitude": 122.06957000,
		"latitude": 41.12448400,
		"children": [{
			"areaId": 211102,
			"areaName": "双台子区",
			"longitude": 122.06011000,
			"latitude": 41.19060000
		}, {
			"areaId": 211103,
			"areaName": "兴隆台区",
			"longitude": 122.07529000,
			"latitude": 41.12402000
		}, {
			"areaId": 211104,
			"areaName": "大洼区",
			"longitude": 122.08239000,
			"latitude": 41.00244000
		}, {
			"areaId": 211122,
			"areaName": "盘山县",
			"longitude": 121.99777000,
			"latitude": 41.23805000
		}]
	}, {
		"areaId": 2112,
		"areaName": "铁岭市",
		"longitude": 123.84427900,
		"latitude": 42.29058500,
		"children": [{
			"areaId": 211202,
			"areaName": "银州区",
			"longitude": 123.85730000,
			"latitude": 42.29507000
		}, {
			"areaId": 211204,
			"areaName": "清河区",
			"longitude": 119.00778000,
			"latitude": 33.59949000
		}, {
			"areaId": 211221,
			"areaName": "铁岭县",
			"longitude": 123.77325000,
			"latitude": 42.22498000
		}, {
			"areaId": 211223,
			"areaName": "西丰县",
			"longitude": 124.73040000,
			"latitude": 42.73756000
		}, {
			"areaId": 211224,
			"areaName": "昌图县",
			"longitude": 124.11206000,
			"latitude": 42.78428000
		}, {
			"areaId": 211281,
			"areaName": "调兵山市",
			"longitude": 123.56689000,
			"latitude": 42.46750000
		}, {
			"areaId": 211282,
			"areaName": "开原市",
			"longitude": 124.03945000,
			"latitude": 42.54585000
		}]
	}, {
		"areaId": 2113,
		"areaName": "朝阳市",
		"longitude": 120.45117600,
		"latitude": 41.57675800,
		"children": [{
			"areaId": 211302,
			"areaName": "双塔区",
			"longitude": 120.45385000,
			"latitude": 41.56600000
		}, {
			"areaId": 211303,
			"areaName": "龙城区",
			"longitude": 120.43719000,
			"latitude": 41.59264000
		}, {
			"areaId": 211321,
			"areaName": "朝阳县",
			"longitude": 120.17401000,
			"latitude": 41.43240000
		}, {
			"areaId": 211322,
			"areaName": "建平县",
			"longitude": 119.64392000,
			"latitude": 41.40315000
		}, {
			"areaId": 211324,
			"areaName": "喀喇沁左翼蒙古族自治县",
			"longitude": 119.74185000,
			"latitude": 41.12801000
		}, {
			"areaId": 211381,
			"areaName": "北票市",
			"longitude": 120.76977000,
			"latitude": 41.80196000
		}, {
			"areaId": 211382,
			"areaName": "凌源市",
			"longitude": 119.40148000,
			"latitude": 41.24558000
		}]
	}, {
		"areaId": 2114,
		"areaName": "葫芦岛市",
		"longitude": 120.85639400,
		"latitude": 40.75557200,
		"children": [{
			"areaId": 211402,
			"areaName": "连山区",
			"longitude": 120.86393000,
			"latitude": 40.75554000
		}, {
			"areaId": 211403,
			"areaName": "龙港区",
			"longitude": 120.94866000,
			"latitude": 40.71919000
		}, {
			"areaId": 211404,
			"areaName": "南票区",
			"longitude": 120.74978000,
			"latitude": 41.10707000
		}, {
			"areaId": 211421,
			"areaName": "绥中县",
			"longitude": 120.34451000,
			"latitude": 40.32552000
		}, {
			"areaId": 211422,
			"areaName": "建昌县",
			"longitude": 119.83770000,
			"latitude": 40.82448000
		}, {
			"areaId": 211481,
			"areaName": "兴城市",
			"longitude": 120.72537000,
			"latitude": 40.61492000
		}]
	}]
}, {
	"areaId": 22,
	"areaName": "吉林省",
	"longitude": 125.32450000,
	"latitude": 43.88684100,
	"children": [{
		"areaId": 2201,
		"areaName": "长春市",
		"longitude": 125.32450000,
		"latitude": 43.88684100,
		"children": [{
			"areaId": 220102,
			"areaName": "南关区",
			"longitude": 125.35035000,
			"latitude": 43.86401000
		}, {
			"areaId": 220103,
			"areaName": "宽城区",
			"longitude": 125.32635000,
			"latitude": 43.90182000
		}, {
			"areaId": 220104,
			"areaName": "朝阳区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220105,
			"areaName": "二道区",
			"longitude": 125.37429000,
			"latitude": 43.86501000
		}, {
			"areaId": 220106,
			"areaName": "绿园区",
			"longitude": 125.25582000,
			"latitude": 43.88045000
		}, {
			"areaId": 220112,
			"areaName": "双阳区",
			"longitude": 125.65631000,
			"latitude": 43.52803000
		}, {
			"areaId": 220113,
			"areaName": "九台区",
			"longitude": 125.83950000,
			"latitude": 44.15163000
		}, {
			"areaId": 220122,
			"areaName": "农安县",
			"longitude": 125.18481000,
			"latitude": 44.43265000
		}, {
			"areaId": 220171,
			"areaName": "长春经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220172,
			"areaName": "长春净月高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220173,
			"areaName": "长春高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220174,
			"areaName": "长春汽车经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220182,
			"areaName": "榆树市",
			"longitude": 126.55688000,
			"latitude": 44.82523000
		}, {
			"areaId": 220183,
			"areaName": "德惠市",
			"longitude": 125.70538000,
			"latitude": 44.53719000
		}, {
			"areaId": 220184,
			"areaName": "公主岭市",
			"longitude": 124.82266000,
			"latitude": 43.50453000
		}]
	}, {
		"areaId": 2202,
		"areaName": "吉林市",
		"longitude": 126.55302000,
		"latitude": 43.84357700,
		"children": [{
			"areaId": 220202,
			"areaName": "昌邑区",
			"longitude": 126.57424000,
			"latitude": 43.88183000
		}, {
			"areaId": 220203,
			"areaName": "龙潭区",
			"longitude": 121.21639200,
			"latitude": 24.86385100
		}, {
			"areaId": 220204,
			"areaName": "船营区",
			"longitude": 126.54096000,
			"latitude": 43.83344000
		}, {
			"areaId": 220211,
			"areaName": "丰满区",
			"longitude": 126.56237000,
			"latitude": 43.82236000
		}, {
			"areaId": 220221,
			"areaName": "永吉县",
			"longitude": 126.49630000,
			"latitude": 43.67197000
		}, {
			"areaId": 220271,
			"areaName": "吉林经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220272,
			"areaName": "吉林高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220273,
			"areaName": "吉林中国新加坡食品区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220281,
			"areaName": "蛟河市",
			"longitude": 127.34426000,
			"latitude": 43.72696000
		}, {
			"areaId": 220282,
			"areaName": "桦甸市",
			"longitude": 126.74624000,
			"latitude": 42.97206000
		}, {
			"areaId": 220283,
			"areaName": "舒兰市",
			"longitude": 126.96530000,
			"latitude": 44.40582000
		}, {
			"areaId": 220284,
			"areaName": "磐石市",
			"longitude": 126.06250000,
			"latitude": 42.94628000
		}]
	}, {
		"areaId": 2203,
		"areaName": "四平市",
		"longitude": 124.37078500,
		"latitude": 43.17034400,
		"children": [{
			"areaId": 220302,
			"areaName": "铁西区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220303,
			"areaName": "铁东区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220322,
			"areaName": "梨树县",
			"longitude": 124.33563000,
			"latitude": 43.30717000
		}, {
			"areaId": 220323,
			"areaName": "伊通满族自治县",
			"longitude": 125.30596000,
			"latitude": 43.34434000
		}, {
			"areaId": 220382,
			"areaName": "双辽市",
			"longitude": 123.50106000,
			"latitude": 43.52099000
		}]
	}, {
		"areaId": 2204,
		"areaName": "辽源市",
		"longitude": 125.14534900,
		"latitude": 42.90269200,
		"children": [{
			"areaId": 220402,
			"areaName": "龙山区",
			"longitude": 125.13641000,
			"latitude": 42.89714000
		}, {
			"areaId": 220403,
			"areaName": "西安区",
			"longitude": 129.61616000,
			"latitude": 44.57766000
		}, {
			"areaId": 220421,
			"areaName": "东丰县",
			"longitude": 125.53244000,
			"latitude": 42.67830000
		}, {
			"areaId": 220422,
			"areaName": "东辽县",
			"longitude": 124.98596000,
			"latitude": 42.92492000
		}]
	}, {
		"areaId": 2205,
		"areaName": "通化市",
		"longitude": 125.93650100,
		"latitude": 41.72117700,
		"children": [{
			"areaId": 220502,
			"areaName": "东昌区",
			"longitude": 125.95510000,
			"latitude": 41.72849000
		}, {
			"areaId": 220503,
			"areaName": "二道江区",
			"longitude": 126.04257000,
			"latitude": 41.77410000
		}, {
			"areaId": 220521,
			"areaName": "通化县",
			"longitude": 125.75936000,
			"latitude": 41.67928000
		}, {
			"areaId": 220523,
			"areaName": "辉南县",
			"longitude": 126.04684000,
			"latitude": 42.68497000
		}, {
			"areaId": 220524,
			"areaName": "柳河县",
			"longitude": 125.74475000,
			"latitude": 42.28468000
		}, {
			"areaId": 220581,
			"areaName": "梅河口市",
			"longitude": 125.71041000,
			"latitude": 42.53828000
		}, {
			"areaId": 220582,
			"areaName": "集安市",
			"longitude": 126.18829000,
			"latitude": 41.12268000
		}]
	}, {
		"areaId": 2206,
		"areaName": "白山市",
		"longitude": 126.42783900,
		"latitude": 41.94250500,
		"children": [{
			"areaId": 220602,
			"areaName": "浑江区",
			"longitude": 126.42234200,
			"latitude": 41.94565600
		}, {
			"areaId": 220605,
			"areaName": "江源区",
			"longitude": 126.59079000,
			"latitude": 42.05664000
		}, {
			"areaId": 220621,
			"areaName": "抚松县",
			"longitude": 127.28030000,
			"latitude": 42.34198000
		}, {
			"areaId": 220622,
			"areaName": "靖宇县",
			"longitude": 126.81308000,
			"latitude": 42.38863000
		}, {
			"areaId": 220623,
			"areaName": "长白朝鲜族自治县",
			"longitude": 128.20047000,
			"latitude": 41.41996000
		}, {
			"areaId": 220681,
			"areaName": "临江市",
			"longitude": 126.91751000,
			"latitude": 41.81142000
		}]
	}, {
		"areaId": 2207,
		"areaName": "松原市",
		"longitude": 124.82360800,
		"latitude": 45.11824300,
		"children": [{
			"areaId": 220702,
			"areaName": "宁江区",
			"longitude": 124.81689000,
			"latitude": 45.17175000
		}, {
			"areaId": 220721,
			"areaName": "前郭尔罗斯蒙古族自治县",
			"longitude": 124.82351000,
			"latitude": 45.11726000
		}, {
			"areaId": 220722,
			"areaName": "长岭县",
			"longitude": 123.96725000,
			"latitude": 44.27581000
		}, {
			"areaId": 220723,
			"areaName": "乾安县",
			"longitude": 124.02737000,
			"latitude": 45.01068000
		}, {
			"areaId": 220771,
			"areaName": "吉林松原经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220781,
			"areaName": "扶余市",
			"longitude": 126.04275800,
			"latitude": 44.98619900
		}]
	}, {
		"areaId": 2208,
		"areaName": "白城市",
		"longitude": 122.84111400,
		"latitude": 45.61902600,
		"children": [{
			"areaId": 220802,
			"areaName": "洮北区",
			"longitude": 122.85104000,
			"latitude": 45.62167000
		}, {
			"areaId": 220821,
			"areaName": "镇赉县",
			"longitude": 123.19924000,
			"latitude": 45.84779000
		}, {
			"areaId": 220822,
			"areaName": "通榆县",
			"longitude": 123.08761000,
			"latitude": 44.81388000
		}, {
			"areaId": 220871,
			"areaName": "吉林白城经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 220881,
			"areaName": "洮南市",
			"longitude": 122.78772000,
			"latitude": 45.33502000
		}, {
			"areaId": 220882,
			"areaName": "大安市",
			"longitude": 124.29519000,
			"latitude": 45.50846000
		}]
	}, {
		"areaId": 2224,
		"areaName": "延边朝鲜族自治州",
		"longitude": 129.51322800,
		"latitude": 42.90482300,
		"children": [{
			"areaId": 222401,
			"areaName": "延吉市",
			"longitude": 129.51357000,
			"latitude": 42.90682000
		}, {
			"areaId": 222402,
			"areaName": "图们市",
			"longitude": 129.84381000,
			"latitude": 42.96801000
		}, {
			"areaId": 222403,
			"areaName": "敦化市",
			"longitude": 128.23242000,
			"latitude": 43.37304000
		}, {
			"areaId": 222404,
			"areaName": "珲春市",
			"longitude": 130.36572000,
			"latitude": 42.86242000
		}, {
			"areaId": 222405,
			"areaName": "龙井市",
			"longitude": 120.54594000,
			"latitude": 24.19271000
		}, {
			"areaId": 222406,
			"areaName": "和龙市",
			"longitude": 129.01077000,
			"latitude": 42.54640000
		}, {
			"areaId": 222424,
			"areaName": "汪清县",
			"longitude": 129.77121000,
			"latitude": 43.31278000
		}, {
			"areaId": 222426,
			"areaName": "安图县",
			"longitude": 128.90625000,
			"latitude": 43.11533000
		}]
	}]
}, {
	"areaId": 23,
	"areaName": "黑龙江省",
	"longitude": 126.64246400,
	"latitude": 45.75696700,
	"children": [{
		"areaId": 2301,
		"areaName": "哈尔滨市",
		"longitude": 126.64246400,
		"latitude": 45.75696700,
		"children": [{
			"areaId": 230102,
			"areaName": "道里区",
			"longitude": 126.61705000,
			"latitude": 45.75586000
		}, {
			"areaId": 230103,
			"areaName": "南岗区",
			"longitude": 126.66854000,
			"latitude": 45.75996000
		}, {
			"areaId": 230104,
			"areaName": "道外区",
			"longitude": 126.64938000,
			"latitude": 45.79187000
		}, {
			"areaId": 230108,
			"areaName": "平房区",
			"longitude": 126.63729000,
			"latitude": 45.59777000
		}, {
			"areaId": 230109,
			"areaName": "松北区",
			"longitude": 126.56276000,
			"latitude": 45.80831000
		}, {
			"areaId": 230110,
			"areaName": "香坊区",
			"longitude": 126.67968000,
			"latitude": 45.72383000
		}, {
			"areaId": 230111,
			"areaName": "呼兰区",
			"longitude": 126.58792000,
			"latitude": 45.88895000
		}, {
			"areaId": 230112,
			"areaName": "阿城区",
			"longitude": 126.97525000,
			"latitude": 45.54144000
		}, {
			"areaId": 230113,
			"areaName": "双城区",
			"longitude": 126.30878400,
			"latitude": 45.37794200
		}, {
			"areaId": 230123,
			"areaName": "依兰县",
			"longitude": 129.56817000,
			"latitude": 46.32470000
		}, {
			"areaId": 230124,
			"areaName": "方正县",
			"longitude": 128.82952000,
			"latitude": 45.85162000
		}, {
			"areaId": 230125,
			"areaName": "宾县",
			"longitude": 104.53314000,
			"latitude": 28.68996000
		}, {
			"areaId": 230126,
			"areaName": "巴彦县",
			"longitude": 127.40799000,
			"latitude": 46.08148000
		}, {
			"areaId": 230127,
			"areaName": "木兰县",
			"longitude": 128.04480000,
			"latitude": 45.94944000
		}, {
			"areaId": 230128,
			"areaName": "通河县",
			"longitude": 128.74603000,
			"latitude": 45.99007000
		}, {
			"areaId": 230129,
			"areaName": "延寿县",
			"longitude": 128.33419000,
			"latitude": 45.45540000
		}, {
			"areaId": 230183,
			"areaName": "尚志市",
			"longitude": 127.96191000,
			"latitude": 45.21736000
		}, {
			"areaId": 230184,
			"areaName": "五常市",
			"longitude": 127.16751000,
			"latitude": 44.93184000
		}]
	}, {
		"areaId": 2302,
		"areaName": "齐齐哈尔市",
		"longitude": 123.95348600,
		"latitude": 47.34807900,
		"children": [{
			"areaId": 230202,
			"areaName": "龙沙区",
			"longitude": 123.95752000,
			"latitude": 47.31776000
		}, {
			"areaId": 230203,
			"areaName": "建华区",
			"longitude": 124.01330000,
			"latitude": 47.36718000
		}, {
			"areaId": 230204,
			"areaName": "铁锋区",
			"longitude": 123.97821000,
			"latitude": 47.34075000
		}, {
			"areaId": 230205,
			"areaName": "昂昂溪区",
			"longitude": 123.82229000,
			"latitude": 47.15513000
		}, {
			"areaId": 230206,
			"areaName": "富拉尔基区",
			"longitude": 123.62918000,
			"latitude": 47.20884000
		}, {
			"areaId": 230207,
			"areaName": "碾子山区",
			"longitude": 122.88183000,
			"latitude": 47.51662000
		}, {
			"areaId": 230208,
			"areaName": "梅里斯达斡尔族区",
			"longitude": 123.75274000,
			"latitude": 47.30946000
		}, {
			"areaId": 230221,
			"areaName": "龙江县",
			"longitude": 123.20532000,
			"latitude": 47.33868000
		}, {
			"areaId": 230223,
			"areaName": "依安县",
			"longitude": 125.30896000,
			"latitude": 47.89310000
		}, {
			"areaId": 230224,
			"areaName": "泰来县",
			"longitude": 123.42285000,
			"latitude": 46.39386000
		}, {
			"areaId": 230225,
			"areaName": "甘南县",
			"longitude": 123.50317000,
			"latitude": 47.92437000
		}, {
			"areaId": 230227,
			"areaName": "富裕县",
			"longitude": 124.47457000,
			"latitude": 47.77431000
		}, {
			"areaId": 230229,
			"areaName": "克山县",
			"longitude": 125.87396000,
			"latitude": 48.03265000
		}, {
			"areaId": 230230,
			"areaName": "克东县",
			"longitude": 126.24917000,
			"latitude": 48.03828000
		}, {
			"areaId": 230231,
			"areaName": "拜泉县",
			"longitude": 126.09167000,
			"latitude": 47.60817000
		}, {
			"areaId": 230281,
			"areaName": "讷河市",
			"longitude": 124.87713000,
			"latitude": 48.48388000
		}]
	}, {
		"areaId": 2303,
		"areaName": "鸡西市",
		"longitude": 130.97596600,
		"latitude": 45.30004600,
		"children": [{
			"areaId": 230302,
			"areaName": "鸡冠区",
			"longitude": 130.98139000,
			"latitude": 45.30396000
		}, {
			"areaId": 230303,
			"areaName": "恒山区",
			"longitude": 130.90493000,
			"latitude": 45.21071000
		}, {
			"areaId": 230304,
			"areaName": "滴道区",
			"longitude": 130.84841000,
			"latitude": 45.35109000
		}, {
			"areaId": 230305,
			"areaName": "梨树区",
			"longitude": 130.69848000,
			"latitude": 45.09037000
		}, {
			"areaId": 230306,
			"areaName": "城子河区",
			"longitude": 131.01132000,
			"latitude": 45.33689000
		}, {
			"areaId": 230307,
			"areaName": "麻山区",
			"longitude": 130.47811000,
			"latitude": 45.21209000
		}, {
			"areaId": 230321,
			"areaName": "鸡东县",
			"longitude": 131.12423000,
			"latitude": 45.26025000
		}, {
			"areaId": 230381,
			"areaName": "虎林市",
			"longitude": 132.93679000,
			"latitude": 45.76291000
		}, {
			"areaId": 230382,
			"areaName": "密山市",
			"longitude": 131.84625000,
			"latitude": 45.52970000
		}]
	}, {
		"areaId": 2304,
		"areaName": "鹤岗市",
		"longitude": 130.27748700,
		"latitude": 47.33208500,
		"children": [{
			"areaId": 230402,
			"areaName": "向阳区",
			"longitude": 130.36519000,
			"latitude": 46.80778000
		}, {
			"areaId": 230403,
			"areaName": "工农区",
			"longitude": 130.27468000,
			"latitude": 47.31869000
		}, {
			"areaId": 230404,
			"areaName": "南山区",
			"longitude": 113.93029000,
			"latitude": 22.53291000
		}, {
			"areaId": 230405,
			"areaName": "兴安区",
			"longitude": 130.23965000,
			"latitude": 47.25260000
		}, {
			"areaId": 230406,
			"areaName": "东山区",
			"longitude": 120.40398400,
			"latitude": 23.32609200
		}, {
			"areaId": 230407,
			"areaName": "兴山区",
			"longitude": 130.29271000,
			"latitude": 47.35776000
		}, {
			"areaId": 230421,
			"areaName": "萝北县",
			"longitude": 130.83346000,
			"latitude": 47.57959000
		}, {
			"areaId": 230422,
			"areaName": "绥滨县",
			"longitude": 131.86029000,
			"latitude": 47.29030000
		}]
	}, {
		"areaId": 2305,
		"areaName": "双鸭山市",
		"longitude": 131.15730400,
		"latitude": 46.64344200,
		"children": [{
			"areaId": 230502,
			"areaName": "尖山区",
			"longitude": 131.15841000,
			"latitude": 46.64635000
		}, {
			"areaId": 230503,
			"areaName": "岭东区",
			"longitude": 131.16473000,
			"latitude": 46.59043000
		}, {
			"areaId": 230505,
			"areaName": "四方台区",
			"longitude": 131.33593000,
			"latitude": 46.59499000
		}, {
			"areaId": 230506,
			"areaName": "宝山区",
			"longitude": 121.48910000,
			"latitude": 31.40450000
		}, {
			"areaId": 230521,
			"areaName": "集贤县",
			"longitude": 131.14053000,
			"latitude": 46.72678000
		}, {
			"areaId": 230522,
			"areaName": "友谊县",
			"longitude": 131.80789000,
			"latitude": 46.76739000
		}, {
			"areaId": 230523,
			"areaName": "宝清县",
			"longitude": 132.19695000,
			"latitude": 46.32716000
		}, {
			"areaId": 230524,
			"areaName": "饶河县",
			"longitude": 134.01986000,
			"latitude": 46.79899000
		}]
	}, {
		"areaId": 2306,
		"areaName": "大庆市",
		"longitude": 125.11272000,
		"latitude": 46.59073400,
		"children": [{
			"areaId": 230602,
			"areaName": "萨尔图区",
			"longitude": 125.08792000,
			"latitude": 46.59359000
		}, {
			"areaId": 230603,
			"areaName": "龙凤区",
			"longitude": 125.11657000,
			"latitude": 46.53273000
		}, {
			"areaId": 230604,
			"areaName": "让胡路区",
			"longitude": 124.87075000,
			"latitude": 46.65220000
		}, {
			"areaId": 230605,
			"areaName": "红岗区",
			"longitude": 124.89248000,
			"latitude": 46.40128000
		}, {
			"areaId": 230606,
			"areaName": "大同区",
			"longitude": 121.51551400,
			"latitude": 25.06598600
		}, {
			"areaId": 230621,
			"areaName": "肇州县",
			"longitude": 125.27059000,
			"latitude": 45.70414000
		}, {
			"areaId": 230622,
			"areaName": "肇源县",
			"longitude": 125.08456000,
			"latitude": 45.52032000
		}, {
			"areaId": 230623,
			"areaName": "林甸县",
			"longitude": 124.87564000,
			"latitude": 47.18601000
		}, {
			"areaId": 230624,
			"areaName": "杜尔伯特蒙古族自治县",
			"longitude": 124.44937000,
			"latitude": 46.86507000
		}, {
			"areaId": 230671,
			"areaName": "大庆高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 2307,
		"areaName": "伊春市",
		"longitude": 128.90752000,
		"latitude": 47.72800000,
		"children": [{
			"areaId": 230717,
			"areaName": "伊美区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 230718,
			"areaName": "乌翠区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 230719,
			"areaName": "友好区",
			"longitude": 128.84039000,
			"latitude": 47.85371000
		}, {
			"areaId": 230722,
			"areaName": "嘉荫县",
			"longitude": 130.39825000,
			"latitude": 48.89170000
		}, {
			"areaId": 230723,
			"areaName": "汤旺县",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 230724,
			"areaName": "丰林县",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 230725,
			"areaName": "大箐山县",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 230726,
			"areaName": "南岔县",
			"longitude": 129.28362000,
			"latitude": 47.13897000
		}, {
			"areaId": 230751,
			"areaName": "金林区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 230781,
			"areaName": "铁力市",
			"longitude": 128.03170000,
			"latitude": 46.98571000
		}]
	}, {
		"areaId": 2308,
		"areaName": "佳木斯市",
		"longitude": 130.36163400,
		"latitude": 46.80960600,
		"children": [{
			"areaId": 230803,
			"areaName": "向阳区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 230804,
			"areaName": "前进区",
			"longitude": 130.37497000,
			"latitude": 46.81401000
		}, {
			"areaId": 230805,
			"areaName": "东风区",
			"longitude": 130.40366000,
			"latitude": 46.82257000
		}, {
			"areaId": 230811,
			"areaName": "郊区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 230822,
			"areaName": "桦南县",
			"longitude": 130.55361000,
			"latitude": 46.23921000
		}, {
			"areaId": 230826,
			"areaName": "桦川县",
			"longitude": 130.71893000,
			"latitude": 47.02297000
		}, {
			"areaId": 230828,
			"areaName": "汤原县",
			"longitude": 129.90966000,
			"latitude": 46.72755000
		}, {
			"areaId": 230881,
			"areaName": "同江市",
			"longitude": 132.51095000,
			"latitude": 47.64211000
		}, {
			"areaId": 230882,
			"areaName": "富锦市",
			"longitude": 132.03707000,
			"latitude": 47.25132000
		}, {
			"areaId": 230883,
			"areaName": "抚远市",
			"longitude": 134.29595000,
			"latitude": 48.36794000
		}]
	}, {
		"areaId": 2309,
		"areaName": "七台河市",
		"longitude": 131.01558400,
		"latitude": 45.77126600,
		"children": [{
			"areaId": 230902,
			"areaName": "新兴区",
			"longitude": 120.30953500,
			"latitude": 22.63114700
		}, {
			"areaId": 230903,
			"areaName": "桃山区",
			"longitude": 131.01786000,
			"latitude": 45.76782000
		}, {
			"areaId": 230904,
			"areaName": "茄子河区",
			"longitude": 131.06807000,
			"latitude": 45.78519000
		}, {
			"areaId": 230921,
			"areaName": "勃利县",
			"longitude": 130.59179000,
			"latitude": 45.75500000
		}]
	}, {
		"areaId": 2310,
		"areaName": "牡丹江市",
		"longitude": 120.77010800,
		"latitude": 22.12568700,
		"children": [{
			"areaId": 231002,
			"areaName": "东安区",
			"longitude": 129.62665000,
			"latitude": 44.58133000
		}, {
			"areaId": 231003,
			"areaName": "阳明区",
			"longitude": 129.63547000,
			"latitude": 44.59603000
		}, {
			"areaId": 231004,
			"areaName": "爱民区",
			"longitude": 129.59077000,
			"latitude": 44.59648000
		}, {
			"areaId": 231005,
			"areaName": "西安区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 231025,
			"areaName": "林口县",
			"longitude": 121.39160200,
			"latitude": 25.07753100
		}, {
			"areaId": 231071,
			"areaName": "牡丹江经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 231081,
			"areaName": "绥芬河市",
			"longitude": 131.15139000,
			"latitude": 44.41249000
		}, {
			"areaId": 231083,
			"areaName": "海林市",
			"longitude": 129.38156000,
			"latitude": 44.59000000
		}, {
			"areaId": 231084,
			"areaName": "宁安市",
			"longitude": 129.48303000,
			"latitude": 44.34016000
		}, {
			"areaId": 231085,
			"areaName": "穆棱市",
			"longitude": 130.52465000,
			"latitude": 44.91900000
		}, {
			"areaId": 231086,
			"areaName": "东宁市",
			"longitude": 131.12793000,
			"latitude": 44.06610000
		}]
	}, {
		"areaId": 2311,
		"areaName": "黑河市",
		"longitude": 127.49902300,
		"latitude": 50.24958500,
		"children": [{
			"areaId": 231102,
			"areaName": "爱辉区",
			"longitude": 127.50074000,
			"latitude": 50.25202000
		}, {
			"areaId": 231123,
			"areaName": "逊克县",
			"longitude": 128.47882000,
			"latitude": 49.57983000
		}, {
			"areaId": 231124,
			"areaName": "孙吴县",
			"longitude": 127.33599000,
			"latitude": 49.42539000
		}, {
			"areaId": 231181,
			"areaName": "北安市",
			"longitude": 126.48193000,
			"latitude": 48.23872000
		}, {
			"areaId": 231182,
			"areaName": "五大连池市",
			"longitude": 126.20294000,
			"latitude": 48.51507000
		}, {
			"areaId": 231183,
			"areaName": "嫩江市",
			"longitude": 125.22607000,
			"latitude": 49.17844000
		}]
	}, {
		"areaId": 2312,
		"areaName": "绥化市",
		"longitude": 126.99293000,
		"latitude": 46.63739300,
		"children": [{
			"areaId": 231202,
			"areaName": "北林区",
			"longitude": 126.98564000,
			"latitude": 46.63735000
		}, {
			"areaId": 231221,
			"areaName": "望奎县",
			"longitude": 126.48187000,
			"latitude": 46.83079000
		}, {
			"areaId": 231222,
			"areaName": "兰西县",
			"longitude": 126.28994000,
			"latitude": 46.25250000
		}, {
			"areaId": 231223,
			"areaName": "青冈县",
			"longitude": 126.11325000,
			"latitude": 46.68534000
		}, {
			"areaId": 231224,
			"areaName": "庆安县",
			"longitude": 127.50753000,
			"latitude": 46.88016000
		}, {
			"areaId": 231225,
			"areaName": "明水县",
			"longitude": 125.90594000,
			"latitude": 47.17327000
		}, {
			"areaId": 231226,
			"areaName": "绥棱县",
			"longitude": 127.11584000,
			"latitude": 47.24267000
		}, {
			"areaId": 231281,
			"areaName": "安达市",
			"longitude": 125.34375000,
			"latitude": 46.41770000
		}, {
			"areaId": 231282,
			"areaName": "肇东市",
			"longitude": 125.96243000,
			"latitude": 46.05131000
		}, {
			"areaId": 231283,
			"areaName": "海伦市",
			"longitude": 126.96820000,
			"latitude": 47.46093000
		}]
	}, {
		"areaId": 2327,
		"areaName": "大兴安岭地区",
		"longitude": 124.71152600,
		"latitude": 52.33526200,
		"children": [{
			"areaId": 232701,
			"areaName": "漠河市",
			"longitude": 122.53759000,
			"latitude": 52.97003000
		}, {
			"areaId": 232721,
			"areaName": "呼玛县",
			"longitude": 126.66174000,
			"latitude": 51.73112000
		}, {
			"areaId": 232722,
			"areaName": "塔河县",
			"longitude": 124.70999000,
			"latitude": 52.33431000
		}, {
			"areaId": 232761,
			"areaName": "加格达奇区",
			"longitude": 124.30954000,
			"latitude": 51.98144000
		}, {
			"areaId": 232762,
			"areaName": "松岭区",
			"longitude": 124.18971300,
			"latitude": 51.98545300
		}, {
			"areaId": 232763,
			"areaName": "新林区",
			"longitude": 124.39798300,
			"latitude": 51.67341000
		}, {
			"areaId": 232764,
			"areaName": "呼中区",
			"longitude": 123.60009000,
			"latitude": 52.03346000
		}]
	}]
}, {
	"areaId": 31,
	"areaName": "上海市",
	"longitude": 121.47264400,
	"latitude": 31.23170600,
	"children": [{
		"areaId": 310101,
		"areaName": "黄浦区",
		"longitude": 121.49295000,
		"latitude": 31.22337000,
		"children": []
	}, {
		"areaId": 310104,
		"areaName": "徐汇区",
		"longitude": 121.43676000,
		"latitude": 31.18831000,
		"children": []
	}, {
		"areaId": 310105,
		"areaName": "长宁区",
		"longitude": 121.42462000,
		"latitude": 31.22036000,
		"children": []
	}, {
		"areaId": 310106,
		"areaName": "静安区",
		"longitude": 121.44440000,
		"latitude": 31.22884000,
		"children": []
	}, {
		"areaId": 310107,
		"areaName": "普陀区",
		"longitude": 122.30278000,
		"latitude": 29.94908000,
		"children": []
	}, {
		"areaId": 310109,
		"areaName": "虹口区",
		"longitude": 121.48162000,
		"latitude": 31.27788000,
		"children": []
	}, {
		"areaId": 310110,
		"areaName": "杨浦区",
		"longitude": 121.52600000,
		"latitude": 31.25950000,
		"children": []
	}, {
		"areaId": 310112,
		"areaName": "闵行区",
		"longitude": 121.38162000,
		"latitude": 31.11246000,
		"children": []
	}, {
		"areaId": 310113,
		"areaName": "宝山区",
		"longitude": 0.00000000,
		"latitude": 0.00000000,
		"children": []
	}, {
		"areaId": 310114,
		"areaName": "嘉定区",
		"longitude": 121.26550000,
		"latitude": 31.37473000,
		"children": []
	}, {
		"areaId": 310115,
		"areaName": "浦东新区",
		"longitude": 121.54470000,
		"latitude": 31.22249000,
		"children": []
	}, {
		"areaId": 310116,
		"areaName": "金山区",
		"longitude": 121.63642700,
		"latitude": 25.22188300,
		"children": []
	}, {
		"areaId": 310117,
		"areaName": "松江区",
		"longitude": 121.22879000,
		"latitude": 31.03222000,
		"children": []
	}, {
		"areaId": 310118,
		"areaName": "青浦区",
		"longitude": 121.12417000,
		"latitude": 31.14974000,
		"children": []
	}, {
		"areaId": 310120,
		"areaName": "奉贤区",
		"longitude": 121.47412000,
		"latitude": 30.91790000,
		"children": []
	}, {
		"areaId": 310151,
		"areaName": "崇明区",
		"longitude": 121.39758000,
		"latitude": 31.62278000,
		"children": []
	}]
}, {
	"areaId": 32,
	"areaName": "江苏省",
	"longitude": 118.76741300,
	"latitude": 32.04154400,
	"children": [{
		"areaId": 3201,
		"areaName": "南京市",
		"longitude": 118.76741300,
		"latitude": 32.04154400,
		"children": [{
			"areaId": 320102,
			"areaName": "玄武区",
			"longitude": 118.79772000,
			"latitude": 32.04856000
		}, {
			"areaId": 320104,
			"areaName": "秦淮区",
			"longitude": 118.79815000,
			"latitude": 32.01112000
		}, {
			"areaId": 320105,
			"areaName": "建邺区",
			"longitude": 118.76641000,
			"latitude": 32.03096000
		}, {
			"areaId": 320106,
			"areaName": "鼓楼区",
			"longitude": 114.35559000,
			"latitude": 34.79517000
		}, {
			"areaId": 320111,
			"areaName": "浦口区",
			"longitude": 118.62802000,
			"latitude": 32.05881000
		}, {
			"areaId": 320113,
			"areaName": "栖霞区",
			"longitude": 118.88064000,
			"latitude": 32.11352000
		}, {
			"areaId": 320114,
			"areaName": "雨花台区",
			"longitude": 118.77990000,
			"latitude": 31.99202000
		}, {
			"areaId": 320115,
			"areaName": "江宁区",
			"longitude": 118.83990000,
			"latitude": 31.95263000
		}, {
			"areaId": 320116,
			"areaName": "六合区",
			"longitude": 118.84130000,
			"latitude": 32.34222000
		}, {
			"areaId": 320117,
			"areaName": "溧水区",
			"longitude": 119.02873200,
			"latitude": 31.65306100
		}, {
			"areaId": 320118,
			"areaName": "高淳区",
			"longitude": 118.87589000,
			"latitude": 31.32713200
		}]
	}, {
		"areaId": 3202,
		"areaName": "无锡市",
		"longitude": 120.30166300,
		"latitude": 31.57472900,
		"children": [{
			"areaId": 320205,
			"areaName": "锡山区",
			"longitude": 120.35699000,
			"latitude": 31.58860000
		}, {
			"areaId": 320206,
			"areaName": "惠山区",
			"longitude": 120.29849000,
			"latitude": 31.68088000
		}, {
			"areaId": 320211,
			"areaName": "滨湖区",
			"longitude": 120.29461000,
			"latitude": 31.52162000
		}, {
			"areaId": 320213,
			"areaName": "梁溪区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320214,
			"areaName": "新吴区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320281,
			"areaName": "江阴市",
			"longitude": 120.28530000,
			"latitude": 31.91996000
		}, {
			"areaId": 320282,
			"areaName": "宜兴市",
			"longitude": 119.82357000,
			"latitude": 31.33978000
		}]
	}, {
		"areaId": 3203,
		"areaName": "徐州市",
		"longitude": 117.18481100,
		"latitude": 34.26179200,
		"children": [{
			"areaId": 320302,
			"areaName": "鼓楼区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320303,
			"areaName": "云龙区",
			"longitude": 117.23053000,
			"latitude": 34.24895000
		}, {
			"areaId": 320305,
			"areaName": "贾汪区",
			"longitude": 117.45346000,
			"latitude": 34.44264000
		}, {
			"areaId": 320311,
			"areaName": "泉山区",
			"longitude": 117.19378000,
			"latitude": 34.24418000
		}, {
			"areaId": 320312,
			"areaName": "铜山区",
			"longitude": 117.18389400,
			"latitude": 34.19288000
		}, {
			"areaId": 320321,
			"areaName": "丰县",
			"longitude": 118.19158000,
			"latitude": 28.43766000
		}, {
			"areaId": 320322,
			"areaName": "沛县",
			"longitude": 116.93743000,
			"latitude": 34.72163000
		}, {
			"areaId": 320324,
			"areaName": "睢宁县",
			"longitude": 117.94104000,
			"latitude": 33.91269000
		}, {
			"areaId": 320371,
			"areaName": "徐州经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320381,
			"areaName": "新沂市",
			"longitude": 118.35452000,
			"latitude": 34.36942000
		}, {
			"areaId": 320382,
			"areaName": "邳州市",
			"longitude": 117.95858000,
			"latitude": 34.33329000
		}]
	}, {
		"areaId": 3204,
		"areaName": "常州市",
		"longitude": 119.94697300,
		"latitude": 31.77275200,
		"children": [{
			"areaId": 320402,
			"areaName": "天宁区",
			"longitude": 119.95132000,
			"latitude": 31.75211000
		}, {
			"areaId": 320404,
			"areaName": "钟楼区",
			"longitude": 119.90178000,
			"latitude": 31.80221000
		}, {
			"areaId": 320411,
			"areaName": "新北区",
			"longitude": 121.46574600,
			"latitude": 25.01236600
		}, {
			"areaId": 320412,
			"areaName": "武进区",
			"longitude": 119.94244000,
			"latitude": 31.70086000
		}, {
			"areaId": 320413,
			"areaName": "金坛区",
			"longitude": 119.57757000,
			"latitude": 31.74043000
		}, {
			"areaId": 320481,
			"areaName": "溧阳市",
			"longitude": 119.48370000,
			"latitude": 31.41538000
		}]
	}, {
		"areaId": 3205,
		"areaName": "苏州市",
		"longitude": 120.61958500,
		"latitude": 31.29937900,
		"children": [{
			"areaId": 320505,
			"areaName": "虎丘区",
			"longitude": 120.57345000,
			"latitude": 31.29530000
		}, {
			"areaId": 320506,
			"areaName": "吴中区",
			"longitude": 120.63211000,
			"latitude": 31.26226000
		}, {
			"areaId": 320507,
			"areaName": "相城区",
			"longitude": 120.64239000,
			"latitude": 31.36889000
		}, {
			"areaId": 320508,
			"areaName": "姑苏区",
			"longitude": 120.61958500,
			"latitude": 31.29937900
		}, {
			"areaId": 320509,
			"areaName": "吴江区",
			"longitude": 120.63831700,
			"latitude": 31.15981500
		}, {
			"areaId": 320571,
			"areaName": "苏州工业园区",
			"longitude": 106.62643400,
			"latitude": 29.55554000
		}, {
			"areaId": 320581,
			"areaName": "常熟市",
			"longitude": 120.75225000,
			"latitude": 31.65374000
		}, {
			"areaId": 320582,
			"areaName": "张家港市",
			"longitude": 120.55538000,
			"latitude": 31.87532000
		}, {
			"areaId": 320583,
			"areaName": "昆山市",
			"longitude": 120.98074000,
			"latitude": 31.38464000
		}, {
			"areaId": 320585,
			"areaName": "太仓市",
			"longitude": 121.10891000,
			"latitude": 31.44970000
		}]
	}, {
		"areaId": 3206,
		"areaName": "南通市",
		"longitude": 120.86460800,
		"latitude": 32.01621200,
		"children": [{
			"areaId": 320602,
			"areaName": "崇川区",
			"longitude": 120.85730000,
			"latitude": 32.00980000
		}, {
			"areaId": 320611,
			"areaName": "港闸区",
			"longitude": 120.81778000,
			"latitude": 32.03163000
		}, {
			"areaId": 320612,
			"areaName": "通州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320623,
			"areaName": "如东县",
			"longitude": 121.18942000,
			"latitude": 32.31439000
		}, {
			"areaId": 320671,
			"areaName": "南通经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320681,
			"areaName": "启东市",
			"longitude": 121.65985000,
			"latitude": 31.81083000
		}, {
			"areaId": 320682,
			"areaName": "如皋市",
			"longitude": 120.55969000,
			"latitude": 32.37597000
		}, {
			"areaId": 320684,
			"areaName": "海门市",
			"longitude": 121.16995000,
			"latitude": 31.89422000
		}, {
			"areaId": 320685,
			"areaName": "海安市",
			"longitude": 120.45852000,
			"latitude": 32.54514000
		}]
	}, {
		"areaId": 3207,
		"areaName": "连云港市",
		"longitude": 119.17882100,
		"latitude": 34.60001800,
		"children": [{
			"areaId": 320703,
			"areaName": "连云区",
			"longitude": 119.37304000,
			"latitude": 34.75293000
		}, {
			"areaId": 320706,
			"areaName": "海州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320707,
			"areaName": "赣榆区",
			"longitude": 119.12877400,
			"latitude": 34.83915400
		}, {
			"areaId": 320722,
			"areaName": "东海县",
			"longitude": 118.77145000,
			"latitude": 34.54215000
		}, {
			"areaId": 320723,
			"areaName": "灌云县",
			"longitude": 119.23925000,
			"latitude": 34.28391000
		}, {
			"areaId": 320724,
			"areaName": "灌南县",
			"longitude": 119.35632000,
			"latitude": 34.09000000
		}, {
			"areaId": 320771,
			"areaName": "连云港经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320772,
			"areaName": "连云港高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 3208,
		"areaName": "淮安市",
		"longitude": 119.02126500,
		"latitude": 33.59750600,
		"children": [{
			"areaId": 320803,
			"areaName": "淮安区",
			"longitude": 119.02126500,
			"latitude": 33.59750600
		}, {
			"areaId": 320804,
			"areaName": "淮阴区",
			"longitude": 119.03485000,
			"latitude": 33.63171000
		}, {
			"areaId": 320812,
			"areaName": "清江浦区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320813,
			"areaName": "洪泽区",
			"longitude": 118.87344000,
			"latitude": 33.29429000
		}, {
			"areaId": 320826,
			"areaName": "涟水县",
			"longitude": 119.26083000,
			"latitude": 33.78094000
		}, {
			"areaId": 320830,
			"areaName": "盱眙县",
			"longitude": 118.54495000,
			"latitude": 33.01086000
		}, {
			"areaId": 320831,
			"areaName": "金湖县",
			"longitude": 118.41974300,
			"latitude": 24.43863300
		}, {
			"areaId": 320871,
			"areaName": "淮安经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 3209,
		"areaName": "盐城市",
		"longitude": 120.13999800,
		"latitude": 33.37763100,
		"children": [{
			"areaId": 320902,
			"areaName": "亭湖区",
			"longitude": 120.16583000,
			"latitude": 33.37825000
		}, {
			"areaId": 320903,
			"areaName": "盐都区",
			"longitude": 120.15441000,
			"latitude": 33.33730000
		}, {
			"areaId": 320904,
			"areaName": "大丰区",
			"longitude": 120.46594000,
			"latitude": 33.19893000
		}, {
			"areaId": 320921,
			"areaName": "响水县",
			"longitude": 119.56985000,
			"latitude": 34.20513000
		}, {
			"areaId": 320922,
			"areaName": "滨海县",
			"longitude": 119.82058000,
			"latitude": 33.98972000
		}, {
			"areaId": 320923,
			"areaName": "阜宁县",
			"longitude": 119.80175000,
			"latitude": 33.78228000
		}, {
			"areaId": 320924,
			"areaName": "射阳县",
			"longitude": 120.26043000,
			"latitude": 33.77636000
		}, {
			"areaId": 320925,
			"areaName": "建湖县",
			"longitude": 119.79852000,
			"latitude": 33.47241000
		}, {
			"areaId": 320971,
			"areaName": "盐城经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 320981,
			"areaName": "东台市",
			"longitude": 120.32376000,
			"latitude": 32.85078000
		}]
	}, {
		"areaId": 3210,
		"areaName": "扬州市",
		"longitude": 119.42100300,
		"latitude": 32.39315900,
		"children": [{
			"areaId": 321002,
			"areaName": "广陵区",
			"longitude": 119.43186000,
			"latitude": 32.39472000
		}, {
			"areaId": 321003,
			"areaName": "邗江区",
			"longitude": 119.39816000,
			"latitude": 32.37650000
		}, {
			"areaId": 321012,
			"areaName": "江都区",
			"longitude": 119.56748100,
			"latitude": 32.42656400
		}, {
			"areaId": 321023,
			"areaName": "宝应县",
			"longitude": 119.31213000,
			"latitude": 33.23549000
		}, {
			"areaId": 321071,
			"areaName": "扬州经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 321081,
			"areaName": "仪征市",
			"longitude": 119.18432000,
			"latitude": 32.27197000
		}, {
			"areaId": 321084,
			"areaName": "高邮市",
			"longitude": 119.45965000,
			"latitude": 32.78135000
		}]
	}, {
		"areaId": 3211,
		"areaName": "镇江市",
		"longitude": 119.45275300,
		"latitude": 32.20440200,
		"children": [{
			"areaId": 321102,
			"areaName": "京口区",
			"longitude": 119.46947000,
			"latitude": 32.19809000
		}, {
			"areaId": 321111,
			"areaName": "润州区",
			"longitude": 119.41134000,
			"latitude": 32.19523000
		}, {
			"areaId": 321112,
			"areaName": "丹徒区",
			"longitude": 119.43383000,
			"latitude": 32.13183000
		}, {
			"areaId": 321171,
			"areaName": "镇江新区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 321181,
			"areaName": "丹阳市",
			"longitude": 119.57525000,
			"latitude": 31.99121000
		}, {
			"areaId": 321182,
			"areaName": "扬中市",
			"longitude": 119.79718000,
			"latitude": 32.23630000
		}, {
			"areaId": 321183,
			"areaName": "句容市",
			"longitude": 119.16482000,
			"latitude": 31.95591000
		}]
	}, {
		"areaId": 3212,
		"areaName": "泰州市",
		"longitude": 119.91517600,
		"latitude": 32.48488200,
		"children": [{
			"areaId": 321202,
			"areaName": "海陵区",
			"longitude": 119.91942000,
			"latitude": 32.49101000
		}, {
			"areaId": 321203,
			"areaName": "高港区",
			"longitude": 119.88089000,
			"latitude": 32.31833000
		}, {
			"areaId": 321204,
			"areaName": "姜堰区",
			"longitude": 120.14820800,
			"latitude": 32.50848300
		}, {
			"areaId": 321271,
			"areaName": "泰州医药高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 321281,
			"areaName": "兴化市",
			"longitude": 119.85238000,
			"latitude": 32.90944000
		}, {
			"areaId": 321282,
			"areaName": "靖江市",
			"longitude": 120.27291000,
			"latitude": 32.01595000
		}, {
			"areaId": 321283,
			"areaName": "泰兴市",
			"longitude": 120.05194000,
			"latitude": 32.17187000
		}]
	}, {
		"areaId": 3213,
		"areaName": "宿迁市",
		"longitude": 118.29332800,
		"latitude": 33.94515400,
		"children": [{
			"areaId": 321302,
			"areaName": "宿城区",
			"longitude": 118.29141000,
			"latitude": 33.94219000
		}, {
			"areaId": 321311,
			"areaName": "宿豫区",
			"longitude": 118.32922000,
			"latitude": 33.94673000
		}, {
			"areaId": 321322,
			"areaName": "沭阳县",
			"longitude": 118.76873000,
			"latitude": 34.11446000
		}, {
			"areaId": 321323,
			"areaName": "泗阳县",
			"longitude": 118.70330000,
			"latitude": 33.72096000
		}, {
			"areaId": 321324,
			"areaName": "泗洪县",
			"longitude": 118.21716000,
			"latitude": 33.45996000
		}, {
			"areaId": 321371,
			"areaName": "宿迁经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}]
}, {
	"areaId": 33,
	"areaName": "浙江省",
	"longitude": 120.15357600,
	"latitude": 30.28745900,
	"children": [{
		"areaId": 3302,
		"areaName": "宁波市",
		"longitude": 121.54979200,
		"latitude": 29.86838800,
		"children": [{
			"areaId": 330203,
			"areaName": "海曙区",
			"longitude": 121.55106000,
			"latitude": 29.85977000
		}, {
			"areaId": 330205,
			"areaName": "江北区",
			"longitude": 106.57434000,
			"latitude": 29.60658000
		}, {
			"areaId": 330206,
			"areaName": "北仑区",
			"longitude": 121.84408000,
			"latitude": 29.90069000
		}, {
			"areaId": 330211,
			"areaName": "镇海区",
			"longitude": 121.71615000,
			"latitude": 29.94893000
		}, {
			"areaId": 330212,
			"areaName": "鄞州区",
			"longitude": 121.54754000,
			"latitude": 29.81614000
		}, {
			"areaId": 330213,
			"areaName": "奉化区",
			"longitude": 121.41003000,
			"latitude": 29.65537000
		}, {
			"areaId": 330225,
			"areaName": "象山县",
			"longitude": 121.86917000,
			"latitude": 29.47758000
		}, {
			"areaId": 330226,
			"areaName": "宁海县",
			"longitude": 121.43072000,
			"latitude": 29.28890000
		}, {
			"areaId": 330281,
			"areaName": "余姚市",
			"longitude": 121.15341000,
			"latitude": 30.03867000
		}, {
			"areaId": 330282,
			"areaName": "慈溪市",
			"longitude": 121.26641000,
			"latitude": 30.16959000
		}]
	}, {
		"areaId": 3303,
		"areaName": "温州市",
		"longitude": 120.67211100,
		"latitude": 28.00057500,
		"children": [{
			"areaId": 330302,
			"areaName": "鹿城区",
			"longitude": 120.65505000,
			"latitude": 28.01489000
		}, {
			"areaId": 330303,
			"areaName": "龙湾区",
			"longitude": 120.83053000,
			"latitude": 27.91284000
		}, {
			"areaId": 330304,
			"areaName": "瓯海区",
			"longitude": 120.63751000,
			"latitude": 28.00714000
		}, {
			"areaId": 330305,
			"areaName": "洞头区",
			"longitude": 121.15606000,
			"latitude": 27.83634000
		}, {
			"areaId": 330324,
			"areaName": "永嘉县",
			"longitude": 120.69317000,
			"latitude": 28.15456000
		}, {
			"areaId": 330326,
			"areaName": "平阳县",
			"longitude": 120.56506000,
			"latitude": 27.66245000
		}, {
			"areaId": 330327,
			"areaName": "苍南县",
			"longitude": 120.42608000,
			"latitude": 27.51739000
		}, {
			"areaId": 330328,
			"areaName": "文成县",
			"longitude": 120.09063000,
			"latitude": 27.78678000
		}, {
			"areaId": 330329,
			"areaName": "泰顺县",
			"longitude": 119.71820000,
			"latitude": 27.55694000
		}, {
			"areaId": 330371,
			"areaName": "温州经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 330381,
			"areaName": "瑞安市",
			"longitude": 120.65466000,
			"latitude": 27.78041000
		}, {
			"areaId": 330382,
			"areaName": "乐清市",
			"longitude": 120.96170000,
			"latitude": 28.12404000
		}, {
			"areaId": 330383,
			"areaName": "龙港市",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 3304,
		"areaName": "嘉兴市",
		"longitude": 120.75086500,
		"latitude": 30.76265300,
		"children": [{
			"areaId": 330402,
			"areaName": "南湖区",
			"longitude": 120.78524000,
			"latitude": 30.74865000
		}, {
			"areaId": 330411,
			"areaName": "秀洲区",
			"longitude": 120.70867000,
			"latitude": 30.76454000
		}, {
			"areaId": 330421,
			"areaName": "嘉善县",
			"longitude": 120.92559000,
			"latitude": 30.82993000
		}, {
			"areaId": 330424,
			"areaName": "海盐县",
			"longitude": 120.94570000,
			"latitude": 30.52547000
		}, {
			"areaId": 330481,
			"areaName": "海宁市",
			"longitude": 120.68130000,
			"latitude": 30.50970000
		}, {
			"areaId": 330482,
			"areaName": "平湖市",
			"longitude": 121.02166000,
			"latitude": 30.69618000
		}, {
			"areaId": 330483,
			"areaName": "桐乡市",
			"longitude": 120.56485000,
			"latitude": 30.63020000
		}]
	}, {
		"areaId": 3305,
		"areaName": "湖州市",
		"longitude": 120.10239800,
		"latitude": 30.86719800,
		"children": [{
			"areaId": 330502,
			"areaName": "吴兴区",
			"longitude": 120.12548000,
			"latitude": 30.85752000
		}, {
			"areaId": 330503,
			"areaName": "南浔区",
			"longitude": 120.42038000,
			"latitude": 30.86686000
		}, {
			"areaId": 330521,
			"areaName": "德清县",
			"longitude": 119.97836000,
			"latitude": 30.53369000
		}, {
			"areaId": 330522,
			"areaName": "长兴县",
			"longitude": 119.90783000,
			"latitude": 31.00606000
		}, {
			"areaId": 330523,
			"areaName": "安吉县",
			"longitude": 119.68158000,
			"latitude": 30.63798000
		}]
	}, {
		"areaId": 3306,
		"areaName": "绍兴市",
		"longitude": 120.58211200,
		"latitude": 29.99711700,
		"children": [{
			"areaId": 330602,
			"areaName": "越城区",
			"longitude": 120.58190000,
			"latitude": 29.98895000
		}, {
			"areaId": 330603,
			"areaName": "柯桥区",
			"longitude": 120.49273600,
			"latitude": 30.08763000
		}, {
			"areaId": 330604,
			"areaName": "上虞区",
			"longitude": 120.47607500,
			"latitude": 30.07803800
		}, {
			"areaId": 330624,
			"areaName": "新昌县",
			"longitude": 120.90435000,
			"latitude": 29.49991000
		}, {
			"areaId": 330681,
			"areaName": "诸暨市",
			"longitude": 120.23629000,
			"latitude": 29.71358000
		}, {
			"areaId": 330683,
			"areaName": "嵊州市",
			"longitude": 120.82174000,
			"latitude": 29.58854000
		}]
	}, {
		"areaId": 3307,
		"areaName": "金华市",
		"longitude": 119.64950600,
		"latitude": 29.08952400,
		"children": [{
			"areaId": 330702,
			"areaName": "婺城区",
			"longitude": 119.57135000,
			"latitude": 29.09521000
		}, {
			"areaId": 330703,
			"areaName": "金东区",
			"longitude": 119.69302000,
			"latitude": 29.09910000
		}, {
			"areaId": 330723,
			"areaName": "武义县",
			"longitude": 119.81640000,
			"latitude": 28.89331000
		}, {
			"areaId": 330726,
			"areaName": "浦江县",
			"longitude": 119.89181000,
			"latitude": 29.45353000
		}, {
			"areaId": 330727,
			"areaName": "磐安县",
			"longitude": 120.45022000,
			"latitude": 29.05733000
		}, {
			"areaId": 330781,
			"areaName": "兰溪市",
			"longitude": 119.45965000,
			"latitude": 29.20841000
		}, {
			"areaId": 330782,
			"areaName": "义乌市",
			"longitude": 120.07440000,
			"latitude": 29.30558000
		}, {
			"areaId": 330783,
			"areaName": "东阳市",
			"longitude": 120.24185000,
			"latitude": 29.28942000
		}, {
			"areaId": 330784,
			"areaName": "永康市",
			"longitude": 120.25706900,
			"latitude": 23.02606100
		}]
	}, {
		"areaId": 3308,
		"areaName": "衢州市",
		"longitude": 118.87263000,
		"latitude": 28.94170800,
		"children": [{
			"areaId": 330802,
			"areaName": "柯城区",
			"longitude": 118.87109000,
			"latitude": 28.96858000
		}, {
			"areaId": 330803,
			"areaName": "衢江区",
			"longitude": 118.95980000,
			"latitude": 28.97977000
		}, {
			"areaId": 330822,
			"areaName": "常山县",
			"longitude": 118.51025000,
			"latitude": 28.90191000
		}, {
			"areaId": 330824,
			"areaName": "开化县",
			"longitude": 118.41616000,
			"latitude": 29.13785000
		}, {
			"areaId": 330825,
			"areaName": "龙游县",
			"longitude": 119.17221000,
			"latitude": 29.02823000
		}, {
			"areaId": 330881,
			"areaName": "江山市",
			"longitude": 118.62674000,
			"latitude": 28.73860000
		}]
	}, {
		"areaId": 3309,
		"areaName": "舟山市",
		"longitude": 122.03064000,
		"latitude": 30.14037700,
		"children": [{
			"areaId": 330902,
			"areaName": "定海区",
			"longitude": 122.10677000,
			"latitude": 30.01985000
		}, {
			"areaId": 330903,
			"areaName": "普陀区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 330921,
			"areaName": "岱山县",
			"longitude": 122.18012300,
			"latitude": 30.27726900
		}, {
			"areaId": 330922,
			"areaName": "嵊泗县",
			"longitude": 122.45129000,
			"latitude": 30.72678000
		}]
	}, {
		"areaId": 3310,
		"areaName": "台州市",
		"longitude": 121.42859900,
		"latitude": 28.66137800,
		"children": [{
			"areaId": 331002,
			"areaName": "椒江区",
			"longitude": 121.44287000,
			"latitude": 28.67301000
		}, {
			"areaId": 331003,
			"areaName": "黄岩区",
			"longitude": 121.25891000,
			"latitude": 28.65077000
		}, {
			"areaId": 331004,
			"areaName": "路桥区",
			"longitude": 121.37381000,
			"latitude": 28.58016000
		}, {
			"areaId": 331022,
			"areaName": "三门县",
			"longitude": 121.39370000,
			"latitude": 29.10510000
		}, {
			"areaId": 331023,
			"areaName": "天台县",
			"longitude": 121.00848000,
			"latitude": 29.14290000
		}, {
			"areaId": 331024,
			"areaName": "仙居县",
			"longitude": 120.72872000,
			"latitude": 28.84672000
		}, {
			"areaId": 331081,
			"areaName": "温岭市",
			"longitude": 121.38595000,
			"latitude": 28.37176000
		}, {
			"areaId": 331082,
			"areaName": "临海市",
			"longitude": 121.13885000,
			"latitude": 28.85603000
		}, {
			"areaId": 331083,
			"areaName": "玉环市",
			"longitude": 121.23242000,
			"latitude": 28.13637000
		}]
	}, {
		"areaId": 3311,
		"areaName": "丽水市",
		"longitude": 119.92178600,
		"latitude": 28.45199300,
		"children": [{
			"areaId": 331102,
			"areaName": "莲都区",
			"longitude": 119.91270000,
			"latitude": 28.44583000
		}, {
			"areaId": 331121,
			"areaName": "青田县",
			"longitude": 120.29028000,
			"latitude": 28.13897000
		}, {
			"areaId": 331122,
			"areaName": "缙云县",
			"longitude": 120.09036000,
			"latitude": 28.65944000
		}, {
			"areaId": 331123,
			"areaName": "遂昌县",
			"longitude": 119.27606000,
			"latitude": 28.59291000
		}, {
			"areaId": 331124,
			"areaName": "松阳县",
			"longitude": 119.48199000,
			"latitude": 28.44940000
		}, {
			"areaId": 331125,
			"areaName": "云和县",
			"longitude": 119.57287000,
			"latitude": 28.11643000
		}, {
			"areaId": 331126,
			"areaName": "庆元县",
			"longitude": 119.06256000,
			"latitude": 27.61842000
		}, {
			"areaId": 331127,
			"areaName": "景宁畲族自治县",
			"longitude": 119.63839000,
			"latitude": 27.97393000
		}, {
			"areaId": 331181,
			"areaName": "龙泉市",
			"longitude": 119.14163000,
			"latitude": 28.07430000
		}]
	}, {
		"areaId": 3301,
		"areaName": "杭州市",
		"longitude": 120.15357600,
		"latitude": 30.28745900,
		"children": [{
			"areaId": 330102,
			"areaName": "上城区",
			"longitude": 120.16922000,
			"latitude": 30.24255000
		}, {
			"areaId": 330103,
			"areaName": "下城区",
			"longitude": 120.18096000,
			"latitude": 30.28153000
		}, {
			"areaId": 330104,
			"areaName": "江干区",
			"longitude": 120.20517000,
			"latitude": 30.25720000
		}, {
			"areaId": 330105,
			"areaName": "拱墅区",
			"longitude": 120.14209000,
			"latitude": 30.31968000
		}, {
			"areaId": 330106,
			"areaName": "西湖区",
			"longitude": 121.00341800,
			"latitude": 23.77529100
		}, {
			"areaId": 330108,
			"areaName": "滨江区",
			"longitude": 120.21194000,
			"latitude": 30.20835000
		}, {
			"areaId": 330109,
			"areaName": "萧山区",
			"longitude": 120.26452000,
			"latitude": 30.18505000
		}, {
			"areaId": 330110,
			"areaName": "余杭区",
			"longitude": 120.29986000,
			"latitude": 30.41829000
		}, {
			"areaId": 330111,
			"areaName": "富阳区",
			"longitude": 119.96041000,
			"latitude": 30.04878000
		}, {
			"areaId": 330112,
			"areaName": "临安区",
			"longitude": 119.72473000,
			"latitude": 30.23447000
		}, {
			"areaId": 330122,
			"areaName": "桐庐县",
			"longitude": 119.68853000,
			"latitude": 29.79779000
		}, {
			"areaId": 330127,
			"areaName": "淳安县",
			"longitude": 119.04257000,
			"latitude": 29.60988000
		}, {
			"areaId": 330182,
			"areaName": "建德市",
			"longitude": 119.28158000,
			"latitude": 29.47603000
		}]
	}]
}, {
	"areaId": 34,
	"areaName": "安徽省",
	"longitude": 117.28304200,
	"latitude": 31.86119000,
	"children": [{
		"areaId": 3401,
		"areaName": "合肥市",
		"longitude": 117.28304200,
		"latitude": 31.86119000,
		"children": [{
			"areaId": 340102,
			"areaName": "瑶海区",
			"longitude": 117.30947000,
			"latitude": 31.85809000
		}, {
			"areaId": 340103,
			"areaName": "庐阳区",
			"longitude": 117.26452000,
			"latitude": 31.87874000
		}, {
			"areaId": 340104,
			"areaName": "蜀山区",
			"longitude": 117.26104000,
			"latitude": 31.85117000
		}, {
			"areaId": 340111,
			"areaName": "包河区",
			"longitude": 117.30984000,
			"latitude": 31.79502000
		}, {
			"areaId": 340121,
			"areaName": "长丰县",
			"longitude": 117.16549000,
			"latitude": 32.47959000
		}, {
			"areaId": 340122,
			"areaName": "肥东县",
			"longitude": 117.47128000,
			"latitude": 31.88525000
		}, {
			"areaId": 340123,
			"areaName": "肥西县",
			"longitude": 117.16845000,
			"latitude": 31.72143000
		}, {
			"areaId": 340124,
			"areaName": "庐江县",
			"longitude": 117.28984400,
			"latitude": 31.25148800
		}, {
			"areaId": 340171,
			"areaName": "合肥高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340172,
			"areaName": "合肥经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340173,
			"areaName": "合肥新站高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340181,
			"areaName": "巢湖市",
			"longitude": 117.87415500,
			"latitude": 31.60051800
		}]
	}, {
		"areaId": 3402,
		"areaName": "芜湖市",
		"longitude": 118.37645100,
		"latitude": 31.32631900,
		"children": [{
			"areaId": 340202,
			"areaName": "镜湖区",
			"longitude": 118.38525000,
			"latitude": 31.34038000
		}, {
			"areaId": 340203,
			"areaName": "弋江区",
			"longitude": 118.37265000,
			"latitude": 31.31178000
		}, {
			"areaId": 340207,
			"areaName": "鸠江区",
			"longitude": 118.39215000,
			"latitude": 31.36928000
		}, {
			"areaId": 340208,
			"areaName": "三山区",
			"longitude": 118.22509000,
			"latitude": 31.20703000
		}, {
			"areaId": 340221,
			"areaName": "湾沚区",
			"longitude": 118.57525000,
			"latitude": 31.13476000
		}, {
			"areaId": 340222,
			"areaName": "繁昌县",
			"longitude": 118.19982000,
			"latitude": 31.08319000
		}, {
			"areaId": 340223,
			"areaName": "南陵县",
			"longitude": 118.33688000,
			"latitude": 30.91969000
		}, {
			"areaId": 340271,
			"areaName": "芜湖经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340272,
			"areaName": "安徽芜湖长江大桥经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340225,
			"areaName": "无为市",
			"longitude": 117.91143200,
			"latitude": 31.30307500
		}]
	}, {
		"areaId": 3403,
		"areaName": "蚌埠市",
		"longitude": 117.36237000,
		"latitude": 32.93403700,
		"children": [{
			"areaId": 340302,
			"areaName": "龙子湖区",
			"longitude": 117.39379000,
			"latitude": 32.94301000
		}, {
			"areaId": 340303,
			"areaName": "蚌山区",
			"longitude": 117.36767000,
			"latitude": 32.94411000
		}, {
			"areaId": 340304,
			"areaName": "禹会区",
			"longitude": 117.35315000,
			"latitude": 32.93336000
		}, {
			"areaId": 340311,
			"areaName": "淮上区",
			"longitude": 117.35983000,
			"latitude": 32.96423000
		}, {
			"areaId": 340321,
			"areaName": "怀远县",
			"longitude": 117.20507000,
			"latitude": 32.97007000
		}, {
			"areaId": 340322,
			"areaName": "五河县",
			"longitude": 117.89144000,
			"latitude": 33.14457000
		}, {
			"areaId": 340323,
			"areaName": "固镇县",
			"longitude": 117.31558000,
			"latitude": 33.31803000
		}, {
			"areaId": 340371,
			"areaName": "蚌埠市高新技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340372,
			"areaName": "蚌埠市经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 3404,
		"areaName": "淮南市",
		"longitude": 117.02544900,
		"latitude": 32.64594700,
		"children": [{
			"areaId": 340402,
			"areaName": "大通区",
			"longitude": 117.05255000,
			"latitude": 32.63265000
		}, {
			"areaId": 340403,
			"areaName": "田家庵区",
			"longitude": 117.01739000,
			"latitude": 32.64697000
		}, {
			"areaId": 340404,
			"areaName": "谢家集区",
			"longitude": 116.86377000,
			"latitude": 32.59818000
		}, {
			"areaId": 340405,
			"areaName": "八公山区",
			"longitude": 116.83694000,
			"latitude": 32.62941000
		}, {
			"areaId": 340406,
			"areaName": "潘集区",
			"longitude": 116.81622000,
			"latitude": 32.78287000
		}, {
			"areaId": 340421,
			"areaName": "凤台县",
			"longitude": 116.71569000,
			"latitude": 32.70752000
		}, {
			"areaId": 340422,
			"areaName": "寿县",
			"longitude": 116.78466000,
			"latitude": 32.57653000
		}]
	}, {
		"areaId": 3405,
		"areaName": "马鞍山市",
		"longitude": 118.50790600,
		"latitude": 31.68936200,
		"children": [{
			"areaId": 340503,
			"areaName": "花山区",
			"longitude": 118.51231000,
			"latitude": 31.70010000
		}, {
			"areaId": 340504,
			"areaName": "雨山区",
			"longitude": 118.49869000,
			"latitude": 31.68219000
		}, {
			"areaId": 340506,
			"areaName": "博望区",
			"longitude": 118.84438700,
			"latitude": 31.56187100
		}, {
			"areaId": 340521,
			"areaName": "当涂县",
			"longitude": 118.49786000,
			"latitude": 31.57098000
		}, {
			"areaId": 340522,
			"areaName": "含山县",
			"longitude": 118.10554500,
			"latitude": 31.72775800
		}, {
			"areaId": 340523,
			"areaName": "和县",
			"longitude": 118.35140500,
			"latitude": 31.74179400
		}]
	}, {
		"areaId": 3406,
		"areaName": "淮北市",
		"longitude": 116.79466400,
		"latitude": 33.97170700,
		"children": [{
			"areaId": 340602,
			"areaName": "杜集区",
			"longitude": 116.82998000,
			"latitude": 33.99363000
		}, {
			"areaId": 340603,
			"areaName": "相山区",
			"longitude": 116.79464000,
			"latitude": 33.95979000
		}, {
			"areaId": 340604,
			"areaName": "烈山区",
			"longitude": 116.81448000,
			"latitude": 33.89355000
		}, {
			"areaId": 340621,
			"areaName": "濉溪县",
			"longitude": 116.76785000,
			"latitude": 33.91455000
		}]
	}, {
		"areaId": 3407,
		"areaName": "铜陵市",
		"longitude": 117.79113000,
		"latitude": 30.95365000,
		"children": [{
			"areaId": 340705,
			"areaName": "铜官区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340706,
			"areaName": "义安区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340711,
			"areaName": "郊区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340722,
			"areaName": "枞阳县",
			"longitude": 117.22015000,
			"latitude": 30.69956000
		}]
	}, {
		"areaId": 3408,
		"areaName": "安庆市",
		"longitude": 117.05357100,
		"latitude": 30.52481600,
		"children": [{
			"areaId": 340802,
			"areaName": "迎江区",
			"longitude": 117.04930000,
			"latitude": 30.50421000
		}, {
			"areaId": 340803,
			"areaName": "大观区",
			"longitude": 117.03426000,
			"latitude": 30.51216000
		}, {
			"areaId": 340811,
			"areaName": "宜秀区",
			"longitude": 117.06127000,
			"latitude": 30.50783000
		}, {
			"areaId": 340822,
			"areaName": "怀宁县",
			"longitude": 116.82968000,
			"latitude": 30.73376000
		}, {
			"areaId": 340825,
			"areaName": "太湖县",
			"longitude": 116.30880000,
			"latitude": 30.45410000
		}, {
			"areaId": 340826,
			"areaName": "宿松县",
			"longitude": 116.12915000,
			"latitude": 30.15360000
		}, {
			"areaId": 340827,
			"areaName": "望江县",
			"longitude": 116.68814000,
			"latitude": 30.12585000
		}, {
			"areaId": 340828,
			"areaName": "岳西县",
			"longitude": 116.35995000,
			"latitude": 30.84983000
		}, {
			"areaId": 340871,
			"areaName": "安徽安庆经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 340881,
			"areaName": "桐城市",
			"longitude": 116.95071000,
			"latitude": 31.05216000
		}, {
			"areaId": 340882,
			"areaName": "潜山市",
			"longitude": 116.57574000,
			"latitude": 30.63037000
		}]
	}, {
		"areaId": 3410,
		"areaName": "黄山市",
		"longitude": 118.31732500,
		"latitude": 29.70923900,
		"children": [{
			"areaId": 341002,
			"areaName": "屯溪区",
			"longitude": 118.33368000,
			"latitude": 29.71138000
		}, {
			"areaId": 341003,
			"areaName": "黄山区",
			"longitude": 118.14160000,
			"latitude": 30.27290000
		}, {
			"areaId": 341004,
			"areaName": "徽州区",
			"longitude": 118.33654000,
			"latitude": 29.82784000
		}, {
			"areaId": 341021,
			"areaName": "歙县",
			"longitude": 118.43676000,
			"latitude": 29.86745000
		}, {
			"areaId": 341022,
			"areaName": "休宁县",
			"longitude": 118.18136000,
			"latitude": 29.78607000
		}, {
			"areaId": 341023,
			"areaName": "黟县",
			"longitude": 117.94137000,
			"latitude": 29.92588000
		}, {
			"areaId": 341024,
			"areaName": "祁门县",
			"longitude": 117.71847000,
			"latitude": 29.85723000
		}]
	}, {
		"areaId": 3411,
		"areaName": "滁州市",
		"longitude": 118.31626400,
		"latitude": 32.30362700,
		"children": [{
			"areaId": 341102,
			"areaName": "琅琊区",
			"longitude": 118.30538000,
			"latitude": 32.29521000
		}, {
			"areaId": 341103,
			"areaName": "南谯区",
			"longitude": 118.31222000,
			"latitude": 32.31861000
		}, {
			"areaId": 341122,
			"areaName": "来安县",
			"longitude": 118.43438000,
			"latitude": 32.45176000
		}, {
			"areaId": 341124,
			"areaName": "全椒县",
			"longitude": 118.27291000,
			"latitude": 32.08524000
		}, {
			"areaId": 341125,
			"areaName": "定远县",
			"longitude": 117.68035000,
			"latitude": 32.52488000
		}, {
			"areaId": 341126,
			"areaName": "凤阳县",
			"longitude": 117.56454000,
			"latitude": 32.86507000
		}, {
			"areaId": 341171,
			"areaName": "苏滁现代产业园",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 341172,
			"areaName": "滁州经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 341181,
			"areaName": "天长市",
			"longitude": 118.99868000,
			"latitude": 32.69124000
		}, {
			"areaId": 341182,
			"areaName": "明光市",
			"longitude": 117.99093000,
			"latitude": 32.77819000
		}]
	}, {
		"areaId": 3412,
		"areaName": "阜阳市",
		"longitude": 115.81972900,
		"latitude": 32.89696900,
		"children": [{
			"areaId": 341202,
			"areaName": "颍州区",
			"longitude": 115.80694000,
			"latitude": 32.88346000
		}, {
			"areaId": 341203,
			"areaName": "颍东区",
			"longitude": 115.85659000,
			"latitude": 32.91296000
		}, {
			"areaId": 341204,
			"areaName": "颍泉区",
			"longitude": 115.80712000,
			"latitude": 32.92490000
		}, {
			"areaId": 341221,
			"areaName": "临泉县",
			"longitude": 115.26232000,
			"latitude": 33.06758000
		}, {
			"areaId": 341222,
			"areaName": "太和县",
			"longitude": 115.62191000,
			"latitude": 33.16025000
		}, {
			"areaId": 341225,
			"areaName": "阜南县",
			"longitude": 115.58563000,
			"latitude": 32.63551000
		}, {
			"areaId": 341226,
			"areaName": "颍上县",
			"longitude": 116.26458000,
			"latitude": 32.62998000
		}, {
			"areaId": 341271,
			"areaName": "阜阳合肥现代产业园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 341272,
			"areaName": "阜阳经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 341282,
			"areaName": "界首市",
			"longitude": 115.37445000,
			"latitude": 33.25714000
		}]
	}, {
		"areaId": 3413,
		"areaName": "宿州市",
		"longitude": 116.98408400,
		"latitude": 33.63389100,
		"children": [{
			"areaId": 341302,
			"areaName": "埇桥区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 341321,
			"areaName": "砀山县",
			"longitude": 116.35363000,
			"latitude": 34.42356000
		}, {
			"areaId": 341322,
			"areaName": "萧县",
			"longitude": 116.94546000,
			"latitude": 34.18790000
		}, {
			"areaId": 341323,
			"areaName": "灵璧县",
			"longitude": 117.55813000,
			"latitude": 33.54339000
		}, {
			"areaId": 341324,
			"areaName": "泗县",
			"longitude": 117.91033000,
			"latitude": 33.48295000
		}, {
			"areaId": 341371,
			"areaName": "宿州马鞍山现代产业园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 341372,
			"areaName": "宿州经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 3415,
		"areaName": "六安市",
		"longitude": 116.50767600,
		"latitude": 31.75288900,
		"children": [{
			"areaId": 341502,
			"areaName": "金安区",
			"longitude": 116.50912000,
			"latitude": 31.75573000
		}, {
			"areaId": 341503,
			"areaName": "裕安区",
			"longitude": 116.47985000,
			"latitude": 31.73787000
		}, {
			"areaId": 341504,
			"areaName": "叶集区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 341522,
			"areaName": "霍邱县",
			"longitude": 116.27795000,
			"latitude": 32.35300000
		}, {
			"areaId": 341523,
			"areaName": "舒城县",
			"longitude": 116.94491000,
			"latitude": 31.46413000
		}, {
			"areaId": 341524,
			"areaName": "金寨县",
			"longitude": 115.93463000,
			"latitude": 31.73510000
		}, {
			"areaId": 341525,
			"areaName": "霍山县",
			"longitude": 116.33291000,
			"latitude": 31.39290000
		}]
	}, {
		"areaId": 3416,
		"areaName": "亳州市",
		"longitude": 115.78293900,
		"latitude": 33.86933800,
		"children": [{
			"areaId": 341602,
			"areaName": "谯城区",
			"longitude": 115.77941000,
			"latitude": 33.87532000
		}, {
			"areaId": 341621,
			"areaName": "涡阳县",
			"longitude": 116.21682000,
			"latitude": 33.50911000
		}, {
			"areaId": 341622,
			"areaName": "蒙城县",
			"longitude": 116.56460000,
			"latitude": 33.26477000
		}, {
			"areaId": 341623,
			"areaName": "利辛县",
			"longitude": 116.20800000,
			"latitude": 33.14198000
		}]
	}, {
		"areaId": 3417,
		"areaName": "池州市",
		"longitude": 117.48915700,
		"latitude": 30.65603700,
		"children": [{
			"areaId": 341702,
			"areaName": "贵池区",
			"longitude": 117.48722000,
			"latitude": 30.65283000
		}, {
			"areaId": 341721,
			"areaName": "东至县",
			"longitude": 117.02719000,
			"latitude": 30.09690000
		}, {
			"areaId": 341722,
			"areaName": "石台县",
			"longitude": 117.48666000,
			"latitude": 30.21042000
		}, {
			"areaId": 341723,
			"areaName": "青阳县",
			"longitude": 117.84744000,
			"latitude": 30.63932000
		}]
	}, {
		"areaId": 3418,
		"areaName": "宣城市",
		"longitude": 118.75799500,
		"latitude": 30.94566700,
		"children": [{
			"areaId": 341802,
			"areaName": "宣州区",
			"longitude": 118.75462000,
			"latitude": 30.94439000
		}, {
			"areaId": 341821,
			"areaName": "郎溪县",
			"longitude": 119.17923000,
			"latitude": 31.12599000
		}, {
			"areaId": 341823,
			"areaName": "泾县",
			"longitude": 118.41964000,
			"latitude": 30.69498000
		}, {
			"areaId": 341824,
			"areaName": "绩溪县",
			"longitude": 118.59765000,
			"latitude": 30.07069000
		}, {
			"areaId": 341825,
			"areaName": "旌德县",
			"longitude": 118.54299000,
			"latitude": 30.28898000
		}, {
			"areaId": 341871,
			"areaName": "宣城市经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 341881,
			"areaName": "宁国市",
			"longitude": 118.98349000,
			"latitude": 30.62380000
		}, {
			"areaId": 341882,
			"areaName": "广德市",
			"longitude": 119.41769000,
			"latitude": 30.89371000
		}]
	}]
}, {
	"areaId": 35,
	"areaName": "福建省",
	"longitude": 119.30623900,
	"latitude": 26.07530200,
	"children": [{
		"areaId": 3501,
		"areaName": "福州市",
		"longitude": 119.30623900,
		"latitude": 26.07530200,
		"children": [{
			"areaId": 350102,
			"areaName": "鼓楼区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 350103,
			"areaName": "台江区",
			"longitude": 119.30899000,
			"latitude": 26.06204000
		}, {
			"areaId": 350104,
			"areaName": "仓山区",
			"longitude": 119.31543000,
			"latitude": 26.04335000
		}, {
			"areaId": 350105,
			"areaName": "马尾区",
			"longitude": 119.45550000,
			"latitude": 25.98942000
		}, {
			"areaId": 350111,
			"areaName": "晋安区",
			"longitude": 119.32828000,
			"latitude": 26.08180000
		}, {
			"areaId": 350112,
			"areaName": "长乐区",
			"longitude": 119.52313000,
			"latitude": 25.96276000
		}, {
			"areaId": 350121,
			"areaName": "闽侯县",
			"longitude": 119.13388000,
			"latitude": 26.15014000
		}, {
			"areaId": 350122,
			"areaName": "连江县",
			"longitude": 119.53970400,
			"latitude": 26.19736400
		}, {
			"areaId": 350123,
			"areaName": "罗源县",
			"longitude": 119.55090000,
			"latitude": 26.48752000
		}, {
			"areaId": 350124,
			"areaName": "闽清县",
			"longitude": 118.86230000,
			"latitude": 26.21901000
		}, {
			"areaId": 350125,
			"areaName": "永泰县",
			"longitude": 118.93600000,
			"latitude": 25.86816000
		}, {
			"areaId": 350128,
			"areaName": "平潭县",
			"longitude": 119.79119700,
			"latitude": 25.50367200
		}, {
			"areaId": 350181,
			"areaName": "福清市",
			"longitude": 119.38507000,
			"latitude": 25.72086000
		}]
	}, {
		"areaId": 3502,
		"areaName": "厦门市",
		"longitude": 118.11022000,
		"latitude": 24.49047400,
		"children": [{
			"areaId": 350203,
			"areaName": "思明区",
			"longitude": 118.08233000,
			"latitude": 24.44543000
		}, {
			"areaId": 350205,
			"areaName": "海沧区",
			"longitude": 118.03289000,
			"latitude": 24.48461000
		}, {
			"areaId": 350206,
			"areaName": "湖里区",
			"longitude": 118.14621000,
			"latitude": 24.51253000
		}, {
			"areaId": 350211,
			"areaName": "集美区",
			"longitude": 118.09719000,
			"latitude": 24.57584000
		}, {
			"areaId": 350212,
			"areaName": "同安区",
			"longitude": 118.15197000,
			"latitude": 24.72308000
		}, {
			"areaId": 350213,
			"areaName": "翔安区",
			"longitude": 118.24783000,
			"latitude": 24.61863000
		}]
	}, {
		"areaId": 3503,
		"areaName": "莆田市",
		"longitude": 119.00755800,
		"latitude": 25.43101100,
		"children": [{
			"areaId": 350302,
			"areaName": "城厢区",
			"longitude": 118.99462000,
			"latitude": 25.41872000
		}, {
			"areaId": 350303,
			"areaName": "涵江区",
			"longitude": 119.11621000,
			"latitude": 25.45876000
		}, {
			"areaId": 350304,
			"areaName": "荔城区",
			"longitude": 119.01339000,
			"latitude": 25.43369000
		}, {
			"areaId": 350305,
			"areaName": "秀屿区",
			"longitude": 119.10553000,
			"latitude": 25.31831000
		}, {
			"areaId": 350322,
			"areaName": "仙游县",
			"longitude": 118.69177000,
			"latitude": 25.36214000
		}]
	}, {
		"areaId": 3504,
		"areaName": "三明市",
		"longitude": 117.63500100,
		"latitude": 26.26544400,
		"children": [{
			"areaId": 350402,
			"areaName": "梅列区",
			"longitude": 117.64585000,
			"latitude": 26.27171000
		}, {
			"areaId": 350403,
			"areaName": "三元区",
			"longitude": 117.60788000,
			"latitude": 26.23372000
		}, {
			"areaId": 350421,
			"areaName": "明溪县",
			"longitude": 117.20498000,
			"latitude": 26.35294000
		}, {
			"areaId": 350423,
			"areaName": "清流县",
			"longitude": 116.81460000,
			"latitude": 26.17144000
		}, {
			"areaId": 350424,
			"areaName": "宁化县",
			"longitude": 116.66101000,
			"latitude": 26.25874000
		}, {
			"areaId": 350425,
			"areaName": "大田县",
			"longitude": 117.84710000,
			"latitude": 25.69260000
		}, {
			"areaId": 350426,
			"areaName": "尤溪县",
			"longitude": 118.19049000,
			"latitude": 26.17002000
		}, {
			"areaId": 350427,
			"areaName": "沙县",
			"longitude": 117.79266000,
			"latitude": 26.39615000
		}, {
			"areaId": 350428,
			"areaName": "将乐县",
			"longitude": 117.47317000,
			"latitude": 26.72837000
		}, {
			"areaId": 350429,
			"areaName": "泰宁县",
			"longitude": 117.17578000,
			"latitude": 26.90010000
		}, {
			"areaId": 350430,
			"areaName": "建宁县",
			"longitude": 116.84603000,
			"latitude": 26.83091000
		}, {
			"areaId": 350481,
			"areaName": "永安市",
			"longitude": 120.22530800,
			"latitude": 22.81858000
		}]
	}, {
		"areaId": 3505,
		"areaName": "泉州市",
		"longitude": 118.58942100,
		"latitude": 24.90885300,
		"children": [{
			"areaId": 350502,
			"areaName": "鲤城区",
			"longitude": 118.56591000,
			"latitude": 24.88741000
		}, {
			"areaId": 350503,
			"areaName": "丰泽区",
			"longitude": 118.61328000,
			"latitude": 24.89119000
		}, {
			"areaId": 350504,
			"areaName": "洛江区",
			"longitude": 118.67111000,
			"latitude": 24.93984000
		}, {
			"areaId": 350505,
			"areaName": "泉港区",
			"longitude": 118.91586000,
			"latitude": 25.12005000
		}, {
			"areaId": 350521,
			"areaName": "惠安县",
			"longitude": 118.79687000,
			"latitude": 25.03059000
		}, {
			"areaId": 350524,
			"areaName": "安溪县",
			"longitude": 118.18719000,
			"latitude": 25.05627000
		}, {
			"areaId": 350525,
			"areaName": "永春县",
			"longitude": 118.29437000,
			"latitude": 25.32183000
		}, {
			"areaId": 350526,
			"areaName": "德化县",
			"longitude": 118.24176000,
			"latitude": 25.49224000
		}, {
			"areaId": 350581,
			"areaName": "石狮市",
			"longitude": 118.64779000,
			"latitude": 24.73242000
		}, {
			"areaId": 350582,
			"areaName": "晋江市",
			"longitude": 118.55194000,
			"latitude": 24.78141000
		}, {
			"areaId": 350583,
			"areaName": "南安市",
			"longitude": 118.38589000,
			"latitude": 24.96055000
		}]
	}, {
		"areaId": 3506,
		"areaName": "漳州市",
		"longitude": 117.66180100,
		"latitude": 24.51089700,
		"children": [{
			"areaId": 350602,
			"areaName": "芗城区",
			"longitude": 117.65402000,
			"latitude": 24.51081000
		}, {
			"areaId": 350603,
			"areaName": "龙文区",
			"longitude": 117.70971000,
			"latitude": 24.50323000
		}, {
			"areaId": 350622,
			"areaName": "云霄县",
			"longitude": 117.34051000,
			"latitude": 23.95534000
		}, {
			"areaId": 350623,
			"areaName": "漳浦县",
			"longitude": 117.61367000,
			"latitude": 24.11706000
		}, {
			"areaId": 350624,
			"areaName": "诏安县",
			"longitude": 117.17501000,
			"latitude": 23.71148000
		}, {
			"areaId": 350625,
			"areaName": "长泰县",
			"longitude": 117.75924000,
			"latitude": 24.62526000
		}, {
			"areaId": 350626,
			"areaName": "东山县",
			"longitude": 117.42822000,
			"latitude": 23.70109000
		}, {
			"areaId": 350627,
			"areaName": "南靖县",
			"longitude": 117.35736000,
			"latitude": 24.51448000
		}, {
			"areaId": 350628,
			"areaName": "平和县",
			"longitude": 117.31240000,
			"latitude": 24.36395000
		}, {
			"areaId": 350629,
			"areaName": "华安县",
			"longitude": 117.54077000,
			"latitude": 25.00563000
		}, {
			"areaId": 350681,
			"areaName": "龙海市",
			"longitude": 117.81802000,
			"latitude": 24.44655000
		}]
	}, {
		"areaId": 3507,
		"areaName": "南平市",
		"longitude": 118.17845900,
		"latitude": 26.63562700,
		"children": [{
			"areaId": 350702,
			"areaName": "延平区",
			"longitude": 121.08449900,
			"latitude": 22.90235800
		}, {
			"areaId": 350703,
			"areaName": "建阳区",
			"longitude": 118.12267000,
			"latitude": 27.33206700
		}, {
			"areaId": 350721,
			"areaName": "顺昌县",
			"longitude": 117.81030000,
			"latitude": 26.79298000
		}, {
			"areaId": 350722,
			"areaName": "浦城县",
			"longitude": 118.54007000,
			"latitude": 27.91888000
		}, {
			"areaId": 350723,
			"areaName": "光泽县",
			"longitude": 117.33346000,
			"latitude": 27.54231000
		}, {
			"areaId": 350724,
			"areaName": "松溪县",
			"longitude": 118.78533000,
			"latitude": 27.52624000
		}, {
			"areaId": 350725,
			"areaName": "政和县",
			"longitude": 118.85571000,
			"latitude": 27.36769000
		}, {
			"areaId": 350781,
			"areaName": "邵武市",
			"longitude": 117.49240000,
			"latitude": 27.34033000
		}, {
			"areaId": 350782,
			"areaName": "武夷山市",
			"longitude": 118.03665000,
			"latitude": 27.75543000
		}, {
			"areaId": 350783,
			"areaName": "建瓯市",
			"longitude": 118.29766000,
			"latitude": 27.02301000
		}]
	}, {
		"areaId": 3508,
		"areaName": "龙岩市",
		"longitude": 117.02978000,
		"latitude": 25.09160300,
		"children": [{
			"areaId": 350802,
			"areaName": "新罗区",
			"longitude": 117.03693000,
			"latitude": 25.09834000
		}, {
			"areaId": 350803,
			"areaName": "永定区",
			"longitude": 110.47464000,
			"latitude": 29.13387000
		}, {
			"areaId": 350821,
			"areaName": "长汀县",
			"longitude": 116.35888000,
			"latitude": 25.82773000
		}, {
			"areaId": 350823,
			"areaName": "上杭县",
			"longitude": 116.42022000,
			"latitude": 25.04943000
		}, {
			"areaId": 350824,
			"areaName": "武平县",
			"longitude": 116.10229000,
			"latitude": 25.09244000
		}, {
			"areaId": 350825,
			"areaName": "连城县",
			"longitude": 116.75454000,
			"latitude": 25.71030000
		}, {
			"areaId": 350881,
			"areaName": "漳平市",
			"longitude": 117.41992000,
			"latitude": 25.29109000
		}]
	}, {
		"areaId": 3509,
		"areaName": "宁德市",
		"longitude": 119.52708200,
		"latitude": 26.65924000,
		"children": [{
			"areaId": 350902,
			"areaName": "蕉城区",
			"longitude": 119.52643000,
			"latitude": 26.66048000
		}, {
			"areaId": 350921,
			"areaName": "霞浦县",
			"longitude": 119.99893000,
			"latitude": 26.88578000
		}, {
			"areaId": 350922,
			"areaName": "古田县",
			"longitude": 118.74688000,
			"latitude": 26.57682000
		}, {
			"areaId": 350923,
			"areaName": "屏南县",
			"longitude": 118.98861000,
			"latitude": 26.91099000
		}, {
			"areaId": 350924,
			"areaName": "寿宁县",
			"longitude": 119.50390000,
			"latitude": 27.45996000
		}, {
			"areaId": 350925,
			"areaName": "周宁县",
			"longitude": 119.33837000,
			"latitude": 27.10664000
		}, {
			"areaId": 350926,
			"areaName": "柘荣县",
			"longitude": 119.89971000,
			"latitude": 27.23543000
		}, {
			"areaId": 350981,
			"areaName": "福安市",
			"longitude": 119.64950000,
			"latitude": 27.08673000
		}, {
			"areaId": 350982,
			"areaName": "福鼎市",
			"longitude": 120.21664000,
			"latitude": 27.32430000
		}]
	}]
}, {
	"areaId": 36,
	"areaName": "江西省",
	"longitude": 115.89215100,
	"latitude": 28.67649300,
	"children": [{
		"areaId": 3601,
		"areaName": "南昌市",
		"longitude": 115.89215100,
		"latitude": 28.67649300,
		"children": [{
			"areaId": 360102,
			"areaName": "东湖区",
			"longitude": 115.89880000,
			"latitude": 28.68505000
		}, {
			"areaId": 360103,
			"areaName": "西湖区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 360104,
			"areaName": "青云谱区",
			"longitude": 115.91500000,
			"latitude": 28.63199000
		}, {
			"areaId": 360111,
			"areaName": "青山湖区",
			"longitude": 115.96170000,
			"latitude": 28.68206000
		}, {
			"areaId": 360112,
			"areaName": "新建区",
			"longitude": 115.81546000,
			"latitude": 28.69248000
		}, {
			"areaId": 360113,
			"areaName": "红谷滩区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 360121,
			"areaName": "南昌县",
			"longitude": 115.94393000,
			"latitude": 28.54559000
		}, {
			"areaId": 360123,
			"areaName": "安义县",
			"longitude": 115.54879000,
			"latitude": 28.84602000
		}, {
			"areaId": 360124,
			"areaName": "进贤县",
			"longitude": 116.24087000,
			"latitude": 28.37679000
		}]
	}, {
		"areaId": 3602,
		"areaName": "景德镇市",
		"longitude": 117.21466400,
		"latitude": 29.29256000,
		"children": [{
			"areaId": 360202,
			"areaName": "昌江区",
			"longitude": 117.18359000,
			"latitude": 29.27321000
		}, {
			"areaId": 360203,
			"areaName": "珠山区",
			"longitude": 117.20233000,
			"latitude": 29.30127000
		}, {
			"areaId": 360222,
			"areaName": "浮梁县",
			"longitude": 117.21517000,
			"latitude": 29.35156000
		}, {
			"areaId": 360281,
			"areaName": "乐平市",
			"longitude": 117.12887000,
			"latitude": 28.96295000
		}]
	}, {
		"areaId": 3603,
		"areaName": "萍乡市",
		"longitude": 113.85218600,
		"latitude": 27.62294600,
		"children": [{
			"areaId": 360302,
			"areaName": "安源区",
			"longitude": 113.89135000,
			"latitude": 27.61653000
		}, {
			"areaId": 360313,
			"areaName": "湘东区",
			"longitude": 113.73294000,
			"latitude": 27.64007000
		}, {
			"areaId": 360321,
			"areaName": "莲花县",
			"longitude": 113.96142000,
			"latitude": 27.12866000
		}, {
			"areaId": 360322,
			"areaName": "上栗县",
			"longitude": 113.79403000,
			"latitude": 27.87467000
		}, {
			"areaId": 360323,
			"areaName": "芦溪县",
			"longitude": 114.02951000,
			"latitude": 27.63063000
		}]
	}, {
		"areaId": 3604,
		"areaName": "九江市",
		"longitude": 115.91128000,
		"latitude": 29.60852000,
		"children": [{
			"areaId": 360402,
			"areaName": "濂溪区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 360403,
			"areaName": "浔阳区",
			"longitude": 115.98986000,
			"latitude": 29.72786000
		}, {
			"areaId": 360404,
			"areaName": "柴桑区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 360423,
			"areaName": "武宁县",
			"longitude": 115.10061000,
			"latitude": 29.25840000
		}, {
			"areaId": 360424,
			"areaName": "修水县",
			"longitude": 114.54684000,
			"latitude": 29.02539000
		}, {
			"areaId": 360425,
			"areaName": "永修县",
			"longitude": 115.80911000,
			"latitude": 29.02093000
		}, {
			"areaId": 360426,
			"areaName": "德安县",
			"longitude": 115.75601000,
			"latitude": 29.31341000
		}, {
			"areaId": 360428,
			"areaName": "都昌县",
			"longitude": 116.20401000,
			"latitude": 29.27327000
		}, {
			"areaId": 360429,
			"areaName": "湖口县",
			"longitude": 121.04369100,
			"latitude": 24.90394300
		}, {
			"areaId": 360430,
			"areaName": "彭泽县",
			"longitude": 116.55011000,
			"latitude": 29.89589000
		}, {
			"areaId": 360481,
			"areaName": "瑞昌市",
			"longitude": 115.66705000,
			"latitude": 29.67183000
		}, {
			"areaId": 360482,
			"areaName": "共青城市",
			"longitude": 115.80193900,
			"latitude": 29.23878500
		}, {
			"areaId": 360483,
			"areaName": "庐山市",
			"longitude": 115.98904000,
			"latitude": 29.67177000
		}]
	}, {
		"areaId": 3605,
		"areaName": "新余市",
		"longitude": 114.93083500,
		"latitude": 27.81083400,
		"children": [{
			"areaId": 360502,
			"areaName": "渝水区",
			"longitude": 114.94400000,
			"latitude": 27.80098000
		}, {
			"areaId": 360521,
			"areaName": "分宜县",
			"longitude": 114.69189000,
			"latitude": 27.81475000
		}]
	}, {
		"areaId": 3606,
		"areaName": "鹰潭市",
		"longitude": 117.03383800,
		"latitude": 28.23863800,
		"children": [{
			"areaId": 360602,
			"areaName": "月湖区",
			"longitude": 117.03732000,
			"latitude": 28.23913000
		}, {
			"areaId": 360603,
			"areaName": "余江区",
			"longitude": 116.81851000,
			"latitude": 28.21034000
		}, {
			"areaId": 360681,
			"areaName": "贵溪市",
			"longitude": 117.24246000,
			"latitude": 28.29260000
		}]
	}, {
		"areaId": 3607,
		"areaName": "赣州市",
		"longitude": 114.94027800,
		"latitude": 25.85097000,
		"children": [{
			"areaId": 360702,
			"areaName": "章贡区",
			"longitude": 114.94284000,
			"latitude": 25.86240000
		}, {
			"areaId": 360703,
			"areaName": "南康区",
			"longitude": 114.75693300,
			"latitude": 25.66172100
		}, {
			"areaId": 360704,
			"areaName": "赣县区",
			"longitude": 115.01171000,
			"latitude": 25.86149000
		}, {
			"areaId": 360722,
			"areaName": "信丰县",
			"longitude": 114.92279000,
			"latitude": 25.38612000
		}, {
			"areaId": 360723,
			"areaName": "大余县",
			"longitude": 114.35757000,
			"latitude": 25.39561000
		}, {
			"areaId": 360724,
			"areaName": "上犹县",
			"longitude": 114.54138000,
			"latitude": 25.79567000
		}, {
			"areaId": 360725,
			"areaName": "崇义县",
			"longitude": 114.30835000,
			"latitude": 25.68186000
		}, {
			"areaId": 360726,
			"areaName": "安远县",
			"longitude": 115.39483000,
			"latitude": 25.13710000
		}, {
			"areaId": 360728,
			"areaName": "定南县",
			"longitude": 115.02713000,
			"latitude": 24.78395000
		}, {
			"areaId": 360729,
			"areaName": "全南县",
			"longitude": 114.52920000,
			"latitude": 24.74324000
		}, {
			"areaId": 360730,
			"areaName": "宁都县",
			"longitude": 116.01565000,
			"latitude": 26.47227000
		}, {
			"areaId": 360731,
			"areaName": "于都县",
			"longitude": 115.41415000,
			"latitude": 25.95257000
		}, {
			"areaId": 360732,
			"areaName": "兴国县",
			"longitude": 115.36309000,
			"latitude": 26.33776000
		}, {
			"areaId": 360733,
			"areaName": "会昌县",
			"longitude": 115.78555000,
			"latitude": 25.60068000
		}, {
			"areaId": 360734,
			"areaName": "寻乌县",
			"longitude": 115.64852000,
			"latitude": 24.95513000
		}, {
			"areaId": 360735,
			"areaName": "石城县",
			"longitude": 116.34420000,
			"latitude": 26.32617000
		}, {
			"areaId": 360781,
			"areaName": "瑞金市",
			"longitude": 116.02703000,
			"latitude": 25.88557000
		}, {
			"areaId": 360783,
			"areaName": "龙南市",
			"longitude": 114.78994000,
			"latitude": 24.91086000
		}]
	}, {
		"areaId": 3608,
		"areaName": "吉安市",
		"longitude": 121.56800500,
		"latitude": 23.96163500,
		"children": [{
			"areaId": 360802,
			"areaName": "吉州区",
			"longitude": 114.97598000,
			"latitude": 27.10669000
		}, {
			"areaId": 360803,
			"areaName": "青原区",
			"longitude": 115.01747000,
			"latitude": 27.10577000
		}, {
			"areaId": 360821,
			"areaName": "吉安县",
			"longitude": 114.90695000,
			"latitude": 27.04048000
		}, {
			"areaId": 360822,
			"areaName": "吉水县",
			"longitude": 115.13430000,
			"latitude": 27.21071000
		}, {
			"areaId": 360823,
			"areaName": "峡江县",
			"longitude": 115.31723000,
			"latitude": 27.57600000
		}, {
			"areaId": 360824,
			"areaName": "新干县",
			"longitude": 115.39306000,
			"latitude": 27.74092000
		}, {
			"areaId": 360825,
			"areaName": "永丰县",
			"longitude": 115.44238000,
			"latitude": 27.31785000
		}, {
			"areaId": 360826,
			"areaName": "泰和县",
			"longitude": 114.90789000,
			"latitude": 26.79113000
		}, {
			"areaId": 360827,
			"areaName": "遂川县",
			"longitude": 114.51629000,
			"latitude": 26.32598000
		}, {
			"areaId": 360828,
			"areaName": "万安县",
			"longitude": 114.78659000,
			"latitude": 26.45931000
		}, {
			"areaId": 360829,
			"areaName": "安福县",
			"longitude": 114.61956000,
			"latitude": 27.39276000
		}, {
			"areaId": 360830,
			"areaName": "永新县",
			"longitude": 114.24246000,
			"latitude": 26.94488000
		}, {
			"areaId": 360881,
			"areaName": "井冈山市",
			"longitude": 120.29582000,
			"latitude": 22.79676200
		}]
	}, {
		"areaId": 3609,
		"areaName": "宜春市",
		"longitude": 114.39113600,
		"latitude": 27.80430000,
		"children": [{
			"areaId": 360902,
			"areaName": "袁州区",
			"longitude": 114.38246000,
			"latitude": 27.79649000
		}, {
			"areaId": 360921,
			"areaName": "奉新县",
			"longitude": 115.40036000,
			"latitude": 28.68790000
		}, {
			"areaId": 360922,
			"areaName": "万载县",
			"longitude": 114.44580000,
			"latitude": 28.10656000
		}, {
			"areaId": 360923,
			"areaName": "上高县",
			"longitude": 114.92459000,
			"latitude": 28.23423000
		}, {
			"areaId": 360924,
			"areaName": "宜丰县",
			"longitude": 114.78030000,
			"latitude": 28.38555000
		}, {
			"areaId": 360925,
			"areaName": "靖安县",
			"longitude": 115.36279000,
			"latitude": 28.86167000
		}, {
			"areaId": 360926,
			"areaName": "铜鼓县",
			"longitude": 114.37036000,
			"latitude": 28.52311000
		}, {
			"areaId": 360981,
			"areaName": "丰城市",
			"longitude": 115.77114000,
			"latitude": 28.15918000
		}, {
			"areaId": 360982,
			"areaName": "樟树市",
			"longitude": 115.54650000,
			"latitude": 28.05332000
		}, {
			"areaId": 360983,
			"areaName": "高安市",
			"longitude": 115.37530000,
			"latitude": 28.41780000
		}]
	}, {
		"areaId": 3610,
		"areaName": "抚州市",
		"longitude": 116.35835100,
		"latitude": 27.98385000,
		"children": [{
			"areaId": 361002,
			"areaName": "临川区",
			"longitude": 116.35919000,
			"latitude": 27.97721000
		}, {
			"areaId": 361003,
			"areaName": "东乡区",
			"longitude": 116.59039000,
			"latitude": 28.23614000
		}, {
			"areaId": 361021,
			"areaName": "南城县",
			"longitude": 116.64419000,
			"latitude": 27.55381000
		}, {
			"areaId": 361022,
			"areaName": "黎川县",
			"longitude": 116.90771000,
			"latitude": 27.28232000
		}, {
			"areaId": 361023,
			"areaName": "南丰县",
			"longitude": 116.52560000,
			"latitude": 27.21842000
		}, {
			"areaId": 361024,
			"areaName": "崇仁县",
			"longitude": 116.06021000,
			"latitude": 27.75962000
		}, {
			"areaId": 361025,
			"areaName": "乐安县",
			"longitude": 115.83108000,
			"latitude": 27.42812000
		}, {
			"areaId": 361026,
			"areaName": "宜黄县",
			"longitude": 116.23626000,
			"latitude": 27.55487000
		}, {
			"areaId": 361027,
			"areaName": "金溪县",
			"longitude": 116.77392000,
			"latitude": 27.90753000
		}, {
			"areaId": 361028,
			"areaName": "资溪县",
			"longitude": 117.06939000,
			"latitude": 27.70493000
		}, {
			"areaId": 361030,
			"areaName": "广昌县",
			"longitude": 116.32547000,
			"latitude": 26.83410000
		}]
	}, {
		"areaId": 3611,
		"areaName": "上饶市",
		"longitude": 117.90884000,
		"latitude": 28.44856000,
		"children": [{
			"areaId": 361102,
			"areaName": "信州区",
			"longitude": 117.96682000,
			"latitude": 28.43121000
		}, {
			"areaId": 361103,
			"areaName": "广丰区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 361104,
			"areaName": "广信区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 361123,
			"areaName": "玉山县",
			"longitude": 118.24462000,
			"latitude": 28.68180000
		}, {
			"areaId": 361124,
			"areaName": "铅山县",
			"longitude": 117.70996000,
			"latitude": 28.31549000
		}, {
			"areaId": 361125,
			"areaName": "横峰县",
			"longitude": 117.59640000,
			"latitude": 28.40716000
		}, {
			"areaId": 361126,
			"areaName": "弋阳县",
			"longitude": 117.45929000,
			"latitude": 28.37451000
		}, {
			"areaId": 361127,
			"areaName": "余干县",
			"longitude": 116.69555000,
			"latitude": 28.70206000
		}, {
			"areaId": 361128,
			"areaName": "鄱阳县",
			"longitude": 116.69967000,
			"latitude": 29.01180000
		}, {
			"areaId": 361129,
			"areaName": "万年县",
			"longitude": 117.06884000,
			"latitude": 28.69537000
		}, {
			"areaId": 361130,
			"areaName": "婺源县",
			"longitude": 117.86105000,
			"latitude": 29.24841000
		}, {
			"areaId": 361181,
			"areaName": "德兴市",
			"longitude": 117.57919000,
			"latitude": 28.94736000
		}]
	}]
}, {
	"areaId": 37,
	"areaName": "山东省",
	"longitude": 117.00092300,
	"latitude": 36.67580700,
	"children": [{
		"areaId": 3701,
		"areaName": "济南市",
		"longitude": 117.00092300,
		"latitude": 36.67580700,
		"children": [{
			"areaId": 370102,
			"areaName": "历下区",
			"longitude": 117.07680000,
			"latitude": 36.66661000
		}, {
			"areaId": 370103,
			"areaName": "市中区",
			"longitude": 103.76159000,
			"latitude": 29.55543000
		}, {
			"areaId": 370104,
			"areaName": "槐荫区",
			"longitude": 116.90075000,
			"latitude": 36.65136000
		}, {
			"areaId": 370105,
			"areaName": "天桥区",
			"longitude": 116.98749000,
			"latitude": 36.67801000
		}, {
			"areaId": 370112,
			"areaName": "历城区",
			"longitude": 117.06509000,
			"latitude": 36.67995000
		}, {
			"areaId": 370113,
			"areaName": "长清区",
			"longitude": 116.75192000,
			"latitude": 36.55352000
		}, {
			"areaId": 370114,
			"areaName": "章丘区",
			"longitude": 117.53677000,
			"latitude": 36.71392000
		}, {
			"areaId": 370115,
			"areaName": "济阳区",
			"longitude": 117.17327000,
			"latitude": 36.97845000
		}, {
			"areaId": 370116,
			"areaName": "莱芜区",
			"longitude": 117.67773600,
			"latitude": 36.21439700
		}, {
			"areaId": 370117,
			"areaName": "钢城区",
			"longitude": 117.80490000,
			"latitude": 36.06319000
		}, {
			"areaId": 370124,
			"areaName": "平阴县",
			"longitude": 116.45587000,
			"latitude": 36.28955000
		}, {
			"areaId": 370126,
			"areaName": "商河县",
			"longitude": 117.15722000,
			"latitude": 37.31119000
		}, {
			"areaId": 370171,
			"areaName": "济南高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 3702,
		"areaName": "青岛市",
		"longitude": 120.36955700,
		"latitude": 36.09440600,
		"children": [{
			"areaId": 370202,
			"areaName": "市南区",
			"longitude": 120.38773000,
			"latitude": 36.06671000
		}, {
			"areaId": 370203,
			"areaName": "市北区",
			"longitude": 120.37469000,
			"latitude": 36.08734000
		}, {
			"areaId": 370211,
			"areaName": "黄岛区",
			"longitude": 120.19775000,
			"latitude": 35.96065000
		}, {
			"areaId": 370212,
			"areaName": "崂山区",
			"longitude": 120.46923000,
			"latitude": 36.10717000
		}, {
			"areaId": 370213,
			"areaName": "李沧区",
			"longitude": 120.43286000,
			"latitude": 36.14502000
		}, {
			"areaId": 370214,
			"areaName": "城阳区",
			"longitude": 120.39621000,
			"latitude": 36.30735000
		}, {
			"areaId": 370215,
			"areaName": "即墨区",
			"longitude": 120.44699000,
			"latitude": 36.38907000
		}, {
			"areaId": 370271,
			"areaName": "青岛高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 370281,
			"areaName": "胶州市",
			"longitude": 120.03350000,
			"latitude": 36.26442000
		}, {
			"areaId": 370283,
			"areaName": "平度市",
			"longitude": 119.95996000,
			"latitude": 36.78688000
		}, {
			"areaId": 370285,
			"areaName": "莱西市",
			"longitude": 120.51773000,
			"latitude": 36.88804000
		}]
	}, {
		"areaId": 3703,
		"areaName": "淄博市",
		"longitude": 118.04764800,
		"latitude": 36.81493900,
		"children": [{
			"areaId": 370302,
			"areaName": "淄川区",
			"longitude": 117.96655000,
			"latitude": 36.64339000
		}, {
			"areaId": 370303,
			"areaName": "张店区",
			"longitude": 118.01788000,
			"latitude": 36.80676000
		}, {
			"areaId": 370304,
			"areaName": "博山区",
			"longitude": 117.86166000,
			"latitude": 36.49469000
		}, {
			"areaId": 370305,
			"areaName": "临淄区",
			"longitude": 118.30966000,
			"latitude": 36.82590000
		}, {
			"areaId": 370306,
			"areaName": "周村区",
			"longitude": 117.86969000,
			"latitude": 36.80322000
		}, {
			"areaId": 370321,
			"areaName": "桓台县",
			"longitude": 118.09698000,
			"latitude": 36.96036000
		}, {
			"areaId": 370322,
			"areaName": "高青县",
			"longitude": 117.82708000,
			"latitude": 37.17197000
		}, {
			"areaId": 370323,
			"areaName": "沂源县",
			"longitude": 118.17105000,
			"latitude": 36.18536000
		}]
	}, {
		"areaId": 3704,
		"areaName": "枣庄市",
		"longitude": 117.55796400,
		"latitude": 34.85642400,
		"children": [{
			"areaId": 370402,
			"areaName": "市中区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 370403,
			"areaName": "薛城区",
			"longitude": 117.26318000,
			"latitude": 34.79498000
		}, {
			"areaId": 370404,
			"areaName": "峄城区",
			"longitude": 117.59057000,
			"latitude": 34.77225000
		}, {
			"areaId": 370405,
			"areaName": "台儿庄区",
			"longitude": 117.73452000,
			"latitude": 34.56363000
		}, {
			"areaId": 370406,
			"areaName": "山亭区",
			"longitude": 117.46630000,
			"latitude": 35.09541000
		}, {
			"areaId": 370481,
			"areaName": "滕州市",
			"longitude": 117.16500000,
			"latitude": 35.10534000
		}]
	}, {
		"areaId": 3705,
		"areaName": "东营市",
		"longitude": 118.49630000,
		"latitude": 37.46126600,
		"children": [{
			"areaId": 370502,
			"areaName": "东营区",
			"longitude": 118.58160000,
			"latitude": 37.44875000
		}, {
			"areaId": 370503,
			"areaName": "河口区",
			"longitude": 118.52490000,
			"latitude": 37.88541000
		}, {
			"areaId": 370505,
			"areaName": "垦利区",
			"longitude": 118.54815000,
			"latitude": 37.58825000
		}, {
			"areaId": 370522,
			"areaName": "利津县",
			"longitude": 118.25637000,
			"latitude": 37.49157000
		}, {
			"areaId": 370523,
			"areaName": "广饶县",
			"longitude": 118.40704000,
			"latitude": 37.05381000
		}, {
			"areaId": 370571,
			"areaName": "东营经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 370572,
			"areaName": "东营港经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 3706,
		"areaName": "烟台市",
		"longitude": 121.39138200,
		"latitude": 37.53929700,
		"children": [{
			"areaId": 370602,
			"areaName": "芝罘区",
			"longitude": 121.40023000,
			"latitude": 37.54064000
		}, {
			"areaId": 370611,
			"areaName": "福山区",
			"longitude": 121.26812000,
			"latitude": 37.49841000
		}, {
			"areaId": 370612,
			"areaName": "牟平区",
			"longitude": 121.60067000,
			"latitude": 37.38846000
		}, {
			"areaId": 370613,
			"areaName": "莱山区",
			"longitude": 121.44512000,
			"latitude": 37.51165000
		}, {
			"areaId": 370614,
			"areaName": "蓬莱区",
			"longitude": 120.75988000,
			"latitude": 37.81119000
		}, {
			"areaId": 370671,
			"areaName": "烟台高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 370672,
			"areaName": "烟台经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 370681,
			"areaName": "龙口市",
			"longitude": 120.50634000,
			"latitude": 37.64064000
		}, {
			"areaId": 370682,
			"areaName": "莱阳市",
			"longitude": 120.71066000,
			"latitude": 36.98012000
		}, {
			"areaId": 370683,
			"areaName": "莱州市",
			"longitude": 119.94137000,
			"latitude": 37.17806000
		}, {
			"areaId": 370685,
			"areaName": "招远市",
			"longitude": 120.40481000,
			"latitude": 37.36269000
		}, {
			"areaId": 370686,
			"areaName": "栖霞市",
			"longitude": 120.85025000,
			"latitude": 37.33571000
		}, {
			"areaId": 370687,
			"areaName": "海阳市",
			"longitude": 121.15976000,
			"latitude": 36.77622000
		}]
	}, {
		"areaId": 3707,
		"areaName": "潍坊市",
		"longitude": 119.10707800,
		"latitude": 36.70925000,
		"children": [{
			"areaId": 370702,
			"areaName": "潍城区",
			"longitude": 119.10582000,
			"latitude": 36.71390000
		}, {
			"areaId": 370703,
			"areaName": "寒亭区",
			"longitude": 119.21832000,
			"latitude": 36.77504000
		}, {
			"areaId": 370704,
			"areaName": "坊子区",
			"longitude": 119.16476000,
			"latitude": 36.65218000
		}, {
			"areaId": 370705,
			"areaName": "奎文区",
			"longitude": 119.12532000,
			"latitude": 36.70723000
		}, {
			"areaId": 370724,
			"areaName": "临朐县",
			"longitude": 118.54400000,
			"latitude": 36.51216000
		}, {
			"areaId": 370725,
			"areaName": "昌乐县",
			"longitude": 118.83017000,
			"latitude": 36.70780000
		}, {
			"areaId": 370772,
			"areaName": "潍坊滨海经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 370781,
			"areaName": "青州市",
			"longitude": 118.47915000,
			"latitude": 36.68505000
		}, {
			"areaId": 370782,
			"areaName": "诸城市",
			"longitude": 119.40988000,
			"latitude": 35.99662000
		}, {
			"areaId": 370783,
			"areaName": "寿光市",
			"longitude": 118.74047000,
			"latitude": 36.88128000
		}, {
			"areaId": 370784,
			"areaName": "安丘市",
			"longitude": 119.21890000,
			"latitude": 36.47847000
		}, {
			"areaId": 370785,
			"areaName": "高密市",
			"longitude": 119.75701000,
			"latitude": 36.38397000
		}, {
			"areaId": 370786,
			"areaName": "昌邑市",
			"longitude": 119.39767000,
			"latitude": 36.86008000
		}]
	}, {
		"areaId": 3708,
		"areaName": "济宁市",
		"longitude": 116.58724500,
		"latitude": 35.41539300,
		"children": [{
			"areaId": 370811,
			"areaName": "任城区",
			"longitude": 116.59504000,
			"latitude": 35.40659000
		}, {
			"areaId": 370812,
			"areaName": "兖州区",
			"longitude": 116.82654600,
			"latitude": 35.55230500
		}, {
			"areaId": 370826,
			"areaName": "微山县",
			"longitude": 117.12875000,
			"latitude": 34.80712000
		}, {
			"areaId": 370827,
			"areaName": "鱼台县",
			"longitude": 116.64761000,
			"latitude": 34.99674000
		}, {
			"areaId": 370828,
			"areaName": "金乡县",
			"longitude": 116.31146000,
			"latitude": 35.06500000
		}, {
			"areaId": 370829,
			"areaName": "嘉祥县",
			"longitude": 116.34249000,
			"latitude": 35.40836000
		}, {
			"areaId": 370830,
			"areaName": "汶上县",
			"longitude": 116.48742000,
			"latitude": 35.73295000
		}, {
			"areaId": 370831,
			"areaName": "泗水县",
			"longitude": 117.27948000,
			"latitude": 35.66113000
		}, {
			"areaId": 370832,
			"areaName": "梁山县",
			"longitude": 116.09683000,
			"latitude": 35.80322000
		}, {
			"areaId": 370871,
			"areaName": "济宁高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 370881,
			"areaName": "曲阜市",
			"longitude": 116.98645000,
			"latitude": 35.58091000
		}, {
			"areaId": 370883,
			"areaName": "邹城市",
			"longitude": 116.97335000,
			"latitude": 35.40531000
		}]
	}, {
		"areaId": 3709,
		"areaName": "泰安市",
		"longitude": 120.90444100,
		"latitude": 24.44260000,
		"children": [{
			"areaId": 370902,
			"areaName": "泰山区",
			"longitude": 121.43081100,
			"latitude": 25.05886400
		}, {
			"areaId": 370911,
			"areaName": "岱岳区",
			"longitude": 117.04174000,
			"latitude": 36.18750000
		}, {
			"areaId": 370921,
			"areaName": "宁阳县",
			"longitude": 116.80542000,
			"latitude": 35.75990000
		}, {
			"areaId": 370923,
			"areaName": "东平县",
			"longitude": 116.47113000,
			"latitude": 35.93792000
		}, {
			"areaId": 370982,
			"areaName": "新泰市",
			"longitude": 117.76959000,
			"latitude": 35.90887000
		}, {
			"areaId": 370983,
			"areaName": "肥城市",
			"longitude": 116.76815000,
			"latitude": 36.18247000
		}]
	}, {
		"areaId": 3710,
		"areaName": "威海市",
		"longitude": 122.11639400,
		"latitude": 37.50969100,
		"children": [{
			"areaId": 371002,
			"areaName": "环翠区",
			"longitude": 122.12344000,
			"latitude": 37.50199000
		}, {
			"areaId": 371003,
			"areaName": "文登区",
			"longitude": 122.05713900,
			"latitude": 37.19621100
		}, {
			"areaId": 371071,
			"areaName": "威海火炬高技术产业开发区",
			"longitude": 113.48052300,
			"latitude": 22.56608200
		}, {
			"areaId": 371072,
			"areaName": "威海经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 371073,
			"areaName": "威海临港经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 371082,
			"areaName": "荣成市",
			"longitude": 122.48773000,
			"latitude": 37.16520000
		}, {
			"areaId": 371083,
			"areaName": "乳山市",
			"longitude": 121.53814000,
			"latitude": 36.91918000
		}]
	}, {
		"areaId": 3711,
		"areaName": "日照市",
		"longitude": 119.46120800,
		"latitude": 35.42858800,
		"children": [{
			"areaId": 371102,
			"areaName": "东港区",
			"longitude": 119.46237000,
			"latitude": 35.42541000
		}, {
			"areaId": 371103,
			"areaName": "岚山区",
			"longitude": 119.31884000,
			"latitude": 35.12203000
		}, {
			"areaId": 371121,
			"areaName": "五莲县",
			"longitude": 119.20700000,
			"latitude": 35.75004000
		}, {
			"areaId": 371122,
			"areaName": "莒县",
			"longitude": 118.83789000,
			"latitude": 35.58054000
		}, {
			"areaId": 371171,
			"areaName": "日照经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 3713,
		"areaName": "临沂市",
		"longitude": 118.32644300,
		"latitude": 35.06528200,
		"children": [{
			"areaId": 371302,
			"areaName": "兰山区",
			"longitude": 118.34817000,
			"latitude": 35.06872000
		}, {
			"areaId": 371311,
			"areaName": "罗庄区",
			"longitude": 118.28466000,
			"latitude": 34.99627000
		}, {
			"areaId": 371312,
			"areaName": "河东区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 371321,
			"areaName": "沂南县",
			"longitude": 118.47061000,
			"latitude": 35.55131000
		}, {
			"areaId": 371322,
			"areaName": "郯城县",
			"longitude": 118.36712000,
			"latitude": 34.61354000
		}, {
			"areaId": 371323,
			"areaName": "沂水县",
			"longitude": 118.63009000,
			"latitude": 35.78731000
		}, {
			"areaId": 371324,
			"areaName": "兰陵县",
			"longitude": 117.85659200,
			"latitude": 34.73831500
		}, {
			"areaId": 371325,
			"areaName": "费县",
			"longitude": 117.97836000,
			"latitude": 35.26562000
		}, {
			"areaId": 371326,
			"areaName": "平邑县",
			"longitude": 117.63867000,
			"latitude": 35.50573000
		}, {
			"areaId": 371327,
			"areaName": "莒南县",
			"longitude": 118.83227000,
			"latitude": 35.17539000
		}, {
			"areaId": 371328,
			"areaName": "蒙阴县",
			"longitude": 117.94592000,
			"latitude": 35.70996000
		}, {
			"areaId": 371329,
			"areaName": "临沭县",
			"longitude": 118.65267000,
			"latitude": 34.92091000
		}, {
			"areaId": 371371,
			"areaName": "临沂高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 3714,
		"areaName": "德州市",
		"longitude": 116.30742800,
		"latitude": 37.45396800,
		"children": [{
			"areaId": 371402,
			"areaName": "德城区",
			"longitude": 116.29943000,
			"latitude": 37.45126000
		}, {
			"areaId": 371403,
			"areaName": "陵城区",
			"longitude": 116.57601000,
			"latitude": 37.33571000
		}, {
			"areaId": 371422,
			"areaName": "宁津县",
			"longitude": 116.79702000,
			"latitude": 37.65301000
		}, {
			"areaId": 371423,
			"areaName": "庆云县",
			"longitude": 117.38635000,
			"latitude": 37.77616000
		}, {
			"areaId": 371424,
			"areaName": "临邑县",
			"longitude": 116.86547000,
			"latitude": 37.19053000
		}, {
			"areaId": 371425,
			"areaName": "齐河县",
			"longitude": 116.75515000,
			"latitude": 36.79532000
		}, {
			"areaId": 371426,
			"areaName": "平原县",
			"longitude": 116.43432000,
			"latitude": 37.16632000
		}, {
			"areaId": 371427,
			"areaName": "夏津县",
			"longitude": 116.00170000,
			"latitude": 36.94852000
		}, {
			"areaId": 371428,
			"areaName": "武城县",
			"longitude": 116.07009000,
			"latitude": 37.21403000
		}, {
			"areaId": 371471,
			"areaName": "德州经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 371472,
			"areaName": "德州运河经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 371481,
			"areaName": "乐陵市",
			"longitude": 117.23141000,
			"latitude": 37.73164000
		}, {
			"areaId": 371482,
			"areaName": "禹城市",
			"longitude": 116.64309000,
			"latitude": 36.93444000
		}]
	}, {
		"areaId": 3715,
		"areaName": "聊城市",
		"longitude": 115.98036700,
		"latitude": 36.45601300,
		"children": [{
			"areaId": 371502,
			"areaName": "东昌府区",
			"longitude": 115.97383000,
			"latitude": 36.44458000
		}, {
			"areaId": 371503,
			"areaName": "茌平区",
			"longitude": 116.25491000,
			"latitude": 36.57969000
		}, {
			"areaId": 371521,
			"areaName": "阳谷县",
			"longitude": 115.79126000,
			"latitude": 36.11444000
		}, {
			"areaId": 371522,
			"areaName": "莘县",
			"longitude": 115.66970000,
			"latitude": 36.23423000
		}, {
			"areaId": 371524,
			"areaName": "东阿县",
			"longitude": 116.25012000,
			"latitude": 36.33209000
		}, {
			"areaId": 371525,
			"areaName": "冠县",
			"longitude": 115.44195000,
			"latitude": 36.48429000
		}, {
			"areaId": 371526,
			"areaName": "高唐县",
			"longitude": 116.23172000,
			"latitude": 36.86535000
		}, {
			"areaId": 371581,
			"areaName": "临清市",
			"longitude": 115.70629000,
			"latitude": 36.83945000
		}]
	}, {
		"areaId": 3716,
		"areaName": "滨州市",
		"longitude": 118.01697400,
		"latitude": 37.38354200,
		"children": [{
			"areaId": 371602,
			"areaName": "滨城区",
			"longitude": 118.02026000,
			"latitude": 37.38524000
		}, {
			"areaId": 371603,
			"areaName": "沾化区",
			"longitude": 118.13214000,
			"latitude": 37.69832000
		}, {
			"areaId": 371621,
			"areaName": "惠民县",
			"longitude": 117.51113000,
			"latitude": 37.49013000
		}, {
			"areaId": 371622,
			"areaName": "阳信县",
			"longitude": 117.58139000,
			"latitude": 37.64198000
		}, {
			"areaId": 371623,
			"areaName": "无棣县",
			"longitude": 117.61395000,
			"latitude": 37.74009000
		}, {
			"areaId": 371625,
			"areaName": "博兴县",
			"longitude": 118.13360000,
			"latitude": 37.14316000
		}, {
			"areaId": 371681,
			"areaName": "邹平市",
			"longitude": 117.74307000,
			"latitude": 36.86295000
		}]
	}, {
		"areaId": 3717,
		"areaName": "菏泽市",
		"longitude": 115.46938100,
		"latitude": 35.24653100,
		"children": [{
			"areaId": 371702,
			"areaName": "牡丹区",
			"longitude": 115.41662000,
			"latitude": 35.25091000
		}, {
			"areaId": 371703,
			"areaName": "定陶区",
			"longitude": 115.57287000,
			"latitude": 35.07118000
		}, {
			"areaId": 371721,
			"areaName": "曹县",
			"longitude": 115.54226000,
			"latitude": 34.82659000
		}, {
			"areaId": 371722,
			"areaName": "单县",
			"longitude": 116.08703000,
			"latitude": 34.79514000
		}, {
			"areaId": 371723,
			"areaName": "成武县",
			"longitude": 115.88970000,
			"latitude": 34.95332000
		}, {
			"areaId": 371724,
			"areaName": "巨野县",
			"longitude": 116.09497000,
			"latitude": 35.39788000
		}, {
			"areaId": 371725,
			"areaName": "郓城县",
			"longitude": 115.94439000,
			"latitude": 35.60044000
		}, {
			"areaId": 371726,
			"areaName": "鄄城县",
			"longitude": 115.50997000,
			"latitude": 35.56412000
		}, {
			"areaId": 371728,
			"areaName": "东明县",
			"longitude": 115.09079000,
			"latitude": 35.28906000
		}, {
			"areaId": 371771,
			"areaName": "菏泽经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 371772,
			"areaName": "菏泽高新技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}]
}, {
	"areaId": 41,
	"areaName": "河南省",
	"longitude": 113.66541200,
	"latitude": 34.75797500,
	"children": [{
		"areaId": 4101,
		"areaName": "郑州市",
		"longitude": 113.66541200,
		"latitude": 34.75797500,
		"children": [{
			"areaId": 410102,
			"areaName": "中原区",
			"longitude": 113.61333000,
			"latitude": 34.74827000
		}, {
			"areaId": 410103,
			"areaName": "二七区",
			"longitude": 113.63931000,
			"latitude": 34.72336000
		}, {
			"areaId": 410104,
			"areaName": "管城回族区",
			"longitude": 113.67734000,
			"latitude": 34.75383000
		}, {
			"areaId": 410105,
			"areaName": "金水区",
			"longitude": 113.66057000,
			"latitude": 34.80028000
		}, {
			"areaId": 410106,
			"areaName": "上街区",
			"longitude": 113.30897000,
			"latitude": 34.80276000
		}, {
			"areaId": 410108,
			"areaName": "惠济区",
			"longitude": 113.61688000,
			"latitude": 34.86735000
		}, {
			"areaId": 410122,
			"areaName": "中牟县",
			"longitude": 113.97619000,
			"latitude": 34.71899000
		}, {
			"areaId": 410171,
			"areaName": "郑州经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410172,
			"areaName": "郑州高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410173,
			"areaName": "郑州航空港经济综合实验区",
			"longitude": 108.76052900,
			"latitude": 34.44089400
		}, {
			"areaId": 410181,
			"areaName": "巩义市",
			"longitude": 113.02200000,
			"latitude": 34.74794000
		}, {
			"areaId": 410182,
			"areaName": "荥阳市",
			"longitude": 113.38345000,
			"latitude": 34.78759000
		}, {
			"areaId": 410183,
			"areaName": "新密市",
			"longitude": 113.38690000,
			"latitude": 34.53704000
		}, {
			"areaId": 410184,
			"areaName": "新郑市",
			"longitude": 113.73645000,
			"latitude": 34.39550000
		}, {
			"areaId": 410185,
			"areaName": "登封市",
			"longitude": 113.05023000,
			"latitude": 34.45345000
		}]
	}, {
		"areaId": 4102,
		"areaName": "开封市",
		"longitude": 114.34144700,
		"latitude": 34.79704900,
		"children": [{
			"areaId": 410202,
			"areaName": "龙亭区",
			"longitude": 114.35484000,
			"latitude": 34.79995000
		}, {
			"areaId": 410203,
			"areaName": "顺河回族区",
			"longitude": 114.36123000,
			"latitude": 34.79586000
		}, {
			"areaId": 410204,
			"areaName": "鼓楼区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410205,
			"areaName": "禹王台区",
			"longitude": 114.34787000,
			"latitude": 34.77693000
		}, {
			"areaId": 410212,
			"areaName": "祥符区",
			"longitude": 114.43859000,
			"latitude": 34.75874000
		}, {
			"areaId": 410221,
			"areaName": "杞县",
			"longitude": 114.78280000,
			"latitude": 34.55033000
		}, {
			"areaId": 410222,
			"areaName": "通许县",
			"longitude": 114.46716000,
			"latitude": 34.47522000
		}, {
			"areaId": 410223,
			"areaName": "尉氏县",
			"longitude": 114.19284000,
			"latitude": 34.41223000
		}, {
			"areaId": 410225,
			"areaName": "兰考县",
			"longitude": 114.81961000,
			"latitude": 34.82350000
		}]
	}, {
		"areaId": 4103,
		"areaName": "洛阳市",
		"longitude": 112.43446800,
		"latitude": 34.66304100,
		"children": [{
			"areaId": 410302,
			"areaName": "老城区",
			"longitude": 112.46902000,
			"latitude": 34.68364000
		}, {
			"areaId": 410303,
			"areaName": "西工区",
			"longitude": 112.43710000,
			"latitude": 34.67000000
		}, {
			"areaId": 410304,
			"areaName": "瀍河回族区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410305,
			"areaName": "涧西区",
			"longitude": 112.39588000,
			"latitude": 34.65823000
		}, {
			"areaId": 410306,
			"areaName": "吉利区",
			"longitude": 112.58905000,
			"latitude": 34.90088000
		}, {
			"areaId": 410311,
			"areaName": "洛龙区",
			"longitude": 112.46412000,
			"latitude": 34.61866000
		}, {
			"areaId": 410322,
			"areaName": "孟津县",
			"longitude": 112.44351000,
			"latitude": 34.82600000
		}, {
			"areaId": 410323,
			"areaName": "新安县",
			"longitude": 112.13238000,
			"latitude": 34.72814000
		}, {
			"areaId": 410324,
			"areaName": "栾川县",
			"longitude": 111.61779000,
			"latitude": 33.78576000
		}, {
			"areaId": 410325,
			"areaName": "嵩县",
			"longitude": 112.08526000,
			"latitude": 34.13466000
		}, {
			"areaId": 410326,
			"areaName": "汝阳县",
			"longitude": 112.47314000,
			"latitude": 34.15387000
		}, {
			"areaId": 410327,
			"areaName": "宜阳县",
			"longitude": 112.17907000,
			"latitude": 34.51523000
		}, {
			"areaId": 410328,
			"areaName": "洛宁县",
			"longitude": 111.65087000,
			"latitude": 34.38913000
		}, {
			"areaId": 410329,
			"areaName": "伊川县",
			"longitude": 112.42947000,
			"latitude": 34.42205000
		}, {
			"areaId": 410371,
			"areaName": "洛阳高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410381,
			"areaName": "偃师市",
			"longitude": 112.79220000,
			"latitude": 34.72810000
		}]
	}, {
		"areaId": 4104,
		"areaName": "平顶山市",
		"longitude": 113.30771800,
		"latitude": 33.73524100,
		"children": [{
			"areaId": 410402,
			"areaName": "新华区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410403,
			"areaName": "卫东区",
			"longitude": 113.33511000,
			"latitude": 33.73472000
		}, {
			"areaId": 410404,
			"areaName": "石龙区",
			"longitude": 113.87638100,
			"latitude": 23.10744400
		}, {
			"areaId": 410411,
			"areaName": "湛河区",
			"longitude": 113.29252000,
			"latitude": 33.73620000
		}, {
			"areaId": 410421,
			"areaName": "宝丰县",
			"longitude": 113.05493000,
			"latitude": 33.86916000
		}, {
			"areaId": 410422,
			"areaName": "叶县",
			"longitude": 113.35104000,
			"latitude": 33.62225000
		}, {
			"areaId": 410423,
			"areaName": "鲁山县",
			"longitude": 112.90570000,
			"latitude": 33.73879000
		}, {
			"areaId": 410425,
			"areaName": "郏县",
			"longitude": 113.21588000,
			"latitude": 33.97072000
		}, {
			"areaId": 410471,
			"areaName": "平顶山高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410472,
			"areaName": "平顶山市城乡一体化示范区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410481,
			"areaName": "舞钢市",
			"longitude": 113.52417000,
			"latitude": 33.29380000
		}, {
			"areaId": 410482,
			"areaName": "汝州市",
			"longitude": 112.84301000,
			"latitude": 34.16135000
		}]
	}, {
		"areaId": 4105,
		"areaName": "安阳市",
		"longitude": 114.35248200,
		"latitude": 36.10344200,
		"children": [{
			"areaId": 410502,
			"areaName": "文峰区",
			"longitude": 114.35708000,
			"latitude": 36.09046000
		}, {
			"areaId": 410503,
			"areaName": "北关区",
			"longitude": 114.35735000,
			"latitude": 36.11872000
		}, {
			"areaId": 410505,
			"areaName": "殷都区",
			"longitude": 114.30340000,
			"latitude": 36.10990000
		}, {
			"areaId": 410506,
			"areaName": "龙安区",
			"longitude": 114.34814000,
			"latitude": 36.11904000
		}, {
			"areaId": 410522,
			"areaName": "安阳县",
			"longitude": 114.36605000,
			"latitude": 36.06695000
		}, {
			"areaId": 410523,
			"areaName": "汤阴县",
			"longitude": 114.35839000,
			"latitude": 35.92152000
		}, {
			"areaId": 410526,
			"areaName": "滑县",
			"longitude": 114.52066000,
			"latitude": 35.58070000
		}, {
			"areaId": 410527,
			"areaName": "内黄县",
			"longitude": 114.90673000,
			"latitude": 35.95269000
		}, {
			"areaId": 410571,
			"areaName": "安阳高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410581,
			"areaName": "林州市",
			"longitude": 113.81558000,
			"latitude": 36.07804000
		}]
	}, {
		"areaId": 4106,
		"areaName": "鹤壁市",
		"longitude": 114.29544400,
		"latitude": 35.74823600,
		"children": [{
			"areaId": 410602,
			"areaName": "鹤山区",
			"longitude": 114.16336000,
			"latitude": 35.95458000
		}, {
			"areaId": 410603,
			"areaName": "山城区",
			"longitude": 114.18443000,
			"latitude": 35.89773000
		}, {
			"areaId": 410611,
			"areaName": "淇滨区",
			"longitude": 114.29867000,
			"latitude": 35.74127000
		}, {
			"areaId": 410621,
			"areaName": "浚县",
			"longitude": 114.54879000,
			"latitude": 35.67085000
		}, {
			"areaId": 410622,
			"areaName": "淇县",
			"longitude": 114.19760000,
			"latitude": 35.60782000
		}, {
			"areaId": 410671,
			"areaName": "鹤壁经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 4107,
		"areaName": "新乡市",
		"longitude": 113.88399100,
		"latitude": 35.30261600,
		"children": [{
			"areaId": 410702,
			"areaName": "红旗区",
			"longitude": 113.87523000,
			"latitude": 35.30367000
		}, {
			"areaId": 410703,
			"areaName": "卫滨区",
			"longitude": 113.86578000,
			"latitude": 35.30211000
		}, {
			"areaId": 410704,
			"areaName": "凤泉区",
			"longitude": 113.91507000,
			"latitude": 35.38399000
		}, {
			"areaId": 410711,
			"areaName": "牧野区",
			"longitude": 113.90860000,
			"latitude": 35.31490000
		}, {
			"areaId": 410721,
			"areaName": "新乡县",
			"longitude": 113.80511000,
			"latitude": 35.19075000
		}, {
			"areaId": 410724,
			"areaName": "获嘉县",
			"longitude": 113.66159000,
			"latitude": 35.26521000
		}, {
			"areaId": 410725,
			"areaName": "原阳县",
			"longitude": 113.93994000,
			"latitude": 35.06565000
		}, {
			"areaId": 410726,
			"areaName": "延津县",
			"longitude": 114.20266000,
			"latitude": 35.14327000
		}, {
			"areaId": 410727,
			"areaName": "封丘县",
			"longitude": 114.41915000,
			"latitude": 35.04166000
		}, {
			"areaId": 410771,
			"areaName": "新乡高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410772,
			"areaName": "新乡经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410773,
			"areaName": "新乡市平原城乡一体化示范区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410781,
			"areaName": "卫辉市",
			"longitude": 114.06454000,
			"latitude": 35.39843000
		}, {
			"areaId": 410782,
			"areaName": "辉县市",
			"longitude": 113.80670000,
			"latitude": 35.46307000
		}, {
			"areaId": 410783,
			"areaName": "长垣市",
			"longitude": 114.66882000,
			"latitude": 35.20046000
		}]
	}, {
		"areaId": 4108,
		"areaName": "焦作市",
		"longitude": 113.23826600,
		"latitude": 35.23904000,
		"children": [{
			"areaId": 410802,
			"areaName": "解放区",
			"longitude": 113.22933000,
			"latitude": 35.24023000
		}, {
			"areaId": 410803,
			"areaName": "中站区",
			"longitude": 113.18315000,
			"latitude": 35.23665000
		}, {
			"areaId": 410804,
			"areaName": "马村区",
			"longitude": 113.31870000,
			"latitude": 35.26908000
		}, {
			"areaId": 410811,
			"areaName": "山阳区",
			"longitude": 113.25464000,
			"latitude": 35.21436000
		}, {
			"areaId": 410821,
			"areaName": "修武县",
			"longitude": 113.44775000,
			"latitude": 35.22357000
		}, {
			"areaId": 410822,
			"areaName": "博爱县",
			"longitude": 113.06698000,
			"latitude": 35.16943000
		}, {
			"areaId": 410823,
			"areaName": "武陟县",
			"longitude": 113.39718000,
			"latitude": 35.09505000
		}, {
			"areaId": 410825,
			"areaName": "温县",
			"longitude": 113.08065000,
			"latitude": 34.94022000
		}, {
			"areaId": 410871,
			"areaName": "焦作城乡一体化示范区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410882,
			"areaName": "沁阳市",
			"longitude": 112.94494000,
			"latitude": 35.08935000
		}, {
			"areaId": 410883,
			"areaName": "孟州市",
			"longitude": 112.79138000,
			"latitude": 34.90710000
		}]
	}, {
		"areaId": 4109,
		"areaName": "濮阳市",
		"longitude": 115.04129900,
		"latitude": 35.76823400,
		"children": [{
			"areaId": 410902,
			"areaName": "华龙区",
			"longitude": 115.07446000,
			"latitude": 35.77736000
		}, {
			"areaId": 410922,
			"areaName": "清丰县",
			"longitude": 115.10415000,
			"latitude": 35.88507000
		}, {
			"areaId": 410923,
			"areaName": "南乐县",
			"longitude": 115.20639000,
			"latitude": 36.07686000
		}, {
			"areaId": 410926,
			"areaName": "范县",
			"longitude": 115.50405000,
			"latitude": 35.85178000
		}, {
			"areaId": 410927,
			"areaName": "台前县",
			"longitude": 115.87158000,
			"latitude": 35.96923000
		}, {
			"areaId": 410928,
			"areaName": "濮阳县",
			"longitude": 115.03057000,
			"latitude": 35.70745000
		}, {
			"areaId": 410971,
			"areaName": "河南濮阳工业园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 410972,
			"areaName": "濮阳经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 4110,
		"areaName": "许昌市",
		"longitude": 113.84707000,
		"latitude": 34.00406000,
		"children": [{
			"areaId": 411002,
			"areaName": "魏都区",
			"longitude": 113.82270000,
			"latitude": 34.02544000
		}, {
			"areaId": 411003,
			"areaName": "建安区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411024,
			"areaName": "鄢陵县",
			"longitude": 114.18795000,
			"latitude": 34.10317000
		}, {
			"areaId": 411025,
			"areaName": "襄城县",
			"longitude": 113.48196000,
			"latitude": 33.84928000
		}, {
			"areaId": 411071,
			"areaName": "许昌经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411081,
			"areaName": "禹州市",
			"longitude": 113.48803000,
			"latitude": 34.14054000
		}, {
			"areaId": 411082,
			"areaName": "长葛市",
			"longitude": 113.77328000,
			"latitude": 34.21846000
		}]
	}, {
		"areaId": 4111,
		"areaName": "漯河市",
		"longitude": 114.02640500,
		"latitude": 33.57585500,
		"children": [{
			"areaId": 411102,
			"areaName": "源汇区",
			"longitude": 114.00647000,
			"latitude": 33.55627000
		}, {
			"areaId": 411103,
			"areaName": "郾城区",
			"longitude": 114.00694000,
			"latitude": 33.58723000
		}, {
			"areaId": 411104,
			"areaName": "召陵区",
			"longitude": 114.09399000,
			"latitude": 33.58601000
		}, {
			"areaId": 411121,
			"areaName": "舞阳县",
			"longitude": 113.59848000,
			"latitude": 33.43243000
		}, {
			"areaId": 411122,
			"areaName": "临颍县",
			"longitude": 113.93661000,
			"latitude": 33.81123000
		}, {
			"areaId": 411171,
			"areaName": "漯河经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 4112,
		"areaName": "三门峡市",
		"longitude": 111.19409900,
		"latitude": 34.77733800,
		"children": [{
			"areaId": 411202,
			"areaName": "湖滨区",
			"longitude": 111.20006000,
			"latitude": 34.77872000
		}, {
			"areaId": 411203,
			"areaName": "陕州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411221,
			"areaName": "渑池县",
			"longitude": 111.76184000,
			"latitude": 34.76725000
		}, {
			"areaId": 411224,
			"areaName": "卢氏县",
			"longitude": 111.04782000,
			"latitude": 34.05436000
		}, {
			"areaId": 411271,
			"areaName": "河南三门峡经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411281,
			"areaName": "义马市",
			"longitude": 111.87445000,
			"latitude": 34.74721000
		}, {
			"areaId": 411282,
			"areaName": "灵宝市",
			"longitude": 110.89450000,
			"latitude": 34.51682000
		}]
	}, {
		"areaId": 4113,
		"areaName": "南阳市",
		"longitude": 112.54091800,
		"latitude": 32.99908200,
		"children": [{
			"areaId": 411302,
			"areaName": "宛城区",
			"longitude": 112.53955000,
			"latitude": 33.00378000
		}, {
			"areaId": 411303,
			"areaName": "卧龙区",
			"longitude": 112.53479000,
			"latitude": 32.98615000
		}, {
			"areaId": 411321,
			"areaName": "南召县",
			"longitude": 112.43194000,
			"latitude": 33.49098000
		}, {
			"areaId": 411322,
			"areaName": "方城县",
			"longitude": 113.01269000,
			"latitude": 33.25453000
		}, {
			"areaId": 411323,
			"areaName": "西峡县",
			"longitude": 111.48187000,
			"latitude": 33.29772000
		}, {
			"areaId": 411324,
			"areaName": "镇平县",
			"longitude": 112.23980000,
			"latitude": 33.03629000
		}, {
			"areaId": 411325,
			"areaName": "内乡县",
			"longitude": 111.84957000,
			"latitude": 33.04671000
		}, {
			"areaId": 411326,
			"areaName": "淅川县",
			"longitude": 111.48663000,
			"latitude": 33.13708000
		}, {
			"areaId": 411327,
			"areaName": "社旗县",
			"longitude": 112.94656000,
			"latitude": 33.05503000
		}, {
			"areaId": 411328,
			"areaName": "唐河县",
			"longitude": 112.83609000,
			"latitude": 32.69453000
		}, {
			"areaId": 411329,
			"areaName": "新野县",
			"longitude": 112.36151000,
			"latitude": 32.51698000
		}, {
			"areaId": 411330,
			"areaName": "桐柏县",
			"longitude": 113.42886000,
			"latitude": 32.37917000
		}, {
			"areaId": 411371,
			"areaName": "南阳高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411372,
			"areaName": "南阳市城乡一体化示范区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411381,
			"areaName": "邓州市",
			"longitude": 112.08960000,
			"latitude": 32.68577000
		}]
	}, {
		"areaId": 4114,
		"areaName": "商丘市",
		"longitude": 115.65049700,
		"latitude": 34.43705400,
		"children": [{
			"areaId": 411402,
			"areaName": "梁园区",
			"longitude": 115.64487000,
			"latitude": 34.44341000
		}, {
			"areaId": 411403,
			"areaName": "睢阳区",
			"longitude": 115.65338000,
			"latitude": 34.38804000
		}, {
			"areaId": 411421,
			"areaName": "民权县",
			"longitude": 115.14621000,
			"latitude": 34.64931000
		}, {
			"areaId": 411422,
			"areaName": "睢县",
			"longitude": 115.07168000,
			"latitude": 34.44539000
		}, {
			"areaId": 411423,
			"areaName": "宁陵县",
			"longitude": 115.30511000,
			"latitude": 34.45463000
		}, {
			"areaId": 411424,
			"areaName": "柘城县",
			"longitude": 115.30538000,
			"latitude": 34.09110000
		}, {
			"areaId": 411425,
			"areaName": "虞城县",
			"longitude": 115.86337000,
			"latitude": 34.40189000
		}, {
			"areaId": 411426,
			"areaName": "夏邑县",
			"longitude": 116.13348000,
			"latitude": 34.23242000
		}, {
			"areaId": 411471,
			"areaName": "豫东综合物流产业聚集区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411472,
			"areaName": "河南商丘经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411481,
			"areaName": "永城市",
			"longitude": 116.44943000,
			"latitude": 33.92911000
		}]
	}, {
		"areaId": 4115,
		"areaName": "信阳市",
		"longitude": 114.07503100,
		"latitude": 32.12327400,
		"children": [{
			"areaId": 411502,
			"areaName": "浉河区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411503,
			"areaName": "平桥区",
			"longitude": 114.12435000,
			"latitude": 32.10095000
		}, {
			"areaId": 411521,
			"areaName": "罗山县",
			"longitude": 114.53140000,
			"latitude": 32.20277000
		}, {
			"areaId": 411522,
			"areaName": "光山县",
			"longitude": 114.91873000,
			"latitude": 32.00992000
		}, {
			"areaId": 411523,
			"areaName": "新县",
			"longitude": 114.87924000,
			"latitude": 31.64386000
		}, {
			"areaId": 411524,
			"areaName": "商城县",
			"longitude": 115.40856000,
			"latitude": 31.79986000
		}, {
			"areaId": 411525,
			"areaName": "固始县",
			"longitude": 115.68298000,
			"latitude": 32.18011000
		}, {
			"areaId": 411526,
			"areaName": "潢川县",
			"longitude": 115.04696000,
			"latitude": 32.13763000
		}, {
			"areaId": 411527,
			"areaName": "淮滨县",
			"longitude": 115.42050000,
			"latitude": 32.46614000
		}, {
			"areaId": 411528,
			"areaName": "息县",
			"longitude": 114.74020000,
			"latitude": 32.34279000
		}, {
			"areaId": 411571,
			"areaName": "信阳高新技术产业开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 4116,
		"areaName": "周口市",
		"longitude": 114.64965300,
		"latitude": 33.62035700,
		"children": [{
			"areaId": 411602,
			"areaName": "川汇区",
			"longitude": 114.64202000,
			"latitude": 33.62560000
		}, {
			"areaId": 411603,
			"areaName": "淮阳区",
			"longitude": 114.88848000,
			"latitude": 33.73211000
		}, {
			"areaId": 411621,
			"areaName": "扶沟县",
			"longitude": 114.39477000,
			"latitude": 34.05999000
		}, {
			"areaId": 411622,
			"areaName": "西华县",
			"longitude": 109.77185000,
			"latitude": 34.51255000
		}, {
			"areaId": 411623,
			"areaName": "商水县",
			"longitude": 114.60604000,
			"latitude": 33.53912000
		}, {
			"areaId": 411624,
			"areaName": "沈丘县",
			"longitude": 115.09851000,
			"latitude": 33.40936000
		}, {
			"areaId": 411625,
			"areaName": "郸城县",
			"longitude": 115.17715000,
			"latitude": 33.64485000
		}, {
			"areaId": 411627,
			"areaName": "太康县",
			"longitude": 114.83773000,
			"latitude": 34.06376000
		}, {
			"areaId": 411628,
			"areaName": "鹿邑县",
			"longitude": 115.48553000,
			"latitude": 33.85931000
		}, {
			"areaId": 411671,
			"areaName": "河南周口经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 411681,
			"areaName": "项城市",
			"longitude": 114.87558000,
			"latitude": 33.46720000
		}]
	}, {
		"areaId": 4117,
		"areaName": "驻马店市",
		"longitude": 114.02473600,
		"latitude": 32.98016900,
		"children": [{
			"areaId": 411702,
			"areaName": "驿城区",
			"longitude": 113.99377000,
			"latitude": 32.97316000
		}, {
			"areaId": 411721,
			"areaName": "西平县",
			"longitude": 114.02322000,
			"latitude": 33.38450000
		}, {
			"areaId": 411722,
			"areaName": "上蔡县",
			"longitude": 114.26825000,
			"latitude": 33.26825000
		}, {
			"areaId": 411723,
			"areaName": "平舆县",
			"longitude": 114.63552000,
			"latitude": 32.95727000
		}, {
			"areaId": 411724,
			"areaName": "正阳县",
			"longitude": 114.38952000,
			"latitude": 32.60390000
		}, {
			"areaId": 411725,
			"areaName": "确山县",
			"longitude": 114.02917000,
			"latitude": 32.80281000
		}, {
			"areaId": 411726,
			"areaName": "泌阳县",
			"longitude": 113.32681000,
			"latitude": 32.71781000
		}, {
			"areaId": 411727,
			"areaName": "汝南县",
			"longitude": 114.36138000,
			"latitude": 33.00461000
		}, {
			"areaId": 411728,
			"areaName": "遂平县",
			"longitude": 114.01297000,
			"latitude": 33.14571000
		}, {
			"areaId": 411729,
			"areaName": "新蔡县",
			"longitude": 114.98199000,
			"latitude": 32.75020000
		}, {
			"areaId": 411771,
			"areaName": "河南驻马店经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 4190,
		"areaName": "省直辖县级行政区划",
		"longitude": 0.00000000,
		"latitude": 0.00000000,
		"children": [{
			"areaId": 419001,
			"areaName": "济源市",
			"longitude": 112.59004700,
			"latitude": 35.09037800
		}]
	}]
}, {
	"areaId": 42,
	"areaName": "湖北省",
	"longitude": 114.29857200,
	"latitude": 30.58435500,
	"children": [{
		"areaId": 4201,
		"areaName": "武汉市",
		"longitude": 114.29857200,
		"latitude": 30.58435500,
		"children": [{
			"areaId": 420102,
			"areaName": "江岸区",
			"longitude": 114.30943000,
			"latitude": 30.59982000
		}, {
			"areaId": 420103,
			"areaName": "江汉区",
			"longitude": 114.27093000,
			"latitude": 30.60146000
		}, {
			"areaId": 420104,
			"areaName": "硚口区",
			"longitude": 114.26422000,
			"latitude": 30.56945000
		}, {
			"areaId": 420105,
			"areaName": "汉阳区",
			"longitude": 114.27478000,
			"latitude": 30.54915000
		}, {
			"areaId": 420106,
			"areaName": "武昌区",
			"longitude": 114.31589000,
			"latitude": 30.55389000
		}, {
			"areaId": 420107,
			"areaName": "青山区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 420111,
			"areaName": "洪山区",
			"longitude": 114.34375000,
			"latitude": 30.49989000
		}, {
			"areaId": 420112,
			"areaName": "东西湖区",
			"longitude": 114.13708000,
			"latitude": 30.61989000
		}, {
			"areaId": 420113,
			"areaName": "汉南区",
			"longitude": 114.08462000,
			"latitude": 30.30879000
		}, {
			"areaId": 420114,
			"areaName": "蔡甸区",
			"longitude": 114.02929000,
			"latitude": 30.58197000
		}, {
			"areaId": 420115,
			"areaName": "江夏区",
			"longitude": 114.31301000,
			"latitude": 30.34653000
		}, {
			"areaId": 420116,
			"areaName": "黄陂区",
			"longitude": 114.37512000,
			"latitude": 30.88151000
		}, {
			"areaId": 420117,
			"areaName": "新洲区",
			"longitude": 114.80136000,
			"latitude": 30.84145000
		}]
	}, {
		"areaId": 4202,
		"areaName": "黄石市",
		"longitude": 115.07704800,
		"latitude": 30.22007400,
		"children": [{
			"areaId": 420202,
			"areaName": "黄石港区",
			"longitude": 115.06604000,
			"latitude": 30.22279000
		}, {
			"areaId": 420203,
			"areaName": "西塞山区",
			"longitude": 115.11016000,
			"latitude": 30.20487000
		}, {
			"areaId": 420204,
			"areaName": "下陆区",
			"longitude": 114.96112000,
			"latitude": 30.17368000
		}, {
			"areaId": 420205,
			"areaName": "铁山区",
			"longitude": 114.90109000,
			"latitude": 30.20678000
		}, {
			"areaId": 420222,
			"areaName": "阳新县",
			"longitude": 115.21527000,
			"latitude": 29.83038000
		}, {
			"areaId": 420281,
			"areaName": "大冶市",
			"longitude": 114.97174000,
			"latitude": 30.09438000
		}]
	}, {
		"areaId": 4203,
		"areaName": "十堰市",
		"longitude": 110.78523900,
		"latitude": 32.64701700,
		"children": [{
			"areaId": 420302,
			"areaName": "茅箭区",
			"longitude": 110.81341000,
			"latitude": 32.59153000
		}, {
			"areaId": 420303,
			"areaName": "张湾区",
			"longitude": 110.77067000,
			"latitude": 32.65195000
		}, {
			"areaId": 420304,
			"areaName": "郧阳区",
			"longitude": 110.81854000,
			"latitude": 32.83593000
		}, {
			"areaId": 420322,
			"areaName": "郧西县",
			"longitude": 110.42556000,
			"latitude": 32.99349000
		}, {
			"areaId": 420323,
			"areaName": "竹山县",
			"longitude": 120.67200700,
			"latitude": 23.75765500
		}, {
			"areaId": 420324,
			"areaName": "竹溪县",
			"longitude": 109.71798000,
			"latitude": 32.31901000
		}, {
			"areaId": 420325,
			"areaName": "房县",
			"longitude": 110.74386000,
			"latitude": 32.05794000
		}, {
			"areaId": 420381,
			"areaName": "丹江口市",
			"longitude": 111.51525000,
			"latitude": 32.54085000
		}]
	}, {
		"areaId": 4205,
		"areaName": "宜昌市",
		"longitude": 111.29084300,
		"latitude": 30.70263600,
		"children": [{
			"areaId": 420502,
			"areaName": "西陵区",
			"longitude": 111.28573000,
			"latitude": 30.71077000
		}, {
			"areaId": 420503,
			"areaName": "伍家岗区",
			"longitude": 111.36090000,
			"latitude": 30.64434000
		}, {
			"areaId": 420504,
			"areaName": "点军区",
			"longitude": 111.26828000,
			"latitude": 30.69340000
		}, {
			"areaId": 420505,
			"areaName": "猇亭区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 420506,
			"areaName": "夷陵区",
			"longitude": 111.32620000,
			"latitude": 30.76881000
		}, {
			"areaId": 420525,
			"areaName": "远安县",
			"longitude": 111.64160000,
			"latitude": 31.05989000
		}, {
			"areaId": 420526,
			"areaName": "兴山县",
			"longitude": 110.74951000,
			"latitude": 31.34686000
		}, {
			"areaId": 420527,
			"areaName": "秭归县",
			"longitude": 110.98156000,
			"latitude": 30.82702000
		}, {
			"areaId": 420528,
			"areaName": "长阳土家族自治县",
			"longitude": 111.20105000,
			"latitude": 30.47052000
		}, {
			"areaId": 420529,
			"areaName": "五峰土家族自治县",
			"longitude": 121.00341800,
			"latitude": 23.77529100
		}, {
			"areaId": 420581,
			"areaName": "宜都市",
			"longitude": 111.45025000,
			"latitude": 30.37807000
		}, {
			"areaId": 420582,
			"areaName": "当阳市",
			"longitude": 111.78912000,
			"latitude": 30.82080000
		}, {
			"areaId": 420583,
			"areaName": "枝江市",
			"longitude": 111.76855000,
			"latitude": 30.42612000
		}]
	}, {
		"areaId": 4206,
		"areaName": "襄阳市",
		"longitude": 112.14414600,
		"latitude": 32.04242600,
		"children": [{
			"areaId": 420602,
			"areaName": "襄城区",
			"longitude": 112.13372000,
			"latitude": 32.01017000
		}, {
			"areaId": 420606,
			"areaName": "樊城区",
			"longitude": 112.13546000,
			"latitude": 32.04482000
		}, {
			"areaId": 420607,
			"areaName": "襄州区",
			"longitude": 112.15032700,
			"latitude": 32.01508800
		}, {
			"areaId": 420624,
			"areaName": "南漳县",
			"longitude": 111.84603000,
			"latitude": 31.77653000
		}, {
			"areaId": 420625,
			"areaName": "谷城县",
			"longitude": 111.65267000,
			"latitude": 32.26377000
		}, {
			"areaId": 420626,
			"areaName": "保康县",
			"longitude": 111.26138000,
			"latitude": 31.87874000
		}, {
			"areaId": 420682,
			"areaName": "老河口市",
			"longitude": 111.67117000,
			"latitude": 32.38476000
		}, {
			"areaId": 420683,
			"areaName": "枣阳市",
			"longitude": 112.77444000,
			"latitude": 32.13142000
		}, {
			"areaId": 420684,
			"areaName": "宜城市",
			"longitude": 112.25772000,
			"latitude": 31.71972000
		}]
	}, {
		"areaId": 4207,
		"areaName": "鄂州市",
		"longitude": 114.89059300,
		"latitude": 30.39653600,
		"children": [{
			"areaId": 420702,
			"areaName": "梁子湖区",
			"longitude": 114.68463000,
			"latitude": 30.10003000
		}, {
			"areaId": 420703,
			"areaName": "华容区",
			"longitude": 114.73568000,
			"latitude": 30.53328000
		}, {
			"areaId": 420704,
			"areaName": "鄂城区",
			"longitude": 114.89158000,
			"latitude": 30.40024000
		}]
	}, {
		"areaId": 4208,
		"areaName": "荆门市",
		"longitude": 112.20425100,
		"latitude": 31.03542000,
		"children": [{
			"areaId": 420802,
			"areaName": "东宝区",
			"longitude": 112.20147000,
			"latitude": 31.05192000
		}, {
			"areaId": 420804,
			"areaName": "掇刀区",
			"longitude": 112.20800000,
			"latitude": 30.97316000
		}, {
			"areaId": 420822,
			"areaName": "沙洋县",
			"longitude": 112.58853000,
			"latitude": 30.70916000
		}, {
			"areaId": 420881,
			"areaName": "钟祥市",
			"longitude": 112.58932000,
			"latitude": 31.16780000
		}, {
			"areaId": 420882,
			"areaName": "京山市",
			"longitude": 113.11074000,
			"latitude": 31.02240000
		}]
	}, {
		"areaId": 4209,
		"areaName": "孝感市",
		"longitude": 113.92665500,
		"latitude": 30.92642300,
		"children": [{
			"areaId": 420902,
			"areaName": "孝南区",
			"longitude": 113.91111000,
			"latitude": 30.91680000
		}, {
			"areaId": 420921,
			"areaName": "孝昌县",
			"longitude": 113.99795000,
			"latitude": 31.25799000
		}, {
			"areaId": 420922,
			"areaName": "大悟县",
			"longitude": 114.12564000,
			"latitude": 31.56176000
		}, {
			"areaId": 420923,
			"areaName": "云梦县",
			"longitude": 113.75289000,
			"latitude": 31.02093000
		}, {
			"areaId": 420981,
			"areaName": "应城市",
			"longitude": 113.57287000,
			"latitude": 30.92834000
		}, {
			"areaId": 420982,
			"areaName": "安陆市",
			"longitude": 113.68557000,
			"latitude": 31.25693000
		}, {
			"areaId": 420984,
			"areaName": "汉川市",
			"longitude": 113.83898000,
			"latitude": 30.66117000
		}]
	}, {
		"areaId": 4210,
		"areaName": "荆州市",
		"longitude": 112.23813000,
		"latitude": 30.32685700,
		"children": [{
			"areaId": 421002,
			"areaName": "沙市区",
			"longitude": 112.25543000,
			"latitude": 30.31107000
		}, {
			"areaId": 421003,
			"areaName": "荆州区",
			"longitude": 112.19006000,
			"latitude": 30.35264000
		}, {
			"areaId": 421022,
			"areaName": "公安县",
			"longitude": 112.23242000,
			"latitude": 30.05902000
		}, {
			"areaId": 421023,
			"areaName": "监利县",
			"longitude": 112.89462000,
			"latitude": 29.81494000
		}, {
			"areaId": 421024,
			"areaName": "江陵县",
			"longitude": 112.42468000,
			"latitude": 30.04174000
		}, {
			"areaId": 421071,
			"areaName": "荆州经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 421081,
			"areaName": "石首市",
			"longitude": 112.42636000,
			"latitude": 29.72127000
		}, {
			"areaId": 421083,
			"areaName": "洪湖市",
			"longitude": 113.47598000,
			"latitude": 29.82700000
		}, {
			"areaId": 421087,
			"areaName": "松滋市",
			"longitude": 111.76739000,
			"latitude": 30.16965000
		}]
	}, {
		"areaId": 4211,
		"areaName": "黄冈市",
		"longitude": 114.87936500,
		"latitude": 30.44771100,
		"children": [{
			"areaId": 421102,
			"areaName": "黄州区",
			"longitude": 114.88008000,
			"latitude": 30.43436000
		}, {
			"areaId": 421121,
			"areaName": "团风县",
			"longitude": 114.87228000,
			"latitude": 30.64359000
		}, {
			"areaId": 421122,
			"areaName": "红安县",
			"longitude": 114.62240000,
			"latitude": 31.28668000
		}, {
			"areaId": 421123,
			"areaName": "罗田县",
			"longitude": 115.39971000,
			"latitude": 30.78255000
		}, {
			"areaId": 421124,
			"areaName": "英山县",
			"longitude": 115.68142000,
			"latitude": 30.73516000
		}, {
			"areaId": 421125,
			"areaName": "浠水县",
			"longitude": 115.26913000,
			"latitude": 30.45265000
		}, {
			"areaId": 421126,
			"areaName": "蕲春县",
			"longitude": 115.43615000,
			"latitude": 30.22613000
		}, {
			"areaId": 421127,
			"areaName": "黄梅县",
			"longitude": 115.94427000,
			"latitude": 30.07033000
		}, {
			"areaId": 421171,
			"areaName": "龙感湖管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 421181,
			"areaName": "麻城市",
			"longitude": 115.00988000,
			"latitude": 31.17228000
		}, {
			"areaId": 421182,
			"areaName": "武穴市",
			"longitude": 115.55975000,
			"latitude": 29.84446000
		}]
	}, {
		"areaId": 4212,
		"areaName": "咸宁市",
		"longitude": 114.32896300,
		"latitude": 29.83279800,
		"children": [{
			"areaId": 421202,
			"areaName": "咸安区",
			"longitude": 114.29872000,
			"latitude": 29.85290000
		}, {
			"areaId": 421221,
			"areaName": "嘉鱼县",
			"longitude": 113.93927000,
			"latitude": 29.97054000
		}, {
			"areaId": 421222,
			"areaName": "通城县",
			"longitude": 113.81582000,
			"latitude": 29.24568000
		}, {
			"areaId": 421223,
			"areaName": "崇阳县",
			"longitude": 114.03982000,
			"latitude": 29.55564000
		}, {
			"areaId": 421224,
			"areaName": "通山县",
			"longitude": 114.48239000,
			"latitude": 29.60630000
		}, {
			"areaId": 421281,
			"areaName": "赤壁市",
			"longitude": 113.90039000,
			"latitude": 29.72454000
		}]
	}, {
		"areaId": 4213,
		"areaName": "随州市",
		"longitude": 113.37377000,
		"latitude": 31.71749700,
		"children": [{
			"areaId": 421303,
			"areaName": "曾都区",
			"longitude": 113.37128000,
			"latitude": 31.71614000
		}, {
			"areaId": 421321,
			"areaName": "随县",
			"longitude": 113.82663000,
			"latitude": 31.61790000
		}, {
			"areaId": 421381,
			"areaName": "广水市",
			"longitude": 113.82663000,
			"latitude": 31.61790000
		}]
	}, {
		"areaId": 4228,
		"areaName": "恩施土家族苗族自治州",
		"longitude": 109.48699000,
		"latitude": 30.28311400,
		"children": [{
			"areaId": 422801,
			"areaName": "恩施市",
			"longitude": 109.47942000,
			"latitude": 30.29502000
		}, {
			"areaId": 422802,
			"areaName": "利川市",
			"longitude": 108.93591000,
			"latitude": 30.29117000
		}, {
			"areaId": 422822,
			"areaName": "建始县",
			"longitude": 109.72207000,
			"latitude": 30.60209000
		}, {
			"areaId": 422823,
			"areaName": "巴东县",
			"longitude": 110.34066000,
			"latitude": 31.04233000
		}, {
			"areaId": 422825,
			"areaName": "宣恩县",
			"longitude": 109.49179000,
			"latitude": 29.98714000
		}, {
			"areaId": 422826,
			"areaName": "咸丰县",
			"longitude": 109.15200000,
			"latitude": 29.67983000
		}, {
			"areaId": 422827,
			"areaName": "来凤县",
			"longitude": 109.40716000,
			"latitude": 29.49373000
		}, {
			"areaId": 422828,
			"areaName": "鹤峰县",
			"longitude": 110.03091000,
			"latitude": 29.89072000
		}]
	}, {
		"areaId": 4290,
		"areaName": "省直辖县级行政区划",
		"longitude": 0.00000000,
		"latitude": 0.00000000,
		"children": [{
			"areaId": 429004,
			"areaName": "仙桃市",
			"longitude": 113.45397400,
			"latitude": 30.36495300
		}, {
			"areaId": 429005,
			"areaName": "潜江市",
			"longitude": 112.89686600,
			"latitude": 30.42121500
		}, {
			"areaId": 429006,
			"areaName": "天门市",
			"longitude": 113.16586200,
			"latitude": 30.65306100
		}, {
			"areaId": 429021,
			"areaName": "神农架林区",
			"longitude": 110.67152500,
			"latitude": 31.74444900
		}]
	}]
}, {
	"areaId": 43,
	"areaName": "湖南省",
	"longitude": 112.98227900,
	"latitude": 28.19409000,
	"children": [{
		"areaId": 4301,
		"areaName": "长沙市",
		"longitude": 112.98227900,
		"latitude": 28.19409000,
		"children": [{
			"areaId": 430102,
			"areaName": "芙蓉区",
			"longitude": 113.03176000,
			"latitude": 28.18440000
		}, {
			"areaId": 430103,
			"areaName": "天心区",
			"longitude": 112.98991000,
			"latitude": 28.11270000
		}, {
			"areaId": 430104,
			"areaName": "岳麓区",
			"longitude": 112.93133000,
			"latitude": 28.23510000
		}, {
			"areaId": 430105,
			"areaName": "开福区",
			"longitude": 112.98623000,
			"latitude": 28.25585000
		}, {
			"areaId": 430111,
			"areaName": "雨花区",
			"longitude": 113.03567000,
			"latitude": 28.13541000
		}, {
			"areaId": 430112,
			"areaName": "望城区",
			"longitude": 112.81954900,
			"latitude": 28.34745800
		}, {
			"areaId": 430121,
			"areaName": "长沙县",
			"longitude": 113.08071000,
			"latitude": 28.24595000
		}, {
			"areaId": 430181,
			"areaName": "浏阳市",
			"longitude": 113.64312000,
			"latitude": 28.16375000
		}, {
			"areaId": 430182,
			"areaName": "宁乡市",
			"longitude": 112.55749000,
			"latitude": 28.25358000
		}]
	}, {
		"areaId": 4302,
		"areaName": "株洲市",
		"longitude": 113.14428000,
		"latitude": 27.69826000,
		"children": [{
			"areaId": 430202,
			"areaName": "荷塘区",
			"longitude": 113.17315000,
			"latitude": 27.85569000
		}, {
			"areaId": 430203,
			"areaName": "芦淞区",
			"longitude": 113.15562000,
			"latitude": 27.78525000
		}, {
			"areaId": 430204,
			"areaName": "石峰区",
			"longitude": 113.11776000,
			"latitude": 27.87552000
		}, {
			"areaId": 430211,
			"areaName": "天元区",
			"longitude": 113.12335000,
			"latitude": 27.83103000
		}, {
			"areaId": 430212,
			"areaName": "渌口区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430223,
			"areaName": "攸县",
			"longitude": 113.34365000,
			"latitude": 27.00352000
		}, {
			"areaId": 430224,
			"areaName": "茶陵县",
			"longitude": 113.54364000,
			"latitude": 26.79150000
		}, {
			"areaId": 430225,
			"areaName": "炎陵县",
			"longitude": 113.77163000,
			"latitude": 26.48818000
		}, {
			"areaId": 430271,
			"areaName": "云龙示范区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430281,
			"areaName": "醴陵市",
			"longitude": 113.49704000,
			"latitude": 27.64615000
		}]
	}, {
		"areaId": 4303,
		"areaName": "湘潭市",
		"longitude": 112.92508300,
		"latitude": 27.84672500,
		"children": [{
			"areaId": 430302,
			"areaName": "雨湖区",
			"longitude": 112.90399000,
			"latitude": 27.86859000
		}, {
			"areaId": 430304,
			"areaName": "岳塘区",
			"longitude": 112.96060000,
			"latitude": 27.85784000
		}, {
			"areaId": 430321,
			"areaName": "湘潭县",
			"longitude": 112.95080000,
			"latitude": 27.77893000
		}, {
			"areaId": 430371,
			"areaName": "湖南湘潭高新技术产业园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430372,
			"areaName": "湘潭昭山示范区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430373,
			"areaName": "湘潭九华示范区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430381,
			"areaName": "湘乡市",
			"longitude": 112.53512000,
			"latitude": 27.73543000
		}, {
			"areaId": 430382,
			"areaName": "韶山市",
			"longitude": 112.52655000,
			"latitude": 27.91503000
		}]
	}, {
		"areaId": 4304,
		"areaName": "衡阳市",
		"longitude": 112.60769300,
		"latitude": 26.90035800,
		"children": [{
			"areaId": 430405,
			"areaName": "珠晖区",
			"longitude": 112.62054000,
			"latitude": 26.89361000
		}, {
			"areaId": 430406,
			"areaName": "雁峰区",
			"longitude": 112.61654000,
			"latitude": 26.88866000
		}, {
			"areaId": 430407,
			"areaName": "石鼓区",
			"longitude": 112.61069000,
			"latitude": 26.90232000
		}, {
			"areaId": 430408,
			"areaName": "蒸湘区",
			"longitude": 112.60330000,
			"latitude": 26.89651000
		}, {
			"areaId": 430412,
			"areaName": "南岳区",
			"longitude": 112.73840000,
			"latitude": 27.23262000
		}, {
			"areaId": 430421,
			"areaName": "衡阳县",
			"longitude": 112.37088000,
			"latitude": 26.97060000
		}, {
			"areaId": 430422,
			"areaName": "衡南县",
			"longitude": 112.67788000,
			"latitude": 26.73828000
		}, {
			"areaId": 430423,
			"areaName": "衡山县",
			"longitude": 112.86776000,
			"latitude": 27.23134000
		}, {
			"areaId": 430424,
			"areaName": "衡东县",
			"longitude": 112.94833000,
			"latitude": 27.08093000
		}, {
			"areaId": 430426,
			"areaName": "祁东县",
			"longitude": 112.09039000,
			"latitude": 26.79964000
		}, {
			"areaId": 430471,
			"areaName": "衡阳综合保税区",
			"longitude": 121.94289000,
			"latitude": 39.22461400
		}, {
			"areaId": 430472,
			"areaName": "湖南衡阳高新技术产业园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430473,
			"areaName": "湖南衡阳松木经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430481,
			"areaName": "耒阳市",
			"longitude": 112.85998000,
			"latitude": 26.42132000
		}, {
			"areaId": 430482,
			"areaName": "常宁市",
			"longitude": 112.40090000,
			"latitude": 26.40692000
		}]
	}, {
		"areaId": 4305,
		"areaName": "邵阳市",
		"longitude": 111.46923000,
		"latitude": 27.23784200,
		"children": [{
			"areaId": 430502,
			"areaName": "双清区",
			"longitude": 111.49715000,
			"latitude": 27.23291000
		}, {
			"areaId": 430503,
			"areaName": "大祥区",
			"longitude": 111.45412000,
			"latitude": 27.23332000
		}, {
			"areaId": 430511,
			"areaName": "北塔区",
			"longitude": 111.45219000,
			"latitude": 27.24648000
		}, {
			"areaId": 430522,
			"areaName": "新邵县",
			"longitude": 111.46066000,
			"latitude": 27.32169000
		}, {
			"areaId": 430523,
			"areaName": "邵阳县",
			"longitude": 111.27459000,
			"latitude": 26.99143000
		}, {
			"areaId": 430524,
			"areaName": "隆回县",
			"longitude": 111.03216000,
			"latitude": 27.10937000
		}, {
			"areaId": 430525,
			"areaName": "洞口县",
			"longitude": 110.57388000,
			"latitude": 27.05462000
		}, {
			"areaId": 430527,
			"areaName": "绥宁县",
			"longitude": 110.15576000,
			"latitude": 26.58636000
		}, {
			"areaId": 430528,
			"areaName": "新宁县",
			"longitude": 110.85131000,
			"latitude": 26.42936000
		}, {
			"areaId": 430529,
			"areaName": "城步苗族自治县",
			"longitude": 110.32220000,
			"latitude": 26.39048000
		}, {
			"areaId": 430581,
			"areaName": "武冈市",
			"longitude": 110.63281000,
			"latitude": 26.72817000
		}, {
			"areaId": 430582,
			"areaName": "邵东市",
			"longitude": 111.74441000,
			"latitude": 27.25840000
		}]
	}, {
		"areaId": 4306,
		"areaName": "岳阳市",
		"longitude": 113.13285500,
		"latitude": 29.37029000,
		"children": [{
			"areaId": 430602,
			"areaName": "岳阳楼区",
			"longitude": 113.12942000,
			"latitude": 29.37190000
		}, {
			"areaId": 430603,
			"areaName": "云溪区",
			"longitude": 113.27713000,
			"latitude": 29.47357000
		}, {
			"areaId": 430611,
			"areaName": "君山区",
			"longitude": 113.00439000,
			"latitude": 29.45941000
		}, {
			"areaId": 430621,
			"areaName": "岳阳县",
			"longitude": 113.11987000,
			"latitude": 29.14314000
		}, {
			"areaId": 430623,
			"areaName": "华容县",
			"longitude": 112.54089000,
			"latitude": 29.53019000
		}, {
			"areaId": 430624,
			"areaName": "湘阴县",
			"longitude": 112.90911000,
			"latitude": 28.68922000
		}, {
			"areaId": 430626,
			"areaName": "平江县",
			"longitude": 113.58105000,
			"latitude": 28.70664000
		}, {
			"areaId": 430671,
			"areaName": "岳阳市屈原管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430681,
			"areaName": "汨罗市",
			"longitude": 113.06707000,
			"latitude": 28.80631000
		}, {
			"areaId": 430682,
			"areaName": "临湘市",
			"longitude": 113.45010000,
			"latitude": 29.47701000
		}]
	}, {
		"areaId": 4307,
		"areaName": "常德市",
		"longitude": 111.69134700,
		"latitude": 29.04022500,
		"children": [{
			"areaId": 430702,
			"areaName": "武陵区",
			"longitude": 111.69791000,
			"latitude": 29.02876000
		}, {
			"areaId": 430703,
			"areaName": "鼎城区",
			"longitude": 111.68078000,
			"latitude": 29.01859000
		}, {
			"areaId": 430721,
			"areaName": "安乡县",
			"longitude": 112.16732000,
			"latitude": 29.41326000
		}, {
			"areaId": 430722,
			"areaName": "汉寿县",
			"longitude": 111.96691000,
			"latitude": 28.90299000
		}, {
			"areaId": 430723,
			"areaName": "澧县",
			"longitude": 111.75866000,
			"latitude": 29.63317000
		}, {
			"areaId": 430724,
			"areaName": "临澧县",
			"longitude": 111.65161000,
			"latitude": 29.44163000
		}, {
			"areaId": 430725,
			"areaName": "桃源县",
			"longitude": 120.76004900,
			"latitude": 23.15913700
		}, {
			"areaId": 430726,
			"areaName": "石门县",
			"longitude": 121.56849100,
			"latitude": 25.29041200
		}, {
			"areaId": 430771,
			"areaName": "常德市西洞庭管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430781,
			"areaName": "津市市",
			"longitude": 111.87756000,
			"latitude": 29.60563000
		}]
	}, {
		"areaId": 4308,
		"areaName": "张家界市",
		"longitude": 110.47992100,
		"latitude": 29.12740100,
		"children": [{
			"areaId": 430802,
			"areaName": "永定区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430811,
			"areaName": "武陵源区",
			"longitude": 110.55026000,
			"latitude": 29.34574000
		}, {
			"areaId": 430821,
			"areaName": "慈利县",
			"longitude": 111.13946000,
			"latitude": 29.42989000
		}, {
			"areaId": 430822,
			"areaName": "桑植县",
			"longitude": 110.16308000,
			"latitude": 29.39815000
		}]
	}, {
		"areaId": 4309,
		"areaName": "益阳市",
		"longitude": 112.35504200,
		"latitude": 28.57006600,
		"children": [{
			"areaId": 430902,
			"areaName": "资阳区",
			"longitude": 112.32447000,
			"latitude": 28.59095000
		}, {
			"areaId": 430903,
			"areaName": "赫山区",
			"longitude": 112.37265000,
			"latitude": 28.57425000
		}, {
			"areaId": 430921,
			"areaName": "南县",
			"longitude": 105.84005000,
			"latitude": 30.19120000
		}, {
			"areaId": 430922,
			"areaName": "桃江县",
			"longitude": 112.15570000,
			"latitude": 28.51814000
		}, {
			"areaId": 430923,
			"areaName": "安化县",
			"longitude": 111.21298000,
			"latitude": 28.37424000
		}, {
			"areaId": 430971,
			"areaName": "益阳市大通湖管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430972,
			"areaName": "湖南益阳高新技术产业园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 430981,
			"areaName": "沅江市",
			"longitude": 112.35427000,
			"latitude": 28.84403000
		}]
	}, {
		"areaId": 4310,
		"areaName": "郴州市",
		"longitude": 113.03206700,
		"latitude": 25.79358900,
		"children": [{
			"areaId": 431002,
			"areaName": "北湖区",
			"longitude": 113.01103000,
			"latitude": 25.78405000
		}, {
			"areaId": 431003,
			"areaName": "苏仙区",
			"longitude": 113.04226000,
			"latitude": 25.80045000
		}, {
			"areaId": 431021,
			"areaName": "桂阳县",
			"longitude": 112.73364000,
			"latitude": 25.75406000
		}, {
			"areaId": 431022,
			"areaName": "宜章县",
			"longitude": 112.95147000,
			"latitude": 25.39931000
		}, {
			"areaId": 431023,
			"areaName": "永兴县",
			"longitude": 113.11242000,
			"latitude": 26.12646000
		}, {
			"areaId": 431024,
			"areaName": "嘉禾县",
			"longitude": 112.36935000,
			"latitude": 25.58795000
		}, {
			"areaId": 431025,
			"areaName": "临武县",
			"longitude": 112.56369000,
			"latitude": 25.27602000
		}, {
			"areaId": 431026,
			"areaName": "汝城县",
			"longitude": 113.68582000,
			"latitude": 25.55204000
		}, {
			"areaId": 431027,
			"areaName": "桂东县",
			"longitude": 113.94680000,
			"latitude": 26.07987000
		}, {
			"areaId": 431028,
			"areaName": "安仁县",
			"longitude": 113.26944000,
			"latitude": 26.70931000
		}, {
			"areaId": 431081,
			"areaName": "资兴市",
			"longitude": 113.23724000,
			"latitude": 25.97668000
		}]
	}, {
		"areaId": 4311,
		"areaName": "永州市",
		"longitude": 111.60801900,
		"latitude": 26.43451600,
		"children": [{
			"areaId": 431102,
			"areaName": "零陵区",
			"longitude": 111.62103000,
			"latitude": 26.22109000
		}, {
			"areaId": 431103,
			"areaName": "冷水滩区",
			"longitude": 111.59214000,
			"latitude": 26.46107000
		}, {
			"areaId": 431121,
			"areaName": "祁阳县",
			"longitude": 111.84011000,
			"latitude": 26.58009000
		}, {
			"areaId": 431122,
			"areaName": "东安县",
			"longitude": 111.31640000,
			"latitude": 26.39202000
		}, {
			"areaId": 431123,
			"areaName": "双牌县",
			"longitude": 111.65927000,
			"latitude": 25.95988000
		}, {
			"areaId": 431124,
			"areaName": "道县",
			"longitude": 111.60195000,
			"latitude": 25.52766000
		}, {
			"areaId": 431125,
			"areaName": "江永县",
			"longitude": 111.34082000,
			"latitude": 25.27233000
		}, {
			"areaId": 431126,
			"areaName": "宁远县",
			"longitude": 111.94625000,
			"latitude": 25.56913000
		}, {
			"areaId": 431127,
			"areaName": "蓝山县",
			"longitude": 112.19363000,
			"latitude": 25.36794000
		}, {
			"areaId": 431128,
			"areaName": "新田县",
			"longitude": 112.22103000,
			"latitude": 25.90950000
		}, {
			"areaId": 431129,
			"areaName": "江华瑶族自治县",
			"longitude": 111.58847000,
			"latitude": 25.18450000
		}, {
			"areaId": 431171,
			"areaName": "永州经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 431172,
			"areaName": "永州市金洞管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 431173,
			"areaName": "永州市回龙圩管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 4312,
		"areaName": "怀化市",
		"longitude": 109.97824000,
		"latitude": 27.55008200,
		"children": [{
			"areaId": 431202,
			"areaName": "鹤城区",
			"longitude": 109.96509000,
			"latitude": 27.54942000
		}, {
			"areaId": 431221,
			"areaName": "中方县",
			"longitude": 109.94497000,
			"latitude": 27.43988000
		}, {
			"areaId": 431222,
			"areaName": "沅陵县",
			"longitude": 110.39633000,
			"latitude": 28.45548000
		}, {
			"areaId": 431223,
			"areaName": "辰溪县",
			"longitude": 110.18942000,
			"latitude": 28.00406000
		}, {
			"areaId": 431224,
			"areaName": "溆浦县",
			"longitude": 110.59384000,
			"latitude": 27.90836000
		}, {
			"areaId": 431225,
			"areaName": "会同县",
			"longitude": 109.73568000,
			"latitude": 26.88716000
		}, {
			"areaId": 431226,
			"areaName": "麻阳苗族自治县",
			"longitude": 109.80194000,
			"latitude": 27.86600000
		}, {
			"areaId": 431227,
			"areaName": "新晃侗族自治县",
			"longitude": 109.17166000,
			"latitude": 27.35937000
		}, {
			"areaId": 431228,
			"areaName": "芷江侗族自治县",
			"longitude": 109.68490000,
			"latitude": 27.44297000
		}, {
			"areaId": 431229,
			"areaName": "靖州苗族侗族自治县",
			"longitude": 109.69821000,
			"latitude": 26.57651000
		}, {
			"areaId": 431230,
			"areaName": "通道侗族自治县",
			"longitude": 109.78515000,
			"latitude": 26.15710000
		}, {
			"areaId": 431271,
			"areaName": "怀化市洪江管理区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 431281,
			"areaName": "洪江市",
			"longitude": 109.83651000,
			"latitude": 27.20922000
		}]
	}, {
		"areaId": 4313,
		"areaName": "娄底市",
		"longitude": 112.00849700,
		"latitude": 27.72813600,
		"children": [{
			"areaId": 431302,
			"areaName": "娄星区",
			"longitude": 112.00193000,
			"latitude": 27.72992000
		}, {
			"areaId": 431321,
			"areaName": "双峰县",
			"longitude": 112.19921000,
			"latitude": 27.45418000
		}, {
			"areaId": 431322,
			"areaName": "新化县",
			"longitude": 120.31080700,
			"latitude": 23.03853300
		}, {
			"areaId": 431381,
			"areaName": "冷水江市",
			"longitude": 111.43554000,
			"latitude": 27.68147000
		}, {
			"areaId": 431382,
			"areaName": "涟源市",
			"longitude": 111.67233000,
			"latitude": 27.68831000
		}]
	}, {
		"areaId": 4331,
		"areaName": "湘西土家族苗族自治州",
		"longitude": 109.73973500,
		"latitude": 28.31429600,
		"children": [{
			"areaId": 433101,
			"areaName": "吉首市",
			"longitude": 109.69799000,
			"latitude": 28.26247000
		}, {
			"areaId": 433122,
			"areaName": "泸溪县",
			"longitude": 110.21682000,
			"latitude": 28.22050000
		}, {
			"areaId": 433123,
			"areaName": "凤凰县",
			"longitude": 109.60156000,
			"latitude": 27.94822000
		}, {
			"areaId": 433124,
			"areaName": "花垣县",
			"longitude": 109.48217000,
			"latitude": 28.57210000
		}, {
			"areaId": 433125,
			"areaName": "保靖县",
			"longitude": 109.66049000,
			"latitude": 28.69997000
		}, {
			"areaId": 433126,
			"areaName": "古丈县",
			"longitude": 109.94812000,
			"latitude": 28.61944000
		}, {
			"areaId": 433127,
			"areaName": "永顺县",
			"longitude": 109.85266000,
			"latitude": 29.00103000
		}, {
			"areaId": 433130,
			"areaName": "龙山县",
			"longitude": 109.44320000,
			"latitude": 29.45693000
		}]
	}]
}, {
	"areaId": 44,
	"areaName": "广东省",
	"longitude": 113.28063700,
	"latitude": 23.12517800,
	"children": [{
		"areaId": 4401,
		"areaName": "广州市",
		"longitude": 113.28063700,
		"latitude": 23.12517800,
		"children": [{
			"areaId": 440103,
			"areaName": "荔湾区",
			"longitude": 113.24420000,
			"latitude": 23.12592000
		}, {
			"areaId": 440104,
			"areaName": "越秀区",
			"longitude": 113.26683000,
			"latitude": 23.12897000
		}, {
			"areaId": 440105,
			"areaName": "海珠区",
			"longitude": 113.26197000,
			"latitude": 23.10379000
		}, {
			"areaId": 440106,
			"areaName": "天河区",
			"longitude": 113.36112000,
			"latitude": 23.12467000
		}, {
			"areaId": 440111,
			"areaName": "白云区",
			"longitude": 106.63088000,
			"latitude": 26.68284000
		}, {
			"areaId": 440112,
			"areaName": "黄埔区",
			"longitude": 113.45895000,
			"latitude": 23.10642000
		}, {
			"areaId": 440113,
			"areaName": "番禺区",
			"longitude": 113.38397000,
			"latitude": 22.93599000
		}, {
			"areaId": 440114,
			"areaName": "花都区",
			"longitude": 113.22033000,
			"latitude": 23.40358000
		}, {
			"areaId": 440115,
			"areaName": "南沙区",
			"longitude": 113.60845000,
			"latitude": 22.77144000
		}, {
			"areaId": 440117,
			"areaName": "从化区",
			"longitude": 113.58738600,
			"latitude": 23.54528300
		}, {
			"areaId": 440118,
			"areaName": "增城区",
			"longitude": 113.82957900,
			"latitude": 23.29049700
		}]
	}, {
		"areaId": 4402,
		"areaName": "韶关市",
		"longitude": 113.59154400,
		"latitude": 24.80132200,
		"children": [{
			"areaId": 440203,
			"areaName": "武江区",
			"longitude": 113.58767000,
			"latitude": 24.79264000
		}, {
			"areaId": 440204,
			"areaName": "浈江区",
			"longitude": 113.61109000,
			"latitude": 24.80438000
		}, {
			"areaId": 440205,
			"areaName": "曲江区",
			"longitude": 113.60165000,
			"latitude": 24.67915000
		}, {
			"areaId": 440222,
			"areaName": "始兴县",
			"longitude": 114.06799000,
			"latitude": 24.94759000
		}, {
			"areaId": 440224,
			"areaName": "仁化县",
			"longitude": 113.74737000,
			"latitude": 25.08742000
		}, {
			"areaId": 440229,
			"areaName": "翁源县",
			"longitude": 114.13385000,
			"latitude": 24.34950000
		}, {
			"areaId": 440232,
			"areaName": "乳源瑶族自治县",
			"longitude": 113.27734000,
			"latitude": 24.77803000
		}, {
			"areaId": 440233,
			"areaName": "新丰县",
			"longitude": 120.98300600,
			"latitude": 24.89960000
		}, {
			"areaId": 440281,
			"areaName": "乐昌市",
			"longitude": 113.35653000,
			"latitude": 25.12799000
		}, {
			"areaId": 440282,
			"areaName": "南雄市",
			"longitude": 114.30966000,
			"latitude": 25.11706000
		}]
	}, {
		"areaId": 4403,
		"areaName": "深圳市",
		"longitude": 114.08594700,
		"latitude": 22.54700000,
		"children": [{
			"areaId": 440303,
			"areaName": "罗湖区",
			"longitude": 114.13116000,
			"latitude": 22.54836000
		}, {
			"areaId": 440304,
			"areaName": "福田区",
			"longitude": 114.05571000,
			"latitude": 22.52245000
		}, {
			"areaId": 440305,
			"areaName": "南山区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 440306,
			"areaName": "宝安区",
			"longitude": 113.88311000,
			"latitude": 22.55371000
		}, {
			"areaId": 440307,
			"areaName": "龙岗区",
			"longitude": 114.24771000,
			"latitude": 22.71986000
		}, {
			"areaId": 440308,
			"areaName": "盐田区",
			"longitude": 114.23733000,
			"latitude": 22.55780000
		}, {
			"areaId": 440309,
			"areaName": "龙华区",
			"longitude": 110.30194000,
			"latitude": 20.02866000
		}, {
			"areaId": 440310,
			"areaName": "坪山区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 440311,
			"areaName": "光明区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 4404,
		"areaName": "珠海市",
		"longitude": 113.55272400,
		"latitude": 22.25589900,
		"children": [{
			"areaId": 440402,
			"areaName": "香洲区",
			"longitude": 113.54350000,
			"latitude": 22.26654000
		}, {
			"areaId": 440403,
			"areaName": "斗门区",
			"longitude": 113.29644000,
			"latitude": 22.20898000
		}, {
			"areaId": 440404,
			"areaName": "金湾区",
			"longitude": 113.36361000,
			"latitude": 22.14691000
		}]
	}, {
		"areaId": 4405,
		"areaName": "汕头市",
		"longitude": 116.70846300,
		"latitude": 23.37102000,
		"children": [{
			"areaId": 440507,
			"areaName": "龙湖区",
			"longitude": 116.71641000,
			"latitude": 23.37166000
		}, {
			"areaId": 440511,
			"areaName": "金平区",
			"longitude": 116.70364000,
			"latitude": 23.36637000
		}, {
			"areaId": 440512,
			"areaName": "濠江区",
			"longitude": 116.72659000,
			"latitude": 23.28588000
		}, {
			"areaId": 440513,
			"areaName": "潮阳区",
			"longitude": 116.60150000,
			"latitude": 23.26485000
		}, {
			"areaId": 440514,
			"areaName": "潮南区",
			"longitude": 116.43188000,
			"latitude": 23.25000000
		}, {
			"areaId": 440515,
			"areaName": "澄海区",
			"longitude": 116.75589000,
			"latitude": 23.46728000
		}, {
			"areaId": 440523,
			"areaName": "南澳县",
			"longitude": 121.79981000,
			"latitude": 24.46539300
		}]
	}, {
		"areaId": 4406,
		"areaName": "佛山市",
		"longitude": 113.12271700,
		"latitude": 23.02876200,
		"children": [{
			"areaId": 440604,
			"areaName": "禅城区",
			"longitude": 113.12280000,
			"latitude": 23.00842000
		}, {
			"areaId": 440605,
			"areaName": "南海区",
			"longitude": 113.14299000,
			"latitude": 23.02877000
		}, {
			"areaId": 440606,
			"areaName": "顺德区",
			"longitude": 113.29394000,
			"latitude": 22.80452000
		}, {
			"areaId": 440607,
			"areaName": "三水区",
			"longitude": 112.89703000,
			"latitude": 23.15564000
		}, {
			"areaId": 440608,
			"areaName": "高明区",
			"longitude": 112.89254000,
			"latitude": 22.90022000
		}]
	}, {
		"areaId": 4407,
		"areaName": "江门市",
		"longitude": 113.09494200,
		"latitude": 22.59043100,
		"children": [{
			"areaId": 440703,
			"areaName": "蓬江区",
			"longitude": 113.07849000,
			"latitude": 22.59515000
		}, {
			"areaId": 440704,
			"areaName": "江海区",
			"longitude": 113.11099000,
			"latitude": 22.56024000
		}, {
			"areaId": 440705,
			"areaName": "新会区",
			"longitude": 113.03225000,
			"latitude": 22.45876000
		}, {
			"areaId": 440781,
			"areaName": "台山市",
			"longitude": 112.79382000,
			"latitude": 22.25150000
		}, {
			"areaId": 440783,
			"areaName": "开平市",
			"longitude": 112.69842000,
			"latitude": 22.37622000
		}, {
			"areaId": 440784,
			"areaName": "鹤山市",
			"longitude": 112.96429000,
			"latitude": 22.76523000
		}, {
			"areaId": 440785,
			"areaName": "恩平市",
			"longitude": 112.30496000,
			"latitude": 22.18288000
		}]
	}, {
		"areaId": 4408,
		"areaName": "湛江市",
		"longitude": 110.40552900,
		"latitude": 21.19533800,
		"children": [{
			"areaId": 440802,
			"areaName": "赤坎区",
			"longitude": 110.36592000,
			"latitude": 21.26606000
		}, {
			"areaId": 440803,
			"areaName": "霞山区",
			"longitude": 110.39822000,
			"latitude": 21.19181000
		}, {
			"areaId": 440804,
			"areaName": "坡头区",
			"longitude": 110.45533000,
			"latitude": 21.24472000
		}, {
			"areaId": 440811,
			"areaName": "麻章区",
			"longitude": 110.33420000,
			"latitude": 21.26333000
		}, {
			"areaId": 440823,
			"areaName": "遂溪县",
			"longitude": 110.25003000,
			"latitude": 21.37721000
		}, {
			"areaId": 440825,
			"areaName": "徐闻县",
			"longitude": 110.17379000,
			"latitude": 20.32812000
		}, {
			"areaId": 440881,
			"areaName": "廉江市",
			"longitude": 110.28442000,
			"latitude": 21.60917000
		}, {
			"areaId": 440882,
			"areaName": "雷州市",
			"longitude": 110.10092000,
			"latitude": 20.91428000
		}, {
			"areaId": 440883,
			"areaName": "吴川市",
			"longitude": 110.77703000,
			"latitude": 21.44584000
		}]
	}, {
		"areaId": 4409,
		"areaName": "茂名市",
		"longitude": 110.91922900,
		"latitude": 21.65975100,
		"children": [{
			"areaId": 440902,
			"areaName": "茂南区",
			"longitude": 110.91870000,
			"latitude": 21.64103000
		}, {
			"areaId": 440904,
			"areaName": "电白区",
			"longitude": 111.00726400,
			"latitude": 21.50721900
		}, {
			"areaId": 440981,
			"areaName": "高州市",
			"longitude": 110.85519000,
			"latitude": 21.92057000
		}, {
			"areaId": 440982,
			"areaName": "化州市",
			"longitude": 110.63949000,
			"latitude": 21.66394000
		}, {
			"areaId": 440983,
			"areaName": "信宜市",
			"longitude": 110.94647000,
			"latitude": 22.35351000
		}]
	}, {
		"areaId": 4412,
		"areaName": "肇庆市",
		"longitude": 112.47252900,
		"latitude": 23.05154600,
		"children": [{
			"areaId": 441202,
			"areaName": "端州区",
			"longitude": 112.48495000,
			"latitude": 23.05190000
		}, {
			"areaId": 441203,
			"areaName": "鼎湖区",
			"longitude": 112.56643000,
			"latitude": 23.15846000
		}, {
			"areaId": 441204,
			"areaName": "高要区",
			"longitude": 112.45834000,
			"latitude": 23.02577000
		}, {
			"areaId": 441223,
			"areaName": "广宁县",
			"longitude": 112.44064000,
			"latitude": 23.63460000
		}, {
			"areaId": 441224,
			"areaName": "怀集县",
			"longitude": 112.18396000,
			"latitude": 23.90918000
		}, {
			"areaId": 441225,
			"areaName": "封开县",
			"longitude": 108.39306000,
			"latitude": 31.16095000
		}, {
			"areaId": 441226,
			"areaName": "德庆县",
			"longitude": 91.00033000,
			"latitude": 29.65002000
		}, {
			"areaId": 441284,
			"areaName": "四会市",
			"longitude": 112.73416000,
			"latitude": 23.32686000
		}]
	}, {
		"areaId": 4413,
		"areaName": "惠州市",
		"longitude": 114.41259900,
		"latitude": 23.07940400,
		"children": [{
			"areaId": 441302,
			"areaName": "惠城区",
			"longitude": 114.38280000,
			"latitude": 23.08377000
		}, {
			"areaId": 441303,
			"areaName": "惠阳区",
			"longitude": 114.45639000,
			"latitude": 22.78845000
		}, {
			"areaId": 441322,
			"areaName": "博罗县",
			"longitude": 114.28964000,
			"latitude": 23.17307000
		}, {
			"areaId": 441323,
			"areaName": "惠东县",
			"longitude": 114.72009000,
			"latitude": 22.98484000
		}, {
			"areaId": 441324,
			"areaName": "龙门县",
			"longitude": 114.25479000,
			"latitude": 23.72758000
		}]
	}, {
		"areaId": 4414,
		"areaName": "梅州市",
		"longitude": 116.11758200,
		"latitude": 24.29911200,
		"children": [{
			"areaId": 441402,
			"areaName": "梅江区",
			"longitude": 116.11663000,
			"latitude": 24.31062000
		}, {
			"areaId": 441403,
			"areaName": "梅县区",
			"longitude": 116.09775300,
			"latitude": 24.28673900
		}, {
			"areaId": 441422,
			"areaName": "大埔县",
			"longitude": 114.17174300,
			"latitude": 22.44565300
		}, {
			"areaId": 441423,
			"areaName": "丰顺县",
			"longitude": 116.18219000,
			"latitude": 23.74094000
		}, {
			"areaId": 441424,
			"areaName": "五华县",
			"longitude": 115.77893000,
			"latitude": 23.92417000
		}, {
			"areaId": 441426,
			"areaName": "平远县",
			"longitude": 115.89556000,
			"latitude": 24.57116000
		}, {
			"areaId": 441427,
			"areaName": "蕉岭县",
			"longitude": 116.17089000,
			"latitude": 24.65732000
		}, {
			"areaId": 441481,
			"areaName": "兴宁市",
			"longitude": 115.73141000,
			"latitude": 24.14001000
		}]
	}, {
		"areaId": 4415,
		"areaName": "汕尾市",
		"longitude": 115.36423800,
		"latitude": 22.77448500,
		"children": [{
			"areaId": 441502,
			"areaName": "城区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 441521,
			"areaName": "海丰县",
			"longitude": 115.32336000,
			"latitude": 22.96653000
		}, {
			"areaId": 441523,
			"areaName": "陆河县",
			"longitude": 115.65597000,
			"latitude": 23.30365000
		}, {
			"areaId": 441581,
			"areaName": "陆丰市",
			"longitude": 115.64813000,
			"latitude": 22.94335000
		}]
	}, {
		"areaId": 4416,
		"areaName": "河源市",
		"longitude": 114.69780200,
		"latitude": 23.74626600,
		"children": [{
			"areaId": 441602,
			"areaName": "源城区",
			"longitude": 114.70242000,
			"latitude": 23.73410000
		}, {
			"areaId": 441621,
			"areaName": "紫金县",
			"longitude": 115.18365000,
			"latitude": 23.63867000
		}, {
			"areaId": 441622,
			"areaName": "龙川县",
			"longitude": 115.26025000,
			"latitude": 24.10142000
		}, {
			"areaId": 441623,
			"areaName": "连平县",
			"longitude": 114.49026000,
			"latitude": 24.37156000
		}, {
			"areaId": 441624,
			"areaName": "和平县",
			"longitude": 114.93841000,
			"latitude": 24.44319000
		}, {
			"areaId": 441625,
			"areaName": "东源县",
			"longitude": 114.74633000,
			"latitude": 23.78835000
		}]
	}, {
		"areaId": 4417,
		"areaName": "阳江市",
		"longitude": 111.97510700,
		"latitude": 21.85922200,
		"children": [{
			"areaId": 441702,
			"areaName": "江城区",
			"longitude": 111.95488000,
			"latitude": 21.86193000
		}, {
			"areaId": 441704,
			"areaName": "阳东区",
			"longitude": 112.01467000,
			"latitude": 21.87398000
		}, {
			"areaId": 441721,
			"areaName": "阳西县",
			"longitude": 111.61785000,
			"latitude": 21.75234000
		}, {
			"areaId": 441781,
			"areaName": "阳春市",
			"longitude": 111.78854000,
			"latitude": 22.17232000
		}]
	}, {
		"areaId": 4418,
		"areaName": "清远市",
		"longitude": 113.03677900,
		"latitude": 23.70418800,
		"children": [{
			"areaId": 441802,
			"areaName": "清城区",
			"longitude": 113.06265000,
			"latitude": 23.69784000
		}, {
			"areaId": 441803,
			"areaName": "清新区",
			"longitude": 113.01520300,
			"latitude": 23.73694900
		}, {
			"areaId": 441821,
			"areaName": "佛冈县",
			"longitude": 113.53286000,
			"latitude": 23.87231000
		}, {
			"areaId": 441823,
			"areaName": "阳山县",
			"longitude": 112.64129000,
			"latitude": 24.46516000
		}, {
			"areaId": 441825,
			"areaName": "连山壮族瑶族自治县",
			"longitude": 112.08020000,
			"latitude": 24.56807000
		}, {
			"areaId": 441826,
			"areaName": "连南瑶族自治县",
			"longitude": 112.28842000,
			"latitude": 24.71726000
		}, {
			"areaId": 441881,
			"areaName": "英德市",
			"longitude": 113.41500000,
			"latitude": 24.18571000
		}, {
			"areaId": 441882,
			"areaName": "连州市",
			"longitude": 112.38153000,
			"latitude": 24.77913000
		}]
	}, {
		"areaId": 4419,
		"areaName": "东莞市",
		"longitude": 113.76023400,
		"latitude": 23.04888400,
		"children": []
	}, {
		"areaId": 4420,
		"areaName": "中山市",
		"longitude": 113.38239100,
		"latitude": 22.52111300,
		"children": []
	}, {
		"areaId": 4451,
		"areaName": "潮州市",
		"longitude": 120.54285400,
		"latitude": 22.55053600,
		"children": [{
			"areaId": 445102,
			"areaName": "湘桥区",
			"longitude": 116.62805000,
			"latitude": 23.67451000
		}, {
			"areaId": 445103,
			"areaName": "潮安区",
			"longitude": 116.59289500,
			"latitude": 23.64365600
		}, {
			"areaId": 445122,
			"areaName": "饶平县",
			"longitude": 117.00692000,
			"latitude": 23.66994000
		}]
	}, {
		"areaId": 4452,
		"areaName": "揭阳市",
		"longitude": 116.35573300,
		"latitude": 23.54377800,
		"children": [{
			"areaId": 445202,
			"areaName": "榕城区",
			"longitude": 116.36710000,
			"latitude": 23.52508000
		}, {
			"areaId": 445203,
			"areaName": "揭东区",
			"longitude": 116.41294700,
			"latitude": 23.56988700
		}, {
			"areaId": 445222,
			"areaName": "揭西县",
			"longitude": 115.83883000,
			"latitude": 23.42714000
		}, {
			"areaId": 445224,
			"areaName": "惠来县",
			"longitude": 116.29599000,
			"latitude": 23.03289000
		}, {
			"areaId": 445281,
			"areaName": "普宁市",
			"longitude": 116.16564000,
			"latitude": 23.29732000
		}]
	}, {
		"areaId": 4453,
		"areaName": "云浮市",
		"longitude": 112.04443900,
		"latitude": 22.92980100,
		"children": [{
			"areaId": 445302,
			"areaName": "云城区",
			"longitude": 112.03908000,
			"latitude": 22.92996000
		}, {
			"areaId": 445303,
			"areaName": "云安区",
			"longitude": 112.00936000,
			"latitude": 23.07779000
		}, {
			"areaId": 445321,
			"areaName": "新兴县",
			"longitude": 112.23019000,
			"latitude": 22.69734000
		}, {
			"areaId": 445322,
			"areaName": "郁南县",
			"longitude": 111.53387000,
			"latitude": 23.23307000
		}, {
			"areaId": 445381,
			"areaName": "罗定市",
			"longitude": 111.56979000,
			"latitude": 22.76967000
		}]
	}]
}, {
	"areaId": 45,
	"areaName": "广西壮族自治区",
	"longitude": 108.32000400,
	"latitude": 22.82402000,
	"children": [{
		"areaId": 4501,
		"areaName": "南宁市",
		"longitude": 108.32000400,
		"latitude": 22.82402000,
		"children": [{
			"areaId": 450102,
			"areaName": "兴宁区",
			"longitude": 108.36694000,
			"latitude": 22.85355000
		}, {
			"areaId": 450103,
			"areaName": "青秀区",
			"longitude": 108.49545000,
			"latitude": 22.78511000
		}, {
			"areaId": 450105,
			"areaName": "江南区",
			"longitude": 108.27325000,
			"latitude": 22.78127000
		}, {
			"areaId": 450107,
			"areaName": "西乡塘区",
			"longitude": 108.31347000,
			"latitude": 22.83386000
		}, {
			"areaId": 450108,
			"areaName": "良庆区",
			"longitude": 108.41284000,
			"latitude": 22.74914000
		}, {
			"areaId": 450109,
			"areaName": "邕宁区",
			"longitude": 108.48684000,
			"latitude": 22.75628000
		}, {
			"areaId": 450110,
			"areaName": "武鸣区",
			"longitude": 108.27719000,
			"latitude": 23.15643000
		}, {
			"areaId": 450123,
			"areaName": "隆安县",
			"longitude": 107.69192000,
			"latitude": 23.17336000
		}, {
			"areaId": 450124,
			"areaName": "马山县",
			"longitude": 108.17697000,
			"latitude": 23.70931000
		}, {
			"areaId": 450125,
			"areaName": "上林县",
			"longitude": 108.60522000,
			"latitude": 23.43200000
		}, {
			"areaId": 450126,
			"areaName": "宾阳县",
			"longitude": 108.81185000,
			"latitude": 23.21960000
		}, {
			"areaId": 450127,
			"areaName": "横县",
			"longitude": 109.26608000,
			"latitude": 22.68448000
		}]
	}, {
		"areaId": 4502,
		"areaName": "柳州市",
		"longitude": 109.41170300,
		"latitude": 24.31461700,
		"children": [{
			"areaId": 450202,
			"areaName": "城中区",
			"longitude": 101.78394000,
			"latitude": 36.62279000
		}, {
			"areaId": 450203,
			"areaName": "鱼峰区",
			"longitude": 109.45330000,
			"latitude": 24.31868000
		}, {
			"areaId": 450204,
			"areaName": "柳南区",
			"longitude": 109.38548000,
			"latitude": 24.33599000
		}, {
			"areaId": 450205,
			"areaName": "柳北区",
			"longitude": 109.40202000,
			"latitude": 24.36267000
		}, {
			"areaId": 450206,
			"areaName": "柳江区",
			"longitude": 109.33273000,
			"latitude": 24.25596000
		}, {
			"areaId": 450222,
			"areaName": "柳城县",
			"longitude": 109.23877000,
			"latitude": 24.64951000
		}, {
			"areaId": 450223,
			"areaName": "鹿寨县",
			"longitude": 109.75177000,
			"latitude": 24.47306000
		}, {
			"areaId": 450224,
			"areaName": "融安县",
			"longitude": 109.39761000,
			"latitude": 25.22465000
		}, {
			"areaId": 450225,
			"areaName": "融水苗族自治县",
			"longitude": 109.25634000,
			"latitude": 25.06628000
		}, {
			"areaId": 450226,
			"areaName": "三江侗族自治县",
			"longitude": 109.60446000,
			"latitude": 25.78428000
		}]
	}, {
		"areaId": 4503,
		"areaName": "桂林市",
		"longitude": 110.29912100,
		"latitude": 25.27421500,
		"children": [{
			"areaId": 450302,
			"areaName": "秀峰区",
			"longitude": 110.28915000,
			"latitude": 25.28249000
		}, {
			"areaId": 450303,
			"areaName": "叠彩区",
			"longitude": 110.30195000,
			"latitude": 25.31381000
		}, {
			"areaId": 450304,
			"areaName": "象山区",
			"longitude": 110.28108000,
			"latitude": 25.26168000
		}, {
			"areaId": 450305,
			"areaName": "七星区",
			"longitude": 110.31793000,
			"latitude": 25.25250000
		}, {
			"areaId": 450311,
			"areaName": "雁山区",
			"longitude": 110.30911000,
			"latitude": 25.06038000
		}, {
			"areaId": 450312,
			"areaName": "临桂区",
			"longitude": 110.20548700,
			"latitude": 25.24625700
		}, {
			"areaId": 450321,
			"areaName": "阳朔县",
			"longitude": 110.49475000,
			"latitude": 24.77579000
		}, {
			"areaId": 450323,
			"areaName": "灵川县",
			"longitude": 110.32949000,
			"latitude": 25.41292000
		}, {
			"areaId": 450324,
			"areaName": "全州县",
			"longitude": 111.07211000,
			"latitude": 25.92799000
		}, {
			"areaId": 450325,
			"areaName": "兴安县",
			"longitude": 110.67144000,
			"latitude": 25.61167000
		}, {
			"areaId": 450326,
			"areaName": "永福县",
			"longitude": 109.98333000,
			"latitude": 24.98004000
		}, {
			"areaId": 450327,
			"areaName": "灌阳县",
			"longitude": 111.15954000,
			"latitude": 25.48803000
		}, {
			"areaId": 450328,
			"areaName": "龙胜各族自治县",
			"longitude": 110.01226000,
			"latitude": 25.79614000
		}, {
			"areaId": 450329,
			"areaName": "资源县",
			"longitude": 110.65255000,
			"latitude": 26.04237000
		}, {
			"areaId": 450330,
			"areaName": "平乐县",
			"longitude": 110.64175000,
			"latitude": 24.63242000
		}, {
			"areaId": 450332,
			"areaName": "恭城瑶族自治县",
			"longitude": 110.83035000,
			"latitude": 24.83286000
		}, {
			"areaId": 450381,
			"areaName": "荔浦市",
			"longitude": 110.39710000,
			"latitude": 24.49589000
		}]
	}, {
		"areaId": 4504,
		"areaName": "梧州市",
		"longitude": 111.31622900,
		"latitude": 23.47230900,
		"children": [{
			"areaId": 450403,
			"areaName": "万秀区",
			"longitude": 111.32052000,
			"latitude": 23.47298000
		}, {
			"areaId": 450405,
			"areaName": "长洲区",
			"longitude": 111.27494000,
			"latitude": 23.48573000
		}, {
			"areaId": 450406,
			"areaName": "龙圩区",
			"longitude": 111.31622900,
			"latitude": 23.47230900
		}, {
			"areaId": 450421,
			"areaName": "苍梧县",
			"longitude": 111.24533000,
			"latitude": 23.42049000
		}, {
			"areaId": 450422,
			"areaName": "藤县",
			"longitude": 110.91418000,
			"latitude": 23.37605000
		}, {
			"areaId": 450423,
			"areaName": "蒙山县",
			"longitude": 110.52221000,
			"latitude": 24.20168000
		}, {
			"areaId": 450481,
			"areaName": "岑溪市",
			"longitude": 110.99594000,
			"latitude": 22.91910000
		}]
	}, {
		"areaId": 4505,
		"areaName": "北海市",
		"longitude": 109.11925400,
		"latitude": 21.47334300,
		"children": [{
			"areaId": 450502,
			"areaName": "海城区",
			"longitude": 109.11744000,
			"latitude": 21.47501000
		}, {
			"areaId": 450503,
			"areaName": "银海区",
			"longitude": 109.13029000,
			"latitude": 21.47830000
		}, {
			"areaId": 450512,
			"areaName": "铁山港区",
			"longitude": 109.45578000,
			"latitude": 21.59661000
		}, {
			"areaId": 450521,
			"areaName": "合浦县",
			"longitude": 109.20068000,
			"latitude": 21.66601000
		}]
	}, {
		"areaId": 4506,
		"areaName": "防城港市",
		"longitude": 108.34547800,
		"latitude": 21.61463100,
		"children": [{
			"areaId": 450602,
			"areaName": "港口区",
			"longitude": 108.38022000,
			"latitude": 21.64342000
		}, {
			"areaId": 450603,
			"areaName": "防城区",
			"longitude": 108.35726000,
			"latitude": 21.76464000
		}, {
			"areaId": 450621,
			"areaName": "上思县",
			"longitude": 107.98230000,
			"latitude": 22.14957000
		}, {
			"areaId": 450681,
			"areaName": "东兴市",
			"longitude": 107.97204000,
			"latitude": 21.54713000
		}]
	}, {
		"areaId": 4507,
		"areaName": "钦州市",
		"longitude": 108.62417500,
		"latitude": 21.96712700,
		"children": [{
			"areaId": 450702,
			"areaName": "钦南区",
			"longitude": 108.61775000,
			"latitude": 21.95137000
		}, {
			"areaId": 450703,
			"areaName": "钦北区",
			"longitude": 108.63037000,
			"latitude": 21.95127000
		}, {
			"areaId": 450721,
			"areaName": "灵山县",
			"longitude": 109.29153000,
			"latitude": 22.41650000
		}, {
			"areaId": 450722,
			"areaName": "浦北县",
			"longitude": 109.55572000,
			"latitude": 22.26888000
		}]
	}, {
		"areaId": 4508,
		"areaName": "贵港市",
		"longitude": 109.60214600,
		"latitude": 23.09360000,
		"children": [{
			"areaId": 450802,
			"areaName": "港北区",
			"longitude": 109.57224000,
			"latitude": 23.11153000
		}, {
			"areaId": 450803,
			"areaName": "港南区",
			"longitude": 109.60617000,
			"latitude": 23.07226000
		}, {
			"areaId": 450804,
			"areaName": "覃塘区",
			"longitude": 109.44293000,
			"latitude": 23.12677000
		}, {
			"areaId": 450821,
			"areaName": "平南县",
			"longitude": 110.39062000,
			"latitude": 23.54201000
		}, {
			"areaId": 450881,
			"areaName": "桂平市",
			"longitude": 110.08105000,
			"latitude": 23.39339000
		}]
	}, {
		"areaId": 4509,
		"areaName": "玉林市",
		"longitude": 110.15439300,
		"latitude": 22.63136000,
		"children": [{
			"areaId": 450902,
			"areaName": "玉州区",
			"longitude": 110.15114000,
			"latitude": 22.62810000
		}, {
			"areaId": 450903,
			"areaName": "福绵区",
			"longitude": 110.06481600,
			"latitude": 22.58305700
		}, {
			"areaId": 450921,
			"areaName": "容县",
			"longitude": 110.55593000,
			"latitude": 22.85701000
		}, {
			"areaId": 450922,
			"areaName": "陆川县",
			"longitude": 110.26413000,
			"latitude": 22.32454000
		}, {
			"areaId": 450923,
			"areaName": "博白县",
			"longitude": 109.97744000,
			"latitude": 22.27286000
		}, {
			"areaId": 450924,
			"areaName": "兴业县",
			"longitude": 109.87612000,
			"latitude": 22.74237000
		}, {
			"areaId": 450981,
			"areaName": "北流市",
			"longitude": 110.35302000,
			"latitude": 22.70817000
		}]
	}, {
		"areaId": 4510,
		"areaName": "百色市",
		"longitude": 106.61628500,
		"latitude": 23.89774200,
		"children": [{
			"areaId": 451002,
			"areaName": "右江区",
			"longitude": 106.61764000,
			"latitude": 23.90090000
		}, {
			"areaId": 451003,
			"areaName": "田阳区",
			"longitude": 106.91558000,
			"latitude": 23.73535000
		}, {
			"areaId": 451022,
			"areaName": "田东县",
			"longitude": 107.12432000,
			"latitude": 23.60003000
		}, {
			"areaId": 451024,
			"areaName": "德保县",
			"longitude": 106.61917000,
			"latitude": 23.32515000
		}, {
			"areaId": 451026,
			"areaName": "那坡县",
			"longitude": 105.84191000,
			"latitude": 23.40649000
		}, {
			"areaId": 451027,
			"areaName": "凌云县",
			"longitude": 106.56155000,
			"latitude": 24.34747000
		}, {
			"areaId": 451028,
			"areaName": "乐业县",
			"longitude": 106.56124000,
			"latitude": 24.78295000
		}, {
			"areaId": 451029,
			"areaName": "田林县",
			"longitude": 106.22882000,
			"latitude": 24.29207000
		}, {
			"areaId": 451030,
			"areaName": "西林县",
			"longitude": 105.09722000,
			"latitude": 24.48966000
		}, {
			"areaId": 451031,
			"areaName": "隆林各族自治县",
			"longitude": 105.34295000,
			"latitude": 24.77036000
		}, {
			"areaId": 451081,
			"areaName": "靖西市",
			"longitude": 106.41766000,
			"latitude": 23.13425000
		}, {
			"areaId": 451082,
			"areaName": "平果市",
			"longitude": 107.59045000,
			"latitude": 23.32969000
		}]
	}, {
		"areaId": 4511,
		"areaName": "贺州市",
		"longitude": 111.55205600,
		"latitude": 24.41414100,
		"children": [{
			"areaId": 451102,
			"areaName": "八步区",
			"longitude": 111.55225000,
			"latitude": 24.41179000
		}, {
			"areaId": 451103,
			"areaName": "平桂区",
			"longitude": 111.48565100,
			"latitude": 24.45804100
		}, {
			"areaId": 451121,
			"areaName": "昭平县",
			"longitude": 110.81082000,
			"latitude": 24.17010000
		}, {
			"areaId": 451122,
			"areaName": "钟山县",
			"longitude": 111.30459000,
			"latitude": 24.52482000
		}, {
			"areaId": 451123,
			"areaName": "富川瑶族自治县",
			"longitude": 111.27767000,
			"latitude": 24.81431000
		}]
	}, {
		"areaId": 4512,
		"areaName": "河池市",
		"longitude": 108.06210500,
		"latitude": 24.69589900,
		"children": [{
			"areaId": 451202,
			"areaName": "金城江区",
			"longitude": 118.31666700,
			"latitude": 24.41666700
		}, {
			"areaId": 451203,
			"areaName": "宜州区",
			"longitude": 108.65304000,
			"latitude": 24.49391000
		}, {
			"areaId": 451221,
			"areaName": "南丹县",
			"longitude": 107.54562000,
			"latitude": 24.97760000
		}, {
			"areaId": 451222,
			"areaName": "天峨县",
			"longitude": 107.17205000,
			"latitude": 24.99593000
		}, {
			"areaId": 451223,
			"areaName": "凤山县",
			"longitude": 120.35689200,
			"latitude": 22.62694500
		}, {
			"areaId": 451224,
			"areaName": "东兰县",
			"longitude": 107.37527000,
			"latitude": 24.51053000
		}, {
			"areaId": 451225,
			"areaName": "罗城仫佬族自治县",
			"longitude": 108.90777000,
			"latitude": 24.77923000
		}, {
			"areaId": 451226,
			"areaName": "环江毛南族自治县",
			"longitude": 108.26055000,
			"latitude": 24.82916000
		}, {
			"areaId": 451227,
			"areaName": "巴马瑶族自治县",
			"longitude": 107.25308000,
			"latitude": 24.14135000
		}, {
			"areaId": 451228,
			"areaName": "都安瑶族自治县",
			"longitude": 108.10116000,
			"latitude": 23.93245000
		}, {
			"areaId": 451229,
			"areaName": "大化瑶族自治县",
			"longitude": 107.99850000,
			"latitude": 23.74487000
		}]
	}, {
		"areaId": 4513,
		"areaName": "来宾市",
		"longitude": 109.22977200,
		"latitude": 23.73376600,
		"children": [{
			"areaId": 451302,
			"areaName": "兴宾区",
			"longitude": 109.23471000,
			"latitude": 23.72731000
		}, {
			"areaId": 451321,
			"areaName": "忻城县",
			"longitude": 108.66357000,
			"latitude": 24.06862000
		}, {
			"areaId": 451322,
			"areaName": "象州县",
			"longitude": 109.69940000,
			"latitude": 23.97355000
		}, {
			"areaId": 451323,
			"areaName": "武宣县",
			"longitude": 109.66284000,
			"latitude": 23.59474000
		}, {
			"areaId": 451324,
			"areaName": "金秀瑶族自治县",
			"longitude": 110.19079000,
			"latitude": 24.12929000
		}, {
			"areaId": 451381,
			"areaName": "合山市",
			"longitude": 108.88586000,
			"latitude": 23.80619000
		}]
	}, {
		"areaId": 4514,
		"areaName": "崇左市",
		"longitude": 107.35392600,
		"latitude": 22.40410800,
		"children": [{
			"areaId": 451402,
			"areaName": "江州区",
			"longitude": 107.34747000,
			"latitude": 22.41135000
		}, {
			"areaId": 451421,
			"areaName": "扶绥县",
			"longitude": 107.90405000,
			"latitude": 22.63413000
		}, {
			"areaId": 451422,
			"areaName": "宁明县",
			"longitude": 107.07299000,
			"latitude": 22.13655000
		}, {
			"areaId": 451423,
			"areaName": "龙州县",
			"longitude": 106.85415000,
			"latitude": 22.33937000
		}, {
			"areaId": 451424,
			"areaName": "大新县",
			"longitude": 107.19821000,
			"latitude": 22.83412000
		}, {
			"areaId": 451425,
			"areaName": "天等县",
			"longitude": 107.13998000,
			"latitude": 23.07700000
		}, {
			"areaId": 451481,
			"areaName": "凭祥市",
			"longitude": 106.75534000,
			"latitude": 22.10573000
		}]
	}]
}, {
	"areaId": 46,
	"areaName": "海南省",
	"longitude": 110.33119000,
	"latitude": 20.03197100,
	"children": [{
		"areaId": 4601,
		"areaName": "海口市",
		"longitude": 110.33119000,
		"latitude": 20.03197100,
		"children": [{
			"areaId": 460105,
			"areaName": "秀英区",
			"longitude": 110.29345000,
			"latitude": 20.00752000
		}, {
			"areaId": 460106,
			"areaName": "龙华区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 460107,
			"areaName": "琼山区",
			"longitude": 110.35418000,
			"latitude": 20.00321000
		}, {
			"areaId": 460108,
			"areaName": "美兰区",
			"longitude": 110.36908000,
			"latitude": 20.02864000
		}]
	}, {
		"areaId": 4602,
		"areaName": "三亚市",
		"longitude": 109.50826800,
		"latitude": 18.24787200,
		"children": [{
			"areaId": 460202,
			"areaName": "海棠区",
			"longitude": 109.50826800,
			"latitude": 18.24787200
		}, {
			"areaId": 460203,
			"areaName": "吉阳区",
			"longitude": 109.50826800,
			"latitude": 18.24787200
		}, {
			"areaId": 460204,
			"areaName": "天涯区",
			"longitude": 109.50826800,
			"latitude": 18.24787200
		}, {
			"areaId": 460205,
			"areaName": "崖州区",
			"longitude": 109.50826800,
			"latitude": 18.24787200
		}]
	}, {
		"areaId": 4603,
		"areaName": "三沙市",
		"longitude": 112.34882000,
		"latitude": 16.83103900,
		"children": [{
			"areaId": 460321,
			"areaName": "西沙群岛",
			"longitude": 112.02552800,
			"latitude": 16.33134200
		}, {
			"areaId": 460322,
			"areaName": "南沙群岛",
			"longitude": 116.74999800,
			"latitude": 11.47188800
		}, {
			"areaId": 460323,
			"areaName": "中沙群岛的岛礁及其海域",
			"longitude": 117.74007100,
			"latitude": 15.11285600
		}]
	}, {
		"areaId": 4604,
		"areaName": "儋州市",
		"longitude": 109.57678200,
		"latitude": 19.51748600,
		"children": []
	}, {
		"areaId": 4690,
		"areaName": "省直辖县级行政区划",
		"longitude": 0.00000000,
		"latitude": 0.00000000,
		"children": [{
			"areaId": 469001,
			"areaName": "五指山市",
			"longitude": 109.51666200,
			"latitude": 18.77692100
		}, {
			"areaId": 469002,
			"areaName": "琼海市",
			"longitude": 110.46678500,
			"latitude": 19.24601100
		}, {
			"areaId": 469005,
			"areaName": "文昌市",
			"longitude": 110.75397500,
			"latitude": 19.61298600
		}, {
			"areaId": 469006,
			"areaName": "万宁市",
			"longitude": 110.38879300,
			"latitude": 18.79621600
		}, {
			"areaId": 469007,
			"areaName": "东方市",
			"longitude": 108.65378900,
			"latitude": 19.10198000
		}, {
			"areaId": 469021,
			"areaName": "定安县",
			"longitude": 110.32395900,
			"latitude": 19.69921100
		}, {
			"areaId": 469022,
			"areaName": "屯昌县",
			"longitude": 110.10277300,
			"latitude": 19.36291600
		}, {
			"areaId": 469023,
			"areaName": "澄迈县",
			"longitude": 110.00714700,
			"latitude": 19.73709500
		}, {
			"areaId": 469024,
			"areaName": "临高县",
			"longitude": 109.68769700,
			"latitude": 19.90829300
		}, {
			"areaId": 469025,
			"areaName": "白沙黎族自治县",
			"longitude": 119.59791900,
			"latitude": 23.66606000
		}, {
			"areaId": 469026,
			"areaName": "昌江黎族自治县",
			"longitude": 109.05335100,
			"latitude": 19.26096800
		}, {
			"areaId": 469027,
			"areaName": "乐东黎族自治县",
			"longitude": 109.17544400,
			"latitude": 18.74758000
		}, {
			"areaId": 469028,
			"areaName": "陵水黎族自治县",
			"longitude": 110.03721800,
			"latitude": 18.50500600
		}, {
			"areaId": 469029,
			"areaName": "保亭黎族苗族自治县",
			"longitude": 109.70245000,
			"latitude": 18.63637100
		}, {
			"areaId": 469030,
			"areaName": "琼中黎族苗族自治县",
			"longitude": 109.83999600,
			"latitude": 19.03557000
		}]
	}]
}, {
	"areaId": 50,
	"areaName": "重庆市",
	"longitude": 106.50496200,
	"latitude": 29.53315500,
	"children": [{
		"areaId": 500101,
		"areaName": "万州区",
		"longitude": 108.40869000,
		"latitude": 30.80788000,
		"children": []
	}, {
		"areaId": 500102,
		"areaName": "涪陵区",
		"longitude": 107.39007000,
		"latitude": 29.70292000,
		"children": []
	}, {
		"areaId": 500103,
		"areaName": "渝中区",
		"longitude": 106.56901000,
		"latitude": 29.55279000,
		"children": []
	}, {
		"areaId": 500104,
		"areaName": "大渡口区",
		"longitude": 106.48262000,
		"latitude": 29.48447000,
		"children": []
	}, {
		"areaId": 500105,
		"areaName": "江北区",
		"longitude": 0.00000000,
		"latitude": 0.00000000,
		"children": []
	}, {
		"areaId": 500106,
		"areaName": "沙坪坝区",
		"longitude": 106.45752000,
		"latitude": 29.54113000,
		"children": []
	}, {
		"areaId": 500107,
		"areaName": "九龙坡区",
		"longitude": 114.17495000,
		"latitude": 22.32711500,
		"children": []
	}, {
		"areaId": 500108,
		"areaName": "南岸区",
		"longitude": 106.56347000,
		"latitude": 29.52311000,
		"children": []
	}, {
		"areaId": 500109,
		"areaName": "北碚区",
		"longitude": 106.39614000,
		"latitude": 29.80574000,
		"children": []
	}, {
		"areaId": 500110,
		"areaName": "綦江区",
		"longitude": 106.92677900,
		"latitude": 28.96065600,
		"children": []
	}, {
		"areaId": 500111,
		"areaName": "大足区",
		"longitude": 105.76812100,
		"latitude": 29.48402500,
		"children": []
	}, {
		"areaId": 500112,
		"areaName": "渝北区",
		"longitude": 106.63070000,
		"latitude": 29.71820000,
		"children": []
	}, {
		"areaId": 500113,
		"areaName": "巴南区",
		"longitude": 106.52365000,
		"latitude": 29.38311000,
		"children": []
	}, {
		"areaId": 500114,
		"areaName": "黔江区",
		"longitude": 108.77090000,
		"latitude": 29.53320000,
		"children": []
	}, {
		"areaId": 500115,
		"areaName": "长寿区",
		"longitude": 107.08166000,
		"latitude": 29.85359000,
		"children": []
	}, {
		"areaId": 500116,
		"areaName": "江津区",
		"longitude": 106.25912000,
		"latitude": 29.29008000,
		"children": []
	}, {
		"areaId": 500117,
		"areaName": "合川区",
		"longitude": 106.27633000,
		"latitude": 29.97227000,
		"children": []
	}, {
		"areaId": 500118,
		"areaName": "永川区",
		"longitude": 105.92700000,
		"latitude": 29.35593000,
		"children": []
	}, {
		"areaId": 500119,
		"areaName": "南川区",
		"longitude": 107.09936000,
		"latitude": 29.15751000,
		"children": []
	}, {
		"areaId": 500120,
		"areaName": "璧山区",
		"longitude": 106.23112600,
		"latitude": 29.59358100,
		"children": []
	}, {
		"areaId": 500151,
		"areaName": "铜梁区",
		"longitude": 106.05494800,
		"latitude": 29.83994400,
		"children": []
	}, {
		"areaId": 500152,
		"areaName": "潼南区",
		"longitude": 0.00000000,
		"latitude": 0.00000000,
		"children": []
	}, {
		"areaId": 500153,
		"areaName": "荣昌区",
		"longitude": 105.59442000,
		"latitude": 29.40488000,
		"children": []
	}, {
		"areaId": 500154,
		"areaName": "开州区",
		"longitude": 0.00000000,
		"latitude": 0.00000000,
		"children": []
	}, {
		"areaId": 500155,
		"areaName": "梁平区",
		"longitude": 107.79998000,
		"latitude": 30.67545000,
		"children": []
	}, {
		"areaId": 500156,
		"areaName": "武隆区",
		"longitude": 107.76010000,
		"latitude": 29.32548000,
		"children": []
	}, {
		"areaId": 500229,
		"areaName": "城口县",
		"longitude": 108.66513000,
		"latitude": 31.94801000,
		"children": []
	}, {
		"areaId": 500230,
		"areaName": "丰都县",
		"longitude": 107.73098000,
		"latitude": 29.86348000,
		"children": []
	}, {
		"areaId": 500231,
		"areaName": "垫江县",
		"longitude": 107.35446000,
		"latitude": 30.33359000,
		"children": []
	}, {
		"areaId": 500233,
		"areaName": "忠县",
		"longitude": 108.03689000,
		"latitude": 30.28898000,
		"children": []
	}, {
		"areaId": 500235,
		"areaName": "云阳县",
		"longitude": 108.69726000,
		"latitude": 30.93062000,
		"children": []
	}, {
		"areaId": 500236,
		"areaName": "奉节县",
		"longitude": 109.46478000,
		"latitude": 31.01825000,
		"children": []
	}, {
		"areaId": 500237,
		"areaName": "巫山县",
		"longitude": 109.87814000,
		"latitude": 31.07458000,
		"children": []
	}, {
		"areaId": 500238,
		"areaName": "巫溪县",
		"longitude": 109.63128000,
		"latitude": 31.39756000,
		"children": []
	}, {
		"areaId": 500240,
		"areaName": "石柱土家族自治县",
		"longitude": 108.11389000,
		"latitude": 30.00054000,
		"children": []
	}, {
		"areaId": 500241,
		"areaName": "秀山土家族苗族自治县",
		"longitude": 108.98861000,
		"latitude": 28.45062000,
		"children": []
	}, {
		"areaId": 500242,
		"areaName": "酉阳土家族苗族自治县",
		"longitude": 108.77212000,
		"latitude": 28.84460000,
		"children": []
	}, {
		"areaId": 500243,
		"areaName": "彭水苗族土家族自治县",
		"longitude": 108.16638000,
		"latitude": 29.29516000,
		"children": []
	}]
}, {
	"areaId": 51,
	"areaName": "四川省",
	"longitude": 104.06573500,
	"latitude": 30.65946200,
	"children": [{
		"areaId": 5101,
		"areaName": "成都市",
		"longitude": 104.06573500,
		"latitude": 30.65946200,
		"children": [{
			"areaId": 510104,
			"areaName": "锦江区",
			"longitude": 104.08347000,
			"latitude": 30.65614000
		}, {
			"areaId": 510105,
			"areaName": "青羊区",
			"longitude": 104.06151000,
			"latitude": 30.67387000
		}, {
			"areaId": 510106,
			"areaName": "金牛区",
			"longitude": 104.05114000,
			"latitude": 30.69126000
		}, {
			"areaId": 510107,
			"areaName": "武侯区",
			"longitude": 104.04303000,
			"latitude": 30.64235000
		}, {
			"areaId": 510108,
			"areaName": "成华区",
			"longitude": 104.10193000,
			"latitude": 30.65993000
		}, {
			"areaId": 510112,
			"areaName": "龙泉驿区",
			"longitude": 104.27462000,
			"latitude": 30.55658000
		}, {
			"areaId": 510113,
			"areaName": "青白江区",
			"longitude": 104.25100000,
			"latitude": 30.87841000
		}, {
			"areaId": 510114,
			"areaName": "新都区",
			"longitude": 104.15921000,
			"latitude": 30.82314000
		}, {
			"areaId": 510115,
			"areaName": "温江区",
			"longitude": 103.84881000,
			"latitude": 30.68444000
		}, {
			"areaId": 510116,
			"areaName": "双流区",
			"longitude": 103.92373000,
			"latitude": 30.57444000
		}, {
			"areaId": 510117,
			"areaName": "郫都区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 510118,
			"areaName": "新津区",
			"longitude": 103.81140000,
			"latitude": 30.40983000
		}, {
			"areaId": 510121,
			"areaName": "金堂县",
			"longitude": 104.41195000,
			"latitude": 30.86195000
		}, {
			"areaId": 510129,
			"areaName": "大邑县",
			"longitude": 103.52075000,
			"latitude": 30.58738000
		}, {
			"areaId": 510131,
			"areaName": "蒲江县",
			"longitude": 103.50616000,
			"latitude": 30.19667000
		}, {
			"areaId": 510181,
			"areaName": "都江堰市",
			"longitude": 103.61941000,
			"latitude": 30.99825000
		}, {
			"areaId": 510182,
			"areaName": "彭州市",
			"longitude": 103.95800000,
			"latitude": 30.99011000
		}, {
			"areaId": 510183,
			"areaName": "邛崃市",
			"longitude": 103.46283000,
			"latitude": 30.41489000
		}, {
			"areaId": 510184,
			"areaName": "崇州市",
			"longitude": 103.67285000,
			"latitude": 30.63014000
		}, {
			"areaId": 510185,
			"areaName": "简阳市",
			"longitude": 104.54864000,
			"latitude": 30.39040000
		}]
	}, {
		"areaId": 5103,
		"areaName": "自贡市",
		"longitude": 104.77344700,
		"latitude": 29.35276500,
		"children": [{
			"areaId": 510302,
			"areaName": "自流井区",
			"longitude": 104.77719000,
			"latitude": 29.33745000
		}, {
			"areaId": 510303,
			"areaName": "贡井区",
			"longitude": 104.71536000,
			"latitude": 29.34576000
		}, {
			"areaId": 510304,
			"areaName": "大安区",
			"longitude": 120.58652000,
			"latitude": 24.34607000
		}, {
			"areaId": 510311,
			"areaName": "沿滩区",
			"longitude": 104.88012000,
			"latitude": 29.26611000
		}, {
			"areaId": 510321,
			"areaName": "荣县",
			"longitude": 104.41760000,
			"latitude": 29.44445000
		}, {
			"areaId": 510322,
			"areaName": "富顺县",
			"longitude": 104.97491000,
			"latitude": 29.18123000
		}]
	}, {
		"areaId": 5104,
		"areaName": "攀枝花市",
		"longitude": 101.71600700,
		"latitude": 26.58044600,
		"children": [{
			"areaId": 510402,
			"areaName": "东区",
			"longitude": 114.25599300,
			"latitude": 22.26275500
		}, {
			"areaId": 510403,
			"areaName": "西区",
			"longitude": 114.15437400,
			"latitude": 22.28198100
		}, {
			"areaId": 510411,
			"areaName": "仁和区",
			"longitude": 101.73812000,
			"latitude": 26.49841000
		}, {
			"areaId": 510421,
			"areaName": "米易县",
			"longitude": 102.11132000,
			"latitude": 26.88718000
		}, {
			"areaId": 510422,
			"areaName": "盐边县",
			"longitude": 101.85446000,
			"latitude": 26.68847000
		}]
	}, {
		"areaId": 5105,
		"areaName": "泸州市",
		"longitude": 105.44334800,
		"latitude": 28.88913800,
		"children": [{
			"areaId": 510502,
			"areaName": "江阳区",
			"longitude": 105.45336000,
			"latitude": 28.88934000
		}, {
			"areaId": 510503,
			"areaName": "纳溪区",
			"longitude": 105.37255000,
			"latitude": 28.77343000
		}, {
			"areaId": 510504,
			"areaName": "龙马潭区",
			"longitude": 105.43774000,
			"latitude": 28.91308000
		}, {
			"areaId": 510521,
			"areaName": "泸县",
			"longitude": 105.38192000,
			"latitude": 29.15041000
		}, {
			"areaId": 510522,
			"areaName": "合江县",
			"longitude": 105.83520000,
			"latitude": 28.81005000
		}, {
			"areaId": 510524,
			"areaName": "叙永县",
			"longitude": 105.44473000,
			"latitude": 28.15586000
		}, {
			"areaId": 510525,
			"areaName": "古蔺县",
			"longitude": 105.81347000,
			"latitude": 28.03867000
		}]
	}, {
		"areaId": 5106,
		"areaName": "德阳市",
		"longitude": 104.39865100,
		"latitude": 31.12799100,
		"children": [{
			"areaId": 510603,
			"areaName": "旌阳区",
			"longitude": 104.39367000,
			"latitude": 31.13906000
		}, {
			"areaId": 510604,
			"areaName": "罗江区",
			"longitude": 104.51025000,
			"latitude": 31.31665000
		}, {
			"areaId": 510623,
			"areaName": "中江县",
			"longitude": 104.67861000,
			"latitude": 31.03297000
		}, {
			"areaId": 510681,
			"areaName": "广汉市",
			"longitude": 104.28234000,
			"latitude": 30.97686000
		}, {
			"areaId": 510682,
			"areaName": "什邡市",
			"longitude": 104.16754000,
			"latitude": 31.12640000
		}, {
			"areaId": 510683,
			"areaName": "绵竹市",
			"longitude": 104.22076000,
			"latitude": 31.33772000
		}]
	}, {
		"areaId": 5107,
		"areaName": "绵阳市",
		"longitude": 104.74172200,
		"latitude": 31.46402000,
		"children": [{
			"areaId": 510703,
			"areaName": "涪城区",
			"longitude": 104.75719000,
			"latitude": 31.45522000
		}, {
			"areaId": 510704,
			"areaName": "游仙区",
			"longitude": 104.77092000,
			"latitude": 31.46574000
		}, {
			"areaId": 510705,
			"areaName": "安州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 510722,
			"areaName": "三台县",
			"longitude": 105.09079000,
			"latitude": 31.09179000
		}, {
			"areaId": 510723,
			"areaName": "盐亭县",
			"longitude": 105.38980000,
			"latitude": 31.22176000
		}, {
			"areaId": 510725,
			"areaName": "梓潼县",
			"longitude": 105.16183000,
			"latitude": 31.63590000
		}, {
			"areaId": 510726,
			"areaName": "北川羌族自治县",
			"longitude": 104.46408000,
			"latitude": 31.83286000
		}, {
			"areaId": 510727,
			"areaName": "平武县",
			"longitude": 104.52862000,
			"latitude": 32.40791000
		}, {
			"areaId": 510781,
			"areaName": "江油市",
			"longitude": 104.74539000,
			"latitude": 31.77775000
		}]
	}, {
		"areaId": 5108,
		"areaName": "广元市",
		"longitude": 105.82975700,
		"latitude": 32.43366800,
		"children": [{
			"areaId": 510802,
			"areaName": "利州区",
			"longitude": 105.82619400,
			"latitude": 32.43227600
		}, {
			"areaId": 510811,
			"areaName": "昭化区",
			"longitude": 105.64049100,
			"latitude": 32.38651800
		}, {
			"areaId": 510812,
			"areaName": "朝天区",
			"longitude": 105.89273000,
			"latitude": 32.64398000
		}, {
			"areaId": 510821,
			"areaName": "旺苍县",
			"longitude": 106.29022000,
			"latitude": 32.22845000
		}, {
			"areaId": 510822,
			"areaName": "青川县",
			"longitude": 105.23910000,
			"latitude": 32.58563000
		}, {
			"areaId": 510823,
			"areaName": "剑阁县",
			"longitude": 105.52520000,
			"latitude": 32.28845000
		}, {
			"areaId": 510824,
			"areaName": "苍溪县",
			"longitude": 105.93600000,
			"latitude": 31.73209000
		}]
	}, {
		"areaId": 5109,
		"areaName": "遂宁市",
		"longitude": 105.57133100,
		"latitude": 30.51331100,
		"children": [{
			"areaId": 510903,
			"areaName": "船山区",
			"longitude": 105.58090000,
			"latitude": 30.49991000
		}, {
			"areaId": 510904,
			"areaName": "安居区",
			"longitude": 105.46402000,
			"latitude": 30.35778000
		}, {
			"areaId": 510921,
			"areaName": "蓬溪县",
			"longitude": 105.70752000,
			"latitude": 30.75775000
		}, {
			"areaId": 510923,
			"areaName": "大英县",
			"longitude": 105.24346000,
			"latitude": 30.59434000
		}, {
			"areaId": 510981,
			"areaName": "射洪市",
			"longitude": 105.38922000,
			"latitude": 30.87203000
		}]
	}, {
		"areaId": 5110,
		"areaName": "内江市",
		"longitude": 105.06613800,
		"latitude": 29.58708000,
		"children": [{
			"areaId": 511002,
			"areaName": "市中区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 511011,
			"areaName": "东兴区",
			"longitude": 105.07554000,
			"latitude": 29.59278000
		}, {
			"areaId": 511024,
			"areaName": "威远县",
			"longitude": 104.66955000,
			"latitude": 29.52823000
		}, {
			"areaId": 511025,
			"areaName": "资中县",
			"longitude": 104.85205000,
			"latitude": 29.76409000
		}, {
			"areaId": 511071,
			"areaName": "内江经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 511083,
			"areaName": "隆昌市",
			"longitude": 105.28738000,
			"latitude": 29.33937000
		}]
	}, {
		"areaId": 5111,
		"areaName": "乐山市",
		"longitude": 103.76126300,
		"latitude": 29.58202400,
		"children": [{
			"areaId": 511102,
			"areaName": "市中区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 511111,
			"areaName": "沙湾区",
			"longitude": 103.54873000,
			"latitude": 29.41194000
		}, {
			"areaId": 511112,
			"areaName": "五通桥区",
			"longitude": 103.82345000,
			"latitude": 29.40344000
		}, {
			"areaId": 511113,
			"areaName": "金口河区",
			"longitude": 103.07858000,
			"latitude": 29.24578000
		}, {
			"areaId": 511123,
			"areaName": "犍为县",
			"longitude": 103.94989000,
			"latitude": 29.20973000
		}, {
			"areaId": 511124,
			"areaName": "井研县",
			"longitude": 104.07019000,
			"latitude": 29.65228000
		}, {
			"areaId": 511126,
			"areaName": "夹江县",
			"longitude": 103.57199000,
			"latitude": 29.73868000
		}, {
			"areaId": 511129,
			"areaName": "沐川县",
			"longitude": 103.90353000,
			"latitude": 28.95646000
		}, {
			"areaId": 511132,
			"areaName": "峨边彝族自治县",
			"longitude": 103.26339000,
			"latitude": 29.23004000
		}, {
			"areaId": 511133,
			"areaName": "马边彝族自治县",
			"longitude": 103.54617000,
			"latitude": 28.83593000
		}, {
			"areaId": 511181,
			"areaName": "峨眉山市",
			"longitude": 121.01529100,
			"latitude": 24.68612700
		}]
	}, {
		"areaId": 5113,
		"areaName": "南充市",
		"longitude": 106.08297400,
		"latitude": 30.79528100,
		"children": [{
			"areaId": 511302,
			"areaName": "顺庆区",
			"longitude": 106.09216000,
			"latitude": 30.79642000
		}, {
			"areaId": 511303,
			"areaName": "高坪区",
			"longitude": 106.11894000,
			"latitude": 30.78162000
		}, {
			"areaId": 511304,
			"areaName": "嘉陵区",
			"longitude": 106.07141000,
			"latitude": 30.75848000
		}, {
			"areaId": 511321,
			"areaName": "南部县",
			"longitude": 106.06738000,
			"latitude": 31.35451000
		}, {
			"areaId": 511322,
			"areaName": "营山县",
			"longitude": 106.56637000,
			"latitude": 31.07747000
		}, {
			"areaId": 511323,
			"areaName": "蓬安县",
			"longitude": 106.41262000,
			"latitude": 31.02964000
		}, {
			"areaId": 511324,
			"areaName": "仪陇县",
			"longitude": 106.29974000,
			"latitude": 31.27628000
		}, {
			"areaId": 511325,
			"areaName": "西充县",
			"longitude": 105.89996000,
			"latitude": 30.99690000
		}, {
			"areaId": 511381,
			"areaName": "阆中市",
			"longitude": 106.00494000,
			"latitude": 31.55832000
		}]
	}, {
		"areaId": 5114,
		"areaName": "眉山市",
		"longitude": 103.83178800,
		"latitude": 30.04831800,
		"children": [{
			"areaId": 511402,
			"areaName": "东坡区",
			"longitude": 103.83200000,
			"latitude": 30.04219000
		}, {
			"areaId": 511403,
			"areaName": "彭山区",
			"longitude": 103.87268000,
			"latitude": 30.19283000
		}, {
			"areaId": 511421,
			"areaName": "仁寿县",
			"longitude": 104.13412000,
			"latitude": 29.99599000
		}, {
			"areaId": 511423,
			"areaName": "洪雅县",
			"longitude": 103.37313000,
			"latitude": 29.90661000
		}, {
			"areaId": 511424,
			"areaName": "丹棱县",
			"longitude": 103.51339000,
			"latitude": 30.01562000
		}, {
			"areaId": 511425,
			"areaName": "青神县",
			"longitude": 103.84771000,
			"latitude": 29.83235000
		}]
	}, {
		"areaId": 5115,
		"areaName": "宜宾市",
		"longitude": 104.63082500,
		"latitude": 28.76018900,
		"children": [{
			"areaId": 511502,
			"areaName": "翠屏区",
			"longitude": 104.61978000,
			"latitude": 28.76566000
		}, {
			"areaId": 511503,
			"areaName": "南溪区",
			"longitude": 104.98113300,
			"latitude": 28.83980600
		}, {
			"areaId": 511504,
			"areaName": "叙州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 511523,
			"areaName": "江安县",
			"longitude": 105.06683000,
			"latitude": 28.72385000
		}, {
			"areaId": 511524,
			"areaName": "长宁县",
			"longitude": 104.92520000,
			"latitude": 28.57777000
		}, {
			"areaId": 511525,
			"areaName": "高县",
			"longitude": 104.51754000,
			"latitude": 28.43619000
		}, {
			"areaId": 511526,
			"areaName": "珙县",
			"longitude": 104.71398000,
			"latitude": 28.44512000
		}, {
			"areaId": 511527,
			"areaName": "筠连县",
			"longitude": 104.51217000,
			"latitude": 28.16495000
		}, {
			"areaId": 511528,
			"areaName": "兴文县",
			"longitude": 105.23675000,
			"latitude": 28.30440000
		}, {
			"areaId": 511529,
			"areaName": "屏山县",
			"longitude": 104.16293000,
			"latitude": 28.64369000
		}]
	}, {
		"areaId": 5116,
		"areaName": "广安市",
		"longitude": 106.63336900,
		"latitude": 30.45639800,
		"children": [{
			"areaId": 511602,
			"areaName": "广安区",
			"longitude": 106.64163000,
			"latitude": 30.47389000
		}, {
			"areaId": 511603,
			"areaName": "前锋区",
			"longitude": 106.89353700,
			"latitude": 30.49457200
		}, {
			"areaId": 511621,
			"areaName": "岳池县",
			"longitude": 106.44079000,
			"latitude": 30.53918000
		}, {
			"areaId": 511622,
			"areaName": "武胜县",
			"longitude": 106.29592000,
			"latitude": 30.34932000
		}, {
			"areaId": 511623,
			"areaName": "邻水县",
			"longitude": 106.92968000,
			"latitude": 30.33449000
		}, {
			"areaId": 511681,
			"areaName": "华蓥市",
			"longitude": 106.78466000,
			"latitude": 30.39007000
		}]
	}, {
		"areaId": 5117,
		"areaName": "达州市",
		"longitude": 107.50226200,
		"latitude": 31.20948400,
		"children": [{
			"areaId": 511702,
			"areaName": "通川区",
			"longitude": 107.50456000,
			"latitude": 31.21469000
		}, {
			"areaId": 511703,
			"areaName": "达川区",
			"longitude": 107.50226200,
			"latitude": 31.20948400
		}, {
			"areaId": 511722,
			"areaName": "宣汉县",
			"longitude": 107.72775000,
			"latitude": 31.35516000
		}, {
			"areaId": 511723,
			"areaName": "开江县",
			"longitude": 107.86889000,
			"latitude": 31.08410000
		}, {
			"areaId": 511724,
			"areaName": "大竹县",
			"longitude": 107.20855000,
			"latitude": 30.74147000
		}, {
			"areaId": 511725,
			"areaName": "渠县",
			"longitude": 106.97381000,
			"latitude": 30.83760000
		}, {
			"areaId": 511771,
			"areaName": "达州经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 511781,
			"areaName": "万源市",
			"longitude": 108.03598000,
			"latitude": 32.08091000
		}]
	}, {
		"areaId": 5118,
		"areaName": "雅安市",
		"longitude": 103.00103300,
		"latitude": 29.98772200,
		"children": [{
			"areaId": 511802,
			"areaName": "雨城区",
			"longitude": 103.03305000,
			"latitude": 30.00531000
		}, {
			"areaId": 511803,
			"areaName": "名山区",
			"longitude": 103.11221400,
			"latitude": 30.08471800
		}, {
			"areaId": 511822,
			"areaName": "荥经县",
			"longitude": 102.84652000,
			"latitude": 29.79402000
		}, {
			"areaId": 511823,
			"areaName": "汉源县",
			"longitude": 102.67840000,
			"latitude": 29.35168000
		}, {
			"areaId": 511824,
			"areaName": "石棉县",
			"longitude": 102.35943000,
			"latitude": 29.22796000
		}, {
			"areaId": 511825,
			"areaName": "天全县",
			"longitude": 102.75906000,
			"latitude": 30.06754000
		}, {
			"areaId": 511826,
			"areaName": "芦山县",
			"longitude": 102.92791000,
			"latitude": 30.14369000
		}, {
			"areaId": 511827,
			"areaName": "宝兴县",
			"longitude": 102.81555000,
			"latitude": 30.36836000
		}]
	}, {
		"areaId": 5119,
		"areaName": "巴中市",
		"longitude": 106.75366900,
		"latitude": 31.85880900,
		"children": [{
			"areaId": 511902,
			"areaName": "巴州区",
			"longitude": 106.76889000,
			"latitude": 31.85125000
		}, {
			"areaId": 511903,
			"areaName": "恩阳区",
			"longitude": 106.75366900,
			"latitude": 31.85880900
		}, {
			"areaId": 511921,
			"areaName": "通江县",
			"longitude": 107.24398000,
			"latitude": 31.91294000
		}, {
			"areaId": 511922,
			"areaName": "南江县",
			"longitude": 106.84164000,
			"latitude": 32.35335000
		}, {
			"areaId": 511923,
			"areaName": "平昌县",
			"longitude": 107.10424000,
			"latitude": 31.55940000
		}, {
			"areaId": 511971,
			"areaName": "巴中经济开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 5120,
		"areaName": "资阳市",
		"longitude": 104.64191700,
		"latitude": 30.12221100,
		"children": [{
			"areaId": 512002,
			"areaName": "雁江区",
			"longitude": 104.65216000,
			"latitude": 30.11525000
		}, {
			"areaId": 512021,
			"areaName": "安岳县",
			"longitude": 105.33630000,
			"latitude": 30.09786000
		}, {
			"areaId": 512022,
			"areaName": "乐至县",
			"longitude": 105.03207000,
			"latitude": 30.27227000
		}]
	}, {
		"areaId": 5132,
		"areaName": "阿坝藏族羌族自治州",
		"longitude": 102.22137400,
		"latitude": 31.89979200,
		"children": [{
			"areaId": 513201,
			"areaName": "马尔康市",
			"longitude": 102.20625000,
			"latitude": 31.90584000
		}, {
			"areaId": 513221,
			"areaName": "汶川县",
			"longitude": 103.59079000,
			"latitude": 31.47326000
		}, {
			"areaId": 513222,
			"areaName": "理县",
			"longitude": 103.17175000,
			"latitude": 31.43603000
		}, {
			"areaId": 513223,
			"areaName": "茂县",
			"longitude": 103.85372000,
			"latitude": 31.68200000
		}, {
			"areaId": 513224,
			"areaName": "松潘县",
			"longitude": 103.59924000,
			"latitude": 32.63871000
		}, {
			"areaId": 513225,
			"areaName": "九寨沟县",
			"longitude": 104.23672000,
			"latitude": 33.26318000
		}, {
			"areaId": 513226,
			"areaName": "金川县",
			"longitude": 102.06555000,
			"latitude": 31.47623000
		}, {
			"areaId": 513227,
			"areaName": "小金县",
			"longitude": 102.36499000,
			"latitude": 30.99934000
		}, {
			"areaId": 513228,
			"areaName": "黑水县",
			"longitude": 102.99176000,
			"latitude": 32.06184000
		}, {
			"areaId": 513230,
			"areaName": "壤塘县",
			"longitude": 100.97830000,
			"latitude": 32.26578000
		}, {
			"areaId": 513231,
			"areaName": "阿坝县",
			"longitude": 101.70632000,
			"latitude": 32.90301000
		}, {
			"areaId": 513232,
			"areaName": "若尔盖县",
			"longitude": 102.95980000,
			"latitude": 33.57432000
		}, {
			"areaId": 513233,
			"areaName": "红原县",
			"longitude": 102.54525000,
			"latitude": 32.78989000
		}]
	}, {
		"areaId": 5133,
		"areaName": "甘孜藏族自治州",
		"longitude": 101.96381500,
		"latitude": 30.05066300,
		"children": [{
			"areaId": 513301,
			"areaName": "康定市",
			"longitude": 101.96487000,
			"latitude": 30.05532000
		}, {
			"areaId": 513322,
			"areaName": "泸定县",
			"longitude": 102.23507000,
			"latitude": 29.91475000
		}, {
			"areaId": 513323,
			"areaName": "丹巴县",
			"longitude": 101.88424000,
			"latitude": 30.87656000
		}, {
			"areaId": 513324,
			"areaName": "九龙县",
			"longitude": 101.50848000,
			"latitude": 29.00091000
		}, {
			"areaId": 513325,
			"areaName": "雅江县",
			"longitude": 101.01492000,
			"latitude": 30.03281000
		}, {
			"areaId": 513326,
			"areaName": "道孚县",
			"longitude": 101.12554000,
			"latitude": 30.98046000
		}, {
			"areaId": 513327,
			"areaName": "炉霍县",
			"longitude": 100.67681000,
			"latitude": 31.39170000
		}, {
			"areaId": 513328,
			"areaName": "甘孜县",
			"longitude": 99.99307000,
			"latitude": 31.62672000
		}, {
			"areaId": 513329,
			"areaName": "新龙县",
			"longitude": 100.31250000,
			"latitude": 30.94067000
		}, {
			"areaId": 513330,
			"areaName": "德格县",
			"longitude": 98.58078000,
			"latitude": 31.80615000
		}, {
			"areaId": 513331,
			"areaName": "白玉县",
			"longitude": 98.82568000,
			"latitude": 31.20902000
		}, {
			"areaId": 513332,
			"areaName": "石渠县",
			"longitude": 98.10156000,
			"latitude": 32.97884000
		}, {
			"areaId": 513333,
			"areaName": "色达县",
			"longitude": 100.33224000,
			"latitude": 32.26839000
		}, {
			"areaId": 513334,
			"areaName": "理塘县",
			"longitude": 100.27005000,
			"latitude": 29.99674000
		}, {
			"areaId": 513335,
			"areaName": "巴塘县",
			"longitude": 99.10409000,
			"latitude": 30.00423000
		}, {
			"areaId": 513336,
			"areaName": "乡城县",
			"longitude": 99.79943000,
			"latitude": 28.93554000
		}, {
			"areaId": 513337,
			"areaName": "稻城县",
			"longitude": 100.29809000,
			"latitude": 29.03790000
		}, {
			"areaId": 513338,
			"areaName": "得荣县",
			"longitude": 99.28628000,
			"latitude": 28.71297000
		}]
	}, {
		"areaId": 5134,
		"areaName": "凉山彝族自治州",
		"longitude": 102.25874600,
		"latitude": 27.88676200,
		"children": [{
			"areaId": 513401,
			"areaName": "西昌市",
			"longitude": 102.26413000,
			"latitude": 27.89524000
		}, {
			"areaId": 513422,
			"areaName": "木里藏族自治县",
			"longitude": 101.27960000,
			"latitude": 27.92875000
		}, {
			"areaId": 513423,
			"areaName": "盐源县",
			"longitude": 101.50970000,
			"latitude": 27.42177000
		}, {
			"areaId": 513424,
			"areaName": "德昌县",
			"longitude": 102.18017000,
			"latitude": 27.40482000
		}, {
			"areaId": 513425,
			"areaName": "会理县",
			"longitude": 102.24539000,
			"latitude": 26.65627000
		}, {
			"areaId": 513426,
			"areaName": "会东县",
			"longitude": 102.57815000,
			"latitude": 26.63429000
		}, {
			"areaId": 513427,
			"areaName": "宁南县",
			"longitude": 102.76116000,
			"latitude": 27.06567000
		}, {
			"areaId": 513428,
			"areaName": "普格县",
			"longitude": 102.54055000,
			"latitude": 27.37485000
		}, {
			"areaId": 513429,
			"areaName": "布拖县",
			"longitude": 102.81234000,
			"latitude": 27.70790000
		}, {
			"areaId": 513430,
			"areaName": "金阳县",
			"longitude": 103.24774000,
			"latitude": 27.69698000
		}, {
			"areaId": 513431,
			"areaName": "昭觉县",
			"longitude": 102.84661000,
			"latitude": 28.01155000
		}, {
			"areaId": 513432,
			"areaName": "喜德县",
			"longitude": 102.41336000,
			"latitude": 28.30739000
		}, {
			"areaId": 513433,
			"areaName": "冕宁县",
			"longitude": 102.17108000,
			"latitude": 28.55161000
		}, {
			"areaId": 513434,
			"areaName": "越西县",
			"longitude": 102.50790000,
			"latitude": 28.64133000
		}, {
			"areaId": 513435,
			"areaName": "甘洛县",
			"longitude": 102.77154000,
			"latitude": 28.96624000
		}, {
			"areaId": 513436,
			"areaName": "美姑县",
			"longitude": 103.13116000,
			"latitude": 28.32596000
		}, {
			"areaId": 513437,
			"areaName": "雷波县",
			"longitude": 103.57287000,
			"latitude": 28.26407000
		}]
	}]
}, {
	"areaId": 52,
	"areaName": "贵州省",
	"longitude": 106.71347800,
	"latitude": 26.57834300,
	"children": [{
		"areaId": 5201,
		"areaName": "贵阳市",
		"longitude": 106.71347800,
		"latitude": 26.57834300,
		"children": [{
			"areaId": 520102,
			"areaName": "南明区",
			"longitude": 106.71450000,
			"latitude": 26.56819000
		}, {
			"areaId": 520103,
			"areaName": "云岩区",
			"longitude": 106.72485000,
			"latitude": 26.60484000
		}, {
			"areaId": 520111,
			"areaName": "花溪区",
			"longitude": 106.67688000,
			"latitude": 26.43343000
		}, {
			"areaId": 520112,
			"areaName": "乌当区",
			"longitude": 106.75210000,
			"latitude": 26.63020000
		}, {
			"areaId": 520113,
			"areaName": "白云区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 520115,
			"areaName": "观山湖区",
			"longitude": 106.62544200,
			"latitude": 26.61820900
		}, {
			"areaId": 520121,
			"areaName": "开阳县",
			"longitude": 106.96920000,
			"latitude": 27.05533000
		}, {
			"areaId": 520122,
			"areaName": "息烽县",
			"longitude": 106.73800000,
			"latitude": 27.09346000
		}, {
			"areaId": 520123,
			"areaName": "修文县",
			"longitude": 106.59487000,
			"latitude": 26.83783000
		}, {
			"areaId": 520181,
			"areaName": "清镇市",
			"longitude": 106.46862000,
			"latitude": 26.55261000
		}]
	}, {
		"areaId": 5202,
		"areaName": "六盘水市",
		"longitude": 104.84674300,
		"latitude": 26.58464300,
		"children": [{
			"areaId": 520201,
			"areaName": "钟山区",
			"longitude": 104.87848000,
			"latitude": 26.57699000
		}, {
			"areaId": 520203,
			"areaName": "六枝特区",
			"longitude": 105.48062000,
			"latitude": 26.20117000
		}, {
			"areaId": 520221,
			"areaName": "水城县",
			"longitude": 104.95764000,
			"latitude": 26.54785000
		}, {
			"areaId": 520281,
			"areaName": "盘州市",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 5203,
		"areaName": "遵义市",
		"longitude": 106.93726500,
		"latitude": 27.70662600,
		"children": [{
			"areaId": 520302,
			"areaName": "红花岗区",
			"longitude": 106.89404000,
			"latitude": 27.64471000
		}, {
			"areaId": 520303,
			"areaName": "汇川区",
			"longitude": 106.93930000,
			"latitude": 27.70625000
		}, {
			"areaId": 520304,
			"areaName": "播州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 520322,
			"areaName": "桐梓县",
			"longitude": 106.82568000,
			"latitude": 28.13806000
		}, {
			"areaId": 520323,
			"areaName": "绥阳县",
			"longitude": 107.19064000,
			"latitude": 27.94702000
		}, {
			"areaId": 520324,
			"areaName": "正安县",
			"longitude": 107.44357000,
			"latitude": 28.55120000
		}, {
			"areaId": 520325,
			"areaName": "道真仡佬族苗族自治县",
			"longitude": 107.61152000,
			"latitude": 28.86400000
		}, {
			"areaId": 520326,
			"areaName": "务川仡佬族苗族自治县",
			"longitude": 107.88935000,
			"latitude": 28.52227000
		}, {
			"areaId": 520327,
			"areaName": "凤冈县",
			"longitude": 107.71682000,
			"latitude": 27.95461000
		}, {
			"areaId": 520328,
			"areaName": "湄潭县",
			"longitude": 107.48779000,
			"latitude": 27.76676000
		}, {
			"areaId": 520329,
			"areaName": "余庆县",
			"longitude": 107.88821000,
			"latitude": 27.22532000
		}, {
			"areaId": 520330,
			"areaName": "习水县",
			"longitude": 106.21267000,
			"latitude": 28.31976000
		}, {
			"areaId": 520381,
			"areaName": "赤水市",
			"longitude": 105.69845000,
			"latitude": 28.58921000
		}, {
			"areaId": 520382,
			"areaName": "仁怀市",
			"longitude": 106.40152000,
			"latitude": 27.79231000
		}]
	}, {
		"areaId": 5204,
		"areaName": "安顺市",
		"longitude": 105.93218800,
		"latitude": 26.24554400,
		"children": [{
			"areaId": 520402,
			"areaName": "西秀区",
			"longitude": 105.96585000,
			"latitude": 26.24491000
		}, {
			"areaId": 520403,
			"areaName": "平坝区",
			"longitude": 106.25683000,
			"latitude": 26.40543000
		}, {
			"areaId": 520422,
			"areaName": "普定县",
			"longitude": 105.74285000,
			"latitude": 26.30141000
		}, {
			"areaId": 520423,
			"areaName": "镇宁布依族苗族自治县",
			"longitude": 105.76513000,
			"latitude": 26.05533000
		}, {
			"areaId": 520424,
			"areaName": "关岭布依族苗族自治县",
			"longitude": 105.61883000,
			"latitude": 25.94248000
		}, {
			"areaId": 520425,
			"areaName": "紫云苗族布依族自治县",
			"longitude": 106.08364000,
			"latitude": 25.75258000
		}]
	}, {
		"areaId": 5205,
		"areaName": "毕节市",
		"longitude": 105.28501000,
		"latitude": 27.30169300,
		"children": [{
			"areaId": 520502,
			"areaName": "七星关区",
			"longitude": 104.94970000,
			"latitude": 27.15355600
		}, {
			"areaId": 520521,
			"areaName": "大方县",
			"longitude": 105.60925400,
			"latitude": 27.14352100
		}, {
			"areaId": 520522,
			"areaName": "黔西县",
			"longitude": 106.03829900,
			"latitude": 27.02492300
		}, {
			"areaId": 520523,
			"areaName": "金沙县",
			"longitude": 118.42799300,
			"latitude": 24.48110900
		}, {
			"areaId": 520524,
			"areaName": "织金县",
			"longitude": 105.76899700,
			"latitude": 26.66849700
		}, {
			"areaId": 520525,
			"areaName": "纳雍县",
			"longitude": 105.37532200,
			"latitude": 26.76987500
		}, {
			"areaId": 520526,
			"areaName": "威宁彝族回族苗族自治县",
			"longitude": 104.28652300,
			"latitude": 26.85909900
		}, {
			"areaId": 520527,
			"areaName": "赫章县",
			"longitude": 104.72643800,
			"latitude": 27.11924300
		}]
	}, {
		"areaId": 5206,
		"areaName": "铜仁市",
		"longitude": 109.19155500,
		"latitude": 27.71834600,
		"children": [{
			"areaId": 520602,
			"areaName": "碧江区",
			"longitude": 109.19155500,
			"latitude": 27.71834600
		}, {
			"areaId": 520603,
			"areaName": "万山区",
			"longitude": 109.21199000,
			"latitude": 27.51903000
		}, {
			"areaId": 520621,
			"areaName": "江口县",
			"longitude": 108.84842700,
			"latitude": 27.69190400
		}, {
			"areaId": 520622,
			"areaName": "玉屏侗族自治县",
			"longitude": 108.91788200,
			"latitude": 27.23802400
		}, {
			"areaId": 520623,
			"areaName": "石阡县",
			"longitude": 108.22985400,
			"latitude": 27.51938600
		}, {
			"areaId": 520624,
			"areaName": "思南县",
			"longitude": 108.25582700,
			"latitude": 27.94133100
		}, {
			"areaId": 520625,
			"areaName": "印江土家族苗族自治县",
			"longitude": 108.40551700,
			"latitude": 27.99797600
		}, {
			"areaId": 520626,
			"areaName": "德江县",
			"longitude": 108.11731700,
			"latitude": 28.26094000
		}, {
			"areaId": 520627,
			"areaName": "沿河土家族自治县",
			"longitude": 108.49574600,
			"latitude": 28.56048700
		}, {
			"areaId": 520628,
			"areaName": "松桃苗族自治县",
			"longitude": 109.20262700,
			"latitude": 28.16541900
		}]
	}, {
		"areaId": 5223,
		"areaName": "黔西南布依族苗族自治州",
		"longitude": 104.89797100,
		"latitude": 25.08812000,
		"children": [{
			"areaId": 522301,
			"areaName": "兴义市",
			"longitude": 104.89548000,
			"latitude": 25.09205000
		}, {
			"areaId": 522302,
			"areaName": "兴仁市",
			"longitude": 105.18652000,
			"latitude": 25.43282000
		}, {
			"areaId": 522323,
			"areaName": "普安县",
			"longitude": 104.95529000,
			"latitude": 25.78603000
		}, {
			"areaId": 522324,
			"areaName": "晴隆县",
			"longitude": 105.21920000,
			"latitude": 25.83522000
		}, {
			"areaId": 522325,
			"areaName": "贞丰县",
			"longitude": 105.65454000,
			"latitude": 25.38464000
		}, {
			"areaId": 522326,
			"areaName": "望谟县",
			"longitude": 106.09957000,
			"latitude": 25.17822000
		}, {
			"areaId": 522327,
			"areaName": "册亨县",
			"longitude": 105.81240000,
			"latitude": 24.98376000
		}, {
			"areaId": 522328,
			"areaName": "安龙县",
			"longitude": 105.44268000,
			"latitude": 25.09818000
		}]
	}, {
		"areaId": 5226,
		"areaName": "黔东南苗族侗族自治州",
		"longitude": 107.97748800,
		"latitude": 26.58335200,
		"children": [{
			"areaId": 522601,
			"areaName": "凯里市",
			"longitude": 107.98132000,
			"latitude": 26.56689000
		}, {
			"areaId": 522622,
			"areaName": "黄平县",
			"longitude": 107.90179000,
			"latitude": 26.89573000
		}, {
			"areaId": 522623,
			"areaName": "施秉县",
			"longitude": 108.12597000,
			"latitude": 27.03495000
		}, {
			"areaId": 522624,
			"areaName": "三穗县",
			"longitude": 108.67132000,
			"latitude": 26.94765000
		}, {
			"areaId": 522625,
			"areaName": "镇远县",
			"longitude": 108.42721000,
			"latitude": 27.04933000
		}, {
			"areaId": 522626,
			"areaName": "岑巩县",
			"longitude": 108.81884000,
			"latitude": 27.17539000
		}, {
			"areaId": 522627,
			"areaName": "天柱县",
			"longitude": 109.20718000,
			"latitude": 26.90781000
		}, {
			"areaId": 522628,
			"areaName": "锦屏县",
			"longitude": 109.19982000,
			"latitude": 26.67635000
		}, {
			"areaId": 522629,
			"areaName": "剑河县",
			"longitude": 108.59130000,
			"latitude": 26.65250000
		}, {
			"areaId": 522630,
			"areaName": "台江县",
			"longitude": 108.31814000,
			"latitude": 26.66916000
		}, {
			"areaId": 522631,
			"areaName": "黎平县",
			"longitude": 109.13607000,
			"latitude": 26.23114000
		}, {
			"areaId": 522632,
			"areaName": "榕江县",
			"longitude": 108.52072000,
			"latitude": 25.92421000
		}, {
			"areaId": 522633,
			"areaName": "从江县",
			"longitude": 108.90527000,
			"latitude": 25.75415000
		}, {
			"areaId": 522634,
			"areaName": "雷山县",
			"longitude": 108.07745000,
			"latitude": 26.38385000
		}, {
			"areaId": 522635,
			"areaName": "麻江县",
			"longitude": 107.59155000,
			"latitude": 26.49235000
		}, {
			"areaId": 522636,
			"areaName": "丹寨县",
			"longitude": 107.79718000,
			"latitude": 26.19816000
		}]
	}, {
		"areaId": 5227,
		"areaName": "黔南布依族苗族自治州",
		"longitude": 107.51715600,
		"latitude": 26.25821900,
		"children": [{
			"areaId": 522701,
			"areaName": "都匀市",
			"longitude": 107.51872000,
			"latitude": 26.25940000
		}, {
			"areaId": 522702,
			"areaName": "福泉市",
			"longitude": 107.51715000,
			"latitude": 26.67989000
		}, {
			"areaId": 522722,
			"areaName": "荔波县",
			"longitude": 107.88592000,
			"latitude": 25.41390000
		}, {
			"areaId": 522723,
			"areaName": "贵定县",
			"longitude": 107.23654000,
			"latitude": 26.57812000
		}, {
			"areaId": 522725,
			"areaName": "瓮安县",
			"longitude": 107.47570000,
			"latitude": 27.06813000
		}, {
			"areaId": 522726,
			"areaName": "独山县",
			"longitude": 107.54101000,
			"latitude": 25.82450000
		}, {
			"areaId": 522727,
			"areaName": "平塘县",
			"longitude": 107.32428000,
			"latitude": 25.83294000
		}, {
			"areaId": 522728,
			"areaName": "罗甸县",
			"longitude": 106.75186000,
			"latitude": 25.42586000
		}, {
			"areaId": 522729,
			"areaName": "长顺县",
			"longitude": 106.45217000,
			"latitude": 26.02299000
		}, {
			"areaId": 522730,
			"areaName": "龙里县",
			"longitude": 106.97662000,
			"latitude": 26.45076000
		}, {
			"areaId": 522731,
			"areaName": "惠水县",
			"longitude": 106.65911000,
			"latitude": 26.13389000
		}, {
			"areaId": 522732,
			"areaName": "三都水族自治县",
			"longitude": 107.87464000,
			"latitude": 25.98562000
		}]
	}]
}, {
	"areaId": 53,
	"areaName": "云南省",
	"longitude": 102.71225100,
	"latitude": 25.04060900,
	"children": [{
		"areaId": 5301,
		"areaName": "昆明市",
		"longitude": 102.71225100,
		"latitude": 25.04060900,
		"children": [{
			"areaId": 530102,
			"areaName": "五华区",
			"longitude": 102.70786000,
			"latitude": 25.03521000
		}, {
			"areaId": 530103,
			"areaName": "盘龙区",
			"longitude": 102.71994000,
			"latitude": 25.04053000
		}, {
			"areaId": 530111,
			"areaName": "官渡区",
			"longitude": 102.74362000,
			"latitude": 25.01497000
		}, {
			"areaId": 530112,
			"areaName": "西山区",
			"longitude": 102.66464000,
			"latitude": 25.03796000
		}, {
			"areaId": 530113,
			"areaName": "东川区",
			"longitude": 103.18832000,
			"latitude": 26.08300000
		}, {
			"areaId": 530114,
			"areaName": "呈贡区",
			"longitude": 102.80138200,
			"latitude": 24.88927500
		}, {
			"areaId": 530115,
			"areaName": "晋宁区",
			"longitude": 102.59393000,
			"latitude": 24.66650000
		}, {
			"areaId": 530124,
			"areaName": "富民县",
			"longitude": 102.49850000,
			"latitude": 25.22119000
		}, {
			"areaId": 530125,
			"areaName": "宜良县",
			"longitude": 103.14117000,
			"latitude": 24.91705000
		}, {
			"areaId": 530126,
			"areaName": "石林彝族自治县",
			"longitude": 103.27148000,
			"latitude": 24.75897000
		}, {
			"areaId": 530127,
			"areaName": "嵩明县",
			"longitude": 103.03729000,
			"latitude": 25.33986000
		}, {
			"areaId": 530128,
			"areaName": "禄劝彝族苗族自治县",
			"longitude": 102.46710000,
			"latitude": 25.55387000
		}, {
			"areaId": 530129,
			"areaName": "寻甸回族彝族自治县",
			"longitude": 103.25570000,
			"latitude": 25.55961000
		}, {
			"areaId": 530181,
			"areaName": "安宁市",
			"longitude": 102.46972000,
			"latitude": 24.91652000
		}]
	}, {
		"areaId": 5303,
		"areaName": "曲靖市",
		"longitude": 103.79785100,
		"latitude": 25.50155700,
		"children": [{
			"areaId": 530302,
			"areaName": "麒麟区",
			"longitude": 103.80504000,
			"latitude": 25.49515000
		}, {
			"areaId": 530303,
			"areaName": "沾益区",
			"longitude": 103.82135000,
			"latitude": 25.60715000
		}, {
			"areaId": 530304,
			"areaName": "马龙区",
			"longitude": 103.57873000,
			"latitude": 25.42521000
		}, {
			"areaId": 530322,
			"areaName": "陆良县",
			"longitude": 103.66650000,
			"latitude": 25.02335000
		}, {
			"areaId": 530323,
			"areaName": "师宗县",
			"longitude": 103.99084000,
			"latitude": 24.82822000
		}, {
			"areaId": 530324,
			"areaName": "罗平县",
			"longitude": 104.30859000,
			"latitude": 24.88444000
		}, {
			"areaId": 530325,
			"areaName": "富源县",
			"longitude": 104.25387000,
			"latitude": 25.66587000
		}, {
			"areaId": 530326,
			"areaName": "会泽县",
			"longitude": 103.30017000,
			"latitude": 26.41076000
		}, {
			"areaId": 530381,
			"areaName": "宣威市",
			"longitude": 104.10409000,
			"latitude": 26.21730000
		}]
	}, {
		"areaId": 5304,
		"areaName": "玉溪市",
		"longitude": 102.54390700,
		"latitude": 24.35046100,
		"children": [{
			"areaId": 530402,
			"areaName": "红塔区",
			"longitude": 102.54490000,
			"latitude": 24.35411000
		}, {
			"areaId": 530403,
			"areaName": "江川区",
			"longitude": 102.75412000,
			"latitude": 24.28863000
		}, {
			"areaId": 530423,
			"areaName": "通海县",
			"longitude": 102.76641000,
			"latitude": 24.11362000
		}, {
			"areaId": 530424,
			"areaName": "华宁县",
			"longitude": 102.92831000,
			"latitude": 24.19260000
		}, {
			"areaId": 530425,
			"areaName": "易门县",
			"longitude": 102.16354000,
			"latitude": 24.67122000
		}, {
			"areaId": 530426,
			"areaName": "峨山彝族自治县",
			"longitude": 102.40576000,
			"latitude": 24.16904000
		}, {
			"areaId": 530427,
			"areaName": "新平彝族傣族自治县",
			"longitude": 101.98895000,
			"latitude": 24.06886000
		}, {
			"areaId": 530428,
			"areaName": "元江哈尼族彝族傣族自治县",
			"longitude": 101.99812000,
			"latitude": 23.59655000
		}, {
			"areaId": 530481,
			"areaName": "澄江市",
			"longitude": 102.90817000,
			"latitude": 24.67376000
		}]
	}, {
		"areaId": 5305,
		"areaName": "保山市",
		"longitude": 99.16713300,
		"latitude": 25.11180200,
		"children": [{
			"areaId": 530502,
			"areaName": "隆阳区",
			"longitude": 99.16334000,
			"latitude": 25.11163000
		}, {
			"areaId": 530521,
			"areaName": "施甸县",
			"longitude": 99.18768000,
			"latitude": 24.72418000
		}, {
			"areaId": 530523,
			"areaName": "龙陵县",
			"longitude": 98.69024000,
			"latitude": 24.58746000
		}, {
			"areaId": 530524,
			"areaName": "昌宁县",
			"longitude": 99.60360000,
			"latitude": 24.82763000
		}, {
			"areaId": 530581,
			"areaName": "腾冲市",
			"longitude": 98.49414000,
			"latitude": 25.02539000
		}]
	}, {
		"areaId": 5306,
		"areaName": "昭通市",
		"longitude": 103.71721600,
		"latitude": 27.33699900,
		"children": [{
			"areaId": 530602,
			"areaName": "昭阳区",
			"longitude": 103.70654000,
			"latitude": 27.31998000
		}, {
			"areaId": 530621,
			"areaName": "鲁甸县",
			"longitude": 103.54721000,
			"latitude": 27.19238000
		}, {
			"areaId": 530622,
			"areaName": "巧家县",
			"longitude": 102.92416000,
			"latitude": 26.91237000
		}, {
			"areaId": 530623,
			"areaName": "盐津县",
			"longitude": 104.23461000,
			"latitude": 28.10856000
		}, {
			"areaId": 530624,
			"areaName": "大关县",
			"longitude": 103.89254000,
			"latitude": 27.74880000
		}, {
			"areaId": 530625,
			"areaName": "永善县",
			"longitude": 103.63504000,
			"latitude": 28.22790000
		}, {
			"areaId": 530626,
			"areaName": "绥江县",
			"longitude": 103.94937000,
			"latitude": 28.59661000
		}, {
			"areaId": 530627,
			"areaName": "镇雄县",
			"longitude": 104.87258000,
			"latitude": 27.43981000
		}, {
			"areaId": 530628,
			"areaName": "彝良县",
			"longitude": 104.04983000,
			"latitude": 27.62809000
		}, {
			"areaId": 530629,
			"areaName": "威信县",
			"longitude": 105.04754000,
			"latitude": 27.84065000
		}, {
			"areaId": 530681,
			"areaName": "水富市",
			"longitude": 104.41580000,
			"latitude": 28.62986000
		}]
	}, {
		"areaId": 5307,
		"areaName": "丽江市",
		"longitude": 100.23302600,
		"latitude": 26.87210800,
		"children": [{
			"areaId": 530702,
			"areaName": "古城区",
			"longitude": 100.22570000,
			"latitude": 26.87697000
		}, {
			"areaId": 530721,
			"areaName": "玉龙纳西族自治县",
			"longitude": 100.23690000,
			"latitude": 26.82149000
		}, {
			"areaId": 530722,
			"areaName": "永胜县",
			"longitude": 100.74667000,
			"latitude": 26.68591000
		}, {
			"areaId": 530723,
			"areaName": "华坪县",
			"longitude": 101.26562000,
			"latitude": 26.62967000
		}, {
			"areaId": 530724,
			"areaName": "宁蒗彝族自治县",
			"longitude": 100.85070000,
			"latitude": 27.28179000
		}]
	}, {
		"areaId": 5308,
		"areaName": "普洱市",
		"longitude": 100.97234400,
		"latitude": 22.77732100,
		"children": [{
			"areaId": 530802,
			"areaName": "思茅区",
			"longitude": 100.97716000,
			"latitude": 22.78691000
		}, {
			"areaId": 530821,
			"areaName": "宁洱哈尼族彝族自治县",
			"longitude": 101.04653000,
			"latitude": 23.06341000
		}, {
			"areaId": 530822,
			"areaName": "墨江哈尼族自治县",
			"longitude": 101.69171000,
			"latitude": 23.43214000
		}, {
			"areaId": 530823,
			"areaName": "景东彝族自治县",
			"longitude": 100.83599000,
			"latitude": 24.44791000
		}, {
			"areaId": 530824,
			"areaName": "景谷傣族彝族自治县",
			"longitude": 100.70251000,
			"latitude": 23.49705000
		}, {
			"areaId": 530825,
			"areaName": "镇沅彝族哈尼族拉祜族自治县",
			"longitude": 101.10675000,
			"latitude": 24.00557000
		}, {
			"areaId": 530826,
			"areaName": "江城哈尼族彝族自治县",
			"longitude": 101.85788000,
			"latitude": 22.58424000
		}, {
			"areaId": 530827,
			"areaName": "孟连傣族拉祜族佤族自治县",
			"longitude": 99.58424000,
			"latitude": 22.32922000
		}, {
			"areaId": 530828,
			"areaName": "澜沧拉祜族自治县",
			"longitude": 99.93591000,
			"latitude": 22.55474000
		}, {
			"areaId": 530829,
			"areaName": "西盟佤族自治县",
			"longitude": 99.59869000,
			"latitude": 22.64774000
		}]
	}, {
		"areaId": 5309,
		"areaName": "临沧市",
		"longitude": 100.08697000,
		"latitude": 23.88656700,
		"children": [{
			"areaId": 530902,
			"areaName": "临翔区",
			"longitude": 100.08242000,
			"latitude": 23.89497000
		}, {
			"areaId": 530921,
			"areaName": "凤庆县",
			"longitude": 99.92837000,
			"latitude": 24.58034000
		}, {
			"areaId": 530922,
			"areaName": "云县",
			"longitude": 100.12808000,
			"latitude": 24.44675000
		}, {
			"areaId": 530923,
			"areaName": "永德县",
			"longitude": 99.25326000,
			"latitude": 24.02760000
		}, {
			"areaId": 530924,
			"areaName": "镇康县",
			"longitude": 98.82550000,
			"latitude": 23.76241000
		}, {
			"areaId": 530925,
			"areaName": "双江拉祜族佤族布朗族傣族自治县",
			"longitude": 99.82769000,
			"latitude": 23.47349000
		}, {
			"areaId": 530926,
			"areaName": "耿马傣族佤族自治县",
			"longitude": 99.39785000,
			"latitude": 23.53776000
		}, {
			"areaId": 530927,
			"areaName": "沧源佤族自治县",
			"longitude": 99.24545000,
			"latitude": 23.14821000
		}]
	}, {
		"areaId": 5323,
		"areaName": "楚雄彝族自治州",
		"longitude": 101.54604600,
		"latitude": 25.04198800,
		"children": [{
			"areaId": 532301,
			"areaName": "楚雄市",
			"longitude": 101.54615000,
			"latitude": 25.03290000
		}, {
			"areaId": 532322,
			"areaName": "双柏县",
			"longitude": 101.64205000,
			"latitude": 24.68882000
		}, {
			"areaId": 532323,
			"areaName": "牟定县",
			"longitude": 101.54000000,
			"latitude": 25.31551000
		}, {
			"areaId": 532324,
			"areaName": "南华县",
			"longitude": 101.27313000,
			"latitude": 25.19293000
		}, {
			"areaId": 532325,
			"areaName": "姚安县",
			"longitude": 101.24279000,
			"latitude": 25.50467000
		}, {
			"areaId": 532326,
			"areaName": "大姚县",
			"longitude": 101.32397000,
			"latitude": 25.72218000
		}, {
			"areaId": 532327,
			"areaName": "永仁县",
			"longitude": 101.67160000,
			"latitude": 26.05794000
		}, {
			"areaId": 532328,
			"areaName": "元谋县",
			"longitude": 101.87728000,
			"latitude": 25.70438000
		}, {
			"areaId": 532329,
			"areaName": "武定县",
			"longitude": 102.40380000,
			"latitude": 25.52950000
		}, {
			"areaId": 532331,
			"areaName": "禄丰县",
			"longitude": 102.07797000,
			"latitude": 25.14815000
		}]
	}, {
		"areaId": 5325,
		"areaName": "红河哈尼族彝族自治州",
		"longitude": 103.38418200,
		"latitude": 23.36677500,
		"children": [{
			"areaId": 532501,
			"areaName": "个旧市",
			"longitude": 103.15966000,
			"latitude": 23.35894000
		}, {
			"areaId": 532502,
			"areaName": "开远市",
			"longitude": 103.26986000,
			"latitude": 23.71012000
		}, {
			"areaId": 532503,
			"areaName": "蒙自市",
			"longitude": 103.38500500,
			"latitude": 23.36684300
		}, {
			"areaId": 532504,
			"areaName": "弥勒市",
			"longitude": 103.43698800,
			"latitude": 24.40837000
		}, {
			"areaId": 532523,
			"areaName": "屏边苗族自治县",
			"longitude": 103.68554000,
			"latitude": 22.98425000
		}, {
			"areaId": 532524,
			"areaName": "建水县",
			"longitude": 102.82656000,
			"latitude": 23.63472000
		}, {
			"areaId": 532525,
			"areaName": "石屏县",
			"longitude": 102.49408000,
			"latitude": 23.71441000
		}, {
			"areaId": 532527,
			"areaName": "泸西县",
			"longitude": 103.76373000,
			"latitude": 24.52854000
		}, {
			"areaId": 532528,
			"areaName": "元阳县",
			"longitude": 102.83261000,
			"latitude": 23.22281000
		}, {
			"areaId": 532529,
			"areaName": "红河县",
			"longitude": 102.42059000,
			"latitude": 23.36767000
		}, {
			"areaId": 532530,
			"areaName": "金平苗族瑶族傣族自治县",
			"longitude": 103.22651000,
			"latitude": 22.77959000
		}, {
			"areaId": 532531,
			"areaName": "绿春县",
			"longitude": 102.39672000,
			"latitude": 22.99371000
		}, {
			"areaId": 532532,
			"areaName": "河口瑶族自治县",
			"longitude": 103.93936000,
			"latitude": 22.52929000
		}]
	}, {
		"areaId": 5326,
		"areaName": "文山壮族苗族自治州",
		"longitude": 121.57045800,
		"latitude": 24.98978600,
		"children": [{
			"areaId": 532601,
			"areaName": "文山市",
			"longitude": 104.24427700,
			"latitude": 23.36921600
		}, {
			"areaId": 532622,
			"areaName": "砚山县",
			"longitude": 104.33306000,
			"latitude": 23.60723000
		}, {
			"areaId": 532623,
			"areaName": "西畴县",
			"longitude": 104.67419000,
			"latitude": 23.43941000
		}, {
			"areaId": 532624,
			"areaName": "麻栗坡县",
			"longitude": 104.70132000,
			"latitude": 23.12028000
		}, {
			"areaId": 532625,
			"areaName": "马关县",
			"longitude": 104.39514000,
			"latitude": 23.01293000
		}, {
			"areaId": 532626,
			"areaName": "丘北县",
			"longitude": 104.19256000,
			"latitude": 24.03957000
		}, {
			"areaId": 532627,
			"areaName": "广南县",
			"longitude": 105.05511000,
			"latitude": 24.04640000
		}, {
			"areaId": 532628,
			"areaName": "富宁县",
			"longitude": 105.63085000,
			"latitude": 23.62536000
		}]
	}, {
		"areaId": 5328,
		"areaName": "西双版纳傣族自治州",
		"longitude": 100.79794100,
		"latitude": 22.00172400,
		"children": [{
			"areaId": 532801,
			"areaName": "景洪市",
			"longitude": 100.79977000,
			"latitude": 22.01071000
		}, {
			"areaId": 532822,
			"areaName": "勐海县",
			"longitude": 100.44931000,
			"latitude": 21.96175000
		}, {
			"areaId": 532823,
			"areaName": "勐腊县",
			"longitude": 101.56488000,
			"latitude": 21.48162000
		}]
	}, {
		"areaId": 5329,
		"areaName": "大理白族自治州",
		"longitude": 100.24003700,
		"latitude": 25.59276500,
		"children": [{
			"areaId": 532901,
			"areaName": "大理市",
			"longitude": 100.22998000,
			"latitude": 25.59157000
		}, {
			"areaId": 532922,
			"areaName": "漾濞彝族自治县",
			"longitude": 99.95474000,
			"latitude": 25.66520000
		}, {
			"areaId": 532923,
			"areaName": "祥云县",
			"longitude": 100.55761000,
			"latitude": 25.47342000
		}, {
			"areaId": 532924,
			"areaName": "宾川县",
			"longitude": 100.57666000,
			"latitude": 25.83144000
		}, {
			"areaId": 532925,
			"areaName": "弥渡县",
			"longitude": 100.49075000,
			"latitude": 25.34179000
		}, {
			"areaId": 532926,
			"areaName": "南涧彝族自治县",
			"longitude": 100.50964000,
			"latitude": 25.04349000
		}, {
			"areaId": 532927,
			"areaName": "巍山彝族回族自治县",
			"longitude": 100.30612000,
			"latitude": 25.23197000
		}, {
			"areaId": 532928,
			"areaName": "永平县",
			"longitude": 99.54095000,
			"latitude": 25.46451000
		}, {
			"areaId": 532929,
			"areaName": "云龙县",
			"longitude": 99.37255000,
			"latitude": 25.88505000
		}, {
			"areaId": 532930,
			"areaName": "洱源县",
			"longitude": 99.94903000,
			"latitude": 26.10829000
		}, {
			"areaId": 532931,
			"areaName": "剑川县",
			"longitude": 99.90545000,
			"latitude": 26.53688000
		}, {
			"areaId": 532932,
			"areaName": "鹤庆县",
			"longitude": 100.17697000,
			"latitude": 26.55798000
		}]
	}, {
		"areaId": 5331,
		"areaName": "德宏傣族景颇族自治州",
		"longitude": 98.57836300,
		"latitude": 24.43669400,
		"children": [{
			"areaId": 533102,
			"areaName": "瑞丽市",
			"longitude": 97.85183000,
			"latitude": 24.01277000
		}, {
			"areaId": 533103,
			"areaName": "芒市",
			"longitude": 98.58864100,
			"latitude": 24.43373500
		}, {
			"areaId": 533122,
			"areaName": "梁河县",
			"longitude": 98.29705000,
			"latitude": 24.80658000
		}, {
			"areaId": 533123,
			"areaName": "盈江县",
			"longitude": 97.93179000,
			"latitude": 24.70579000
		}, {
			"areaId": 533124,
			"areaName": "陇川县",
			"longitude": 97.79199000,
			"latitude": 24.18302000
		}]
	}, {
		"areaId": 5333,
		"areaName": "怒江傈僳族自治州",
		"longitude": 98.85430400,
		"latitude": 25.85094900,
		"children": [{
			"areaId": 533301,
			"areaName": "泸水市",
			"longitude": 98.85534000,
			"latitude": 25.83772000
		}, {
			"areaId": 533323,
			"areaName": "福贡县",
			"longitude": 98.86969000,
			"latitude": 26.90366000
		}, {
			"areaId": 533324,
			"areaName": "贡山独龙族怒族自治县",
			"longitude": 98.66583000,
			"latitude": 27.74088000
		}, {
			"areaId": 533325,
			"areaName": "兰坪白族普米族自治县",
			"longitude": 99.41891000,
			"latitude": 26.45251000
		}]
	}, {
		"areaId": 5334,
		"areaName": "迪庆藏族自治州",
		"longitude": 99.70646300,
		"latitude": 27.82685300,
		"children": [{
			"areaId": 533401,
			"areaName": "香格里拉市",
			"longitude": 99.70601000,
			"latitude": 27.82308000
		}, {
			"areaId": 533422,
			"areaName": "德钦县",
			"longitude": 98.91082000,
			"latitude": 28.48630000
		}, {
			"areaId": 533423,
			"areaName": "维西傈僳族自治县",
			"longitude": 99.28402000,
			"latitude": 27.17930000
		}]
	}]
}, {
	"areaId": 54,
	"areaName": "西藏自治区",
	"longitude": 91.13221200,
	"latitude": 29.66036100,
	"children": [{
		"areaId": 5401,
		"areaName": "拉萨市",
		"longitude": 91.13221200,
		"latitude": 29.66036100,
		"children": [{
			"areaId": 540102,
			"areaName": "城关区",
			"longitude": 103.82520000,
			"latitude": 36.05725000
		}, {
			"areaId": 540103,
			"areaName": "堆龙德庆区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 540104,
			"areaName": "达孜区",
			"longitude": 91.35757000,
			"latitude": 29.67220000
		}, {
			"areaId": 540121,
			"areaName": "林周县",
			"longitude": 91.25860000,
			"latitude": 29.89445000
		}, {
			"areaId": 540122,
			"areaName": "当雄县",
			"longitude": 91.10076000,
			"latitude": 30.48309000
		}, {
			"areaId": 540123,
			"areaName": "尼木县",
			"longitude": 90.16378000,
			"latitude": 29.43353000
		}, {
			"areaId": 540124,
			"areaName": "曲水县",
			"longitude": 90.73187000,
			"latitude": 29.35636000
		}, {
			"areaId": 540127,
			"areaName": "墨竹工卡县",
			"longitude": 91.72814000,
			"latitude": 29.83614000
		}, {
			"areaId": 540171,
			"areaName": "格尔木藏青工业园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 540172,
			"areaName": "拉萨经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 540173,
			"areaName": "西藏文化旅游创意园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 540174,
			"areaName": "达孜工业园区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 5402,
		"areaName": "日喀则市",
		"longitude": 88.88487400,
		"latitude": 29.26379200,
		"children": [{
			"areaId": 540202,
			"areaName": "桑珠孜区",
			"longitude": 88.88036700,
			"latitude": 29.26956500
		}, {
			"areaId": 540221,
			"areaName": "南木林县",
			"longitude": 89.09686000,
			"latitude": 29.68206000
		}, {
			"areaId": 540222,
			"areaName": "江孜县",
			"longitude": 89.60263000,
			"latitude": 28.91744000
		}, {
			"areaId": 540223,
			"areaName": "定日县",
			"longitude": 87.12176000,
			"latitude": 28.66129000
		}, {
			"areaId": 540224,
			"areaName": "萨迦县",
			"longitude": 88.02191000,
			"latitude": 28.90299000
		}, {
			"areaId": 540225,
			"areaName": "拉孜县",
			"longitude": 87.63412000,
			"latitude": 29.08500000
		}, {
			"areaId": 540226,
			"areaName": "昂仁县",
			"longitude": 87.23858000,
			"latitude": 29.29496000
		}, {
			"areaId": 540227,
			"areaName": "谢通门县",
			"longitude": 88.26242000,
			"latitude": 29.43337000
		}, {
			"areaId": 540228,
			"areaName": "白朗县",
			"longitude": 89.26205000,
			"latitude": 29.10553000
		}, {
			"areaId": 540229,
			"areaName": "仁布县",
			"longitude": 89.84228000,
			"latitude": 29.23010000
		}, {
			"areaId": 540230,
			"areaName": "康马县",
			"longitude": 89.68527000,
			"latitude": 28.55670000
		}, {
			"areaId": 540231,
			"areaName": "定结县",
			"longitude": 87.77255000,
			"latitude": 28.36403000
		}, {
			"areaId": 540232,
			"areaName": "仲巴县",
			"longitude": 84.02951000,
			"latitude": 29.76595000
		}, {
			"areaId": 540233,
			"areaName": "亚东县",
			"longitude": 88.90802000,
			"latitude": 27.48390000
		}, {
			"areaId": 540234,
			"areaName": "吉隆县",
			"longitude": 85.29846000,
			"latitude": 28.85382000
		}, {
			"areaId": 540235,
			"areaName": "聂拉木县",
			"longitude": 85.97998000,
			"latitude": 28.15645000
		}, {
			"areaId": 540236,
			"areaName": "萨嘎县",
			"longitude": 85.23413000,
			"latitude": 29.32936000
		}, {
			"areaId": 540237,
			"areaName": "岗巴县",
			"longitude": 88.52069000,
			"latitude": 28.27504000
		}]
	}, {
		"areaId": 5403,
		"areaName": "昌都市",
		"longitude": 97.17845200,
		"latitude": 31.13687500,
		"children": [{
			"areaId": 540302,
			"areaName": "卡若区",
			"longitude": 97.18043000,
			"latitude": 31.13850000
		}, {
			"areaId": 540321,
			"areaName": "江达县",
			"longitude": 98.21865000,
			"latitude": 31.50343000
		}, {
			"areaId": 540322,
			"areaName": "贡觉县",
			"longitude": 98.27163000,
			"latitude": 30.85941000
		}, {
			"areaId": 540323,
			"areaName": "类乌齐县",
			"longitude": 96.60015000,
			"latitude": 31.21207000
		}, {
			"areaId": 540324,
			"areaName": "丁青县",
			"longitude": 95.59362000,
			"latitude": 31.41621000
		}, {
			"areaId": 540325,
			"areaName": "察雅县",
			"longitude": 97.56521000,
			"latitude": 30.65336000
		}, {
			"areaId": 540326,
			"areaName": "八宿县",
			"longitude": 96.91760000,
			"latitude": 30.05346000
		}, {
			"areaId": 540327,
			"areaName": "左贡县",
			"longitude": 97.84429000,
			"latitude": 29.67108000
		}, {
			"areaId": 540328,
			"areaName": "芒康县",
			"longitude": 98.59378000,
			"latitude": 29.67946000
		}, {
			"areaId": 540329,
			"areaName": "洛隆县",
			"longitude": 95.82644000,
			"latitude": 30.74049000
		}, {
			"areaId": 540330,
			"areaName": "边坝县",
			"longitude": 94.70687000,
			"latitude": 30.93434000
		}]
	}, {
		"areaId": 5404,
		"areaName": "林芝市",
		"longitude": 94.48391000,
		"latitude": 29.57562000,
		"children": [{
			"areaId": 540402,
			"areaName": "巴宜区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 540421,
			"areaName": "工布江达县",
			"longitude": 93.24520000,
			"latitude": 29.88576000
		}, {
			"areaId": 540422,
			"areaName": "米林县",
			"longitude": 94.21316000,
			"latitude": 29.21535000
		}, {
			"areaId": 540423,
			"areaName": "墨脱县",
			"longitude": 95.33160000,
			"latitude": 29.32698000
		}, {
			"areaId": 540424,
			"areaName": "波密县",
			"longitude": 95.77096000,
			"latitude": 29.85907000
		}, {
			"areaId": 540425,
			"areaName": "察隅县",
			"longitude": 97.46679000,
			"latitude": 28.66180000
		}, {
			"areaId": 540426,
			"areaName": "朗县",
			"longitude": 93.07540000,
			"latitude": 29.04549000
		}]
	}, {
		"areaId": 5405,
		"areaName": "山南市",
		"longitude": 91.76652900,
		"latitude": 29.23602300,
		"children": [{
			"areaId": 540502,
			"areaName": "乃东区",
			"longitude": 91.76153000,
			"latitude": 29.22490000
		}, {
			"areaId": 540521,
			"areaName": "扎囊县",
			"longitude": 91.33288000,
			"latitude": 29.23990000
		}, {
			"areaId": 540522,
			"areaName": "贡嘎县",
			"longitude": 90.98867000,
			"latitude": 29.29408000
		}, {
			"areaId": 540523,
			"areaName": "桑日县",
			"longitude": 92.02005000,
			"latitude": 29.26643000
		}, {
			"areaId": 540524,
			"areaName": "琼结县",
			"longitude": 91.68093000,
			"latitude": 29.02632000
		}, {
			"areaId": 540525,
			"areaName": "曲松县",
			"longitude": 92.20263000,
			"latitude": 29.06412000
		}, {
			"areaId": 540526,
			"areaName": "措美县",
			"longitude": 91.43237000,
			"latitude": 28.43794000
		}, {
			"areaId": 540527,
			"areaName": "洛扎县",
			"longitude": 90.86035000,
			"latitude": 28.38720000
		}, {
			"areaId": 540528,
			"areaName": "加查县",
			"longitude": 92.57702000,
			"latitude": 29.13973000
		}, {
			"areaId": 540529,
			"areaName": "隆子县",
			"longitude": 92.46148000,
			"latitude": 28.40797000
		}, {
			"areaId": 540530,
			"areaName": "错那县",
			"longitude": 91.95752000,
			"latitude": 27.99224000
		}, {
			"areaId": 540531,
			"areaName": "浪卡子县",
			"longitude": 90.40002000,
			"latitude": 28.96948000
		}]
	}, {
		"areaId": 5406,
		"areaName": "那曲市",
		"longitude": 92.05350000,
		"latitude": 31.46964000,
		"children": [{
			"areaId": 540602,
			"areaName": "色尼区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 540621,
			"areaName": "嘉黎县",
			"longitude": 93.24987000,
			"latitude": 30.64233000
		}, {
			"areaId": 540622,
			"areaName": "比如县",
			"longitude": 93.68685000,
			"latitude": 31.47790000
		}, {
			"areaId": 540623,
			"areaName": "聂荣县",
			"longitude": 92.29574000,
			"latitude": 32.11193000
		}, {
			"areaId": 540624,
			"areaName": "安多县",
			"longitude": 91.67950000,
			"latitude": 32.26125000
		}, {
			"areaId": 540625,
			"areaName": "申扎县",
			"longitude": 88.70776000,
			"latitude": 30.92995000
		}, {
			"areaId": 540626,
			"areaName": "索县",
			"longitude": 93.78295000,
			"latitude": 31.88427000
		}, {
			"areaId": 540627,
			"areaName": "班戈县",
			"longitude": 90.01907000,
			"latitude": 31.36149000
		}, {
			"areaId": 540628,
			"areaName": "巴青县",
			"longitude": 94.05316000,
			"latitude": 31.91833000
		}, {
			"areaId": 540629,
			"areaName": "尼玛县",
			"longitude": 87.25256000,
			"latitude": 31.79654000
		}, {
			"areaId": 540630,
			"areaName": "双湖县",
			"longitude": 88.83777600,
			"latitude": 33.18903200
		}]
	}, {
		"areaId": 5425,
		"areaName": "阿里地区",
		"longitude": 80.10549800,
		"latitude": 32.50318700,
		"children": [{
			"areaId": 542521,
			"areaName": "普兰县",
			"longitude": 81.17700000,
			"latitude": 30.30002000
		}, {
			"areaId": 542522,
			"areaName": "札达县",
			"longitude": 79.80255000,
			"latitude": 31.48345000
		}, {
			"areaId": 542523,
			"areaName": "噶尔县",
			"longitude": 80.09579000,
			"latitude": 32.50024000
		}, {
			"areaId": 542524,
			"areaName": "日土县",
			"longitude": 79.71310000,
			"latitude": 33.38741000
		}, {
			"areaId": 542525,
			"areaName": "革吉县",
			"longitude": 81.15100000,
			"latitude": 32.39640000
		}, {
			"areaId": 542526,
			"areaName": "改则县",
			"longitude": 84.06295000,
			"latitude": 32.30446000
		}, {
			"areaId": 542527,
			"areaName": "措勤县",
			"longitude": 85.16616000,
			"latitude": 31.02095000
		}]
	}]
}, {
	"areaId": 61,
	"areaName": "陕西省",
	"longitude": 108.94802400,
	"latitude": 34.26316100,
	"children": [{
		"areaId": 6101,
		"areaName": "西安市",
		"longitude": 108.94802400,
		"latitude": 34.26316100,
		"children": [{
			"areaId": 610102,
			"areaName": "新城区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 610103,
			"areaName": "碑林区",
			"longitude": 108.93426000,
			"latitude": 34.23040000
		}, {
			"areaId": 610104,
			"areaName": "莲湖区",
			"longitude": 108.94010000,
			"latitude": 34.26709000
		}, {
			"areaId": 610111,
			"areaName": "灞桥区",
			"longitude": 109.06451000,
			"latitude": 34.27264000
		}, {
			"areaId": 610112,
			"areaName": "未央区",
			"longitude": 108.94683000,
			"latitude": 34.29296000
		}, {
			"areaId": 610113,
			"areaName": "雁塔区",
			"longitude": 108.94866000,
			"latitude": 34.22245000
		}, {
			"areaId": 610114,
			"areaName": "阎良区",
			"longitude": 109.22616000,
			"latitude": 34.66221000
		}, {
			"areaId": 610115,
			"areaName": "临潼区",
			"longitude": 109.21417000,
			"latitude": 34.36665000
		}, {
			"areaId": 610116,
			"areaName": "长安区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 610117,
			"areaName": "高陵区",
			"longitude": 109.08816000,
			"latitude": 34.53483000
		}, {
			"areaId": 610118,
			"areaName": "鄠邑区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 610122,
			"areaName": "蓝田县",
			"longitude": 109.32339000,
			"latitude": 34.15128000
		}, {
			"areaId": 610124,
			"areaName": "周至县",
			"longitude": 108.22207000,
			"latitude": 34.16337000
		}]
	}, {
		"areaId": 6102,
		"areaName": "铜川市",
		"longitude": 108.96312200,
		"latitude": 34.90892000,
		"children": [{
			"areaId": 610202,
			"areaName": "王益区",
			"longitude": 109.07564000,
			"latitude": 35.06896000
		}, {
			"areaId": 610203,
			"areaName": "印台区",
			"longitude": 109.10208000,
			"latitude": 35.11690000
		}, {
			"areaId": 610204,
			"areaName": "耀州区",
			"longitude": 108.98556000,
			"latitude": 34.91308000
		}, {
			"areaId": 610222,
			"areaName": "宜君县",
			"longitude": 109.11813000,
			"latitude": 35.40108000
		}]
	}, {
		"areaId": 6103,
		"areaName": "宝鸡市",
		"longitude": 107.14487000,
		"latitude": 34.36931500,
		"children": [{
			"areaId": 610302,
			"areaName": "渭滨区",
			"longitude": 107.14991000,
			"latitude": 34.37116000
		}, {
			"areaId": 610303,
			"areaName": "金台区",
			"longitude": 107.14691000,
			"latitude": 34.37612000
		}, {
			"areaId": 610304,
			"areaName": "陈仓区",
			"longitude": 107.38742000,
			"latitude": 34.35451000
		}, {
			"areaId": 610322,
			"areaName": "凤翔县",
			"longitude": 107.39645000,
			"latitude": 34.52321000
		}, {
			"areaId": 610323,
			"areaName": "岐山县",
			"longitude": 107.62173000,
			"latitude": 34.44378000
		}, {
			"areaId": 610324,
			"areaName": "扶风县",
			"longitude": 107.90017000,
			"latitude": 34.37524000
		}, {
			"areaId": 610326,
			"areaName": "眉县",
			"longitude": 107.75079000,
			"latitude": 34.27569000
		}, {
			"areaId": 610327,
			"areaName": "陇县",
			"longitude": 106.85946000,
			"latitude": 34.89404000
		}, {
			"areaId": 610328,
			"areaName": "千阳县",
			"longitude": 107.13043000,
			"latitude": 34.64219000
		}, {
			"areaId": 610329,
			"areaName": "麟游县",
			"longitude": 107.79623000,
			"latitude": 34.67844000
		}, {
			"areaId": 610330,
			"areaName": "凤县",
			"longitude": 106.52356000,
			"latitude": 33.91172000
		}, {
			"areaId": 610331,
			"areaName": "太白县",
			"longitude": 107.31646000,
			"latitude": 34.06207000
		}]
	}, {
		"areaId": 6104,
		"areaName": "咸阳市",
		"longitude": 108.70511700,
		"latitude": 34.33343900,
		"children": [{
			"areaId": 610402,
			"areaName": "秦都区",
			"longitude": 108.71493000,
			"latitude": 34.33804000
		}, {
			"areaId": 610403,
			"areaName": "杨陵区",
			"longitude": 108.08348100,
			"latitude": 34.27043400
		}, {
			"areaId": 610404,
			"areaName": "渭城区",
			"longitude": 108.72227000,
			"latitude": 34.33198000
		}, {
			"areaId": 610422,
			"areaName": "三原县",
			"longitude": 108.93194000,
			"latitude": 34.61556000
		}, {
			"areaId": 610423,
			"areaName": "泾阳县",
			"longitude": 108.84259000,
			"latitude": 34.52705000
		}, {
			"areaId": 610424,
			"areaName": "乾县",
			"longitude": 108.24231000,
			"latitude": 34.52946000
		}, {
			"areaId": 610425,
			"areaName": "礼泉县",
			"longitude": 108.42630000,
			"latitude": 34.48455000
		}, {
			"areaId": 610426,
			"areaName": "永寿县",
			"longitude": 108.14474000,
			"latitude": 34.69081000
		}, {
			"areaId": 610428,
			"areaName": "长武县",
			"longitude": 107.79510000,
			"latitude": 35.20670000
		}, {
			"areaId": 610429,
			"areaName": "旬邑县",
			"longitude": 108.33410000,
			"latitude": 35.11338000
		}, {
			"areaId": 610430,
			"areaName": "淳化县",
			"longitude": 108.58026000,
			"latitude": 34.79886000
		}, {
			"areaId": 610431,
			"areaName": "武功县",
			"longitude": 108.20434000,
			"latitude": 34.26003000
		}, {
			"areaId": 610481,
			"areaName": "兴平市",
			"longitude": 108.49057000,
			"latitude": 34.29785000
		}, {
			"areaId": 610482,
			"areaName": "彬州市",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 6105,
		"areaName": "渭南市",
		"longitude": 109.50288200,
		"latitude": 34.49938100,
		"children": [{
			"areaId": 610502,
			"areaName": "临渭区",
			"longitude": 109.49296000,
			"latitude": 34.49822000
		}, {
			"areaId": 610503,
			"areaName": "华州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 610522,
			"areaName": "潼关县",
			"longitude": 110.24362000,
			"latitude": 34.54284000
		}, {
			"areaId": 610523,
			"areaName": "大荔县",
			"longitude": 109.94216000,
			"latitude": 34.79565000
		}, {
			"areaId": 610524,
			"areaName": "合阳县",
			"longitude": 110.14862000,
			"latitude": 35.23805000
		}, {
			"areaId": 610525,
			"areaName": "澄城县",
			"longitude": 109.93444000,
			"latitude": 35.18396000
		}, {
			"areaId": 610526,
			"areaName": "蒲城县",
			"longitude": 109.59030000,
			"latitude": 34.95680000
		}, {
			"areaId": 610527,
			"areaName": "白水县",
			"longitude": 109.59286000,
			"latitude": 35.17863000
		}, {
			"areaId": 610528,
			"areaName": "富平县",
			"longitude": 109.18020000,
			"latitude": 34.75109000
		}, {
			"areaId": 610581,
			"areaName": "韩城市",
			"longitude": 110.44238000,
			"latitude": 35.47926000
		}, {
			"areaId": 610582,
			"areaName": "华阴市",
			"longitude": 110.08752000,
			"latitude": 34.56608000
		}]
	}, {
		"areaId": 6106,
		"areaName": "延安市",
		"longitude": 109.49081000,
		"latitude": 36.59653700,
		"children": [{
			"areaId": 610602,
			"areaName": "宝塔区",
			"longitude": 109.49336000,
			"latitude": 36.59154000
		}, {
			"areaId": 610603,
			"areaName": "安塞区",
			"longitude": 109.32708000,
			"latitude": 36.86507000
		}, {
			"areaId": 610621,
			"areaName": "延长县",
			"longitude": 110.01083000,
			"latitude": 36.57904000
		}, {
			"areaId": 610622,
			"areaName": "延川县",
			"longitude": 110.19415000,
			"latitude": 36.87817000
		}, {
			"areaId": 610625,
			"areaName": "志丹县",
			"longitude": 108.76815000,
			"latitude": 36.82177000
		}, {
			"areaId": 610626,
			"areaName": "吴起县",
			"longitude": 108.17611000,
			"latitude": 36.92785000
		}, {
			"areaId": 610627,
			"areaName": "甘泉县",
			"longitude": 109.35012000,
			"latitude": 36.27754000
		}, {
			"areaId": 610628,
			"areaName": "富县",
			"longitude": 109.37927000,
			"latitude": 35.98803000
		}, {
			"areaId": 610629,
			"areaName": "洛川县",
			"longitude": 109.43286000,
			"latitude": 35.76076000
		}, {
			"areaId": 610630,
			"areaName": "宜川县",
			"longitude": 110.17196000,
			"latitude": 36.04732000
		}, {
			"areaId": 610631,
			"areaName": "黄龙县",
			"longitude": 109.84259000,
			"latitude": 35.58349000
		}, {
			"areaId": 610632,
			"areaName": "黄陵县",
			"longitude": 109.26333000,
			"latitude": 35.58357000
		}, {
			"areaId": 610681,
			"areaName": "子长市",
			"longitude": 109.67532000,
			"latitude": 37.14253000
		}]
	}, {
		"areaId": 6107,
		"areaName": "汉中市",
		"longitude": 107.02862100,
		"latitude": 33.07766800,
		"children": [{
			"areaId": 610702,
			"areaName": "汉台区",
			"longitude": 107.03187000,
			"latitude": 33.06774000
		}, {
			"areaId": 610703,
			"areaName": "南郑区",
			"longitude": 106.94024000,
			"latitude": 33.00299000
		}, {
			"areaId": 610722,
			"areaName": "城固县",
			"longitude": 107.33367000,
			"latitude": 33.15661000
		}, {
			"areaId": 610723,
			"areaName": "洋县",
			"longitude": 107.54672000,
			"latitude": 33.22102000
		}, {
			"areaId": 610724,
			"areaName": "西乡县",
			"longitude": 107.76867000,
			"latitude": 32.98411000
		}, {
			"areaId": 610725,
			"areaName": "勉县",
			"longitude": 106.67584000,
			"latitude": 33.15273000
		}, {
			"areaId": 610726,
			"areaName": "宁强县",
			"longitude": 106.25958000,
			"latitude": 32.82881000
		}, {
			"areaId": 610727,
			"areaName": "略阳县",
			"longitude": 106.15399000,
			"latitude": 33.33009000
		}, {
			"areaId": 610728,
			"areaName": "镇巴县",
			"longitude": 107.89648000,
			"latitude": 32.53487000
		}, {
			"areaId": 610729,
			"areaName": "留坝县",
			"longitude": 106.92233000,
			"latitude": 33.61606000
		}, {
			"areaId": 610730,
			"areaName": "佛坪县",
			"longitude": 107.98974000,
			"latitude": 33.52496000
		}]
	}, {
		"areaId": 6108,
		"areaName": "榆林市",
		"longitude": 109.74119300,
		"latitude": 38.29016200,
		"children": [{
			"areaId": 610802,
			"areaName": "榆阳区",
			"longitude": 109.73473000,
			"latitude": 38.27843000
		}, {
			"areaId": 610803,
			"areaName": "横山区",
			"longitude": 121.11624400,
			"latitude": 24.72080700
		}, {
			"areaId": 610822,
			"areaName": "府谷县",
			"longitude": 111.06723000,
			"latitude": 39.02805000
		}, {
			"areaId": 610824,
			"areaName": "靖边县",
			"longitude": 108.79412000,
			"latitude": 37.59938000
		}, {
			"areaId": 610825,
			"areaName": "定边县",
			"longitude": 107.59793000,
			"latitude": 37.59037000
		}, {
			"areaId": 610826,
			"areaName": "绥德县",
			"longitude": 110.26126000,
			"latitude": 37.49778000
		}, {
			"areaId": 610827,
			"areaName": "米脂县",
			"longitude": 110.18417000,
			"latitude": 37.75529000
		}, {
			"areaId": 610828,
			"areaName": "佳县",
			"longitude": 110.49362000,
			"latitude": 38.02248000
		}, {
			"areaId": 610829,
			"areaName": "吴堡县",
			"longitude": 110.74533000,
			"latitude": 37.45709000
		}, {
			"areaId": 610830,
			"areaName": "清涧县",
			"longitude": 110.12173000,
			"latitude": 37.08854000
		}, {
			"areaId": 610831,
			"areaName": "子洲县",
			"longitude": 110.03488000,
			"latitude": 37.61238000
		}, {
			"areaId": 610881,
			"areaName": "神木市",
			"longitude": 110.49890000,
			"latitude": 38.84234000
		}]
	}, {
		"areaId": 6109,
		"areaName": "安康市",
		"longitude": 109.02927300,
		"latitude": 32.69030000,
		"children": [{
			"areaId": 610902,
			"areaName": "汉滨区",
			"longitude": 109.02683000,
			"latitude": 32.69517000
		}, {
			"areaId": 610921,
			"areaName": "汉阴县",
			"longitude": 108.51098000,
			"latitude": 32.89129000
		}, {
			"areaId": 610922,
			"areaName": "石泉县",
			"longitude": 108.24755000,
			"latitude": 33.03971000
		}, {
			"areaId": 610923,
			"areaName": "宁陕县",
			"longitude": 108.31515000,
			"latitude": 33.31726000
		}, {
			"areaId": 610924,
			"areaName": "紫阳县",
			"longitude": 108.53680000,
			"latitude": 32.52115000
		}, {
			"areaId": 610925,
			"areaName": "岚皋县",
			"longitude": 108.90289000,
			"latitude": 32.30794000
		}, {
			"areaId": 610926,
			"areaName": "平利县",
			"longitude": 109.35775000,
			"latitude": 32.39111000
		}, {
			"areaId": 610927,
			"areaName": "镇坪县",
			"longitude": 109.52456000,
			"latitude": 31.88330000
		}, {
			"areaId": 610928,
			"areaName": "旬阳县",
			"longitude": 109.36190000,
			"latitude": 32.83207000
		}, {
			"areaId": 610929,
			"areaName": "白河县",
			"longitude": 120.41581000,
			"latitude": 23.35122100
		}]
	}, {
		"areaId": 6110,
		"areaName": "商洛市",
		"longitude": 109.93977600,
		"latitude": 33.86831900,
		"children": [{
			"areaId": 611002,
			"areaName": "商州区",
			"longitude": 109.94126000,
			"latitude": 33.86270000
		}, {
			"areaId": 611021,
			"areaName": "洛南县",
			"longitude": 110.14645000,
			"latitude": 34.08994000
		}, {
			"areaId": 611022,
			"areaName": "丹凤县",
			"longitude": 110.33486000,
			"latitude": 33.69468000
		}, {
			"areaId": 611023,
			"areaName": "商南县",
			"longitude": 110.88375000,
			"latitude": 33.52581000
		}, {
			"areaId": 611024,
			"areaName": "山阳县",
			"longitude": 109.88784000,
			"latitude": 33.52931000
		}, {
			"areaId": 611025,
			"areaName": "镇安县",
			"longitude": 109.15374000,
			"latitude": 33.42366000
		}, {
			"areaId": 611026,
			"areaName": "柞水县",
			"longitude": 109.11105000,
			"latitude": 33.68310000
		}]
	}]
}, {
	"areaId": 62,
	"areaName": "甘肃省",
	"longitude": 103.82355700,
	"latitude": 36.05803900,
	"children": [{
		"areaId": 6201,
		"areaName": "兰州市",
		"longitude": 103.82355700,
		"latitude": 36.05803900,
		"children": [{
			"areaId": 620102,
			"areaName": "城关区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 620103,
			"areaName": "七里河区",
			"longitude": 103.78564000,
			"latitude": 36.06585000
		}, {
			"areaId": 620104,
			"areaName": "西固区",
			"longitude": 103.62811000,
			"latitude": 36.08858000
		}, {
			"areaId": 620105,
			"areaName": "安宁区",
			"longitude": 103.71890000,
			"latitude": 36.10384000
		}, {
			"areaId": 620111,
			"areaName": "红古区",
			"longitude": 102.85955000,
			"latitude": 36.34537000
		}, {
			"areaId": 620121,
			"areaName": "永登县",
			"longitude": 103.26055000,
			"latitude": 36.73522000
		}, {
			"areaId": 620122,
			"areaName": "皋兰县",
			"longitude": 103.94506000,
			"latitude": 36.33215000
		}, {
			"areaId": 620123,
			"areaName": "榆中县",
			"longitude": 104.11450000,
			"latitude": 35.84415000
		}, {
			"areaId": 620171,
			"areaName": "兰州新区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 6202,
		"areaName": "嘉峪关市",
		"longitude": 98.27730400,
		"latitude": 39.78652900,
		"children": [{
			"areaId": 620201,
			"areaName": "市辖区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 6203,
		"areaName": "金昌市",
		"longitude": 102.18788800,
		"latitude": 38.51423800,
		"children": [{
			"areaId": 620302,
			"areaName": "金川区",
			"longitude": 102.19376000,
			"latitude": 38.52101000
		}, {
			"areaId": 620321,
			"areaName": "永昌县",
			"longitude": 101.97222000,
			"latitude": 38.24711000
		}]
	}, {
		"areaId": 6204,
		"areaName": "白银市",
		"longitude": 104.17360600,
		"latitude": 36.54568000,
		"children": [{
			"areaId": 620402,
			"areaName": "白银区",
			"longitude": 104.17355000,
			"latitude": 36.54411000
		}, {
			"areaId": 620403,
			"areaName": "平川区",
			"longitude": 104.82498000,
			"latitude": 36.72770000
		}, {
			"areaId": 620421,
			"areaName": "靖远县",
			"longitude": 104.68325000,
			"latitude": 36.56602000
		}, {
			"areaId": 620422,
			"areaName": "会宁县",
			"longitude": 105.05297000,
			"latitude": 35.69626000
		}, {
			"areaId": 620423,
			"areaName": "景泰县",
			"longitude": 104.06295000,
			"latitude": 37.18359000
		}]
	}, {
		"areaId": 6205,
		"areaName": "天水市",
		"longitude": 105.72499800,
		"latitude": 34.57852900,
		"children": [{
			"areaId": 620502,
			"areaName": "秦州区",
			"longitude": 105.72421000,
			"latitude": 34.58089000
		}, {
			"areaId": 620503,
			"areaName": "麦积区",
			"longitude": 105.89013000,
			"latitude": 34.57069000
		}, {
			"areaId": 620521,
			"areaName": "清水县",
			"longitude": 106.13671000,
			"latitude": 34.75032000
		}, {
			"areaId": 620522,
			"areaName": "秦安县",
			"longitude": 105.66955000,
			"latitude": 34.85894000
		}, {
			"areaId": 620523,
			"areaName": "甘谷县",
			"longitude": 105.33291000,
			"latitude": 34.73665000
		}, {
			"areaId": 620524,
			"areaName": "武山县",
			"longitude": 104.88382000,
			"latitude": 34.72123000
		}, {
			"areaId": 620525,
			"areaName": "张家川回族自治县",
			"longitude": 106.21582000,
			"latitude": 34.99582000
		}]
	}, {
		"areaId": 6206,
		"areaName": "武威市",
		"longitude": 102.63469700,
		"latitude": 37.92999600,
		"children": [{
			"areaId": 620602,
			"areaName": "凉州区",
			"longitude": 102.64203000,
			"latitude": 37.92832000
		}, {
			"areaId": 620621,
			"areaName": "民勤县",
			"longitude": 103.09011000,
			"latitude": 38.62487000
		}, {
			"areaId": 620622,
			"areaName": "古浪县",
			"longitude": 102.89154000,
			"latitude": 37.46508000
		}, {
			"areaId": 620623,
			"areaName": "天祝藏族自治县",
			"longitude": 103.13610000,
			"latitude": 36.97715000
		}]
	}, {
		"areaId": 6207,
		"areaName": "张掖市",
		"longitude": 100.45547200,
		"latitude": 38.93289700,
		"children": [{
			"areaId": 620702,
			"areaName": "甘州区",
			"longitude": 100.45270000,
			"latitude": 38.92947000
		}, {
			"areaId": 620721,
			"areaName": "肃南裕固族自治县",
			"longitude": 99.61407000,
			"latitude": 38.83776000
		}, {
			"areaId": 620722,
			"areaName": "民乐县",
			"longitude": 100.81091000,
			"latitude": 38.43479000
		}, {
			"areaId": 620723,
			"areaName": "临泽县",
			"longitude": 100.16445000,
			"latitude": 39.15252000
		}, {
			"areaId": 620724,
			"areaName": "高台县",
			"longitude": 99.81918000,
			"latitude": 39.37829000
		}, {
			"areaId": 620725,
			"areaName": "山丹县",
			"longitude": 101.09359000,
			"latitude": 38.78468000
		}]
	}, {
		"areaId": 6208,
		"areaName": "平凉市",
		"longitude": 106.68469100,
		"latitude": 35.54279000,
		"children": [{
			"areaId": 620802,
			"areaName": "崆峒区",
			"longitude": 106.67483000,
			"latitude": 35.54262000
		}, {
			"areaId": 620821,
			"areaName": "泾川县",
			"longitude": 107.36581000,
			"latitude": 35.33223000
		}, {
			"areaId": 620822,
			"areaName": "灵台县",
			"longitude": 107.61740000,
			"latitude": 35.06768000
		}, {
			"areaId": 620823,
			"areaName": "崇信县",
			"longitude": 107.03738000,
			"latitude": 35.30344000
		}, {
			"areaId": 620825,
			"areaName": "庄浪县",
			"longitude": 106.03662000,
			"latitude": 35.20235000
		}, {
			"areaId": 620826,
			"areaName": "静宁县",
			"longitude": 105.72723000,
			"latitude": 35.51991000
		}, {
			"areaId": 620881,
			"areaName": "华亭市",
			"longitude": 106.65463000,
			"latitude": 35.21830000
		}]
	}, {
		"areaId": 6209,
		"areaName": "酒泉市",
		"longitude": 98.51079500,
		"latitude": 39.74402300,
		"children": [{
			"areaId": 620902,
			"areaName": "肃州区",
			"longitude": 98.50775000,
			"latitude": 39.74506000
		}, {
			"areaId": 620921,
			"areaName": "金塔县",
			"longitude": 98.90002000,
			"latitude": 39.97733000
		}, {
			"areaId": 620922,
			"areaName": "瓜州县",
			"longitude": 95.78271000,
			"latitude": 40.51548000
		}, {
			"areaId": 620923,
			"areaName": "肃北蒙古族自治县",
			"longitude": 94.87649000,
			"latitude": 39.51214000
		}, {
			"areaId": 620924,
			"areaName": "阿克塞哈萨克族自治县",
			"longitude": 94.34097000,
			"latitude": 39.63435000
		}, {
			"areaId": 620981,
			"areaName": "玉门市",
			"longitude": 97.04538000,
			"latitude": 40.29172000
		}, {
			"areaId": 620982,
			"areaName": "敦煌市",
			"longitude": 94.66159000,
			"latitude": 40.14211000
		}]
	}, {
		"areaId": 6210,
		"areaName": "庆阳市",
		"longitude": 107.63837200,
		"latitude": 35.73421800,
		"children": [{
			"areaId": 621002,
			"areaName": "西峰区",
			"longitude": 107.65107000,
			"latitude": 35.73065000
		}, {
			"areaId": 621021,
			"areaName": "庆城县",
			"longitude": 107.88272000,
			"latitude": 36.01507000
		}, {
			"areaId": 621022,
			"areaName": "环县",
			"longitude": 107.30835000,
			"latitude": 36.56846000
		}, {
			"areaId": 621023,
			"areaName": "华池县",
			"longitude": 107.98910000,
			"latitude": 36.46108000
		}, {
			"areaId": 621024,
			"areaName": "合水县",
			"longitude": 108.02032000,
			"latitude": 35.81911000
		}, {
			"areaId": 621025,
			"areaName": "正宁县",
			"longitude": 108.36007000,
			"latitude": 35.49174000
		}, {
			"areaId": 621026,
			"areaName": "宁县",
			"longitude": 107.92517000,
			"latitude": 35.50164000
		}, {
			"areaId": 621027,
			"areaName": "镇原县",
			"longitude": 107.19900000,
			"latitude": 35.67712000
		}]
	}, {
		"areaId": 6211,
		"areaName": "定西市",
		"longitude": 104.62629400,
		"latitude": 35.57957800,
		"children": [{
			"areaId": 621102,
			"areaName": "安定区",
			"longitude": 120.23708300,
			"latitude": 23.12149800
		}, {
			"areaId": 621121,
			"areaName": "通渭县",
			"longitude": 105.24224000,
			"latitude": 35.21101000
		}, {
			"areaId": 621122,
			"areaName": "陇西县",
			"longitude": 104.63446000,
			"latitude": 35.00238000
		}, {
			"areaId": 621123,
			"areaName": "渭源县",
			"longitude": 104.21435000,
			"latitude": 35.13649000
		}, {
			"areaId": 621124,
			"areaName": "临洮县",
			"longitude": 103.86196000,
			"latitude": 35.37510000
		}, {
			"areaId": 621125,
			"areaName": "漳县",
			"longitude": 104.46704000,
			"latitude": 34.84977000
		}, {
			"areaId": 621126,
			"areaName": "岷县",
			"longitude": 104.03772000,
			"latitude": 34.43444000
		}]
	}, {
		"areaId": 6212,
		"areaName": "陇南市",
		"longitude": 104.92937900,
		"latitude": 33.38859800,
		"children": [{
			"areaId": 621202,
			"areaName": "武都区",
			"longitude": 104.92652000,
			"latitude": 33.39239000
		}, {
			"areaId": 621221,
			"areaName": "成县",
			"longitude": 105.72586000,
			"latitude": 33.73925000
		}, {
			"areaId": 621222,
			"areaName": "文县",
			"longitude": 104.68362000,
			"latitude": 32.94337000
		}, {
			"areaId": 621223,
			"areaName": "宕昌县",
			"longitude": 104.39349000,
			"latitude": 34.04732000
		}, {
			"areaId": 621224,
			"areaName": "康县",
			"longitude": 105.60711000,
			"latitude": 33.32912000
		}, {
			"areaId": 621225,
			"areaName": "西和县",
			"longitude": 105.30099000,
			"latitude": 34.01432000
		}, {
			"areaId": 621226,
			"areaName": "礼县",
			"longitude": 105.17785000,
			"latitude": 34.18935000
		}, {
			"areaId": 621227,
			"areaName": "徽县",
			"longitude": 106.08529000,
			"latitude": 33.76898000
		}, {
			"areaId": 621228,
			"areaName": "两当县",
			"longitude": 106.30484000,
			"latitude": 33.90960000
		}]
	}, {
		"areaId": 6229,
		"areaName": "临夏回族自治州",
		"longitude": 103.21200600,
		"latitude": 35.59944600,
		"children": [{
			"areaId": 622901,
			"areaName": "临夏市",
			"longitude": 103.21000000,
			"latitude": 35.59916000
		}, {
			"areaId": 622921,
			"areaName": "临夏县",
			"longitude": 102.99380000,
			"latitude": 35.49519000
		}, {
			"areaId": 622922,
			"areaName": "康乐县",
			"longitude": 103.71093000,
			"latitude": 35.37219000
		}, {
			"areaId": 622923,
			"areaName": "永靖县",
			"longitude": 120.54777500,
			"latitude": 23.92470300
		}, {
			"areaId": 622924,
			"areaName": "广河县",
			"longitude": 103.56933000,
			"latitude": 35.48097000
		}, {
			"areaId": 622925,
			"areaName": "和政县",
			"longitude": 103.34936000,
			"latitude": 35.42592000
		}, {
			"areaId": 622926,
			"areaName": "东乡族自治县",
			"longitude": 103.39477000,
			"latitude": 35.66471000
		}, {
			"areaId": 622927,
			"areaName": "积石山保安族东乡族撒拉族自治县",
			"longitude": 102.87374000,
			"latitude": 35.71820000
		}]
	}, {
		"areaId": 6230,
		"areaName": "甘南藏族自治州",
		"longitude": 102.91100800,
		"latitude": 34.98635400,
		"children": [{
			"areaId": 623001,
			"areaName": "合作市",
			"longitude": 102.91082000,
			"latitude": 35.00016000
		}, {
			"areaId": 623021,
			"areaName": "临潭县",
			"longitude": 103.35287000,
			"latitude": 34.69515000
		}, {
			"areaId": 623022,
			"areaName": "卓尼县",
			"longitude": 103.50811000,
			"latitude": 34.58919000
		}, {
			"areaId": 623023,
			"areaName": "舟曲县",
			"longitude": 104.37155000,
			"latitude": 33.78468000
		}, {
			"areaId": 623024,
			"areaName": "迭部县",
			"longitude": 103.22274000,
			"latitude": 34.05623000
		}, {
			"areaId": 623025,
			"areaName": "玛曲县",
			"longitude": 102.07540000,
			"latitude": 33.99700000
		}, {
			"areaId": 623026,
			"areaName": "碌曲县",
			"longitude": 102.49176000,
			"latitude": 34.58872000
		}, {
			"areaId": 623027,
			"areaName": "夏河县",
			"longitude": 102.52215000,
			"latitude": 35.20487000
		}]
	}]
}, {
	"areaId": 63,
	"areaName": "青海省",
	"longitude": 101.77891600,
	"latitude": 36.62317800,
	"children": [{
		"areaId": 6301,
		"areaName": "西宁市",
		"longitude": 101.77891600,
		"latitude": 36.62317800,
		"children": [{
			"areaId": 630102,
			"areaName": "城东区",
			"longitude": 101.80373000,
			"latitude": 36.59969000
		}, {
			"areaId": 630103,
			"areaName": "城中区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 630104,
			"areaName": "城西区",
			"longitude": 101.76588000,
			"latitude": 36.62828000
		}, {
			"areaId": 630105,
			"areaName": "城北区",
			"longitude": 101.76620000,
			"latitude": 36.65014000
		}, {
			"areaId": 630106,
			"areaName": "湟中区",
			"longitude": 101.57159000,
			"latitude": 36.50083000
		}, {
			"areaId": 630121,
			"areaName": "大通回族土族自治县",
			"longitude": 101.70236000,
			"latitude": 36.93489000
		}, {
			"areaId": 630123,
			"areaName": "湟源县",
			"longitude": 101.25643000,
			"latitude": 36.68243000
		}]
	}, {
		"areaId": 6302,
		"areaName": "海东市",
		"longitude": 102.10327000,
		"latitude": 36.50291600,
		"children": [{
			"areaId": 630202,
			"areaName": "乐都区",
			"longitude": 102.40243100,
			"latitude": 36.48029100
		}, {
			"areaId": 630203,
			"areaName": "平安区",
			"longitude": 102.10429500,
			"latitude": 36.50271400
		}, {
			"areaId": 630222,
			"areaName": "民和回族土族自治县",
			"longitude": 102.80420900,
			"latitude": 36.32945100
		}, {
			"areaId": 630223,
			"areaName": "互助土族自治县",
			"longitude": 101.95673400,
			"latitude": 36.83994000
		}, {
			"areaId": 630224,
			"areaName": "化隆回族自治县",
			"longitude": 102.26232900,
			"latitude": 36.09832200
		}, {
			"areaId": 630225,
			"areaName": "循化撒拉族自治县",
			"longitude": 102.48653400,
			"latitude": 35.84724700
		}]
	}, {
		"areaId": 6322,
		"areaName": "海北藏族自治州",
		"longitude": 100.90105900,
		"latitude": 36.95943500,
		"children": [{
			"areaId": 632221,
			"areaName": "门源回族自治县",
			"longitude": 101.62228000,
			"latitude": 37.37611000
		}, {
			"areaId": 632222,
			"areaName": "祁连县",
			"longitude": 100.24618000,
			"latitude": 38.17901000
		}, {
			"areaId": 632223,
			"areaName": "海晏县",
			"longitude": 100.99270000,
			"latitude": 36.89902000
		}, {
			"areaId": 632224,
			"areaName": "刚察县",
			"longitude": 100.14675000,
			"latitude": 37.32161000
		}]
	}, {
		"areaId": 6323,
		"areaName": "黄南藏族自治州",
		"longitude": 102.01998800,
		"latitude": 35.51774400,
		"children": [{
			"areaId": 632321,
			"areaName": "同仁县",
			"longitude": 102.01840000,
			"latitude": 35.51603000
		}, {
			"areaId": 632322,
			"areaName": "尖扎县",
			"longitude": 102.03411000,
			"latitude": 35.93947000
		}, {
			"areaId": 632323,
			"areaName": "泽库县",
			"longitude": 101.46444000,
			"latitude": 35.03519000
		}, {
			"areaId": 632324,
			"areaName": "河南蒙古族自治县",
			"longitude": 101.60864000,
			"latitude": 34.73476000
		}]
	}, {
		"areaId": 6325,
		"areaName": "海南藏族自治州",
		"longitude": 100.61954200,
		"latitude": 36.28035300,
		"children": [{
			"areaId": 632521,
			"areaName": "共和县",
			"longitude": 100.62003000,
			"latitude": 36.28410000
		}, {
			"areaId": 632522,
			"areaName": "同德县",
			"longitude": 100.57159000,
			"latitude": 35.25488000
		}, {
			"areaId": 632523,
			"areaName": "贵德县",
			"longitude": 101.43200000,
			"latitude": 36.04400000
		}, {
			"areaId": 632524,
			"areaName": "兴海县",
			"longitude": 99.98846000,
			"latitude": 35.59031000
		}, {
			"areaId": 632525,
			"areaName": "贵南县",
			"longitude": 100.74716000,
			"latitude": 35.58667000
		}]
	}, {
		"areaId": 6326,
		"areaName": "果洛藏族自治州",
		"longitude": 100.24214300,
		"latitude": 34.47360000,
		"children": [{
			"areaId": 632621,
			"areaName": "玛沁县",
			"longitude": 100.23901000,
			"latitude": 34.47746000
		}, {
			"areaId": 632622,
			"areaName": "班玛县",
			"longitude": 100.73745000,
			"latitude": 32.93253000
		}, {
			"areaId": 632623,
			"areaName": "甘德县",
			"longitude": 99.90246000,
			"latitude": 33.96838000
		}, {
			"areaId": 632624,
			"areaName": "达日县",
			"longitude": 99.65179000,
			"latitude": 33.75193000
		}, {
			"areaId": 632625,
			"areaName": "久治县",
			"longitude": 101.48342000,
			"latitude": 33.42989000
		}, {
			"areaId": 632626,
			"areaName": "玛多县",
			"longitude": 98.20996000,
			"latitude": 34.91567000
		}]
	}, {
		"areaId": 6327,
		"areaName": "玉树藏族自治州",
		"longitude": 97.00852200,
		"latitude": 33.00404900,
		"children": [{
			"areaId": 632701,
			"areaName": "玉树市",
			"longitude": 97.00876200,
			"latitude": 33.00393000
		}, {
			"areaId": 632722,
			"areaName": "杂多县",
			"longitude": 95.29864000,
			"latitude": 32.89318000
		}, {
			"areaId": 632723,
			"areaName": "称多县",
			"longitude": 97.10788000,
			"latitude": 33.36899000
		}, {
			"areaId": 632724,
			"areaName": "治多县",
			"longitude": 95.61572000,
			"latitude": 33.85280000
		}, {
			"areaId": 632725,
			"areaName": "囊谦县",
			"longitude": 96.47753000,
			"latitude": 32.20359000
		}, {
			"areaId": 632726,
			"areaName": "曲麻莱县",
			"longitude": 95.79757000,
			"latitude": 34.12609000
		}]
	}, {
		"areaId": 6328,
		"areaName": "海西蒙古族藏族自治州",
		"longitude": 97.37078500,
		"latitude": 37.37466300,
		"children": [{
			"areaId": 632801,
			"areaName": "格尔木市",
			"longitude": 94.90329000,
			"latitude": 36.40236000
		}, {
			"areaId": 632802,
			"areaName": "德令哈市",
			"longitude": 97.36084000,
			"latitude": 37.36946000
		}, {
			"areaId": 632803,
			"areaName": "茫崖市",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 632821,
			"areaName": "乌兰县",
			"longitude": 98.48196000,
			"latitude": 36.93471000
		}, {
			"areaId": 632822,
			"areaName": "都兰县",
			"longitude": 98.09228000,
			"latitude": 36.30135000
		}, {
			"areaId": 632823,
			"areaName": "天峻县",
			"longitude": 99.02453000,
			"latitude": 37.30326000
		}, {
			"areaId": 632857,
			"areaName": "大柴旦行政委员会",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}]
}, {
	"areaId": 64,
	"areaName": "宁夏回族自治区",
	"longitude": 106.27817900,
	"latitude": 38.46637000,
	"children": [{
		"areaId": 6401,
		"areaName": "银川市",
		"longitude": 106.27817900,
		"latitude": 38.46637000,
		"children": [{
			"areaId": 640104,
			"areaName": "兴庆区",
			"longitude": 106.28872000,
			"latitude": 38.47392000
		}, {
			"areaId": 640105,
			"areaName": "西夏区",
			"longitude": 106.15023000,
			"latitude": 38.49137000
		}, {
			"areaId": 640106,
			"areaName": "金凤区",
			"longitude": 106.24261000,
			"latitude": 38.47294000
		}, {
			"areaId": 640121,
			"areaName": "永宁县",
			"longitude": 106.25170000,
			"latitude": 38.27559000
		}, {
			"areaId": 640122,
			"areaName": "贺兰县",
			"longitude": 106.34982000,
			"latitude": 38.55440000
		}, {
			"areaId": 640181,
			"areaName": "灵武市",
			"longitude": 106.33999000,
			"latitude": 38.10266000
		}]
	}, {
		"areaId": 6402,
		"areaName": "石嘴山市",
		"longitude": 106.37617300,
		"latitude": 39.01333000,
		"children": [{
			"areaId": 640202,
			"areaName": "大武口区",
			"longitude": 120.88993800,
			"latitude": 22.33991900
		}, {
			"areaId": 640205,
			"areaName": "惠农区",
			"longitude": 106.71145000,
			"latitude": 39.13193000
		}, {
			"areaId": 640221,
			"areaName": "平罗县",
			"longitude": 106.54538000,
			"latitude": 38.90429000
		}]
	}, {
		"areaId": 6403,
		"areaName": "吴忠市",
		"longitude": 106.19940900,
		"latitude": 37.98616500,
		"children": [{
			"areaId": 640302,
			"areaName": "利通区",
			"longitude": 106.20311000,
			"latitude": 37.98512000
		}, {
			"areaId": 640303,
			"areaName": "红寺堡区",
			"longitude": 106.19822000,
			"latitude": 37.99747000
		}, {
			"areaId": 640323,
			"areaName": "盐池县",
			"longitude": 107.40707000,
			"latitude": 37.78330000
		}, {
			"areaId": 640324,
			"areaName": "同心县",
			"longitude": 105.91418000,
			"latitude": 36.98116000
		}, {
			"areaId": 640381,
			"areaName": "青铜峡市",
			"longitude": 106.07489000,
			"latitude": 38.02004000
		}]
	}, {
		"areaId": 6404,
		"areaName": "固原市",
		"longitude": 106.28524100,
		"latitude": 36.00456100,
		"children": [{
			"areaId": 640402,
			"areaName": "原州区",
			"longitude": 106.28778000,
			"latitude": 36.00374000
		}, {
			"areaId": 640422,
			"areaName": "西吉县",
			"longitude": 105.73107000,
			"latitude": 35.96616000
		}, {
			"areaId": 640423,
			"areaName": "隆德县",
			"longitude": 106.12426000,
			"latitude": 35.61718000
		}, {
			"areaId": 640424,
			"areaName": "泾源县",
			"longitude": 106.33902000,
			"latitude": 35.49072000
		}, {
			"areaId": 640425,
			"areaName": "彭阳县",
			"longitude": 106.64462000,
			"latitude": 35.85076000
		}]
	}, {
		"areaId": 6405,
		"areaName": "中卫市",
		"longitude": 105.18956800,
		"latitude": 37.51495100,
		"children": [{
			"areaId": 640502,
			"areaName": "沙坡头区",
			"longitude": 105.18962000,
			"latitude": 37.51044000
		}, {
			"areaId": 640521,
			"areaName": "中宁县",
			"longitude": 105.68515000,
			"latitude": 37.49149000
		}, {
			"areaId": 640522,
			"areaName": "海原县",
			"longitude": 105.64712000,
			"latitude": 36.56498000
		}]
	}]
}, {
	"areaId": 65,
	"areaName": "新疆维吾尔自治区",
	"longitude": 87.61773300,
	"latitude": 43.79281800,
	"children": [{
		"areaId": 6501,
		"areaName": "乌鲁木齐市",
		"longitude": 87.61773300,
		"latitude": 43.79281800,
		"children": [{
			"areaId": 650102,
			"areaName": "天山区",
			"longitude": 87.63167000,
			"latitude": 43.79439000
		}, {
			"areaId": 650103,
			"areaName": "沙依巴克区",
			"longitude": 87.59788000,
			"latitude": 43.80118000
		}, {
			"areaId": 650104,
			"areaName": "新市区",
			"longitude": 120.29513800,
			"latitude": 23.07897000
		}, {
			"areaId": 650105,
			"areaName": "水磨沟区",
			"longitude": 87.64249000,
			"latitude": 43.83247000
		}, {
			"areaId": 650106,
			"areaName": "头屯河区",
			"longitude": 87.29138000,
			"latitude": 43.85487000
		}, {
			"areaId": 650107,
			"areaName": "达坂城区",
			"longitude": 88.30697000,
			"latitude": 43.35797000
		}, {
			"areaId": 650109,
			"areaName": "米东区",
			"longitude": 87.68583000,
			"latitude": 43.94739000
		}, {
			"areaId": 650121,
			"areaName": "乌鲁木齐县",
			"longitude": 87.40939000,
			"latitude": 43.47125000
		}]
	}, {
		"areaId": 6502,
		"areaName": "克拉玛依市",
		"longitude": 84.87394600,
		"latitude": 45.59588600,
		"children": [{
			"areaId": 650202,
			"areaName": "独山子区",
			"longitude": 84.88671000,
			"latitude": 44.32867000
		}, {
			"areaId": 650203,
			"areaName": "克拉玛依区",
			"longitude": 84.86225000,
			"latitude": 45.59089000
		}, {
			"areaId": 650204,
			"areaName": "白碱滩区",
			"longitude": 85.13244000,
			"latitude": 45.68768000
		}, {
			"areaId": 650205,
			"areaName": "乌尔禾区",
			"longitude": 85.69143000,
			"latitude": 46.09006000
		}]
	}, {
		"areaId": 6504,
		"areaName": "吐鲁番市",
		"longitude": 89.18579000,
		"latitude": 42.93505000,
		"children": [{
			"areaId": 650402,
			"areaName": "高昌区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 650421,
			"areaName": "鄯善县",
			"longitude": 90.21402000,
			"latitude": 42.86350000
		}, {
			"areaId": 650422,
			"areaName": "托克逊县",
			"longitude": 88.65823000,
			"latitude": 42.79231000
		}]
	}, {
		"areaId": 6505,
		"areaName": "哈密市",
		"longitude": 93.51452000,
		"latitude": 42.82699000,
		"children": [{
			"areaId": 650502,
			"areaName": "伊州区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 650521,
			"areaName": "巴里坤哈萨克自治县",
			"longitude": 93.01236000,
			"latitude": 43.59993000
		}, {
			"areaId": 650522,
			"areaName": "伊吾县",
			"longitude": 94.69403000,
			"latitude": 43.25370000
		}]
	}, {
		"areaId": 6523,
		"areaName": "昌吉回族自治州",
		"longitude": 87.30401200,
		"latitude": 44.01457700,
		"children": [{
			"areaId": 652301,
			"areaName": "昌吉市",
			"longitude": 87.30249000,
			"latitude": 44.01267000
		}, {
			"areaId": 652302,
			"areaName": "阜康市",
			"longitude": 87.98529000,
			"latitude": 44.15840000
		}, {
			"areaId": 652323,
			"areaName": "呼图壁县",
			"longitude": 86.89892000,
			"latitude": 44.18977000
		}, {
			"areaId": 652324,
			"areaName": "玛纳斯县",
			"longitude": 86.21450000,
			"latitude": 44.30438000
		}, {
			"areaId": 652325,
			"areaName": "奇台县",
			"longitude": 89.59320000,
			"latitude": 44.02221000
		}, {
			"areaId": 652327,
			"areaName": "吉木萨尔县",
			"longitude": 89.18078000,
			"latitude": 44.00048000
		}, {
			"areaId": 652328,
			"areaName": "木垒哈萨克自治县",
			"longitude": 90.28897000,
			"latitude": 43.83508000
		}]
	}, {
		"areaId": 6527,
		"areaName": "博尔塔拉蒙古自治州",
		"longitude": 82.07477800,
		"latitude": 44.90325800,
		"children": [{
			"areaId": 652701,
			"areaName": "博乐市",
			"longitude": 82.07130000,
			"latitude": 44.90052000
		}, {
			"areaId": 652702,
			"areaName": "阿拉山口市",
			"longitude": 82.56772100,
			"latitude": 45.17061600
		}, {
			"areaId": 652722,
			"areaName": "精河县",
			"longitude": 82.89419000,
			"latitude": 44.60774000
		}, {
			"areaId": 652723,
			"areaName": "温泉县",
			"longitude": 81.03134000,
			"latitude": 44.97373000
		}]
	}, {
		"areaId": 6528,
		"areaName": "巴音郭楞蒙古自治州",
		"longitude": 86.15096900,
		"latitude": 41.76855200,
		"children": [{
			"areaId": 652801,
			"areaName": "库尔勒市",
			"longitude": 86.15528000,
			"latitude": 41.76602000
		}, {
			"areaId": 652822,
			"areaName": "轮台县",
			"longitude": 84.26101000,
			"latitude": 41.77642000
		}, {
			"areaId": 652823,
			"areaName": "尉犁县",
			"longitude": 86.25903000,
			"latitude": 41.33632000
		}, {
			"areaId": 652824,
			"areaName": "若羌县",
			"longitude": 88.16812000,
			"latitude": 39.01790000
		}, {
			"areaId": 652825,
			"areaName": "且末县",
			"longitude": 85.52975000,
			"latitude": 38.14534000
		}, {
			"areaId": 652826,
			"areaName": "焉耆回族自治县",
			"longitude": 86.57440000,
			"latitude": 42.05900000
		}, {
			"areaId": 652827,
			"areaName": "和静县",
			"longitude": 86.39611000,
			"latitude": 42.31838000
		}, {
			"areaId": 652828,
			"areaName": "和硕县",
			"longitude": 86.86392000,
			"latitude": 42.26814000
		}, {
			"areaId": 652829,
			"areaName": "博湖县",
			"longitude": 86.63333000,
			"latitude": 41.98014000
		}, {
			"areaId": 652871,
			"areaName": "库尔勒经济技术开发区",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}, {
		"areaId": 6529,
		"areaName": "阿克苏地区",
		"longitude": 80.26506800,
		"latitude": 41.17071200,
		"children": [{
			"areaId": 652901,
			"areaName": "阿克苏市",
			"longitude": 80.26338000,
			"latitude": 41.16754000
		}, {
			"areaId": 652902,
			"areaName": "库车市",
			"longitude": 82.96209000,
			"latitude": 41.71793000
		}, {
			"areaId": 652922,
			"areaName": "温宿县",
			"longitude": 80.24173000,
			"latitude": 41.27679000
		}, {
			"areaId": 652924,
			"areaName": "沙雅县",
			"longitude": 82.78131000,
			"latitude": 41.22497000
		}, {
			"areaId": 652925,
			"areaName": "新和县",
			"longitude": 82.61053000,
			"latitude": 41.54964000
		}, {
			"areaId": 652926,
			"areaName": "拜城县",
			"longitude": 81.87564000,
			"latitude": 41.79801000
		}, {
			"areaId": 652927,
			"areaName": "乌什县",
			"longitude": 79.22937000,
			"latitude": 41.21569000
		}, {
			"areaId": 652928,
			"areaName": "阿瓦提县",
			"longitude": 80.38336000,
			"latitude": 40.63926000
		}, {
			"areaId": 652929,
			"areaName": "柯坪县",
			"longitude": 79.04751000,
			"latitude": 40.50585000
		}]
	}, {
		"areaId": 6530,
		"areaName": "克孜勒苏柯尔克孜自治州",
		"longitude": 76.17282500,
		"latitude": 39.71343100,
		"children": [{
			"areaId": 653001,
			"areaName": "阿图什市",
			"longitude": 76.16827000,
			"latitude": 39.71615000
		}, {
			"areaId": 653022,
			"areaName": "阿克陶县",
			"longitude": 75.94692000,
			"latitude": 39.14892000
		}, {
			"areaId": 653023,
			"areaName": "阿合奇县",
			"longitude": 78.44848000,
			"latitude": 40.93947000
		}, {
			"areaId": 653024,
			"areaName": "乌恰县",
			"longitude": 75.25839000,
			"latitude": 39.71984000
		}]
	}, {
		"areaId": 6531,
		"areaName": "喀什地区",
		"longitude": 75.98913800,
		"latitude": 39.46766400,
		"children": [{
			"areaId": 653101,
			"areaName": "喀什市",
			"longitude": 75.99379000,
			"latitude": 39.46768000
		}, {
			"areaId": 653121,
			"areaName": "疏附县",
			"longitude": 75.86029000,
			"latitude": 39.37534000
		}, {
			"areaId": 653122,
			"areaName": "疏勒县",
			"longitude": 76.05398000,
			"latitude": 39.40625000
		}, {
			"areaId": 653123,
			"areaName": "英吉沙县",
			"longitude": 76.17565000,
			"latitude": 38.92968000
		}, {
			"areaId": 653124,
			"areaName": "泽普县",
			"longitude": 77.27145000,
			"latitude": 38.18935000
		}, {
			"areaId": 653125,
			"areaName": "莎车县",
			"longitude": 77.24316000,
			"latitude": 38.41601000
		}, {
			"areaId": 653126,
			"areaName": "叶城县",
			"longitude": 77.41659000,
			"latitude": 37.88324000
		}, {
			"areaId": 653127,
			"areaName": "麦盖提县",
			"longitude": 77.64224000,
			"latitude": 38.89662000
		}, {
			"areaId": 653128,
			"areaName": "岳普湖县",
			"longitude": 76.77233000,
			"latitude": 39.23561000
		}, {
			"areaId": 653129,
			"areaName": "伽师县",
			"longitude": 76.72372000,
			"latitude": 39.48801000
		}, {
			"areaId": 653130,
			"areaName": "巴楚县",
			"longitude": 78.54888000,
			"latitude": 39.78550000
		}, {
			"areaId": 653131,
			"areaName": "塔什库尔干塔吉克自治县",
			"longitude": 75.23196000,
			"latitude": 37.77893000
		}]
	}, {
		"areaId": 6532,
		"areaName": "和田地区",
		"longitude": 79.92533000,
		"latitude": 37.11068700,
		"children": [{
			"areaId": 653201,
			"areaName": "和田市",
			"longitude": 79.91353000,
			"latitude": 37.11214000
		}, {
			"areaId": 653221,
			"areaName": "和田县",
			"longitude": 79.82874000,
			"latitude": 37.08922000
		}, {
			"areaId": 653222,
			"areaName": "墨玉县",
			"longitude": 79.74035000,
			"latitude": 37.27248000
		}, {
			"areaId": 653223,
			"areaName": "皮山县",
			"longitude": 78.28125000,
			"latitude": 37.62007000
		}, {
			"areaId": 653224,
			"areaName": "洛浦县",
			"longitude": 80.18536000,
			"latitude": 37.07364000
		}, {
			"areaId": 653225,
			"areaName": "策勒县",
			"longitude": 80.80999000,
			"latitude": 36.99843000
		}, {
			"areaId": 653226,
			"areaName": "于田县",
			"longitude": 81.66717000,
			"latitude": 36.85400000
		}, {
			"areaId": 653227,
			"areaName": "民丰县",
			"longitude": 82.68444000,
			"latitude": 37.06577000
		}]
	}, {
		"areaId": 6540,
		"areaName": "伊犁哈萨克自治州",
		"longitude": 81.31794600,
		"latitude": 43.92186000,
		"children": [{
			"areaId": 654002,
			"areaName": "伊宁市",
			"longitude": 81.32932000,
			"latitude": 43.91294000
		}, {
			"areaId": 654003,
			"areaName": "奎屯市",
			"longitude": 84.90228000,
			"latitude": 44.42500000
		}, {
			"areaId": 654004,
			"areaName": "霍尔果斯市",
			"longitude": 80.41818900,
			"latitude": 44.20577800
		}, {
			"areaId": 654021,
			"areaName": "伊宁县",
			"longitude": 81.52764000,
			"latitude": 43.97863000
		}, {
			"areaId": 654022,
			"areaName": "察布查尔锡伯自治县",
			"longitude": 81.14956000,
			"latitude": 43.84023000
		}, {
			"areaId": 654023,
			"areaName": "霍城县",
			"longitude": 80.87826000,
			"latitude": 44.05330000
		}, {
			"areaId": 654024,
			"areaName": "巩留县",
			"longitude": 82.22851000,
			"latitude": 43.48429000
		}, {
			"areaId": 654025,
			"areaName": "新源县",
			"longitude": 83.26095000,
			"latitude": 43.42840000
		}, {
			"areaId": 654026,
			"areaName": "昭苏县",
			"longitude": 81.13070000,
			"latitude": 43.15828000
		}, {
			"areaId": 654027,
			"areaName": "特克斯县",
			"longitude": 81.84005000,
			"latitude": 43.21938000
		}, {
			"areaId": 654028,
			"areaName": "尼勒克县",
			"longitude": 82.51184000,
			"latitude": 43.79901000
		}]
	}, {
		"areaId": 6542,
		"areaName": "塔城地区",
		"longitude": 82.98573200,
		"latitude": 46.74630100,
		"children": [{
			"areaId": 654201,
			"areaName": "塔城市",
			"longitude": 82.97892000,
			"latitude": 46.74852000
		}, {
			"areaId": 654202,
			"areaName": "乌苏市",
			"longitude": 84.68258000,
			"latitude": 44.43729000
		}, {
			"areaId": 654221,
			"areaName": "额敏县",
			"longitude": 83.62872000,
			"latitude": 46.52840000
		}, {
			"areaId": 654223,
			"areaName": "沙湾县",
			"longitude": 85.61932000,
			"latitude": 44.33144000
		}, {
			"areaId": 654224,
			"areaName": "托里县",
			"longitude": 83.60592000,
			"latitude": 45.93623000
		}, {
			"areaId": 654225,
			"areaName": "裕民县",
			"longitude": 82.99002000,
			"latitude": 46.20377000
		}, {
			"areaId": 654226,
			"areaName": "和布克赛尔蒙古自治县",
			"longitude": 85.72662000,
			"latitude": 46.79362000
		}]
	}, {
		"areaId": 6543,
		"areaName": "阿勒泰地区",
		"longitude": 88.13963000,
		"latitude": 47.84839300,
		"children": [{
			"areaId": 654301,
			"areaName": "阿勒泰市",
			"longitude": 88.13913000,
			"latitude": 47.83170000
		}, {
			"areaId": 654321,
			"areaName": "布尔津县",
			"longitude": 86.85751000,
			"latitude": 47.70062000
		}, {
			"areaId": 654322,
			"areaName": "富蕴县",
			"longitude": 89.52679000,
			"latitude": 46.99444000
		}, {
			"areaId": 654323,
			"areaName": "福海县",
			"longitude": 87.49508000,
			"latitude": 47.11065000
		}, {
			"areaId": 654324,
			"areaName": "哈巴河县",
			"longitude": 86.42092000,
			"latitude": 48.06046000
		}, {
			"areaId": 654325,
			"areaName": "青河县",
			"longitude": 90.38305000,
			"latitude": 46.67382000
		}, {
			"areaId": 654326,
			"areaName": "吉木乃县",
			"longitude": 85.87814000,
			"latitude": 47.43359000
		}]
	}, {
		"areaId": 6590,
		"areaName": "自治区直辖县级行政区划",
		"longitude": 0.00000000,
		"latitude": 0.00000000,
		"children": [{
			"areaId": 659001,
			"areaName": "石河子市",
			"longitude": 86.04107500,
			"latitude": 44.30588600
		}, {
			"areaId": 659002,
			"areaName": "阿拉尔市",
			"longitude": 81.28588400,
			"latitude": 40.54191400
		}, {
			"areaId": 659003,
			"areaName": "图木舒克市",
			"longitude": 79.07797800,
			"latitude": 39.86731600
		}, {
			"areaId": 659004,
			"areaName": "五家渠市",
			"longitude": 87.52688400,
			"latitude": 44.16740100
		}, {
			"areaId": 659005,
			"areaName": "北屯市",
			"longitude": 120.68625000,
			"latitude": 24.18222000
		}, {
			"areaId": 659006,
			"areaName": "铁门关市",
			"longitude": 86.19468700,
			"latitude": 41.81100700
		}, {
			"areaId": 659007,
			"areaName": "双河市",
			"longitude": 91.13221200,
			"latitude": 29.66036100
		}, {
			"areaId": 659008,
			"areaName": "可克达拉市",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 659009,
			"areaName": "昆玉市",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}, {
			"areaId": 659010,
			"areaName": "胡杨河市",
			"longitude": 0.00000000,
			"latitude": 0.00000000
		}]
	}]
}, ]
	return PCCList;
}
/*

{
	"areaId": 71,
	"areaName": "台湾省",
	"longitude": 121.50906200,
	"latitude": 25.04433200,
	"children": []
}, {
	"areaId": 81,
	"areaName": "香港",
	"longitude": 114.17731400,
	"latitude": 22.26641600,
	"children": []
}, {
	"areaId": 82,
	"areaName": "澳门",
	"longitude": 113.54913400,
	"latitude": 22.19875100,
	"children": []
}
*/